import ee, { createElement as n0, useState as vn, useRef as Gl, useEffect as Pe, createContext as kv, useContext as Fv, useMemo as qv } from "react";
import Kv from "react-dom";
function Zv(l) {
  return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
}
var Tf = { exports: {} }, Jo = {}, Ef = { exports: {} }, xf = {};
var zp;
function Pv() {
  return zp || (zp = 1, (function(l) {
    function o(V, H) {
      var Z = V.length;
      V.push(H);
      t: for (; 0 < Z; ) {
        var st = Z - 1 >>> 1, ht = V[st];
        if (0 < u(ht, H))
          V[st] = H, V[Z] = ht, Z = st;
        else break t;
      }
    }
    function c(V) {
      return V.length === 0 ? null : V[0];
    }
    function s(V) {
      if (V.length === 0) return null;
      var H = V[0], Z = V.pop();
      if (Z !== H) {
        V[0] = Z;
        t: for (var st = 0, ht = V.length, ft = ht >>> 1; st < ft; ) {
          var Mt = 2 * (st + 1) - 1, gt = V[Mt], at = Mt + 1, ct = V[at];
          if (0 > u(gt, Z))
            at < ht && 0 > u(ct, gt) ? (V[st] = ct, V[at] = Z, st = at) : (V[st] = gt, V[Mt] = Z, st = Mt);
          else if (at < ht && 0 > u(ct, Z))
            V[st] = ct, V[at] = Z, st = at;
          else break t;
        }
      }
      return H;
    }
    function u(V, H) {
      var Z = V.sortIndex - H.sortIndex;
      return Z !== 0 ? Z : V.id - H.id;
    }
    if (l.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var d = performance;
      l.unstable_now = function() {
        return d.now();
      };
    } else {
      var h = Date, p = h.now();
      l.unstable_now = function() {
        return h.now() - p;
      };
    }
    var y = [], T = [], M = 1, C = null, x = 3, J = !1, j = !1, I = !1, k = !1, K = typeof setTimeout == "function" ? setTimeout : null, X = typeof clearTimeout == "function" ? clearTimeout : null, tt = typeof setImmediate < "u" ? setImmediate : null;
    function et(V) {
      for (var H = c(T); H !== null; ) {
        if (H.callback === null) s(T);
        else if (H.startTime <= V)
          s(T), H.sortIndex = H.expirationTime, o(y, H);
        else break;
        H = c(T);
      }
    }
    function lt(V) {
      if (I = !1, et(V), !j)
        if (c(y) !== null)
          j = !0, Q || (Q = !0, yt());
        else {
          var H = c(T);
          H !== null && kt(lt, H.startTime - V);
        }
    }
    var Q = !1, G = -1, P = 5, Dt = -1;
    function ot() {
      return k ? !0 : !(l.unstable_now() - Dt < P);
    }
    function dt() {
      if (k = !1, Q) {
        var V = l.unstable_now();
        Dt = V;
        var H = !0;
        try {
          t: {
            j = !1, I && (I = !1, X(G), G = -1), J = !0;
            var Z = x;
            try {
              e: {
                for (et(V), C = c(y); C !== null && !(C.expirationTime > V && ot()); ) {
                  var st = C.callback;
                  if (typeof st == "function") {
                    C.callback = null, x = C.priorityLevel;
                    var ht = st(
                      C.expirationTime <= V
                    );
                    if (V = l.unstable_now(), typeof ht == "function") {
                      C.callback = ht, et(V), H = !0;
                      break e;
                    }
                    C === c(y) && s(y), et(V);
                  } else s(y);
                  C = c(y);
                }
                if (C !== null) H = !0;
                else {
                  var ft = c(T);
                  ft !== null && kt(
                    lt,
                    ft.startTime - V
                  ), H = !1;
                }
              }
              break t;
            } finally {
              C = null, x = Z, J = !1;
            }
            H = void 0;
          }
        } finally {
          H ? yt() : Q = !1;
        }
      }
    }
    var yt;
    if (typeof tt == "function")
      yt = function() {
        tt(dt);
      };
    else if (typeof MessageChannel < "u") {
      var Tt = new MessageChannel(), ne = Tt.port2;
      Tt.port1.onmessage = dt, yt = function() {
        ne.postMessage(null);
      };
    } else
      yt = function() {
        K(dt, 0);
      };
    function kt(V, H) {
      G = K(function() {
        V(l.unstable_now());
      }, H);
    }
    l.unstable_IdlePriority = 5, l.unstable_ImmediatePriority = 1, l.unstable_LowPriority = 4, l.unstable_NormalPriority = 3, l.unstable_Profiling = null, l.unstable_UserBlockingPriority = 2, l.unstable_cancelCallback = function(V) {
      V.callback = null;
    }, l.unstable_forceFrameRate = function(V) {
      0 > V || 125 < V ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : P = 0 < V ? Math.floor(1e3 / V) : 5;
    }, l.unstable_getCurrentPriorityLevel = function() {
      return x;
    }, l.unstable_next = function(V) {
      switch (x) {
        case 1:
        case 2:
        case 3:
          var H = 3;
          break;
        default:
          H = x;
      }
      var Z = x;
      x = H;
      try {
        return V();
      } finally {
        x = Z;
      }
    }, l.unstable_requestPaint = function() {
      k = !0;
    }, l.unstable_runWithPriority = function(V, H) {
      switch (V) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          V = 3;
      }
      var Z = x;
      x = V;
      try {
        return H();
      } finally {
        x = Z;
      }
    }, l.unstable_scheduleCallback = function(V, H, Z) {
      var st = l.unstable_now();
      switch (typeof Z == "object" && Z !== null ? (Z = Z.delay, Z = typeof Z == "number" && 0 < Z ? st + Z : st) : Z = st, V) {
        case 1:
          var ht = -1;
          break;
        case 2:
          ht = 250;
          break;
        case 5:
          ht = 1073741823;
          break;
        case 4:
          ht = 1e4;
          break;
        default:
          ht = 5e3;
      }
      return ht = Z + ht, V = {
        id: M++,
        callback: H,
        priorityLevel: V,
        startTime: Z,
        expirationTime: ht,
        sortIndex: -1
      }, Z > st ? (V.sortIndex = Z, o(T, V), c(y) === null && V === c(T) && (I ? (X(G), G = -1) : I = !0, kt(lt, Z - st))) : (V.sortIndex = ht, o(y, V), j || J || (j = !0, Q || (Q = !0, yt()))), V;
    }, l.unstable_shouldYield = ot, l.unstable_wrapCallback = function(V) {
      var H = x;
      return function() {
        var Z = x;
        x = H;
        try {
          return V.apply(this, arguments);
        } finally {
          x = Z;
        }
      };
    };
  })(xf)), xf;
}
var Lp;
function Wv() {
  return Lp || (Lp = 1, Ef.exports = Pv()), Ef.exports;
}
var Rp;
function Jv() {
  if (Rp) return Jo;
  Rp = 1;
  var l = { env: { NODE_ENV: "production" } };
  var o = Wv(), c = ee, s = Kv;
  function u(t) {
    var e = "https://react.dev/errors/" + t;
    if (1 < arguments.length) {
      e += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var n = 2; n < arguments.length; n++)
        e += "&args[]=" + encodeURIComponent(arguments[n]);
    }
    return "Minified React error #" + t + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function d(t) {
    return !(!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11);
  }
  function h(t) {
    var e = t, n = t;
    if (t.alternate) for (; e.return; ) e = e.return;
    else {
      t = e;
      do
        e = t, (e.flags & 4098) !== 0 && (n = e.return), t = e.return;
      while (t);
    }
    return e.tag === 3 ? n : null;
  }
  function p(t) {
    if (t.tag === 13) {
      var e = t.memoizedState;
      if (e === null && (t = t.alternate, t !== null && (e = t.memoizedState)), e !== null) return e.dehydrated;
    }
    return null;
  }
  function y(t) {
    if (t.tag === 31) {
      var e = t.memoizedState;
      if (e === null && (t = t.alternate, t !== null && (e = t.memoizedState)), e !== null) return e.dehydrated;
    }
    return null;
  }
  function T(t) {
    if (h(t) !== t)
      throw Error(u(188));
  }
  function M(t) {
    var e = t.alternate;
    if (!e) {
      if (e = h(t), e === null) throw Error(u(188));
      return e !== t ? null : t;
    }
    for (var n = t, a = e; ; ) {
      var i = n.return;
      if (i === null) break;
      var r = i.alternate;
      if (r === null) {
        if (a = i.return, a !== null) {
          n = a;
          continue;
        }
        break;
      }
      if (i.child === r.child) {
        for (r = i.child; r; ) {
          if (r === n) return T(i), t;
          if (r === a) return T(i), e;
          r = r.sibling;
        }
        throw Error(u(188));
      }
      if (n.return !== a.return) n = i, a = r;
      else {
        for (var f = !1, m = i.child; m; ) {
          if (m === n) {
            f = !0, n = i, a = r;
            break;
          }
          if (m === a) {
            f = !0, a = i, n = r;
            break;
          }
          m = m.sibling;
        }
        if (!f) {
          for (m = r.child; m; ) {
            if (m === n) {
              f = !0, n = r, a = i;
              break;
            }
            if (m === a) {
              f = !0, a = r, n = i;
              break;
            }
            m = m.sibling;
          }
          if (!f) throw Error(u(189));
        }
      }
      if (n.alternate !== a) throw Error(u(190));
    }
    if (n.tag !== 3) throw Error(u(188));
    return n.stateNode.current === n ? t : e;
  }
  function C(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t;
    for (t = t.child; t !== null; ) {
      if (e = C(t), e !== null) return e;
      t = t.sibling;
    }
    return null;
  }
  var x = Object.assign, J = Symbol.for("react.element"), j = Symbol.for("react.transitional.element"), I = Symbol.for("react.portal"), k = Symbol.for("react.fragment"), K = Symbol.for("react.strict_mode"), X = Symbol.for("react.profiler"), tt = Symbol.for("react.consumer"), et = Symbol.for("react.context"), lt = Symbol.for("react.forward_ref"), Q = Symbol.for("react.suspense"), G = Symbol.for("react.suspense_list"), P = Symbol.for("react.memo"), Dt = Symbol.for("react.lazy"), ot = Symbol.for("react.activity"), dt = Symbol.for("react.memo_cache_sentinel"), yt = Symbol.iterator;
  function Tt(t) {
    return t === null || typeof t != "object" ? null : (t = yt && t[yt] || t["@@iterator"], typeof t == "function" ? t : null);
  }
  var ne = Symbol.for("react.client.reference");
  function kt(t) {
    if (t == null) return null;
    if (typeof t == "function")
      return t.$$typeof === ne ? null : t.displayName || t.name || null;
    if (typeof t == "string") return t;
    switch (t) {
      case k:
        return "Fragment";
      case X:
        return "Profiler";
      case K:
        return "StrictMode";
      case Q:
        return "Suspense";
      case G:
        return "SuspenseList";
      case ot:
        return "Activity";
    }
    if (typeof t == "object")
      switch (t.$$typeof) {
        case I:
          return "Portal";
        case et:
          return t.displayName || "Context";
        case tt:
          return (t._context.displayName || "Context") + ".Consumer";
        case lt:
          var e = t.render;
          return t = t.displayName, t || (t = e.displayName || e.name || "", t = t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef"), t;
        case P:
          return e = t.displayName || null, e !== null ? e : kt(t.type) || "Memo";
        case Dt:
          e = t._payload, t = t._init;
          try {
            return kt(t(e));
          } catch {
          }
      }
    return null;
  }
  var V = Array.isArray, H = c.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Z = s.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, st = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, ht = [], ft = -1;
  function Mt(t) {
    return { current: t };
  }
  function gt(t) {
    0 > ft || (t.current = ht[ft], ht[ft] = null, ft--);
  }
  function at(t, e) {
    ft++, ht[ft] = t.current, t.current = e;
  }
  var ct = Mt(null), Le = Mt(null), ye = Mt(null), On = Mt(null);
  function Tn(t, e) {
    switch (at(ye, e), at(Le, t), at(ct, null), e.nodeType) {
      case 9:
      case 11:
        t = (t = e.documentElement) && (t = t.namespaceURI) ? ep(t) : 0;
        break;
      default:
        if (t = e.tagName, e = e.namespaceURI)
          e = ep(e), t = np(e, t);
        else
          switch (t) {
            case "svg":
              t = 1;
              break;
            case "math":
              t = 2;
              break;
            default:
              t = 0;
          }
    }
    gt(ct), at(ct, t);
  }
  function ve() {
    gt(ct), gt(Le), gt(ye);
  }
  function Ft(t) {
    t.memoizedState !== null && at(On, t);
    var e = ct.current, n = np(e, t.type);
    e !== n && (at(Le, t), at(ct, n));
  }
  function fl(t) {
    Le.current === t && (gt(ct), gt(Le)), On.current === t && (gt(On), Ko._currentValue = st);
  }
  var qt, Wi;
  function jt(t) {
    if (qt === void 0)
      try {
        throw Error();
      } catch (n) {
        var e = n.stack.trim().match(/\n( *(at )?)/);
        qt = e && e[1] || "", Wi = -1 < n.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < n.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + qt + t + Wi;
  }
  var Zn = !1;
  function Zl(t, e) {
    if (!t || Zn) return "";
    Zn = !0;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var a = {
        DetermineComponentFrameRoot: function() {
          try {
            if (e) {
              var U = function() {
                throw Error();
              };
              if (Object.defineProperty(U.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(U, []);
                } catch (z) {
                  var B = z;
                }
                Reflect.construct(t, [], U);
              } else {
                try {
                  U.call();
                } catch (z) {
                  B = z;
                }
                t.call(U.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (z) {
                B = z;
              }
              (U = t()) && typeof U.catch == "function" && U.catch(function() {
              });
            }
          } catch (z) {
            if (z && B && typeof z.stack == "string")
              return [z.stack, B.stack];
          }
          return [null, null];
        }
      };
      a.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var i = Object.getOwnPropertyDescriptor(
        a.DetermineComponentFrameRoot,
        "name"
      );
      i && i.configurable && Object.defineProperty(
        a.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var r = a.DetermineComponentFrameRoot(), f = r[0], m = r[1];
      if (f && m) {
        var A = f.split(`
`), N = m.split(`
`);
        for (i = a = 0; a < A.length && !A[a].includes("DetermineComponentFrameRoot"); )
          a++;
        for (; i < N.length && !N[i].includes(
          "DetermineComponentFrameRoot"
        ); )
          i++;
        if (a === A.length || i === N.length)
          for (a = A.length - 1, i = N.length - 1; 1 <= a && 0 <= i && A[a] !== N[i]; )
            i--;
        for (; 1 <= a && 0 <= i; a--, i--)
          if (A[a] !== N[i]) {
            if (a !== 1 || i !== 1)
              do
                if (a--, i--, 0 > i || A[a] !== N[i]) {
                  var L = `
` + A[a].replace(" at new ", " at ");
                  return t.displayName && L.includes("<anonymous>") && (L = L.replace("<anonymous>", t.displayName)), L;
                }
              while (1 <= a && 0 <= i);
            break;
          }
      }
    } finally {
      Zn = !1, Error.prepareStackTrace = n;
    }
    return (n = t ? t.displayName || t.name : "") ? jt(n) : "";
  }
  function Bn(t, e) {
    switch (t.tag) {
      case 26:
      case 27:
      case 5:
        return jt(t.type);
      case 16:
        return jt("Lazy");
      case 13:
        return t.child !== e && e !== null ? jt("Suspense Fallback") : jt("Suspense");
      case 19:
        return jt("SuspenseList");
      case 0:
      case 15:
        return Zl(t.type, !1);
      case 11:
        return Zl(t.type.render, !1);
      case 1:
        return Zl(t.type, !0);
      case 31:
        return jt("Activity");
      default:
        return "";
    }
  }
  function Ji(t) {
    try {
      var e = "", n = null;
      do
        e += Bn(t, n), n = t, t = t.return;
      while (t);
      return e;
    } catch (a) {
      return `
Error generating stack: ` + a.message + `
` + a.stack;
    }
  }
  var dl = Object.prototype.hasOwnProperty, Pl = o.unstable_scheduleCallback, Wl = o.unstable_cancelCallback, Mn = o.unstable_shouldYield, ml = o.unstable_requestPaint, ie = o.unstable_now, _i = o.unstable_getCurrentPriorityLevel, Jl = o.unstable_ImmediatePriority, _l = o.unstable_UserBlockingPriority, ba = o.unstable_NormalPriority, Sa = o.unstable_LowPriority, hl = o.unstable_IdlePriority, $l = o.log, Tr = o.unstable_setDisableYieldValue, Oa = null, Be = null;
  function cn(t) {
    if (typeof $l == "function" && Tr(t), Be && typeof Be.setStrictMode == "function")
      try {
        Be.setStrictMode(Oa, t);
      } catch {
      }
  }
  var Oe = Math.clz32 ? Math.clz32 : $i, Ta = Math.log, un = Math.LN2;
  function $i(t) {
    return t >>>= 0, t === 0 ? 32 : 31 - (Ta(t) / un | 0) | 0;
  }
  var gl = 256, pl = 262144, Ea = 4194304;
  function zn(t) {
    var e = t & 42;
    if (e !== 0) return e;
    switch (t & -t) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return t & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return t & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return t;
    }
  }
  function Pn(t, e, n) {
    var a = t.pendingLanes;
    if (a === 0) return 0;
    var i = 0, r = t.suspendedLanes, f = t.pingedLanes;
    t = t.warmLanes;
    var m = a & 134217727;
    return m !== 0 ? (a = m & ~r, a !== 0 ? i = zn(a) : (f &= m, f !== 0 ? i = zn(f) : n || (n = m & ~t, n !== 0 && (i = zn(n))))) : (m = a & ~r, m !== 0 ? i = zn(m) : f !== 0 ? i = zn(f) : n || (n = a & ~t, n !== 0 && (i = zn(n)))), i === 0 ? 0 : e !== 0 && e !== i && (e & r) === 0 && (r = i & -i, n = e & -e, r >= n || r === 32 && (n & 4194048) !== 0) ? e : i;
  }
  function Ln(t, e) {
    return (t.pendingLanes & ~(t.suspendedLanes & ~t.pingedLanes) & e) === 0;
  }
  function sn(t, e) {
    switch (t) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return e + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Wn() {
    var t = Ea;
    return Ea <<= 1, (Ea & 62914560) === 0 && (Ea = 4194304), t;
  }
  function Al(t) {
    for (var e = [], n = 0; 31 > n; n++) e.push(t);
    return e;
  }
  function Jn(t, e) {
    t.pendingLanes |= e, e !== 268435456 && (t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0);
  }
  function Au(t, e, n, a, i, r) {
    var f = t.pendingLanes;
    t.pendingLanes = n, t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0, t.expiredLanes &= n, t.entangledLanes &= n, t.errorRecoveryDisabledLanes &= n, t.shellSuspendCounter = 0;
    var m = t.entanglements, A = t.expirationTimes, N = t.hiddenUpdates;
    for (n = f & ~n; 0 < n; ) {
      var L = 31 - Oe(n), U = 1 << L;
      m[L] = 0, A[L] = -1;
      var B = N[L];
      if (B !== null)
        for (N[L] = null, L = 0; L < B.length; L++) {
          var z = B[L];
          z !== null && (z.lane &= -536870913);
        }
      n &= ~U;
    }
    a !== 0 && to(t, a, 0), r !== 0 && i === 0 && t.tag !== 0 && (t.suspendedLanes |= r & ~(f & ~e));
  }
  function to(t, e, n) {
    t.pendingLanes |= e, t.suspendedLanes &= ~e;
    var a = 31 - Oe(e);
    t.entangledLanes |= e, t.entanglements[a] = t.entanglements[a] | 1073741824 | n & 261930;
  }
  function ti(t, e) {
    var n = t.entangledLanes |= e;
    for (t = t.entanglements; n; ) {
      var a = 31 - Oe(n), i = 1 << a;
      i & e | t[a] & e && (t[a] |= e), n &= ~i;
    }
  }
  function eo(t, e) {
    var n = e & -e;
    return n = (n & 42) !== 0 ? 1 : yl(n), (n & (t.suspendedLanes | e)) !== 0 ? 0 : n;
  }
  function yl(t) {
    switch (t) {
      case 2:
        t = 1;
        break;
      case 8:
        t = 4;
        break;
      case 32:
        t = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        t = 128;
        break;
      case 268435456:
        t = 134217728;
        break;
      default:
        t = 0;
    }
    return t;
  }
  function no(t) {
    return t &= -t, 2 < t ? 8 < t ? (t & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function xa() {
    var t = Z.p;
    return t !== 0 ? t : (t = window.event, t === void 0 ? 32 : xp(t.type));
  }
  function Er(t, e) {
    var n = Z.p;
    try {
      return Z.p = t, e();
    } finally {
      Z.p = n;
    }
  }
  var Rn = Math.random().toString(36).slice(2), vt = "__reactFiber$" + Rn, oe = "__reactProps$" + Rn, Na = "__reactContainer$" + Rn, ei = "__reactEvents$" + Rn, ao = "__reactListeners$" + Rn, xr = "__reactHandles$" + Rn, lo = "__reactResources$" + Rn, vl = "__reactMarker$" + Rn;
  function io(t) {
    delete t[vt], delete t[oe], delete t[ei], delete t[ao], delete t[xr];
  }
  function Ca(t) {
    var e = t[vt];
    if (e) return e;
    for (var n = t.parentNode; n; ) {
      if (e = n[Na] || n[vt]) {
        if (n = e.alternate, e.child !== null || n !== null && n.child !== null)
          for (t = up(t); t !== null; ) {
            if (n = t[vt]) return n;
            t = up(t);
          }
        return e;
      }
      t = n, n = t.parentNode;
    }
    return null;
  }
  function wa(t) {
    if (t = t[vt] || t[Na]) {
      var e = t.tag;
      if (e === 5 || e === 6 || e === 13 || e === 31 || e === 26 || e === 27 || e === 3)
        return t;
    }
    return null;
  }
  function Qe(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t.stateNode;
    throw Error(u(33));
  }
  function _n(t) {
    var e = t[lo];
    return e || (e = t[lo] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), e;
  }
  function Kt(t) {
    t[vl] = !0;
  }
  var Nr = /* @__PURE__ */ new Set(), Cr = {};
  function Un(t, e) {
    $n(t, e), $n(t + "Capture", e);
  }
  function $n(t, e) {
    for (Cr[t] = e, t = 0; t < e.length; t++)
      Nr.add(e[t]);
  }
  var ni = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), ai = {}, bl = {};
  function Da(t) {
    return dl.call(bl, t) ? !0 : dl.call(ai, t) ? !1 : ni.test(t) ? bl[t] = !0 : (ai[t] = !0, !1);
  }
  function Hn(t, e, n) {
    if (Da(e))
      if (n === null) t.removeAttribute(e);
      else {
        switch (typeof n) {
          case "undefined":
          case "function":
          case "symbol":
            t.removeAttribute(e);
            return;
          case "boolean":
            var a = e.toLowerCase().slice(0, 5);
            if (a !== "data-" && a !== "aria-") {
              t.removeAttribute(e);
              return;
            }
        }
        t.setAttribute(e, "" + n);
      }
  }
  function Ve(t, e, n) {
    if (n === null) t.removeAttribute(e);
    else {
      switch (typeof n) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(e);
          return;
      }
      t.setAttribute(e, "" + n);
    }
  }
  function En(t, e, n, a) {
    if (a === null) t.removeAttribute(n);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(n);
          return;
      }
      t.setAttributeNS(e, n, "" + a);
    }
  }
  function Ye(t) {
    switch (typeof t) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return t;
      case "object":
        return t;
      default:
        return "";
    }
  }
  function oo(t) {
    var e = t.type;
    return (t = t.nodeName) && t.toLowerCase() === "input" && (e === "checkbox" || e === "radio");
  }
  function wr(t, e, n) {
    var a = Object.getOwnPropertyDescriptor(
      t.constructor.prototype,
      e
    );
    if (!t.hasOwnProperty(e) && typeof a < "u" && typeof a.get == "function" && typeof a.set == "function") {
      var i = a.get, r = a.set;
      return Object.defineProperty(t, e, {
        configurable: !0,
        get: function() {
          return i.call(this);
        },
        set: function(f) {
          n = "" + f, r.call(this, f);
        }
      }), Object.defineProperty(t, e, {
        enumerable: a.enumerable
      }), {
        getValue: function() {
          return n;
        },
        setValue: function(f) {
          n = "" + f;
        },
        stopTracking: function() {
          t._valueTracker = null, delete t[e];
        }
      };
    }
  }
  function ro(t) {
    if (!t._valueTracker) {
      var e = oo(t) ? "checked" : "value";
      t._valueTracker = wr(
        t,
        e,
        "" + t[e]
      );
    }
  }
  function co(t) {
    if (!t) return !1;
    var e = t._valueTracker;
    if (!e) return !0;
    var n = e.getValue(), a = "";
    return t && (a = oo(t) ? t.checked ? "true" : "false" : t.value), t = a, t !== n ? (e.setValue(t), !0) : !1;
  }
  function li(t) {
    if (t = t || (typeof document < "u" ? document : void 0), typeof t > "u") return null;
    try {
      return t.activeElement || t.body;
    } catch {
      return t.body;
    }
  }
  var yu = /[\n"\\]/g;
  function Re(t) {
    return t.replace(
      yu,
      function(e) {
        return "\\" + e.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function Ba(t, e, n, a, i, r, f, m) {
    t.name = "", f != null && typeof f != "function" && typeof f != "symbol" && typeof f != "boolean" ? t.type = f : t.removeAttribute("type"), e != null ? f === "number" ? (e === 0 && t.value === "" || t.value != e) && (t.value = "" + Ye(e)) : t.value !== "" + Ye(e) && (t.value = "" + Ye(e)) : f !== "submit" && f !== "reset" || t.removeAttribute("value"), e != null ? F(t, f, Ye(e)) : n != null ? F(t, f, Ye(n)) : a != null && t.removeAttribute("value"), i == null && r != null && (t.defaultChecked = !!r), i != null && (t.checked = i && typeof i != "function" && typeof i != "symbol"), m != null && typeof m != "function" && typeof m != "symbol" && typeof m != "boolean" ? t.name = "" + Ye(m) : t.removeAttribute("name");
  }
  function ii(t, e, n, a, i, r, f, m) {
    if (r != null && typeof r != "function" && typeof r != "symbol" && typeof r != "boolean" && (t.type = r), e != null || n != null) {
      if (!(r !== "submit" && r !== "reset" || e != null)) {
        ro(t);
        return;
      }
      n = n != null ? "" + Ye(n) : "", e = e != null ? "" + Ye(e) : n, m || e === t.value || (t.value = e), t.defaultValue = e;
    }
    a = a ?? i, a = typeof a != "function" && typeof a != "symbol" && !!a, t.checked = m ? t.checked : !!a, t.defaultChecked = !!a, f != null && typeof f != "function" && typeof f != "symbol" && typeof f != "boolean" && (t.name = f), ro(t);
  }
  function F(t, e, n) {
    e === "number" && li(t.ownerDocument) === t || t.defaultValue === "" + n || (t.defaultValue = "" + n);
  }
  function g(t, e, n, a) {
    if (t = t.options, e) {
      e = {};
      for (var i = 0; i < n.length; i++)
        e["$" + n[i]] = !0;
      for (n = 0; n < t.length; n++)
        i = e.hasOwnProperty("$" + t[n].value), t[n].selected !== i && (t[n].selected = i), i && a && (t[n].defaultSelected = !0);
    } else {
      for (n = "" + Ye(n), e = null, i = 0; i < t.length; i++) {
        if (t[i].value === n) {
          t[i].selected = !0, a && (t[i].defaultSelected = !0);
          return;
        }
        e !== null || t[i].disabled || (e = t[i]);
      }
      e !== null && (e.selected = !0);
    }
  }
  function w(t, e, n) {
    if (e != null && (e = "" + Ye(e), e !== t.value && (t.value = e), n == null)) {
      t.defaultValue !== e && (t.defaultValue = e);
      return;
    }
    t.defaultValue = n != null ? "" + Ye(n) : "";
  }
  function q(t, e, n, a) {
    if (e == null) {
      if (a != null) {
        if (n != null) throw Error(u(92));
        if (V(a)) {
          if (1 < a.length) throw Error(u(93));
          a = a[0];
        }
        n = a;
      }
      n == null && (n = ""), e = n;
    }
    n = Ye(e), t.defaultValue = n, a = t.textContent, a === n && a !== "" && a !== null && (t.value = a), ro(t);
  }
  function W(t, e) {
    if (e) {
      var n = t.firstChild;
      if (n && n === t.lastChild && n.nodeType === 3) {
        n.nodeValue = e;
        return;
      }
    }
    t.textContent = e;
  }
  var pt = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function Et(t, e, n) {
    var a = e.indexOf("--") === 0;
    n == null || typeof n == "boolean" || n === "" ? a ? t.setProperty(e, "") : e === "float" ? t.cssFloat = "" : t[e] = "" : a ? t.setProperty(e, n) : typeof n != "number" || n === 0 || pt.has(e) ? e === "float" ? t.cssFloat = n : t[e] = ("" + n).trim() : t[e] = n + "px";
  }
  function re(t, e, n) {
    if (e != null && typeof e != "object")
      throw Error(u(62));
    if (t = t.style, n != null) {
      for (var a in n)
        !n.hasOwnProperty(a) || e != null && e.hasOwnProperty(a) || (a.indexOf("--") === 0 ? t.setProperty(a, "") : a === "float" ? t.cssFloat = "" : t[a] = "");
      for (var i in e)
        a = e[i], e.hasOwnProperty(i) && n[i] !== a && Et(t, i, a);
    } else
      for (var r in e)
        e.hasOwnProperty(r) && Et(t, r, e[r]);
  }
  function $t(t) {
    if (t.indexOf("-") === -1) return !1;
    switch (t) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Ge = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), We = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Ma(t) {
    return We.test("" + t) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : t;
  }
  function Zt() {
  }
  var vu = null;
  function bu(t) {
    return t = t.target || t.srcElement || window, t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === 3 ? t.parentNode : t;
  }
  var oi = null, ri = null;
  function tm(t) {
    var e = wa(t);
    if (e && (t = e.stateNode)) {
      var n = t[oe] || null;
      t: switch (t = e.stateNode, e.type) {
        case "input":
          if (Ba(
            t,
            n.value,
            n.defaultValue,
            n.defaultValue,
            n.checked,
            n.defaultChecked,
            n.type,
            n.name
          ), e = n.name, n.type === "radio" && e != null) {
            for (n = t; n.parentNode; ) n = n.parentNode;
            for (n = n.querySelectorAll(
              'input[name="' + Re(
                "" + e
              ) + '"][type="radio"]'
            ), e = 0; e < n.length; e++) {
              var a = n[e];
              if (a !== t && a.form === t.form) {
                var i = a[oe] || null;
                if (!i) throw Error(u(90));
                Ba(
                  a,
                  i.value,
                  i.defaultValue,
                  i.defaultValue,
                  i.checked,
                  i.defaultChecked,
                  i.type,
                  i.name
                );
              }
            }
            for (e = 0; e < n.length; e++)
              a = n[e], a.form === t.form && co(a);
          }
          break t;
        case "textarea":
          w(t, n.value, n.defaultValue);
          break t;
        case "select":
          e = n.value, e != null && g(t, !!n.multiple, e, !1);
      }
    }
  }
  var Su = !1;
  function em(t, e, n) {
    if (Su) return t(e, n);
    Su = !0;
    try {
      var a = t(e);
      return a;
    } finally {
      if (Su = !1, (oi !== null || ri !== null) && (gc(), oi && (e = oi, t = ri, ri = oi = null, tm(e), t)))
        for (e = 0; e < t.length; e++) tm(t[e]);
    }
  }
  function uo(t, e) {
    var n = t.stateNode;
    if (n === null) return null;
    var a = n[oe] || null;
    if (a === null) return null;
    n = a[e];
    t: switch (e) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (a = !a.disabled) || (t = t.type, a = !(t === "button" || t === "input" || t === "select" || t === "textarea")), t = !a;
        break t;
      default:
        t = !1;
    }
    if (t) return null;
    if (n && typeof n != "function")
      throw Error(
        u(231, e, typeof n)
      );
    return n;
  }
  var ta = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), Ou = !1;
  if (ta)
    try {
      var so = {};
      Object.defineProperty(so, "passive", {
        get: function() {
          Ou = !0;
        }
      }), window.addEventListener("test", so, so), window.removeEventListener("test", so, so);
    } catch {
      Ou = !1;
    }
  var za = null, Tu = null, Dr = null;
  function nm() {
    if (Dr) return Dr;
    var t, e = Tu, n = e.length, a, i = "value" in za ? za.value : za.textContent, r = i.length;
    for (t = 0; t < n && e[t] === i[t]; t++) ;
    var f = n - t;
    for (a = 1; a <= f && e[n - a] === i[r - a]; a++) ;
    return Dr = i.slice(t, 1 < a ? 1 - a : void 0);
  }
  function Br(t) {
    var e = t.keyCode;
    return "charCode" in t ? (t = t.charCode, t === 0 && e === 13 && (t = 13)) : t = e, t === 10 && (t = 13), 32 <= t || t === 13 ? t : 0;
  }
  function Mr() {
    return !0;
  }
  function am() {
    return !1;
  }
  function Ie(t) {
    function e(n, a, i, r, f) {
      this._reactName = n, this._targetInst = i, this.type = a, this.nativeEvent = r, this.target = f, this.currentTarget = null;
      for (var m in t)
        t.hasOwnProperty(m) && (n = t[m], this[m] = n ? n(r) : r[m]);
      return this.isDefaultPrevented = (r.defaultPrevented != null ? r.defaultPrevented : r.returnValue === !1) ? Mr : am, this.isPropagationStopped = am, this;
    }
    return x(e.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var n = this.nativeEvent;
        n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = Mr);
      },
      stopPropagation: function() {
        var n = this.nativeEvent;
        n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = Mr);
      },
      persist: function() {
      },
      isPersistent: Mr
    }), e;
  }
  var Sl = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(t) {
      return t.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, zr = Ie(Sl), fo = x({}, Sl, { view: 0, detail: 0 }), G1 = Ie(fo), Eu, xu, mo, Lr = x({}, fo, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Cu,
    button: 0,
    buttons: 0,
    relatedTarget: function(t) {
      return t.relatedTarget === void 0 ? t.fromElement === t.srcElement ? t.toElement : t.fromElement : t.relatedTarget;
    },
    movementX: function(t) {
      return "movementX" in t ? t.movementX : (t !== mo && (mo && t.type === "mousemove" ? (Eu = t.screenX - mo.screenX, xu = t.screenY - mo.screenY) : xu = Eu = 0, mo = t), Eu);
    },
    movementY: function(t) {
      return "movementY" in t ? t.movementY : xu;
    }
  }), lm = Ie(Lr), I1 = x({}, Lr, { dataTransfer: 0 }), k1 = Ie(I1), F1 = x({}, fo, { relatedTarget: 0 }), Nu = Ie(F1), q1 = x({}, Sl, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), K1 = Ie(q1), Z1 = x({}, Sl, {
    clipboardData: function(t) {
      return "clipboardData" in t ? t.clipboardData : window.clipboardData;
    }
  }), P1 = Ie(Z1), W1 = x({}, Sl, { data: 0 }), im = Ie(W1), J1 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, _1 = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, $1 = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function ty(t) {
    var e = this.nativeEvent;
    return e.getModifierState ? e.getModifierState(t) : (t = $1[t]) ? !!e[t] : !1;
  }
  function Cu() {
    return ty;
  }
  var ey = x({}, fo, {
    key: function(t) {
      if (t.key) {
        var e = J1[t.key] || t.key;
        if (e !== "Unidentified") return e;
      }
      return t.type === "keypress" ? (t = Br(t), t === 13 ? "Enter" : String.fromCharCode(t)) : t.type === "keydown" || t.type === "keyup" ? _1[t.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Cu,
    charCode: function(t) {
      return t.type === "keypress" ? Br(t) : 0;
    },
    keyCode: function(t) {
      return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    },
    which: function(t) {
      return t.type === "keypress" ? Br(t) : t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    }
  }), ny = Ie(ey), ay = x({}, Lr, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), om = Ie(ay), ly = x({}, fo, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Cu
  }), iy = Ie(ly), oy = x({}, Sl, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), ry = Ie(oy), cy = x({}, Lr, {
    deltaX: function(t) {
      return "deltaX" in t ? t.deltaX : "wheelDeltaX" in t ? -t.wheelDeltaX : 0;
    },
    deltaY: function(t) {
      return "deltaY" in t ? t.deltaY : "wheelDeltaY" in t ? -t.wheelDeltaY : "wheelDelta" in t ? -t.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), uy = Ie(cy), sy = x({}, Sl, {
    newState: 0,
    oldState: 0
  }), fy = Ie(sy), dy = [9, 13, 27, 32], wu = ta && "CompositionEvent" in window, ho = null;
  ta && "documentMode" in document && (ho = document.documentMode);
  var my = ta && "TextEvent" in window && !ho, rm = ta && (!wu || ho && 8 < ho && 11 >= ho), cm = " ", um = !1;
  function sm(t, e) {
    switch (t) {
      case "keyup":
        return dy.indexOf(e.keyCode) !== -1;
      case "keydown":
        return e.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function fm(t) {
    return t = t.detail, typeof t == "object" && "data" in t ? t.data : null;
  }
  var ci = !1;
  function hy(t, e) {
    switch (t) {
      case "compositionend":
        return fm(e);
      case "keypress":
        return e.which !== 32 ? null : (um = !0, cm);
      case "textInput":
        return t = e.data, t === cm && um ? null : t;
      default:
        return null;
    }
  }
  function gy(t, e) {
    if (ci)
      return t === "compositionend" || !wu && sm(t, e) ? (t = nm(), Dr = Tu = za = null, ci = !1, t) : null;
    switch (t) {
      case "paste":
        return null;
      case "keypress":
        if (!(e.ctrlKey || e.altKey || e.metaKey) || e.ctrlKey && e.altKey) {
          if (e.char && 1 < e.char.length)
            return e.char;
          if (e.which) return String.fromCharCode(e.which);
        }
        return null;
      case "compositionend":
        return rm && e.locale !== "ko" ? null : e.data;
      default:
        return null;
    }
  }
  var py = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function dm(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return e === "input" ? !!py[t.type] : e === "textarea";
  }
  function mm(t, e, n, a) {
    oi ? ri ? ri.push(a) : ri = [a] : oi = a, e = Oc(e, "onChange"), 0 < e.length && (n = new zr(
      "onChange",
      "change",
      null,
      n,
      a
    ), t.push({ event: n, listeners: e }));
  }
  var go = null, po = null;
  function Ay(t) {
    Pg(t, 0);
  }
  function Rr(t) {
    var e = Qe(t);
    if (co(e)) return t;
  }
  function hm(t, e) {
    if (t === "change") return e;
  }
  var gm = !1;
  if (ta) {
    var Du;
    if (ta) {
      var Bu = "oninput" in document;
      if (!Bu) {
        var pm = document.createElement("div");
        pm.setAttribute("oninput", "return;"), Bu = typeof pm.oninput == "function";
      }
      Du = Bu;
    } else Du = !1;
    gm = Du && (!document.documentMode || 9 < document.documentMode);
  }
  function Am() {
    go && (go.detachEvent("onpropertychange", ym), po = go = null);
  }
  function ym(t) {
    if (t.propertyName === "value" && Rr(po)) {
      var e = [];
      mm(
        e,
        po,
        t,
        bu(t)
      ), em(Ay, e);
    }
  }
  function yy(t, e, n) {
    t === "focusin" ? (Am(), go = e, po = n, go.attachEvent("onpropertychange", ym)) : t === "focusout" && Am();
  }
  function vy(t) {
    if (t === "selectionchange" || t === "keyup" || t === "keydown")
      return Rr(po);
  }
  function by(t, e) {
    if (t === "click") return Rr(e);
  }
  function Sy(t, e) {
    if (t === "input" || t === "change")
      return Rr(e);
  }
  function Oy(t, e) {
    return t === e && (t !== 0 || 1 / t === 1 / e) || t !== t && e !== e;
  }
  var Je = typeof Object.is == "function" ? Object.is : Oy;
  function Ao(t, e) {
    if (Je(t, e)) return !0;
    if (typeof t != "object" || t === null || typeof e != "object" || e === null)
      return !1;
    var n = Object.keys(t), a = Object.keys(e);
    if (n.length !== a.length) return !1;
    for (a = 0; a < n.length; a++) {
      var i = n[a];
      if (!dl.call(e, i) || !Je(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  function vm(t) {
    for (; t && t.firstChild; ) t = t.firstChild;
    return t;
  }
  function bm(t, e) {
    var n = vm(t);
    t = 0;
    for (var a; n; ) {
      if (n.nodeType === 3) {
        if (a = t + n.textContent.length, t <= e && a >= e)
          return { node: n, offset: e - t };
        t = a;
      }
      t: {
        for (; n; ) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break t;
          }
          n = n.parentNode;
        }
        n = void 0;
      }
      n = vm(n);
    }
  }
  function Sm(t, e) {
    return t && e ? t === e ? !0 : t && t.nodeType === 3 ? !1 : e && e.nodeType === 3 ? Sm(t, e.parentNode) : "contains" in t ? t.contains(e) : t.compareDocumentPosition ? !!(t.compareDocumentPosition(e) & 16) : !1 : !1;
  }
  function Om(t) {
    t = t != null && t.ownerDocument != null && t.ownerDocument.defaultView != null ? t.ownerDocument.defaultView : window;
    for (var e = li(t.document); e instanceof t.HTMLIFrameElement; ) {
      try {
        var n = typeof e.contentWindow.location.href == "string";
      } catch {
        n = !1;
      }
      if (n) t = e.contentWindow;
      else break;
      e = li(t.document);
    }
    return e;
  }
  function Mu(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return e && (e === "input" && (t.type === "text" || t.type === "search" || t.type === "tel" || t.type === "url" || t.type === "password") || e === "textarea" || t.contentEditable === "true");
  }
  var Ty = ta && "documentMode" in document && 11 >= document.documentMode, ui = null, zu = null, yo = null, Lu = !1;
  function Tm(t, e, n) {
    var a = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    Lu || ui == null || ui !== li(a) || (a = ui, "selectionStart" in a && Mu(a) ? a = { start: a.selectionStart, end: a.selectionEnd } : (a = (a.ownerDocument && a.ownerDocument.defaultView || window).getSelection(), a = {
      anchorNode: a.anchorNode,
      anchorOffset: a.anchorOffset,
      focusNode: a.focusNode,
      focusOffset: a.focusOffset
    }), yo && Ao(yo, a) || (yo = a, a = Oc(zu, "onSelect"), 0 < a.length && (e = new zr(
      "onSelect",
      "select",
      null,
      e,
      n
    ), t.push({ event: e, listeners: a }), e.target = ui)));
  }
  function Ol(t, e) {
    var n = {};
    return n[t.toLowerCase()] = e.toLowerCase(), n["Webkit" + t] = "webkit" + e, n["Moz" + t] = "moz" + e, n;
  }
  var si = {
    animationend: Ol("Animation", "AnimationEnd"),
    animationiteration: Ol("Animation", "AnimationIteration"),
    animationstart: Ol("Animation", "AnimationStart"),
    transitionrun: Ol("Transition", "TransitionRun"),
    transitionstart: Ol("Transition", "TransitionStart"),
    transitioncancel: Ol("Transition", "TransitionCancel"),
    transitionend: Ol("Transition", "TransitionEnd")
  }, Ru = {}, Em = {};
  ta && (Em = document.createElement("div").style, "AnimationEvent" in window || (delete si.animationend.animation, delete si.animationiteration.animation, delete si.animationstart.animation), "TransitionEvent" in window || delete si.transitionend.transition);
  function Tl(t) {
    if (Ru[t]) return Ru[t];
    if (!si[t]) return t;
    var e = si[t], n;
    for (n in e)
      if (e.hasOwnProperty(n) && n in Em)
        return Ru[t] = e[n];
    return t;
  }
  var xm = Tl("animationend"), Nm = Tl("animationiteration"), Cm = Tl("animationstart"), Ey = Tl("transitionrun"), xy = Tl("transitionstart"), Ny = Tl("transitioncancel"), wm = Tl("transitionend"), Dm = /* @__PURE__ */ new Map(), Uu = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  Uu.push("scrollEnd");
  function xn(t, e) {
    Dm.set(t, e), Un(e, [t]);
  }
  var Ur = typeof reportError == "function" ? reportError : function(t) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var e = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof t == "object" && t !== null && typeof t.message == "string" ? String(t.message) : String(t),
        error: t
      });
      if (!window.dispatchEvent(e)) return;
    } else if (typeof l == "object" && typeof l.emit == "function") {
      l.emit("uncaughtException", t);
      return;
    }
    console.error(t);
  }, fn = [], fi = 0, Hu = 0;
  function Hr() {
    for (var t = fi, e = Hu = fi = 0; e < t; ) {
      var n = fn[e];
      fn[e++] = null;
      var a = fn[e];
      fn[e++] = null;
      var i = fn[e];
      fn[e++] = null;
      var r = fn[e];
      if (fn[e++] = null, a !== null && i !== null) {
        var f = a.pending;
        f === null ? i.next = i : (i.next = f.next, f.next = i), a.pending = i;
      }
      r !== 0 && Bm(n, i, r);
    }
  }
  function jr(t, e, n, a) {
    fn[fi++] = t, fn[fi++] = e, fn[fi++] = n, fn[fi++] = a, Hu |= a, t.lanes |= a, t = t.alternate, t !== null && (t.lanes |= a);
  }
  function ju(t, e, n, a) {
    return jr(t, e, n, a), Xr(t);
  }
  function El(t, e) {
    return jr(t, null, null, e), Xr(t);
  }
  function Bm(t, e, n) {
    t.lanes |= n;
    var a = t.alternate;
    a !== null && (a.lanes |= n);
    for (var i = !1, r = t.return; r !== null; )
      r.childLanes |= n, a = r.alternate, a !== null && (a.childLanes |= n), r.tag === 22 && (t = r.stateNode, t === null || t._visibility & 1 || (i = !0)), t = r, r = r.return;
    return t.tag === 3 ? (r = t.stateNode, i && e !== null && (i = 31 - Oe(n), t = r.hiddenUpdates, a = t[i], a === null ? t[i] = [e] : a.push(e), e.lane = n | 536870912), r) : null;
  }
  function Xr(t) {
    if (50 < Vo)
      throw Vo = 0, qs = null, Error(u(185));
    for (var e = t.return; e !== null; )
      t = e, e = t.return;
    return t.tag === 3 ? t.stateNode : null;
  }
  var di = {};
  function Cy(t, e, n, a) {
    this.tag = t, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = e, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = a, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function _e(t, e, n, a) {
    return new Cy(t, e, n, a);
  }
  function Xu(t) {
    return t = t.prototype, !(!t || !t.isReactComponent);
  }
  function ea(t, e) {
    var n = t.alternate;
    return n === null ? (n = _e(
      t.tag,
      e,
      t.key,
      t.mode
    ), n.elementType = t.elementType, n.type = t.type, n.stateNode = t.stateNode, n.alternate = t, t.alternate = n) : (n.pendingProps = e, n.type = t.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = t.flags & 65011712, n.childLanes = t.childLanes, n.lanes = t.lanes, n.child = t.child, n.memoizedProps = t.memoizedProps, n.memoizedState = t.memoizedState, n.updateQueue = t.updateQueue, e = t.dependencies, n.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }, n.sibling = t.sibling, n.index = t.index, n.ref = t.ref, n.refCleanup = t.refCleanup, n;
  }
  function Mm(t, e) {
    t.flags &= 65011714;
    var n = t.alternate;
    return n === null ? (t.childLanes = 0, t.lanes = e, t.child = null, t.subtreeFlags = 0, t.memoizedProps = null, t.memoizedState = null, t.updateQueue = null, t.dependencies = null, t.stateNode = null) : (t.childLanes = n.childLanes, t.lanes = n.lanes, t.child = n.child, t.subtreeFlags = 0, t.deletions = null, t.memoizedProps = n.memoizedProps, t.memoizedState = n.memoizedState, t.updateQueue = n.updateQueue, t.type = n.type, e = n.dependencies, t.dependencies = e === null ? null : {
      lanes: e.lanes,
      firstContext: e.firstContext
    }), t;
  }
  function Qr(t, e, n, a, i, r) {
    var f = 0;
    if (a = t, typeof t == "function") Xu(t) && (f = 1);
    else if (typeof t == "string")
      f = zv(
        t,
        n,
        ct.current
      ) ? 26 : t === "html" || t === "head" || t === "body" ? 27 : 5;
    else
      t: switch (t) {
        case ot:
          return t = _e(31, n, e, i), t.elementType = ot, t.lanes = r, t;
        case k:
          return xl(n.children, i, r, e);
        case K:
          f = 8, i |= 24;
          break;
        case X:
          return t = _e(12, n, e, i | 2), t.elementType = X, t.lanes = r, t;
        case Q:
          return t = _e(13, n, e, i), t.elementType = Q, t.lanes = r, t;
        case G:
          return t = _e(19, n, e, i), t.elementType = G, t.lanes = r, t;
        default:
          if (typeof t == "object" && t !== null)
            switch (t.$$typeof) {
              case et:
                f = 10;
                break t;
              case tt:
                f = 9;
                break t;
              case lt:
                f = 11;
                break t;
              case P:
                f = 14;
                break t;
              case Dt:
                f = 16, a = null;
                break t;
            }
          f = 29, n = Error(
            u(130, t === null ? "null" : typeof t, "")
          ), a = null;
      }
    return e = _e(f, n, e, i), e.elementType = t, e.type = a, e.lanes = r, e;
  }
  function xl(t, e, n, a) {
    return t = _e(7, t, a, e), t.lanes = n, t;
  }
  function Qu(t, e, n) {
    return t = _e(6, t, null, e), t.lanes = n, t;
  }
  function zm(t) {
    var e = _e(18, null, null, 0);
    return e.stateNode = t, e;
  }
  function Vu(t, e, n) {
    return e = _e(
      4,
      t.children !== null ? t.children : [],
      t.key,
      e
    ), e.lanes = n, e.stateNode = {
      containerInfo: t.containerInfo,
      pendingChildren: null,
      implementation: t.implementation
    }, e;
  }
  var Lm = /* @__PURE__ */ new WeakMap();
  function dn(t, e) {
    if (typeof t == "object" && t !== null) {
      var n = Lm.get(t);
      return n !== void 0 ? n : (e = {
        value: t,
        source: e,
        stack: Ji(e)
      }, Lm.set(t, e), e);
    }
    return {
      value: t,
      source: e,
      stack: Ji(e)
    };
  }
  var mi = [], hi = 0, Vr = null, vo = 0, mn = [], hn = 0, La = null, jn = 1, Xn = "";
  function na(t, e) {
    mi[hi++] = vo, mi[hi++] = Vr, Vr = t, vo = e;
  }
  function Rm(t, e, n) {
    mn[hn++] = jn, mn[hn++] = Xn, mn[hn++] = La, La = t;
    var a = jn;
    t = Xn;
    var i = 32 - Oe(a) - 1;
    a &= ~(1 << i), n += 1;
    var r = 32 - Oe(e) + i;
    if (30 < r) {
      var f = i - i % 5;
      r = (a & (1 << f) - 1).toString(32), a >>= f, i -= f, jn = 1 << 32 - Oe(e) + i | n << i | a, Xn = r + t;
    } else
      jn = 1 << r | n << i | a, Xn = t;
  }
  function Yu(t) {
    t.return !== null && (na(t, 1), Rm(t, 1, 0));
  }
  function Gu(t) {
    for (; t === Vr; )
      Vr = mi[--hi], mi[hi] = null, vo = mi[--hi], mi[hi] = null;
    for (; t === La; )
      La = mn[--hn], mn[hn] = null, Xn = mn[--hn], mn[hn] = null, jn = mn[--hn], mn[hn] = null;
  }
  function Um(t, e) {
    mn[hn++] = jn, mn[hn++] = Xn, mn[hn++] = La, jn = e.id, Xn = e.overflow, La = t;
  }
  var Te = null, Pt = null, Ct = !1, Ra = null, gn = !1, Iu = Error(u(519));
  function Ua(t) {
    var e = Error(
      u(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw bo(dn(e, t)), Iu;
  }
  function Hm(t) {
    var e = t.stateNode, n = t.type, a = t.memoizedProps;
    switch (e[vt] = t, e[oe] = a, n) {
      case "dialog":
        Ot("cancel", e), Ot("close", e);
        break;
      case "iframe":
      case "object":
      case "embed":
        Ot("load", e);
        break;
      case "video":
      case "audio":
        for (n = 0; n < Go.length; n++)
          Ot(Go[n], e);
        break;
      case "source":
        Ot("error", e);
        break;
      case "img":
      case "image":
      case "link":
        Ot("error", e), Ot("load", e);
        break;
      case "details":
        Ot("toggle", e);
        break;
      case "input":
        Ot("invalid", e), ii(
          e,
          a.value,
          a.defaultValue,
          a.checked,
          a.defaultChecked,
          a.type,
          a.name,
          !0
        );
        break;
      case "select":
        Ot("invalid", e);
        break;
      case "textarea":
        Ot("invalid", e), q(e, a.value, a.defaultValue, a.children);
    }
    n = a.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || e.textContent === "" + n || a.suppressHydrationWarning === !0 || $g(e.textContent, n) ? (a.popover != null && (Ot("beforetoggle", e), Ot("toggle", e)), a.onScroll != null && Ot("scroll", e), a.onScrollEnd != null && Ot("scrollend", e), a.onClick != null && (e.onclick = Zt), e = !0) : e = !1, e || Ua(t, !0);
  }
  function jm(t) {
    for (Te = t.return; Te; )
      switch (Te.tag) {
        case 5:
        case 31:
        case 13:
          gn = !1;
          return;
        case 27:
        case 3:
          gn = !0;
          return;
        default:
          Te = Te.return;
      }
  }
  function gi(t) {
    if (t !== Te) return !1;
    if (!Ct) return jm(t), Ct = !0, !1;
    var e = t.tag, n;
    if ((n = e !== 3 && e !== 27) && ((n = e === 5) && (n = t.type, n = !(n !== "form" && n !== "button") || cf(t.type, t.memoizedProps)), n = !n), n && Pt && Ua(t), jm(t), e === 13) {
      if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(u(317));
      Pt = cp(t);
    } else if (e === 31) {
      if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(u(317));
      Pt = cp(t);
    } else
      e === 27 ? (e = Pt, Pa(t.type) ? (t = mf, mf = null, Pt = t) : Pt = e) : Pt = Te ? An(t.stateNode.nextSibling) : null;
    return !0;
  }
  function Nl() {
    Pt = Te = null, Ct = !1;
  }
  function ku() {
    var t = Ra;
    return t !== null && (Ke === null ? Ke = t : Ke.push.apply(
      Ke,
      t
    ), Ra = null), t;
  }
  function bo(t) {
    Ra === null ? Ra = [t] : Ra.push(t);
  }
  var Fu = Mt(null), Cl = null, aa = null;
  function Ha(t, e, n) {
    at(Fu, e._currentValue), e._currentValue = n;
  }
  function la(t) {
    t._currentValue = Fu.current, gt(Fu);
  }
  function qu(t, e, n) {
    for (; t !== null; ) {
      var a = t.alternate;
      if ((t.childLanes & e) !== e ? (t.childLanes |= e, a !== null && (a.childLanes |= e)) : a !== null && (a.childLanes & e) !== e && (a.childLanes |= e), t === n) break;
      t = t.return;
    }
  }
  function Ku(t, e, n, a) {
    var i = t.child;
    for (i !== null && (i.return = t); i !== null; ) {
      var r = i.dependencies;
      if (r !== null) {
        var f = i.child;
        r = r.firstContext;
        t: for (; r !== null; ) {
          var m = r;
          r = i;
          for (var A = 0; A < e.length; A++)
            if (m.context === e[A]) {
              r.lanes |= n, m = r.alternate, m !== null && (m.lanes |= n), qu(
                r.return,
                n,
                t
              ), a || (f = null);
              break t;
            }
          r = m.next;
        }
      } else if (i.tag === 18) {
        if (f = i.return, f === null) throw Error(u(341));
        f.lanes |= n, r = f.alternate, r !== null && (r.lanes |= n), qu(f, n, t), f = null;
      } else f = i.child;
      if (f !== null) f.return = i;
      else
        for (f = i; f !== null; ) {
          if (f === t) {
            f = null;
            break;
          }
          if (i = f.sibling, i !== null) {
            i.return = f.return, f = i;
            break;
          }
          f = f.return;
        }
      i = f;
    }
  }
  function pi(t, e, n, a) {
    t = null;
    for (var i = e, r = !1; i !== null; ) {
      if (!r) {
        if ((i.flags & 524288) !== 0) r = !0;
        else if ((i.flags & 262144) !== 0) break;
      }
      if (i.tag === 10) {
        var f = i.alternate;
        if (f === null) throw Error(u(387));
        if (f = f.memoizedProps, f !== null) {
          var m = i.type;
          Je(i.pendingProps.value, f.value) || (t !== null ? t.push(m) : t = [m]);
        }
      } else if (i === On.current) {
        if (f = i.alternate, f === null) throw Error(u(387));
        f.memoizedState.memoizedState !== i.memoizedState.memoizedState && (t !== null ? t.push(Ko) : t = [Ko]);
      }
      i = i.return;
    }
    t !== null && Ku(
      e,
      t,
      n,
      a
    ), e.flags |= 262144;
  }
  function Yr(t) {
    for (t = t.firstContext; t !== null; ) {
      if (!Je(
        t.context._currentValue,
        t.memoizedValue
      ))
        return !0;
      t = t.next;
    }
    return !1;
  }
  function wl(t) {
    Cl = t, aa = null, t = t.dependencies, t !== null && (t.firstContext = null);
  }
  function Ee(t) {
    return Xm(Cl, t);
  }
  function Gr(t, e) {
    return Cl === null && wl(t), Xm(t, e);
  }
  function Xm(t, e) {
    var n = e._currentValue;
    if (e = { context: e, memoizedValue: n, next: null }, aa === null) {
      if (t === null) throw Error(u(308));
      aa = e, t.dependencies = { lanes: 0, firstContext: e }, t.flags |= 524288;
    } else aa = aa.next = e;
    return n;
  }
  var wy = typeof AbortController < "u" ? AbortController : function() {
    var t = [], e = this.signal = {
      aborted: !1,
      addEventListener: function(n, a) {
        t.push(a);
      }
    };
    this.abort = function() {
      e.aborted = !0, t.forEach(function(n) {
        return n();
      });
    };
  }, Dy = o.unstable_scheduleCallback, By = o.unstable_NormalPriority, se = {
    $$typeof: et,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Zu() {
    return {
      controller: new wy(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function So(t) {
    t.refCount--, t.refCount === 0 && Dy(By, function() {
      t.controller.abort();
    });
  }
  var Oo = null, Pu = 0, Ai = 0, yi = null;
  function My(t, e) {
    if (Oo === null) {
      var n = Oo = [];
      Pu = 0, Ai = _s(), yi = {
        status: "pending",
        value: void 0,
        then: function(a) {
          n.push(a);
        }
      };
    }
    return Pu++, e.then(Qm, Qm), e;
  }
  function Qm() {
    if (--Pu === 0 && Oo !== null) {
      yi !== null && (yi.status = "fulfilled");
      var t = Oo;
      Oo = null, Ai = 0, yi = null;
      for (var e = 0; e < t.length; e++) (0, t[e])();
    }
  }
  function zy(t, e) {
    var n = [], a = {
      status: "pending",
      value: null,
      reason: null,
      then: function(i) {
        n.push(i);
      }
    };
    return t.then(
      function() {
        a.status = "fulfilled", a.value = e;
        for (var i = 0; i < n.length; i++) (0, n[i])(e);
      },
      function(i) {
        for (a.status = "rejected", a.reason = i, i = 0; i < n.length; i++)
          (0, n[i])(void 0);
      }
    ), a;
  }
  var Vm = H.S;
  H.S = function(t, e) {
    Tg = ie(), typeof e == "object" && e !== null && typeof e.then == "function" && My(t, e), Vm !== null && Vm(t, e);
  };
  var Dl = Mt(null);
  function Wu() {
    var t = Dl.current;
    return t !== null ? t : It.pooledCache;
  }
  function Ir(t, e) {
    e === null ? at(Dl, Dl.current) : at(Dl, e.pool);
  }
  function Ym() {
    var t = Wu();
    return t === null ? null : { parent: se._currentValue, pool: t };
  }
  var vi = Error(u(460)), Ju = Error(u(474)), kr = Error(u(542)), Fr = { then: function() {
  } };
  function Gm(t) {
    return t = t.status, t === "fulfilled" || t === "rejected";
  }
  function Im(t, e, n) {
    switch (n = t[n], n === void 0 ? t.push(e) : n !== e && (e.then(Zt, Zt), e = n), e.status) {
      case "fulfilled":
        return e.value;
      case "rejected":
        throw t = e.reason, Fm(t), t;
      default:
        if (typeof e.status == "string") e.then(Zt, Zt);
        else {
          if (t = It, t !== null && 100 < t.shellSuspendCounter)
            throw Error(u(482));
          t = e, t.status = "pending", t.then(
            function(a) {
              if (e.status === "pending") {
                var i = e;
                i.status = "fulfilled", i.value = a;
              }
            },
            function(a) {
              if (e.status === "pending") {
                var i = e;
                i.status = "rejected", i.reason = a;
              }
            }
          );
        }
        switch (e.status) {
          case "fulfilled":
            return e.value;
          case "rejected":
            throw t = e.reason, Fm(t), t;
        }
        throw Ml = e, vi;
    }
  }
  function Bl(t) {
    try {
      var e = t._init;
      return e(t._payload);
    } catch (n) {
      throw n !== null && typeof n == "object" && typeof n.then == "function" ? (Ml = n, vi) : n;
    }
  }
  var Ml = null;
  function km() {
    if (Ml === null) throw Error(u(459));
    var t = Ml;
    return Ml = null, t;
  }
  function Fm(t) {
    if (t === vi || t === kr)
      throw Error(u(483));
  }
  var bi = null, To = 0;
  function qr(t) {
    var e = To;
    return To += 1, bi === null && (bi = []), Im(bi, t, e);
  }
  function Eo(t, e) {
    e = e.props.ref, t.ref = e !== void 0 ? e : null;
  }
  function Kr(t, e) {
    throw e.$$typeof === J ? Error(u(525)) : (t = Object.prototype.toString.call(e), Error(
      u(
        31,
        t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t
      )
    ));
  }
  function qm(t) {
    function e(S, v) {
      if (t) {
        var E = S.deletions;
        E === null ? (S.deletions = [v], S.flags |= 16) : E.push(v);
      }
    }
    function n(S, v) {
      if (!t) return null;
      for (; v !== null; )
        e(S, v), v = v.sibling;
      return null;
    }
    function a(S) {
      for (var v = /* @__PURE__ */ new Map(); S !== null; )
        S.key !== null ? v.set(S.key, S) : v.set(S.index, S), S = S.sibling;
      return v;
    }
    function i(S, v) {
      return S = ea(S, v), S.index = 0, S.sibling = null, S;
    }
    function r(S, v, E) {
      return S.index = E, t ? (E = S.alternate, E !== null ? (E = E.index, E < v ? (S.flags |= 67108866, v) : E) : (S.flags |= 67108866, v)) : (S.flags |= 1048576, v);
    }
    function f(S) {
      return t && S.alternate === null && (S.flags |= 67108866), S;
    }
    function m(S, v, E, R) {
      return v === null || v.tag !== 6 ? (v = Qu(E, S.mode, R), v.return = S, v) : (v = i(v, E), v.return = S, v);
    }
    function A(S, v, E, R) {
      var it = E.type;
      return it === k ? L(
        S,
        v,
        E.props.children,
        R,
        E.key
      ) : v !== null && (v.elementType === it || typeof it == "object" && it !== null && it.$$typeof === Dt && Bl(it) === v.type) ? (v = i(v, E.props), Eo(v, E), v.return = S, v) : (v = Qr(
        E.type,
        E.key,
        E.props,
        null,
        S.mode,
        R
      ), Eo(v, E), v.return = S, v);
    }
    function N(S, v, E, R) {
      return v === null || v.tag !== 4 || v.stateNode.containerInfo !== E.containerInfo || v.stateNode.implementation !== E.implementation ? (v = Vu(E, S.mode, R), v.return = S, v) : (v = i(v, E.children || []), v.return = S, v);
    }
    function L(S, v, E, R, it) {
      return v === null || v.tag !== 7 ? (v = xl(
        E,
        S.mode,
        R,
        it
      ), v.return = S, v) : (v = i(v, E), v.return = S, v);
    }
    function U(S, v, E) {
      if (typeof v == "string" && v !== "" || typeof v == "number" || typeof v == "bigint")
        return v = Qu(
          "" + v,
          S.mode,
          E
        ), v.return = S, v;
      if (typeof v == "object" && v !== null) {
        switch (v.$$typeof) {
          case j:
            return E = Qr(
              v.type,
              v.key,
              v.props,
              null,
              S.mode,
              E
            ), Eo(E, v), E.return = S, E;
          case I:
            return v = Vu(
              v,
              S.mode,
              E
            ), v.return = S, v;
          case Dt:
            return v = Bl(v), U(S, v, E);
        }
        if (V(v) || Tt(v))
          return v = xl(
            v,
            S.mode,
            E,
            null
          ), v.return = S, v;
        if (typeof v.then == "function")
          return U(S, qr(v), E);
        if (v.$$typeof === et)
          return U(
            S,
            Gr(S, v),
            E
          );
        Kr(S, v);
      }
      return null;
    }
    function B(S, v, E, R) {
      var it = v !== null ? v.key : null;
      if (typeof E == "string" && E !== "" || typeof E == "number" || typeof E == "bigint")
        return it !== null ? null : m(S, v, "" + E, R);
      if (typeof E == "object" && E !== null) {
        switch (E.$$typeof) {
          case j:
            return E.key === it ? A(S, v, E, R) : null;
          case I:
            return E.key === it ? N(S, v, E, R) : null;
          case Dt:
            return E = Bl(E), B(S, v, E, R);
        }
        if (V(E) || Tt(E))
          return it !== null ? null : L(S, v, E, R, null);
        if (typeof E.then == "function")
          return B(
            S,
            v,
            qr(E),
            R
          );
        if (E.$$typeof === et)
          return B(
            S,
            v,
            Gr(S, E),
            R
          );
        Kr(S, E);
      }
      return null;
    }
    function z(S, v, E, R, it) {
      if (typeof R == "string" && R !== "" || typeof R == "number" || typeof R == "bigint")
        return S = S.get(E) || null, m(v, S, "" + R, it);
      if (typeof R == "object" && R !== null) {
        switch (R.$$typeof) {
          case j:
            return S = S.get(
              R.key === null ? E : R.key
            ) || null, A(v, S, R, it);
          case I:
            return S = S.get(
              R.key === null ? E : R.key
            ) || null, N(v, S, R, it);
          case Dt:
            return R = Bl(R), z(
              S,
              v,
              E,
              R,
              it
            );
        }
        if (V(R) || Tt(R))
          return S = S.get(E) || null, L(v, S, R, it, null);
        if (typeof R.then == "function")
          return z(
            S,
            v,
            E,
            qr(R),
            it
          );
        if (R.$$typeof === et)
          return z(
            S,
            v,
            E,
            Gr(v, R),
            it
          );
        Kr(v, R);
      }
      return null;
    }
    function _(S, v, E, R) {
      for (var it = null, zt = null, $ = v, At = v = 0, Nt = null; $ !== null && At < E.length; At++) {
        $.index > At ? (Nt = $, $ = null) : Nt = $.sibling;
        var Lt = B(
          S,
          $,
          E[At],
          R
        );
        if (Lt === null) {
          $ === null && ($ = Nt);
          break;
        }
        t && $ && Lt.alternate === null && e(S, $), v = r(Lt, v, At), zt === null ? it = Lt : zt.sibling = Lt, zt = Lt, $ = Nt;
      }
      if (At === E.length)
        return n(S, $), Ct && na(S, At), it;
      if ($ === null) {
        for (; At < E.length; At++)
          $ = U(S, E[At], R), $ !== null && (v = r(
            $,
            v,
            At
          ), zt === null ? it = $ : zt.sibling = $, zt = $);
        return Ct && na(S, At), it;
      }
      for ($ = a($); At < E.length; At++)
        Nt = z(
          $,
          S,
          At,
          E[At],
          R
        ), Nt !== null && (t && Nt.alternate !== null && $.delete(
          Nt.key === null ? At : Nt.key
        ), v = r(
          Nt,
          v,
          At
        ), zt === null ? it = Nt : zt.sibling = Nt, zt = Nt);
      return t && $.forEach(function(tl) {
        return e(S, tl);
      }), Ct && na(S, At), it;
    }
    function rt(S, v, E, R) {
      if (E == null) throw Error(u(151));
      for (var it = null, zt = null, $ = v, At = v = 0, Nt = null, Lt = E.next(); $ !== null && !Lt.done; At++, Lt = E.next()) {
        $.index > At ? (Nt = $, $ = null) : Nt = $.sibling;
        var tl = B(S, $, Lt.value, R);
        if (tl === null) {
          $ === null && ($ = Nt);
          break;
        }
        t && $ && tl.alternate === null && e(S, $), v = r(tl, v, At), zt === null ? it = tl : zt.sibling = tl, zt = tl, $ = Nt;
      }
      if (Lt.done)
        return n(S, $), Ct && na(S, At), it;
      if ($ === null) {
        for (; !Lt.done; At++, Lt = E.next())
          Lt = U(S, Lt.value, R), Lt !== null && (v = r(Lt, v, At), zt === null ? it = Lt : zt.sibling = Lt, zt = Lt);
        return Ct && na(S, At), it;
      }
      for ($ = a($); !Lt.done; At++, Lt = E.next())
        Lt = z($, S, At, Lt.value, R), Lt !== null && (t && Lt.alternate !== null && $.delete(Lt.key === null ? At : Lt.key), v = r(Lt, v, At), zt === null ? it = Lt : zt.sibling = Lt, zt = Lt);
      return t && $.forEach(function(Iv) {
        return e(S, Iv);
      }), Ct && na(S, At), it;
    }
    function Gt(S, v, E, R) {
      if (typeof E == "object" && E !== null && E.type === k && E.key === null && (E = E.props.children), typeof E == "object" && E !== null) {
        switch (E.$$typeof) {
          case j:
            t: {
              for (var it = E.key; v !== null; ) {
                if (v.key === it) {
                  if (it = E.type, it === k) {
                    if (v.tag === 7) {
                      n(
                        S,
                        v.sibling
                      ), R = i(
                        v,
                        E.props.children
                      ), R.return = S, S = R;
                      break t;
                    }
                  } else if (v.elementType === it || typeof it == "object" && it !== null && it.$$typeof === Dt && Bl(it) === v.type) {
                    n(
                      S,
                      v.sibling
                    ), R = i(v, E.props), Eo(R, E), R.return = S, S = R;
                    break t;
                  }
                  n(S, v);
                  break;
                } else e(S, v);
                v = v.sibling;
              }
              E.type === k ? (R = xl(
                E.props.children,
                S.mode,
                R,
                E.key
              ), R.return = S, S = R) : (R = Qr(
                E.type,
                E.key,
                E.props,
                null,
                S.mode,
                R
              ), Eo(R, E), R.return = S, S = R);
            }
            return f(S);
          case I:
            t: {
              for (it = E.key; v !== null; ) {
                if (v.key === it)
                  if (v.tag === 4 && v.stateNode.containerInfo === E.containerInfo && v.stateNode.implementation === E.implementation) {
                    n(
                      S,
                      v.sibling
                    ), R = i(v, E.children || []), R.return = S, S = R;
                    break t;
                  } else {
                    n(S, v);
                    break;
                  }
                else e(S, v);
                v = v.sibling;
              }
              R = Vu(E, S.mode, R), R.return = S, S = R;
            }
            return f(S);
          case Dt:
            return E = Bl(E), Gt(
              S,
              v,
              E,
              R
            );
        }
        if (V(E))
          return _(
            S,
            v,
            E,
            R
          );
        if (Tt(E)) {
          if (it = Tt(E), typeof it != "function") throw Error(u(150));
          return E = it.call(E), rt(
            S,
            v,
            E,
            R
          );
        }
        if (typeof E.then == "function")
          return Gt(
            S,
            v,
            qr(E),
            R
          );
        if (E.$$typeof === et)
          return Gt(
            S,
            v,
            Gr(S, E),
            R
          );
        Kr(S, E);
      }
      return typeof E == "string" && E !== "" || typeof E == "number" || typeof E == "bigint" ? (E = "" + E, v !== null && v.tag === 6 ? (n(S, v.sibling), R = i(v, E), R.return = S, S = R) : (n(S, v), R = Qu(E, S.mode, R), R.return = S, S = R), f(S)) : n(S, v);
    }
    return function(S, v, E, R) {
      try {
        To = 0;
        var it = Gt(
          S,
          v,
          E,
          R
        );
        return bi = null, it;
      } catch ($) {
        if ($ === vi || $ === kr) throw $;
        var zt = _e(29, $, null, S.mode);
        return zt.lanes = R, zt.return = S, zt;
      } finally {
      }
    };
  }
  var zl = qm(!0), Km = qm(!1), ja = !1;
  function _u(t) {
    t.updateQueue = {
      baseState: t.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function $u(t, e) {
    t = t.updateQueue, e.updateQueue === t && (e.updateQueue = {
      baseState: t.baseState,
      firstBaseUpdate: t.firstBaseUpdate,
      lastBaseUpdate: t.lastBaseUpdate,
      shared: t.shared,
      callbacks: null
    });
  }
  function Xa(t) {
    return { lane: t, tag: 0, payload: null, callback: null, next: null };
  }
  function Qa(t, e, n) {
    var a = t.updateQueue;
    if (a === null) return null;
    if (a = a.shared, (Rt & 2) !== 0) {
      var i = a.pending;
      return i === null ? e.next = e : (e.next = i.next, i.next = e), a.pending = e, e = Xr(t), Bm(t, null, n), e;
    }
    return jr(t, a, e, n), Xr(t);
  }
  function xo(t, e, n) {
    if (e = e.updateQueue, e !== null && (e = e.shared, (n & 4194048) !== 0)) {
      var a = e.lanes;
      a &= t.pendingLanes, n |= a, e.lanes = n, ti(t, n);
    }
  }
  function ts(t, e) {
    var n = t.updateQueue, a = t.alternate;
    if (a !== null && (a = a.updateQueue, n === a)) {
      var i = null, r = null;
      if (n = n.firstBaseUpdate, n !== null) {
        do {
          var f = {
            lane: n.lane,
            tag: n.tag,
            payload: n.payload,
            callback: null,
            next: null
          };
          r === null ? i = r = f : r = r.next = f, n = n.next;
        } while (n !== null);
        r === null ? i = r = e : r = r.next = e;
      } else i = r = e;
      n = {
        baseState: a.baseState,
        firstBaseUpdate: i,
        lastBaseUpdate: r,
        shared: a.shared,
        callbacks: a.callbacks
      }, t.updateQueue = n;
      return;
    }
    t = n.lastBaseUpdate, t === null ? n.firstBaseUpdate = e : t.next = e, n.lastBaseUpdate = e;
  }
  var es = !1;
  function No() {
    if (es) {
      var t = yi;
      if (t !== null) throw t;
    }
  }
  function Co(t, e, n, a) {
    es = !1;
    var i = t.updateQueue;
    ja = !1;
    var r = i.firstBaseUpdate, f = i.lastBaseUpdate, m = i.shared.pending;
    if (m !== null) {
      i.shared.pending = null;
      var A = m, N = A.next;
      A.next = null, f === null ? r = N : f.next = N, f = A;
      var L = t.alternate;
      L !== null && (L = L.updateQueue, m = L.lastBaseUpdate, m !== f && (m === null ? L.firstBaseUpdate = N : m.next = N, L.lastBaseUpdate = A));
    }
    if (r !== null) {
      var U = i.baseState;
      f = 0, L = N = A = null, m = r;
      do {
        var B = m.lane & -536870913, z = B !== m.lane;
        if (z ? (xt & B) === B : (a & B) === B) {
          B !== 0 && B === Ai && (es = !0), L !== null && (L = L.next = {
            lane: 0,
            tag: m.tag,
            payload: m.payload,
            callback: null,
            next: null
          });
          t: {
            var _ = t, rt = m;
            B = e;
            var Gt = n;
            switch (rt.tag) {
              case 1:
                if (_ = rt.payload, typeof _ == "function") {
                  U = _.call(Gt, U, B);
                  break t;
                }
                U = _;
                break t;
              case 3:
                _.flags = _.flags & -65537 | 128;
              case 0:
                if (_ = rt.payload, B = typeof _ == "function" ? _.call(Gt, U, B) : _, B == null) break t;
                U = x({}, U, B);
                break t;
              case 2:
                ja = !0;
            }
          }
          B = m.callback, B !== null && (t.flags |= 64, z && (t.flags |= 8192), z = i.callbacks, z === null ? i.callbacks = [B] : z.push(B));
        } else
          z = {
            lane: B,
            tag: m.tag,
            payload: m.payload,
            callback: m.callback,
            next: null
          }, L === null ? (N = L = z, A = U) : L = L.next = z, f |= B;
        if (m = m.next, m === null) {
          if (m = i.shared.pending, m === null)
            break;
          z = m, m = z.next, z.next = null, i.lastBaseUpdate = z, i.shared.pending = null;
        }
      } while (!0);
      L === null && (A = U), i.baseState = A, i.firstBaseUpdate = N, i.lastBaseUpdate = L, r === null && (i.shared.lanes = 0), ka |= f, t.lanes = f, t.memoizedState = U;
    }
  }
  function Zm(t, e) {
    if (typeof t != "function")
      throw Error(u(191, t));
    t.call(e);
  }
  function Pm(t, e) {
    var n = t.callbacks;
    if (n !== null)
      for (t.callbacks = null, t = 0; t < n.length; t++)
        Zm(n[t], e);
  }
  var Si = Mt(null), Zr = Mt(0);
  function Wm(t, e) {
    t = ma, at(Zr, t), at(Si, e), ma = t | e.baseLanes;
  }
  function ns() {
    at(Zr, ma), at(Si, Si.current);
  }
  function as() {
    ma = Zr.current, gt(Si), gt(Zr);
  }
  var $e = Mt(null), pn = null;
  function Va(t) {
    var e = t.alternate;
    at(ce, ce.current & 1), at($e, t), pn === null && (e === null || Si.current !== null || e.memoizedState !== null) && (pn = t);
  }
  function ls(t) {
    at(ce, ce.current), at($e, t), pn === null && (pn = t);
  }
  function Jm(t) {
    t.tag === 22 ? (at(ce, ce.current), at($e, t), pn === null && (pn = t)) : Ya();
  }
  function Ya() {
    at(ce, ce.current), at($e, $e.current);
  }
  function tn(t) {
    gt($e), pn === t && (pn = null), gt(ce);
  }
  var ce = Mt(0);
  function Pr(t) {
    for (var e = t; e !== null; ) {
      if (e.tag === 13) {
        var n = e.memoizedState;
        if (n !== null && (n = n.dehydrated, n === null || ff(n) || df(n)))
          return e;
      } else if (e.tag === 19 && (e.memoizedProps.revealOrder === "forwards" || e.memoizedProps.revealOrder === "backwards" || e.memoizedProps.revealOrder === "unstable_legacy-backwards" || e.memoizedProps.revealOrder === "together")) {
        if ((e.flags & 128) !== 0) return e;
      } else if (e.child !== null) {
        e.child.return = e, e = e.child;
        continue;
      }
      if (e === t) break;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) return null;
        e = e.return;
      }
      e.sibling.return = e.return, e = e.sibling;
    }
    return null;
  }
  var ia = 0, mt = null, Vt = null, fe = null, Wr = !1, Oi = !1, Ll = !1, Jr = 0, wo = 0, Ti = null, Ly = 0;
  function ae() {
    throw Error(u(321));
  }
  function is(t, e) {
    if (e === null) return !1;
    for (var n = 0; n < e.length && n < t.length; n++)
      if (!Je(t[n], e[n])) return !1;
    return !0;
  }
  function os(t, e, n, a, i, r) {
    return ia = r, mt = e, e.memoizedState = null, e.updateQueue = null, e.lanes = 0, H.H = t === null || t.memoizedState === null ? Rh : Ss, Ll = !1, r = n(a, i), Ll = !1, Oi && (r = $m(
      e,
      n,
      a,
      i
    )), _m(t), r;
  }
  function _m(t) {
    H.H = Mo;
    var e = Vt !== null && Vt.next !== null;
    if (ia = 0, fe = Vt = mt = null, Wr = !1, wo = 0, Ti = null, e) throw Error(u(300));
    t === null || de || (t = t.dependencies, t !== null && Yr(t) && (de = !0));
  }
  function $m(t, e, n, a) {
    mt = t;
    var i = 0;
    do {
      if (Oi && (Ti = null), wo = 0, Oi = !1, 25 <= i) throw Error(u(301));
      if (i += 1, fe = Vt = null, t.updateQueue != null) {
        var r = t.updateQueue;
        r.lastEffect = null, r.events = null, r.stores = null, r.memoCache != null && (r.memoCache.index = 0);
      }
      H.H = Uh, r = e(n, a);
    } while (Oi);
    return r;
  }
  function Ry() {
    var t = H.H, e = t.useState()[0];
    return e = typeof e.then == "function" ? Do(e) : e, t = t.useState()[0], (Vt !== null ? Vt.memoizedState : null) !== t && (mt.flags |= 1024), e;
  }
  function rs() {
    var t = Jr !== 0;
    return Jr = 0, t;
  }
  function cs(t, e, n) {
    e.updateQueue = t.updateQueue, e.flags &= -2053, t.lanes &= ~n;
  }
  function us(t) {
    if (Wr) {
      for (t = t.memoizedState; t !== null; ) {
        var e = t.queue;
        e !== null && (e.pending = null), t = t.next;
      }
      Wr = !1;
    }
    ia = 0, fe = Vt = mt = null, Oi = !1, wo = Jr = 0, Ti = null;
  }
  function Ue() {
    var t = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return fe === null ? mt.memoizedState = fe = t : fe = fe.next = t, fe;
  }
  function ue() {
    if (Vt === null) {
      var t = mt.alternate;
      t = t !== null ? t.memoizedState : null;
    } else t = Vt.next;
    var e = fe === null ? mt.memoizedState : fe.next;
    if (e !== null)
      fe = e, Vt = t;
    else {
      if (t === null)
        throw mt.alternate === null ? Error(u(467)) : Error(u(310));
      Vt = t, t = {
        memoizedState: Vt.memoizedState,
        baseState: Vt.baseState,
        baseQueue: Vt.baseQueue,
        queue: Vt.queue,
        next: null
      }, fe === null ? mt.memoizedState = fe = t : fe = fe.next = t;
    }
    return fe;
  }
  function _r() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function Do(t) {
    var e = wo;
    return wo += 1, Ti === null && (Ti = []), t = Im(Ti, t, e), e = mt, (fe === null ? e.memoizedState : fe.next) === null && (e = e.alternate, H.H = e === null || e.memoizedState === null ? Rh : Ss), t;
  }
  function $r(t) {
    if (t !== null && typeof t == "object") {
      if (typeof t.then == "function") return Do(t);
      if (t.$$typeof === et) return Ee(t);
    }
    throw Error(u(438, String(t)));
  }
  function ss(t) {
    var e = null, n = mt.updateQueue;
    if (n !== null && (e = n.memoCache), e == null) {
      var a = mt.alternate;
      a !== null && (a = a.updateQueue, a !== null && (a = a.memoCache, a != null && (e = {
        data: a.data.map(function(i) {
          return i.slice();
        }),
        index: 0
      })));
    }
    if (e == null && (e = { data: [], index: 0 }), n === null && (n = _r(), mt.updateQueue = n), n.memoCache = e, n = e.data[e.index], n === void 0)
      for (n = e.data[e.index] = Array(t), a = 0; a < t; a++)
        n[a] = dt;
    return e.index++, n;
  }
  function oa(t, e) {
    return typeof e == "function" ? e(t) : e;
  }
  function tc(t) {
    var e = ue();
    return fs(e, Vt, t);
  }
  function fs(t, e, n) {
    var a = t.queue;
    if (a === null) throw Error(u(311));
    a.lastRenderedReducer = n;
    var i = t.baseQueue, r = a.pending;
    if (r !== null) {
      if (i !== null) {
        var f = i.next;
        i.next = r.next, r.next = f;
      }
      e.baseQueue = i = r, a.pending = null;
    }
    if (r = t.baseState, i === null) t.memoizedState = r;
    else {
      e = i.next;
      var m = f = null, A = null, N = e, L = !1;
      do {
        var U = N.lane & -536870913;
        if (U !== N.lane ? (xt & U) === U : (ia & U) === U) {
          var B = N.revertLane;
          if (B === 0)
            A !== null && (A = A.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: N.action,
              hasEagerState: N.hasEagerState,
              eagerState: N.eagerState,
              next: null
            }), U === Ai && (L = !0);
          else if ((ia & B) === B) {
            N = N.next, B === Ai && (L = !0);
            continue;
          } else
            U = {
              lane: 0,
              revertLane: N.revertLane,
              gesture: null,
              action: N.action,
              hasEagerState: N.hasEagerState,
              eagerState: N.eagerState,
              next: null
            }, A === null ? (m = A = U, f = r) : A = A.next = U, mt.lanes |= B, ka |= B;
          U = N.action, Ll && n(r, U), r = N.hasEagerState ? N.eagerState : n(r, U);
        } else
          B = {
            lane: U,
            revertLane: N.revertLane,
            gesture: N.gesture,
            action: N.action,
            hasEagerState: N.hasEagerState,
            eagerState: N.eagerState,
            next: null
          }, A === null ? (m = A = B, f = r) : A = A.next = B, mt.lanes |= U, ka |= U;
        N = N.next;
      } while (N !== null && N !== e);
      if (A === null ? f = r : A.next = m, !Je(r, t.memoizedState) && (de = !0, L && (n = yi, n !== null)))
        throw n;
      t.memoizedState = r, t.baseState = f, t.baseQueue = A, a.lastRenderedState = r;
    }
    return i === null && (a.lanes = 0), [t.memoizedState, a.dispatch];
  }
  function ds(t) {
    var e = ue(), n = e.queue;
    if (n === null) throw Error(u(311));
    n.lastRenderedReducer = t;
    var a = n.dispatch, i = n.pending, r = e.memoizedState;
    if (i !== null) {
      n.pending = null;
      var f = i = i.next;
      do
        r = t(r, f.action), f = f.next;
      while (f !== i);
      Je(r, e.memoizedState) || (de = !0), e.memoizedState = r, e.baseQueue === null && (e.baseState = r), n.lastRenderedState = r;
    }
    return [r, a];
  }
  function th(t, e, n) {
    var a = mt, i = ue(), r = Ct;
    if (r) {
      if (n === void 0) throw Error(u(407));
      n = n();
    } else n = e();
    var f = !Je(
      (Vt || i).memoizedState,
      n
    );
    if (f && (i.memoizedState = n, de = !0), i = i.queue, gs(ah.bind(null, a, i, t), [
      t
    ]), i.getSnapshot !== e || f || fe !== null && fe.memoizedState.tag & 1) {
      if (a.flags |= 2048, Ei(
        9,
        { destroy: void 0 },
        nh.bind(
          null,
          a,
          i,
          n,
          e
        ),
        null
      ), It === null) throw Error(u(349));
      r || (ia & 127) !== 0 || eh(a, e, n);
    }
    return n;
  }
  function eh(t, e, n) {
    t.flags |= 16384, t = { getSnapshot: e, value: n }, e = mt.updateQueue, e === null ? (e = _r(), mt.updateQueue = e, e.stores = [t]) : (n = e.stores, n === null ? e.stores = [t] : n.push(t));
  }
  function nh(t, e, n, a) {
    e.value = n, e.getSnapshot = a, lh(e) && ih(t);
  }
  function ah(t, e, n) {
    return n(function() {
      lh(e) && ih(t);
    });
  }
  function lh(t) {
    var e = t.getSnapshot;
    t = t.value;
    try {
      var n = e();
      return !Je(t, n);
    } catch {
      return !0;
    }
  }
  function ih(t) {
    var e = El(t, 2);
    e !== null && Ze(e, t, 2);
  }
  function ms(t) {
    var e = Ue();
    if (typeof t == "function") {
      var n = t;
      if (t = n(), Ll) {
        cn(!0);
        try {
          n();
        } finally {
          cn(!1);
        }
      }
    }
    return e.memoizedState = e.baseState = t, e.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: oa,
      lastRenderedState: t
    }, e;
  }
  function oh(t, e, n, a) {
    return t.baseState = n, fs(
      t,
      Vt,
      typeof a == "function" ? a : oa
    );
  }
  function Uy(t, e, n, a, i) {
    if (ac(t)) throw Error(u(485));
    if (t = e.action, t !== null) {
      var r = {
        payload: i,
        action: t,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(f) {
          r.listeners.push(f);
        }
      };
      H.T !== null ? n(!0) : r.isTransition = !1, a(r), n = e.pending, n === null ? (r.next = e.pending = r, rh(e, r)) : (r.next = n.next, e.pending = n.next = r);
    }
  }
  function rh(t, e) {
    var n = e.action, a = e.payload, i = t.state;
    if (e.isTransition) {
      var r = H.T, f = {};
      H.T = f;
      try {
        var m = n(i, a), A = H.S;
        A !== null && A(f, m), ch(t, e, m);
      } catch (N) {
        hs(t, e, N);
      } finally {
        r !== null && f.types !== null && (r.types = f.types), H.T = r;
      }
    } else
      try {
        r = n(i, a), ch(t, e, r);
      } catch (N) {
        hs(t, e, N);
      }
  }
  function ch(t, e, n) {
    n !== null && typeof n == "object" && typeof n.then == "function" ? n.then(
      function(a) {
        uh(t, e, a);
      },
      function(a) {
        return hs(t, e, a);
      }
    ) : uh(t, e, n);
  }
  function uh(t, e, n) {
    e.status = "fulfilled", e.value = n, sh(e), t.state = n, e = t.pending, e !== null && (n = e.next, n === e ? t.pending = null : (n = n.next, e.next = n, rh(t, n)));
  }
  function hs(t, e, n) {
    var a = t.pending;
    if (t.pending = null, a !== null) {
      a = a.next;
      do
        e.status = "rejected", e.reason = n, sh(e), e = e.next;
      while (e !== a);
    }
    t.action = null;
  }
  function sh(t) {
    t = t.listeners;
    for (var e = 0; e < t.length; e++) (0, t[e])();
  }
  function fh(t, e) {
    return e;
  }
  function dh(t, e) {
    if (Ct) {
      var n = It.formState;
      if (n !== null) {
        t: {
          var a = mt;
          if (Ct) {
            if (Pt) {
              e: {
                for (var i = Pt, r = gn; i.nodeType !== 8; ) {
                  if (!r) {
                    i = null;
                    break e;
                  }
                  if (i = An(
                    i.nextSibling
                  ), i === null) {
                    i = null;
                    break e;
                  }
                }
                r = i.data, i = r === "F!" || r === "F" ? i : null;
              }
              if (i) {
                Pt = An(
                  i.nextSibling
                ), a = i.data === "F!";
                break t;
              }
            }
            Ua(a);
          }
          a = !1;
        }
        a && (e = n[0]);
      }
    }
    return n = Ue(), n.memoizedState = n.baseState = e, a = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: fh,
      lastRenderedState: e
    }, n.queue = a, n = Mh.bind(
      null,
      mt,
      a
    ), a.dispatch = n, a = ms(!1), r = bs.bind(
      null,
      mt,
      !1,
      a.queue
    ), a = Ue(), i = {
      state: e,
      dispatch: null,
      action: t,
      pending: null
    }, a.queue = i, n = Uy.bind(
      null,
      mt,
      i,
      r,
      n
    ), i.dispatch = n, a.memoizedState = t, [e, n, !1];
  }
  function mh(t) {
    var e = ue();
    return hh(e, Vt, t);
  }
  function hh(t, e, n) {
    if (e = fs(
      t,
      e,
      fh
    )[0], t = tc(oa)[0], typeof e == "object" && e !== null && typeof e.then == "function")
      try {
        var a = Do(e);
      } catch (f) {
        throw f === vi ? kr : f;
      }
    else a = e;
    e = ue();
    var i = e.queue, r = i.dispatch;
    return n !== e.memoizedState && (mt.flags |= 2048, Ei(
      9,
      { destroy: void 0 },
      Hy.bind(null, i, n),
      null
    )), [a, r, t];
  }
  function Hy(t, e) {
    t.action = e;
  }
  function gh(t) {
    var e = ue(), n = Vt;
    if (n !== null)
      return hh(e, n, t);
    ue(), e = e.memoizedState, n = ue();
    var a = n.queue.dispatch;
    return n.memoizedState = t, [e, a, !1];
  }
  function Ei(t, e, n, a) {
    return t = { tag: t, create: n, deps: a, inst: e, next: null }, e = mt.updateQueue, e === null && (e = _r(), mt.updateQueue = e), n = e.lastEffect, n === null ? e.lastEffect = t.next = t : (a = n.next, n.next = t, t.next = a, e.lastEffect = t), t;
  }
  function ph() {
    return ue().memoizedState;
  }
  function ec(t, e, n, a) {
    var i = Ue();
    mt.flags |= t, i.memoizedState = Ei(
      1 | e,
      { destroy: void 0 },
      n,
      a === void 0 ? null : a
    );
  }
  function nc(t, e, n, a) {
    var i = ue();
    a = a === void 0 ? null : a;
    var r = i.memoizedState.inst;
    Vt !== null && a !== null && is(a, Vt.memoizedState.deps) ? i.memoizedState = Ei(e, r, n, a) : (mt.flags |= t, i.memoizedState = Ei(
      1 | e,
      r,
      n,
      a
    ));
  }
  function Ah(t, e) {
    ec(8390656, 8, t, e);
  }
  function gs(t, e) {
    nc(2048, 8, t, e);
  }
  function jy(t) {
    mt.flags |= 4;
    var e = mt.updateQueue;
    if (e === null)
      e = _r(), mt.updateQueue = e, e.events = [t];
    else {
      var n = e.events;
      n === null ? e.events = [t] : n.push(t);
    }
  }
  function yh(t) {
    var e = ue().memoizedState;
    return jy({ ref: e, nextImpl: t }), function() {
      if ((Rt & 2) !== 0) throw Error(u(440));
      return e.impl.apply(void 0, arguments);
    };
  }
  function vh(t, e) {
    return nc(4, 2, t, e);
  }
  function bh(t, e) {
    return nc(4, 4, t, e);
  }
  function Sh(t, e) {
    if (typeof e == "function") {
      t = t();
      var n = e(t);
      return function() {
        typeof n == "function" ? n() : e(null);
      };
    }
    if (e != null)
      return t = t(), e.current = t, function() {
        e.current = null;
      };
  }
  function Oh(t, e, n) {
    n = n != null ? n.concat([t]) : null, nc(4, 4, Sh.bind(null, e, t), n);
  }
  function ps() {
  }
  function Th(t, e) {
    var n = ue();
    e = e === void 0 ? null : e;
    var a = n.memoizedState;
    return e !== null && is(e, a[1]) ? a[0] : (n.memoizedState = [t, e], t);
  }
  function Eh(t, e) {
    var n = ue();
    e = e === void 0 ? null : e;
    var a = n.memoizedState;
    if (e !== null && is(e, a[1]))
      return a[0];
    if (a = t(), Ll) {
      cn(!0);
      try {
        t();
      } finally {
        cn(!1);
      }
    }
    return n.memoizedState = [a, e], a;
  }
  function As(t, e, n) {
    return n === void 0 || (ia & 1073741824) !== 0 && (xt & 261930) === 0 ? t.memoizedState = e : (t.memoizedState = n, t = xg(), mt.lanes |= t, ka |= t, n);
  }
  function xh(t, e, n, a) {
    return Je(n, e) ? n : Si.current !== null ? (t = As(t, n, a), Je(t, e) || (de = !0), t) : (ia & 42) === 0 || (ia & 1073741824) !== 0 && (xt & 261930) === 0 ? (de = !0, t.memoizedState = n) : (t = xg(), mt.lanes |= t, ka |= t, e);
  }
  function Nh(t, e, n, a, i) {
    var r = Z.p;
    Z.p = r !== 0 && 8 > r ? r : 8;
    var f = H.T, m = {};
    H.T = m, bs(t, !1, e, n);
    try {
      var A = i(), N = H.S;
      if (N !== null && N(m, A), A !== null && typeof A == "object" && typeof A.then == "function") {
        var L = zy(
          A,
          a
        );
        Bo(
          t,
          e,
          L,
          an(t)
        );
      } else
        Bo(
          t,
          e,
          a,
          an(t)
        );
    } catch (U) {
      Bo(
        t,
        e,
        { then: function() {
        }, status: "rejected", reason: U },
        an()
      );
    } finally {
      Z.p = r, f !== null && m.types !== null && (f.types = m.types), H.T = f;
    }
  }
  function Xy() {
  }
  function ys(t, e, n, a) {
    if (t.tag !== 5) throw Error(u(476));
    var i = Ch(t).queue;
    Nh(
      t,
      i,
      e,
      st,
      n === null ? Xy : function() {
        return wh(t), n(a);
      }
    );
  }
  function Ch(t) {
    var e = t.memoizedState;
    if (e !== null) return e;
    e = {
      memoizedState: st,
      baseState: st,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: oa,
        lastRenderedState: st
      },
      next: null
    };
    var n = {};
    return e.next = {
      memoizedState: n,
      baseState: n,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: oa,
        lastRenderedState: n
      },
      next: null
    }, t.memoizedState = e, t = t.alternate, t !== null && (t.memoizedState = e), e;
  }
  function wh(t) {
    var e = Ch(t);
    e.next === null && (e = t.alternate.memoizedState), Bo(
      t,
      e.next.queue,
      {},
      an()
    );
  }
  function vs() {
    return Ee(Ko);
  }
  function Dh() {
    return ue().memoizedState;
  }
  function Bh() {
    return ue().memoizedState;
  }
  function Qy(t) {
    for (var e = t.return; e !== null; ) {
      switch (e.tag) {
        case 24:
        case 3:
          var n = an();
          t = Xa(n);
          var a = Qa(e, t, n);
          a !== null && (Ze(a, e, n), xo(a, e, n)), e = { cache: Zu() }, t.payload = e;
          return;
      }
      e = e.return;
    }
  }
  function Vy(t, e, n) {
    var a = an();
    n = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, ac(t) ? zh(e, n) : (n = ju(t, e, n, a), n !== null && (Ze(n, t, a), Lh(n, e, a)));
  }
  function Mh(t, e, n) {
    var a = an();
    Bo(t, e, n, a);
  }
  function Bo(t, e, n, a) {
    var i = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (ac(t)) zh(e, i);
    else {
      var r = t.alternate;
      if (t.lanes === 0 && (r === null || r.lanes === 0) && (r = e.lastRenderedReducer, r !== null))
        try {
          var f = e.lastRenderedState, m = r(f, n);
          if (i.hasEagerState = !0, i.eagerState = m, Je(m, f))
            return jr(t, e, i, 0), It === null && Hr(), !1;
        } catch {
        } finally {
        }
      if (n = ju(t, e, i, a), n !== null)
        return Ze(n, t, a), Lh(n, e, a), !0;
    }
    return !1;
  }
  function bs(t, e, n, a) {
    if (a = {
      lane: 2,
      revertLane: _s(),
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, ac(t)) {
      if (e) throw Error(u(479));
    } else
      e = ju(
        t,
        n,
        a,
        2
      ), e !== null && Ze(e, t, 2);
  }
  function ac(t) {
    var e = t.alternate;
    return t === mt || e !== null && e === mt;
  }
  function zh(t, e) {
    Oi = Wr = !0;
    var n = t.pending;
    n === null ? e.next = e : (e.next = n.next, n.next = e), t.pending = e;
  }
  function Lh(t, e, n) {
    if ((n & 4194048) !== 0) {
      var a = e.lanes;
      a &= t.pendingLanes, n |= a, e.lanes = n, ti(t, n);
    }
  }
  var Mo = {
    readContext: Ee,
    use: $r,
    useCallback: ae,
    useContext: ae,
    useEffect: ae,
    useImperativeHandle: ae,
    useLayoutEffect: ae,
    useInsertionEffect: ae,
    useMemo: ae,
    useReducer: ae,
    useRef: ae,
    useState: ae,
    useDebugValue: ae,
    useDeferredValue: ae,
    useTransition: ae,
    useSyncExternalStore: ae,
    useId: ae,
    useHostTransitionStatus: ae,
    useFormState: ae,
    useActionState: ae,
    useOptimistic: ae,
    useMemoCache: ae,
    useCacheRefresh: ae
  };
  Mo.useEffectEvent = ae;
  var Rh = {
    readContext: Ee,
    use: $r,
    useCallback: function(t, e) {
      return Ue().memoizedState = [
        t,
        e === void 0 ? null : e
      ], t;
    },
    useContext: Ee,
    useEffect: Ah,
    useImperativeHandle: function(t, e, n) {
      n = n != null ? n.concat([t]) : null, ec(
        4194308,
        4,
        Sh.bind(null, e, t),
        n
      );
    },
    useLayoutEffect: function(t, e) {
      return ec(4194308, 4, t, e);
    },
    useInsertionEffect: function(t, e) {
      ec(4, 2, t, e);
    },
    useMemo: function(t, e) {
      var n = Ue();
      e = e === void 0 ? null : e;
      var a = t();
      if (Ll) {
        cn(!0);
        try {
          t();
        } finally {
          cn(!1);
        }
      }
      return n.memoizedState = [a, e], a;
    },
    useReducer: function(t, e, n) {
      var a = Ue();
      if (n !== void 0) {
        var i = n(e);
        if (Ll) {
          cn(!0);
          try {
            n(e);
          } finally {
            cn(!1);
          }
        }
      } else i = e;
      return a.memoizedState = a.baseState = i, t = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: t,
        lastRenderedState: i
      }, a.queue = t, t = t.dispatch = Vy.bind(
        null,
        mt,
        t
      ), [a.memoizedState, t];
    },
    useRef: function(t) {
      var e = Ue();
      return t = { current: t }, e.memoizedState = t;
    },
    useState: function(t) {
      t = ms(t);
      var e = t.queue, n = Mh.bind(null, mt, e);
      return e.dispatch = n, [t.memoizedState, n];
    },
    useDebugValue: ps,
    useDeferredValue: function(t, e) {
      var n = Ue();
      return As(n, t, e);
    },
    useTransition: function() {
      var t = ms(!1);
      return t = Nh.bind(
        null,
        mt,
        t.queue,
        !0,
        !1
      ), Ue().memoizedState = t, [!1, t];
    },
    useSyncExternalStore: function(t, e, n) {
      var a = mt, i = Ue();
      if (Ct) {
        if (n === void 0)
          throw Error(u(407));
        n = n();
      } else {
        if (n = e(), It === null)
          throw Error(u(349));
        (xt & 127) !== 0 || eh(a, e, n);
      }
      i.memoizedState = n;
      var r = { value: n, getSnapshot: e };
      return i.queue = r, Ah(ah.bind(null, a, r, t), [
        t
      ]), a.flags |= 2048, Ei(
        9,
        { destroy: void 0 },
        nh.bind(
          null,
          a,
          r,
          n,
          e
        ),
        null
      ), n;
    },
    useId: function() {
      var t = Ue(), e = It.identifierPrefix;
      if (Ct) {
        var n = Xn, a = jn;
        n = (a & ~(1 << 32 - Oe(a) - 1)).toString(32) + n, e = "_" + e + "R_" + n, n = Jr++, 0 < n && (e += "H" + n.toString(32)), e += "_";
      } else
        n = Ly++, e = "_" + e + "r_" + n.toString(32) + "_";
      return t.memoizedState = e;
    },
    useHostTransitionStatus: vs,
    useFormState: dh,
    useActionState: dh,
    useOptimistic: function(t) {
      var e = Ue();
      e.memoizedState = e.baseState = t;
      var n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return e.queue = n, e = bs.bind(
        null,
        mt,
        !0,
        n
      ), n.dispatch = e, [t, e];
    },
    useMemoCache: ss,
    useCacheRefresh: function() {
      return Ue().memoizedState = Qy.bind(
        null,
        mt
      );
    },
    useEffectEvent: function(t) {
      var e = Ue(), n = { impl: t };
      return e.memoizedState = n, function() {
        if ((Rt & 2) !== 0)
          throw Error(u(440));
        return n.impl.apply(void 0, arguments);
      };
    }
  }, Ss = {
    readContext: Ee,
    use: $r,
    useCallback: Th,
    useContext: Ee,
    useEffect: gs,
    useImperativeHandle: Oh,
    useInsertionEffect: vh,
    useLayoutEffect: bh,
    useMemo: Eh,
    useReducer: tc,
    useRef: ph,
    useState: function() {
      return tc(oa);
    },
    useDebugValue: ps,
    useDeferredValue: function(t, e) {
      var n = ue();
      return xh(
        n,
        Vt.memoizedState,
        t,
        e
      );
    },
    useTransition: function() {
      var t = tc(oa)[0], e = ue().memoizedState;
      return [
        typeof t == "boolean" ? t : Do(t),
        e
      ];
    },
    useSyncExternalStore: th,
    useId: Dh,
    useHostTransitionStatus: vs,
    useFormState: mh,
    useActionState: mh,
    useOptimistic: function(t, e) {
      var n = ue();
      return oh(n, Vt, t, e);
    },
    useMemoCache: ss,
    useCacheRefresh: Bh
  };
  Ss.useEffectEvent = yh;
  var Uh = {
    readContext: Ee,
    use: $r,
    useCallback: Th,
    useContext: Ee,
    useEffect: gs,
    useImperativeHandle: Oh,
    useInsertionEffect: vh,
    useLayoutEffect: bh,
    useMemo: Eh,
    useReducer: ds,
    useRef: ph,
    useState: function() {
      return ds(oa);
    },
    useDebugValue: ps,
    useDeferredValue: function(t, e) {
      var n = ue();
      return Vt === null ? As(n, t, e) : xh(
        n,
        Vt.memoizedState,
        t,
        e
      );
    },
    useTransition: function() {
      var t = ds(oa)[0], e = ue().memoizedState;
      return [
        typeof t == "boolean" ? t : Do(t),
        e
      ];
    },
    useSyncExternalStore: th,
    useId: Dh,
    useHostTransitionStatus: vs,
    useFormState: gh,
    useActionState: gh,
    useOptimistic: function(t, e) {
      var n = ue();
      return Vt !== null ? oh(n, Vt, t, e) : (n.baseState = t, [t, n.queue.dispatch]);
    },
    useMemoCache: ss,
    useCacheRefresh: Bh
  };
  Uh.useEffectEvent = yh;
  function Os(t, e, n, a) {
    e = t.memoizedState, n = n(a, e), n = n == null ? e : x({}, e, n), t.memoizedState = n, t.lanes === 0 && (t.updateQueue.baseState = n);
  }
  var Ts = {
    enqueueSetState: function(t, e, n) {
      t = t._reactInternals;
      var a = an(), i = Xa(a);
      i.payload = e, n != null && (i.callback = n), e = Qa(t, i, a), e !== null && (Ze(e, t, a), xo(e, t, a));
    },
    enqueueReplaceState: function(t, e, n) {
      t = t._reactInternals;
      var a = an(), i = Xa(a);
      i.tag = 1, i.payload = e, n != null && (i.callback = n), e = Qa(t, i, a), e !== null && (Ze(e, t, a), xo(e, t, a));
    },
    enqueueForceUpdate: function(t, e) {
      t = t._reactInternals;
      var n = an(), a = Xa(n);
      a.tag = 2, e != null && (a.callback = e), e = Qa(t, a, n), e !== null && (Ze(e, t, n), xo(e, t, n));
    }
  };
  function Hh(t, e, n, a, i, r, f) {
    return t = t.stateNode, typeof t.shouldComponentUpdate == "function" ? t.shouldComponentUpdate(a, r, f) : e.prototype && e.prototype.isPureReactComponent ? !Ao(n, a) || !Ao(i, r) : !0;
  }
  function jh(t, e, n, a) {
    t = e.state, typeof e.componentWillReceiveProps == "function" && e.componentWillReceiveProps(n, a), typeof e.UNSAFE_componentWillReceiveProps == "function" && e.UNSAFE_componentWillReceiveProps(n, a), e.state !== t && Ts.enqueueReplaceState(e, e.state, null);
  }
  function Rl(t, e) {
    var n = e;
    if ("ref" in e) {
      n = {};
      for (var a in e)
        a !== "ref" && (n[a] = e[a]);
    }
    if (t = t.defaultProps) {
      n === e && (n = x({}, n));
      for (var i in t)
        n[i] === void 0 && (n[i] = t[i]);
    }
    return n;
  }
  function Xh(t) {
    Ur(t);
  }
  function Qh(t) {
    console.error(t);
  }
  function Vh(t) {
    Ur(t);
  }
  function lc(t, e) {
    try {
      var n = t.onUncaughtError;
      n(e.value, { componentStack: e.stack });
    } catch (a) {
      setTimeout(function() {
        throw a;
      });
    }
  }
  function Yh(t, e, n) {
    try {
      var a = t.onCaughtError;
      a(n.value, {
        componentStack: n.stack,
        errorBoundary: e.tag === 1 ? e.stateNode : null
      });
    } catch (i) {
      setTimeout(function() {
        throw i;
      });
    }
  }
  function Es(t, e, n) {
    return n = Xa(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
      lc(t, e);
    }, n;
  }
  function Gh(t) {
    return t = Xa(t), t.tag = 3, t;
  }
  function Ih(t, e, n, a) {
    var i = n.type.getDerivedStateFromError;
    if (typeof i == "function") {
      var r = a.value;
      t.payload = function() {
        return i(r);
      }, t.callback = function() {
        Yh(e, n, a);
      };
    }
    var f = n.stateNode;
    f !== null && typeof f.componentDidCatch == "function" && (t.callback = function() {
      Yh(e, n, a), typeof i != "function" && (Fa === null ? Fa = /* @__PURE__ */ new Set([this]) : Fa.add(this));
      var m = a.stack;
      this.componentDidCatch(a.value, {
        componentStack: m !== null ? m : ""
      });
    });
  }
  function Yy(t, e, n, a, i) {
    if (n.flags |= 32768, a !== null && typeof a == "object" && typeof a.then == "function") {
      if (e = n.alternate, e !== null && pi(
        e,
        n,
        i,
        !0
      ), n = $e.current, n !== null) {
        switch (n.tag) {
          case 31:
          case 13:
            return pn === null ? pc() : n.alternate === null && le === 0 && (le = 3), n.flags &= -257, n.flags |= 65536, n.lanes = i, a === Fr ? n.flags |= 16384 : (e = n.updateQueue, e === null ? n.updateQueue = /* @__PURE__ */ new Set([a]) : e.add(a), Ps(t, a, i)), !1;
          case 22:
            return n.flags |= 65536, a === Fr ? n.flags |= 16384 : (e = n.updateQueue, e === null ? (e = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([a])
            }, n.updateQueue = e) : (n = e.retryQueue, n === null ? e.retryQueue = /* @__PURE__ */ new Set([a]) : n.add(a)), Ps(t, a, i)), !1;
        }
        throw Error(u(435, n.tag));
      }
      return Ps(t, a, i), pc(), !1;
    }
    if (Ct)
      return e = $e.current, e !== null ? ((e.flags & 65536) === 0 && (e.flags |= 256), e.flags |= 65536, e.lanes = i, a !== Iu && (t = Error(u(422), { cause: a }), bo(dn(t, n)))) : (a !== Iu && (e = Error(u(423), {
        cause: a
      }), bo(
        dn(e, n)
      )), t = t.current.alternate, t.flags |= 65536, i &= -i, t.lanes |= i, a = dn(a, n), i = Es(
        t.stateNode,
        a,
        i
      ), ts(t, i), le !== 4 && (le = 2)), !1;
    var r = Error(u(520), { cause: a });
    if (r = dn(r, n), Qo === null ? Qo = [r] : Qo.push(r), le !== 4 && (le = 2), e === null) return !0;
    a = dn(a, n), n = e;
    do {
      switch (n.tag) {
        case 3:
          return n.flags |= 65536, t = i & -i, n.lanes |= t, t = Es(n.stateNode, a, t), ts(n, t), !1;
        case 1:
          if (e = n.type, r = n.stateNode, (n.flags & 128) === 0 && (typeof e.getDerivedStateFromError == "function" || r !== null && typeof r.componentDidCatch == "function" && (Fa === null || !Fa.has(r))))
            return n.flags |= 65536, i &= -i, n.lanes |= i, i = Gh(i), Ih(
              i,
              t,
              n,
              a
            ), ts(n, i), !1;
      }
      n = n.return;
    } while (n !== null);
    return !1;
  }
  var xs = Error(u(461)), de = !1;
  function xe(t, e, n, a) {
    e.child = t === null ? Km(e, null, n, a) : zl(
      e,
      t.child,
      n,
      a
    );
  }
  function kh(t, e, n, a, i) {
    n = n.render;
    var r = e.ref;
    if ("ref" in a) {
      var f = {};
      for (var m in a)
        m !== "ref" && (f[m] = a[m]);
    } else f = a;
    return wl(e), a = os(
      t,
      e,
      n,
      f,
      r,
      i
    ), m = rs(), t !== null && !de ? (cs(t, e, i), ra(t, e, i)) : (Ct && m && Yu(e), e.flags |= 1, xe(t, e, a, i), e.child);
  }
  function Fh(t, e, n, a, i) {
    if (t === null) {
      var r = n.type;
      return typeof r == "function" && !Xu(r) && r.defaultProps === void 0 && n.compare === null ? (e.tag = 15, e.type = r, qh(
        t,
        e,
        r,
        a,
        i
      )) : (t = Qr(
        n.type,
        null,
        a,
        e,
        e.mode,
        i
      ), t.ref = e.ref, t.return = e, e.child = t);
    }
    if (r = t.child, !Ls(t, i)) {
      var f = r.memoizedProps;
      if (n = n.compare, n = n !== null ? n : Ao, n(f, a) && t.ref === e.ref)
        return ra(t, e, i);
    }
    return e.flags |= 1, t = ea(r, a), t.ref = e.ref, t.return = e, e.child = t;
  }
  function qh(t, e, n, a, i) {
    if (t !== null) {
      var r = t.memoizedProps;
      if (Ao(r, a) && t.ref === e.ref)
        if (de = !1, e.pendingProps = a = r, Ls(t, i))
          (t.flags & 131072) !== 0 && (de = !0);
        else
          return e.lanes = t.lanes, ra(t, e, i);
    }
    return Ns(
      t,
      e,
      n,
      a,
      i
    );
  }
  function Kh(t, e, n, a) {
    var i = a.children, r = t !== null ? t.memoizedState : null;
    if (t === null && e.stateNode === null && (e.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), a.mode === "hidden") {
      if ((e.flags & 128) !== 0) {
        if (r = r !== null ? r.baseLanes | n : n, t !== null) {
          for (a = e.child = t.child, i = 0; a !== null; )
            i = i | a.lanes | a.childLanes, a = a.sibling;
          a = i & ~r;
        } else a = 0, e.child = null;
        return Zh(
          t,
          e,
          r,
          n,
          a
        );
      }
      if ((n & 536870912) !== 0)
        e.memoizedState = { baseLanes: 0, cachePool: null }, t !== null && Ir(
          e,
          r !== null ? r.cachePool : null
        ), r !== null ? Wm(e, r) : ns(), Jm(e);
      else
        return a = e.lanes = 536870912, Zh(
          t,
          e,
          r !== null ? r.baseLanes | n : n,
          n,
          a
        );
    } else
      r !== null ? (Ir(e, r.cachePool), Wm(e, r), Ya(), e.memoizedState = null) : (t !== null && Ir(e, null), ns(), Ya());
    return xe(t, e, i, n), e.child;
  }
  function zo(t, e) {
    return t !== null && t.tag === 22 || e.stateNode !== null || (e.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), e.sibling;
  }
  function Zh(t, e, n, a, i) {
    var r = Wu();
    return r = r === null ? null : { parent: se._currentValue, pool: r }, e.memoizedState = {
      baseLanes: n,
      cachePool: r
    }, t !== null && Ir(e, null), ns(), Jm(e), t !== null && pi(t, e, a, !0), e.childLanes = i, null;
  }
  function ic(t, e) {
    return e = rc(
      { mode: e.mode, children: e.children },
      t.mode
    ), e.ref = t.ref, t.child = e, e.return = t, e;
  }
  function Ph(t, e, n) {
    return zl(e, t.child, null, n), t = ic(e, e.pendingProps), t.flags |= 2, tn(e), e.memoizedState = null, t;
  }
  function Gy(t, e, n) {
    var a = e.pendingProps, i = (e.flags & 128) !== 0;
    if (e.flags &= -129, t === null) {
      if (Ct) {
        if (a.mode === "hidden")
          return t = ic(e, a), e.lanes = 536870912, zo(null, t);
        if (ls(e), (t = Pt) ? (t = rp(
          t,
          gn
        ), t = t !== null && t.data === "&" ? t : null, t !== null && (e.memoizedState = {
          dehydrated: t,
          treeContext: La !== null ? { id: jn, overflow: Xn } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = zm(t), n.return = e, e.child = n, Te = e, Pt = null)) : t = null, t === null) throw Ua(e);
        return e.lanes = 536870912, null;
      }
      return ic(e, a);
    }
    var r = t.memoizedState;
    if (r !== null) {
      var f = r.dehydrated;
      if (ls(e), i)
        if (e.flags & 256)
          e.flags &= -257, e = Ph(
            t,
            e,
            n
          );
        else if (e.memoizedState !== null)
          e.child = t.child, e.flags |= 128, e = null;
        else throw Error(u(558));
      else if (de || pi(t, e, n, !1), i = (n & t.childLanes) !== 0, de || i) {
        if (a = It, a !== null && (f = eo(a, n), f !== 0 && f !== r.retryLane))
          throw r.retryLane = f, El(t, f), Ze(a, t, f), xs;
        pc(), e = Ph(
          t,
          e,
          n
        );
      } else
        t = r.treeContext, Pt = An(f.nextSibling), Te = e, Ct = !0, Ra = null, gn = !1, t !== null && Um(e, t), e = ic(e, a), e.flags |= 4096;
      return e;
    }
    return t = ea(t.child, {
      mode: a.mode,
      children: a.children
    }), t.ref = e.ref, e.child = t, t.return = e, t;
  }
  function oc(t, e) {
    var n = e.ref;
    if (n === null)
      t !== null && t.ref !== null && (e.flags |= 4194816);
    else {
      if (typeof n != "function" && typeof n != "object")
        throw Error(u(284));
      (t === null || t.ref !== n) && (e.flags |= 4194816);
    }
  }
  function Ns(t, e, n, a, i) {
    return wl(e), n = os(
      t,
      e,
      n,
      a,
      void 0,
      i
    ), a = rs(), t !== null && !de ? (cs(t, e, i), ra(t, e, i)) : (Ct && a && Yu(e), e.flags |= 1, xe(t, e, n, i), e.child);
  }
  function Wh(t, e, n, a, i, r) {
    return wl(e), e.updateQueue = null, n = $m(
      e,
      a,
      n,
      i
    ), _m(t), a = rs(), t !== null && !de ? (cs(t, e, r), ra(t, e, r)) : (Ct && a && Yu(e), e.flags |= 1, xe(t, e, n, r), e.child);
  }
  function Jh(t, e, n, a, i) {
    if (wl(e), e.stateNode === null) {
      var r = di, f = n.contextType;
      typeof f == "object" && f !== null && (r = Ee(f)), r = new n(a, r), e.memoizedState = r.state !== null && r.state !== void 0 ? r.state : null, r.updater = Ts, e.stateNode = r, r._reactInternals = e, r = e.stateNode, r.props = a, r.state = e.memoizedState, r.refs = {}, _u(e), f = n.contextType, r.context = typeof f == "object" && f !== null ? Ee(f) : di, r.state = e.memoizedState, f = n.getDerivedStateFromProps, typeof f == "function" && (Os(
        e,
        n,
        f,
        a
      ), r.state = e.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof r.getSnapshotBeforeUpdate == "function" || typeof r.UNSAFE_componentWillMount != "function" && typeof r.componentWillMount != "function" || (f = r.state, typeof r.componentWillMount == "function" && r.componentWillMount(), typeof r.UNSAFE_componentWillMount == "function" && r.UNSAFE_componentWillMount(), f !== r.state && Ts.enqueueReplaceState(r, r.state, null), Co(e, a, r, i), No(), r.state = e.memoizedState), typeof r.componentDidMount == "function" && (e.flags |= 4194308), a = !0;
    } else if (t === null) {
      r = e.stateNode;
      var m = e.memoizedProps, A = Rl(n, m);
      r.props = A;
      var N = r.context, L = n.contextType;
      f = di, typeof L == "object" && L !== null && (f = Ee(L));
      var U = n.getDerivedStateFromProps;
      L = typeof U == "function" || typeof r.getSnapshotBeforeUpdate == "function", m = e.pendingProps !== m, L || typeof r.UNSAFE_componentWillReceiveProps != "function" && typeof r.componentWillReceiveProps != "function" || (m || N !== f) && jh(
        e,
        r,
        a,
        f
      ), ja = !1;
      var B = e.memoizedState;
      r.state = B, Co(e, a, r, i), No(), N = e.memoizedState, m || B !== N || ja ? (typeof U == "function" && (Os(
        e,
        n,
        U,
        a
      ), N = e.memoizedState), (A = ja || Hh(
        e,
        n,
        A,
        a,
        B,
        N,
        f
      )) ? (L || typeof r.UNSAFE_componentWillMount != "function" && typeof r.componentWillMount != "function" || (typeof r.componentWillMount == "function" && r.componentWillMount(), typeof r.UNSAFE_componentWillMount == "function" && r.UNSAFE_componentWillMount()), typeof r.componentDidMount == "function" && (e.flags |= 4194308)) : (typeof r.componentDidMount == "function" && (e.flags |= 4194308), e.memoizedProps = a, e.memoizedState = N), r.props = a, r.state = N, r.context = f, a = A) : (typeof r.componentDidMount == "function" && (e.flags |= 4194308), a = !1);
    } else {
      r = e.stateNode, $u(t, e), f = e.memoizedProps, L = Rl(n, f), r.props = L, U = e.pendingProps, B = r.context, N = n.contextType, A = di, typeof N == "object" && N !== null && (A = Ee(N)), m = n.getDerivedStateFromProps, (N = typeof m == "function" || typeof r.getSnapshotBeforeUpdate == "function") || typeof r.UNSAFE_componentWillReceiveProps != "function" && typeof r.componentWillReceiveProps != "function" || (f !== U || B !== A) && jh(
        e,
        r,
        a,
        A
      ), ja = !1, B = e.memoizedState, r.state = B, Co(e, a, r, i), No();
      var z = e.memoizedState;
      f !== U || B !== z || ja || t !== null && t.dependencies !== null && Yr(t.dependencies) ? (typeof m == "function" && (Os(
        e,
        n,
        m,
        a
      ), z = e.memoizedState), (L = ja || Hh(
        e,
        n,
        L,
        a,
        B,
        z,
        A
      ) || t !== null && t.dependencies !== null && Yr(t.dependencies)) ? (N || typeof r.UNSAFE_componentWillUpdate != "function" && typeof r.componentWillUpdate != "function" || (typeof r.componentWillUpdate == "function" && r.componentWillUpdate(a, z, A), typeof r.UNSAFE_componentWillUpdate == "function" && r.UNSAFE_componentWillUpdate(
        a,
        z,
        A
      )), typeof r.componentDidUpdate == "function" && (e.flags |= 4), typeof r.getSnapshotBeforeUpdate == "function" && (e.flags |= 1024)) : (typeof r.componentDidUpdate != "function" || f === t.memoizedProps && B === t.memoizedState || (e.flags |= 4), typeof r.getSnapshotBeforeUpdate != "function" || f === t.memoizedProps && B === t.memoizedState || (e.flags |= 1024), e.memoizedProps = a, e.memoizedState = z), r.props = a, r.state = z, r.context = A, a = L) : (typeof r.componentDidUpdate != "function" || f === t.memoizedProps && B === t.memoizedState || (e.flags |= 4), typeof r.getSnapshotBeforeUpdate != "function" || f === t.memoizedProps && B === t.memoizedState || (e.flags |= 1024), a = !1);
    }
    return r = a, oc(t, e), a = (e.flags & 128) !== 0, r || a ? (r = e.stateNode, n = a && typeof n.getDerivedStateFromError != "function" ? null : r.render(), e.flags |= 1, t !== null && a ? (e.child = zl(
      e,
      t.child,
      null,
      i
    ), e.child = zl(
      e,
      null,
      n,
      i
    )) : xe(t, e, n, i), e.memoizedState = r.state, t = e.child) : t = ra(
      t,
      e,
      i
    ), t;
  }
  function _h(t, e, n, a) {
    return Nl(), e.flags |= 256, xe(t, e, n, a), e.child;
  }
  var Cs = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function ws(t) {
    return { baseLanes: t, cachePool: Ym() };
  }
  function Ds(t, e, n) {
    return t = t !== null ? t.childLanes & ~n : 0, e && (t |= nn), t;
  }
  function $h(t, e, n) {
    var a = e.pendingProps, i = !1, r = (e.flags & 128) !== 0, f;
    if ((f = r) || (f = t !== null && t.memoizedState === null ? !1 : (ce.current & 2) !== 0), f && (i = !0, e.flags &= -129), f = (e.flags & 32) !== 0, e.flags &= -33, t === null) {
      if (Ct) {
        if (i ? Va(e) : Ya(), (t = Pt) ? (t = rp(
          t,
          gn
        ), t = t !== null && t.data !== "&" ? t : null, t !== null && (e.memoizedState = {
          dehydrated: t,
          treeContext: La !== null ? { id: jn, overflow: Xn } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = zm(t), n.return = e, e.child = n, Te = e, Pt = null)) : t = null, t === null) throw Ua(e);
        return df(t) ? e.lanes = 32 : e.lanes = 536870912, null;
      }
      var m = a.children;
      return a = a.fallback, i ? (Ya(), i = e.mode, m = rc(
        { mode: "hidden", children: m },
        i
      ), a = xl(
        a,
        i,
        n,
        null
      ), m.return = e, a.return = e, m.sibling = a, e.child = m, a = e.child, a.memoizedState = ws(n), a.childLanes = Ds(
        t,
        f,
        n
      ), e.memoizedState = Cs, zo(null, a)) : (Va(e), Bs(e, m));
    }
    var A = t.memoizedState;
    if (A !== null && (m = A.dehydrated, m !== null)) {
      if (r)
        e.flags & 256 ? (Va(e), e.flags &= -257, e = Ms(
          t,
          e,
          n
        )) : e.memoizedState !== null ? (Ya(), e.child = t.child, e.flags |= 128, e = null) : (Ya(), m = a.fallback, i = e.mode, a = rc(
          { mode: "visible", children: a.children },
          i
        ), m = xl(
          m,
          i,
          n,
          null
        ), m.flags |= 2, a.return = e, m.return = e, a.sibling = m, e.child = a, zl(
          e,
          t.child,
          null,
          n
        ), a = e.child, a.memoizedState = ws(n), a.childLanes = Ds(
          t,
          f,
          n
        ), e.memoizedState = Cs, e = zo(null, a));
      else if (Va(e), df(m)) {
        if (f = m.nextSibling && m.nextSibling.dataset, f) var N = f.dgst;
        f = N, a = Error(u(419)), a.stack = "", a.digest = f, bo({ value: a, source: null, stack: null }), e = Ms(
          t,
          e,
          n
        );
      } else if (de || pi(t, e, n, !1), f = (n & t.childLanes) !== 0, de || f) {
        if (f = It, f !== null && (a = eo(f, n), a !== 0 && a !== A.retryLane))
          throw A.retryLane = a, El(t, a), Ze(f, t, a), xs;
        ff(m) || pc(), e = Ms(
          t,
          e,
          n
        );
      } else
        ff(m) ? (e.flags |= 192, e.child = t.child, e = null) : (t = A.treeContext, Pt = An(
          m.nextSibling
        ), Te = e, Ct = !0, Ra = null, gn = !1, t !== null && Um(e, t), e = Bs(
          e,
          a.children
        ), e.flags |= 4096);
      return e;
    }
    return i ? (Ya(), m = a.fallback, i = e.mode, A = t.child, N = A.sibling, a = ea(A, {
      mode: "hidden",
      children: a.children
    }), a.subtreeFlags = A.subtreeFlags & 65011712, N !== null ? m = ea(
      N,
      m
    ) : (m = xl(
      m,
      i,
      n,
      null
    ), m.flags |= 2), m.return = e, a.return = e, a.sibling = m, e.child = a, zo(null, a), a = e.child, m = t.child.memoizedState, m === null ? m = ws(n) : (i = m.cachePool, i !== null ? (A = se._currentValue, i = i.parent !== A ? { parent: A, pool: A } : i) : i = Ym(), m = {
      baseLanes: m.baseLanes | n,
      cachePool: i
    }), a.memoizedState = m, a.childLanes = Ds(
      t,
      f,
      n
    ), e.memoizedState = Cs, zo(t.child, a)) : (Va(e), n = t.child, t = n.sibling, n = ea(n, {
      mode: "visible",
      children: a.children
    }), n.return = e, n.sibling = null, t !== null && (f = e.deletions, f === null ? (e.deletions = [t], e.flags |= 16) : f.push(t)), e.child = n, e.memoizedState = null, n);
  }
  function Bs(t, e) {
    return e = rc(
      { mode: "visible", children: e },
      t.mode
    ), e.return = t, t.child = e;
  }
  function rc(t, e) {
    return t = _e(22, t, null, e), t.lanes = 0, t;
  }
  function Ms(t, e, n) {
    return zl(e, t.child, null, n), t = Bs(
      e,
      e.pendingProps.children
    ), t.flags |= 2, e.memoizedState = null, t;
  }
  function tg(t, e, n) {
    t.lanes |= e;
    var a = t.alternate;
    a !== null && (a.lanes |= e), qu(t.return, e, n);
  }
  function zs(t, e, n, a, i, r) {
    var f = t.memoizedState;
    f === null ? t.memoizedState = {
      isBackwards: e,
      rendering: null,
      renderingStartTime: 0,
      last: a,
      tail: n,
      tailMode: i,
      treeForkCount: r
    } : (f.isBackwards = e, f.rendering = null, f.renderingStartTime = 0, f.last = a, f.tail = n, f.tailMode = i, f.treeForkCount = r);
  }
  function eg(t, e, n) {
    var a = e.pendingProps, i = a.revealOrder, r = a.tail;
    a = a.children;
    var f = ce.current, m = (f & 2) !== 0;
    if (m ? (f = f & 1 | 2, e.flags |= 128) : f &= 1, at(ce, f), xe(t, e, a, n), a = Ct ? vo : 0, !m && t !== null && (t.flags & 128) !== 0)
      t: for (t = e.child; t !== null; ) {
        if (t.tag === 13)
          t.memoizedState !== null && tg(t, n, e);
        else if (t.tag === 19)
          tg(t, n, e);
        else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e) break t;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            break t;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    switch (i) {
      case "forwards":
        for (n = e.child, i = null; n !== null; )
          t = n.alternate, t !== null && Pr(t) === null && (i = n), n = n.sibling;
        n = i, n === null ? (i = e.child, e.child = null) : (i = n.sibling, n.sibling = null), zs(
          e,
          !1,
          i,
          n,
          r,
          a
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (n = null, i = e.child, e.child = null; i !== null; ) {
          if (t = i.alternate, t !== null && Pr(t) === null) {
            e.child = i;
            break;
          }
          t = i.sibling, i.sibling = n, n = i, i = t;
        }
        zs(
          e,
          !0,
          n,
          null,
          r,
          a
        );
        break;
      case "together":
        zs(
          e,
          !1,
          null,
          null,
          void 0,
          a
        );
        break;
      default:
        e.memoizedState = null;
    }
    return e.child;
  }
  function ra(t, e, n) {
    if (t !== null && (e.dependencies = t.dependencies), ka |= e.lanes, (n & e.childLanes) === 0)
      if (t !== null) {
        if (pi(
          t,
          e,
          n,
          !1
        ), (n & e.childLanes) === 0)
          return null;
      } else return null;
    if (t !== null && e.child !== t.child)
      throw Error(u(153));
    if (e.child !== null) {
      for (t = e.child, n = ea(t, t.pendingProps), e.child = n, n.return = e; t.sibling !== null; )
        t = t.sibling, n = n.sibling = ea(t, t.pendingProps), n.return = e;
      n.sibling = null;
    }
    return e.child;
  }
  function Ls(t, e) {
    return (t.lanes & e) !== 0 ? !0 : (t = t.dependencies, !!(t !== null && Yr(t)));
  }
  function Iy(t, e, n) {
    switch (e.tag) {
      case 3:
        Tn(e, e.stateNode.containerInfo), Ha(e, se, t.memoizedState.cache), Nl();
        break;
      case 27:
      case 5:
        Ft(e);
        break;
      case 4:
        Tn(e, e.stateNode.containerInfo);
        break;
      case 10:
        Ha(
          e,
          e.type,
          e.memoizedProps.value
        );
        break;
      case 31:
        if (e.memoizedState !== null)
          return e.flags |= 128, ls(e), null;
        break;
      case 13:
        var a = e.memoizedState;
        if (a !== null)
          return a.dehydrated !== null ? (Va(e), e.flags |= 128, null) : (n & e.child.childLanes) !== 0 ? $h(t, e, n) : (Va(e), t = ra(
            t,
            e,
            n
          ), t !== null ? t.sibling : null);
        Va(e);
        break;
      case 19:
        var i = (t.flags & 128) !== 0;
        if (a = (n & e.childLanes) !== 0, a || (pi(
          t,
          e,
          n,
          !1
        ), a = (n & e.childLanes) !== 0), i) {
          if (a)
            return eg(
              t,
              e,
              n
            );
          e.flags |= 128;
        }
        if (i = e.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), at(ce, ce.current), a) break;
        return null;
      case 22:
        return e.lanes = 0, Kh(
          t,
          e,
          n,
          e.pendingProps
        );
      case 24:
        Ha(e, se, t.memoizedState.cache);
    }
    return ra(t, e, n);
  }
  function ng(t, e, n) {
    if (t !== null)
      if (t.memoizedProps !== e.pendingProps)
        de = !0;
      else {
        if (!Ls(t, n) && (e.flags & 128) === 0)
          return de = !1, Iy(
            t,
            e,
            n
          );
        de = (t.flags & 131072) !== 0;
      }
    else
      de = !1, Ct && (e.flags & 1048576) !== 0 && Rm(e, vo, e.index);
    switch (e.lanes = 0, e.tag) {
      case 16:
        t: {
          var a = e.pendingProps;
          if (t = Bl(e.elementType), e.type = t, typeof t == "function")
            Xu(t) ? (a = Rl(t, a), e.tag = 1, e = Jh(
              null,
              e,
              t,
              a,
              n
            )) : (e.tag = 0, e = Ns(
              null,
              e,
              t,
              a,
              n
            ));
          else {
            if (t != null) {
              var i = t.$$typeof;
              if (i === lt) {
                e.tag = 11, e = kh(
                  null,
                  e,
                  t,
                  a,
                  n
                );
                break t;
              } else if (i === P) {
                e.tag = 14, e = Fh(
                  null,
                  e,
                  t,
                  a,
                  n
                );
                break t;
              }
            }
            throw e = kt(t) || t, Error(u(306, e, ""));
          }
        }
        return e;
      case 0:
        return Ns(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 1:
        return a = e.type, i = Rl(
          a,
          e.pendingProps
        ), Jh(
          t,
          e,
          a,
          i,
          n
        );
      case 3:
        t: {
          if (Tn(
            e,
            e.stateNode.containerInfo
          ), t === null) throw Error(u(387));
          a = e.pendingProps;
          var r = e.memoizedState;
          i = r.element, $u(t, e), Co(e, a, null, n);
          var f = e.memoizedState;
          if (a = f.cache, Ha(e, se, a), a !== r.cache && Ku(
            e,
            [se],
            n,
            !0
          ), No(), a = f.element, r.isDehydrated)
            if (r = {
              element: a,
              isDehydrated: !1,
              cache: f.cache
            }, e.updateQueue.baseState = r, e.memoizedState = r, e.flags & 256) {
              e = _h(
                t,
                e,
                a,
                n
              );
              break t;
            } else if (a !== i) {
              i = dn(
                Error(u(424)),
                e
              ), bo(i), e = _h(
                t,
                e,
                a,
                n
              );
              break t;
            } else {
              switch (t = e.stateNode.containerInfo, t.nodeType) {
                case 9:
                  t = t.body;
                  break;
                default:
                  t = t.nodeName === "HTML" ? t.ownerDocument.body : t;
              }
              for (Pt = An(t.firstChild), Te = e, Ct = !0, Ra = null, gn = !0, n = Km(
                e,
                null,
                a,
                n
              ), e.child = n; n; )
                n.flags = n.flags & -3 | 4096, n = n.sibling;
            }
          else {
            if (Nl(), a === i) {
              e = ra(
                t,
                e,
                n
              );
              break t;
            }
            xe(t, e, a, n);
          }
          e = e.child;
        }
        return e;
      case 26:
        return oc(t, e), t === null ? (n = mp(
          e.type,
          null,
          e.pendingProps,
          null
        )) ? e.memoizedState = n : Ct || (n = e.type, t = e.pendingProps, a = Tc(
          ye.current
        ).createElement(n), a[vt] = e, a[oe] = t, Ne(a, n, t), Kt(a), e.stateNode = a) : e.memoizedState = mp(
          e.type,
          t.memoizedProps,
          e.pendingProps,
          t.memoizedState
        ), null;
      case 27:
        return Ft(e), t === null && Ct && (a = e.stateNode = sp(
          e.type,
          e.pendingProps,
          ye.current
        ), Te = e, gn = !0, i = Pt, Pa(e.type) ? (mf = i, Pt = An(a.firstChild)) : Pt = i), xe(
          t,
          e,
          e.pendingProps.children,
          n
        ), oc(t, e), t === null && (e.flags |= 4194304), e.child;
      case 5:
        return t === null && Ct && ((i = a = Pt) && (a = vv(
          a,
          e.type,
          e.pendingProps,
          gn
        ), a !== null ? (e.stateNode = a, Te = e, Pt = An(a.firstChild), gn = !1, i = !0) : i = !1), i || Ua(e)), Ft(e), i = e.type, r = e.pendingProps, f = t !== null ? t.memoizedProps : null, a = r.children, cf(i, r) ? a = null : f !== null && cf(i, f) && (e.flags |= 32), e.memoizedState !== null && (i = os(
          t,
          e,
          Ry,
          null,
          null,
          n
        ), Ko._currentValue = i), oc(t, e), xe(t, e, a, n), e.child;
      case 6:
        return t === null && Ct && ((t = n = Pt) && (n = bv(
          n,
          e.pendingProps,
          gn
        ), n !== null ? (e.stateNode = n, Te = e, Pt = null, t = !0) : t = !1), t || Ua(e)), null;
      case 13:
        return $h(t, e, n);
      case 4:
        return Tn(
          e,
          e.stateNode.containerInfo
        ), a = e.pendingProps, t === null ? e.child = zl(
          e,
          null,
          a,
          n
        ) : xe(t, e, a, n), e.child;
      case 11:
        return kh(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 7:
        return xe(
          t,
          e,
          e.pendingProps,
          n
        ), e.child;
      case 8:
        return xe(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 12:
        return xe(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 10:
        return a = e.pendingProps, Ha(e, e.type, a.value), xe(t, e, a.children, n), e.child;
      case 9:
        return i = e.type._context, a = e.pendingProps.children, wl(e), i = Ee(i), a = a(i), e.flags |= 1, xe(t, e, a, n), e.child;
      case 14:
        return Fh(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 15:
        return qh(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 19:
        return eg(t, e, n);
      case 31:
        return Gy(t, e, n);
      case 22:
        return Kh(
          t,
          e,
          n,
          e.pendingProps
        );
      case 24:
        return wl(e), a = Ee(se), t === null ? (i = Wu(), i === null && (i = It, r = Zu(), i.pooledCache = r, r.refCount++, r !== null && (i.pooledCacheLanes |= n), i = r), e.memoizedState = { parent: a, cache: i }, _u(e), Ha(e, se, i)) : ((t.lanes & n) !== 0 && ($u(t, e), Co(e, null, null, n), No()), i = t.memoizedState, r = e.memoizedState, i.parent !== a ? (i = { parent: a, cache: a }, e.memoizedState = i, e.lanes === 0 && (e.memoizedState = e.updateQueue.baseState = i), Ha(e, se, a)) : (a = r.cache, Ha(e, se, a), a !== i.cache && Ku(
          e,
          [se],
          n,
          !0
        ))), xe(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 29:
        throw e.pendingProps;
    }
    throw Error(u(156, e.tag));
  }
  function ca(t) {
    t.flags |= 4;
  }
  function Rs(t, e, n, a, i) {
    if ((e = (t.mode & 32) !== 0) && (e = !1), e) {
      if (t.flags |= 16777216, (i & 335544128) === i)
        if (t.stateNode.complete) t.flags |= 8192;
        else if (Dg()) t.flags |= 8192;
        else
          throw Ml = Fr, Ju;
    } else t.flags &= -16777217;
  }
  function ag(t, e) {
    if (e.type !== "stylesheet" || (e.state.loading & 4) !== 0)
      t.flags &= -16777217;
    else if (t.flags |= 16777216, !yp(e))
      if (Dg()) t.flags |= 8192;
      else
        throw Ml = Fr, Ju;
  }
  function cc(t, e) {
    e !== null && (t.flags |= 4), t.flags & 16384 && (e = t.tag !== 22 ? Wn() : 536870912, t.lanes |= e, wi |= e);
  }
  function Lo(t, e) {
    if (!Ct)
      switch (t.tailMode) {
        case "hidden":
          e = t.tail;
          for (var n = null; e !== null; )
            e.alternate !== null && (n = e), e = e.sibling;
          n === null ? t.tail = null : n.sibling = null;
          break;
        case "collapsed":
          n = t.tail;
          for (var a = null; n !== null; )
            n.alternate !== null && (a = n), n = n.sibling;
          a === null ? e || t.tail === null ? t.tail = null : t.tail.sibling = null : a.sibling = null;
      }
  }
  function Wt(t) {
    var e = t.alternate !== null && t.alternate.child === t.child, n = 0, a = 0;
    if (e)
      for (var i = t.child; i !== null; )
        n |= i.lanes | i.childLanes, a |= i.subtreeFlags & 65011712, a |= i.flags & 65011712, i.return = t, i = i.sibling;
    else
      for (i = t.child; i !== null; )
        n |= i.lanes | i.childLanes, a |= i.subtreeFlags, a |= i.flags, i.return = t, i = i.sibling;
    return t.subtreeFlags |= a, t.childLanes = n, e;
  }
  function ky(t, e, n) {
    var a = e.pendingProps;
    switch (Gu(e), e.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Wt(e), null;
      case 1:
        return Wt(e), null;
      case 3:
        return n = e.stateNode, a = null, t !== null && (a = t.memoizedState.cache), e.memoizedState.cache !== a && (e.flags |= 2048), la(se), ve(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (t === null || t.child === null) && (gi(e) ? ca(e) : t === null || t.memoizedState.isDehydrated && (e.flags & 256) === 0 || (e.flags |= 1024, ku())), Wt(e), null;
      case 26:
        var i = e.type, r = e.memoizedState;
        return t === null ? (ca(e), r !== null ? (Wt(e), ag(e, r)) : (Wt(e), Rs(
          e,
          i,
          null,
          a,
          n
        ))) : r ? r !== t.memoizedState ? (ca(e), Wt(e), ag(e, r)) : (Wt(e), e.flags &= -16777217) : (t = t.memoizedProps, t !== a && ca(e), Wt(e), Rs(
          e,
          i,
          t,
          a,
          n
        )), null;
      case 27:
        if (fl(e), n = ye.current, i = e.type, t !== null && e.stateNode != null)
          t.memoizedProps !== a && ca(e);
        else {
          if (!a) {
            if (e.stateNode === null)
              throw Error(u(166));
            return Wt(e), null;
          }
          t = ct.current, gi(e) ? Hm(e) : (t = sp(i, a, n), e.stateNode = t, ca(e));
        }
        return Wt(e), null;
      case 5:
        if (fl(e), i = e.type, t !== null && e.stateNode != null)
          t.memoizedProps !== a && ca(e);
        else {
          if (!a) {
            if (e.stateNode === null)
              throw Error(u(166));
            return Wt(e), null;
          }
          if (r = ct.current, gi(e))
            Hm(e);
          else {
            var f = Tc(
              ye.current
            );
            switch (r) {
              case 1:
                r = f.createElementNS(
                  "http://www.w3.org/2000/svg",
                  i
                );
                break;
              case 2:
                r = f.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  i
                );
                break;
              default:
                switch (i) {
                  case "svg":
                    r = f.createElementNS(
                      "http://www.w3.org/2000/svg",
                      i
                    );
                    break;
                  case "math":
                    r = f.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      i
                    );
                    break;
                  case "script":
                    r = f.createElement("div"), r.innerHTML = "<script><\/script>", r = r.removeChild(
                      r.firstChild
                    );
                    break;
                  case "select":
                    r = typeof a.is == "string" ? f.createElement("select", {
                      is: a.is
                    }) : f.createElement("select"), a.multiple ? r.multiple = !0 : a.size && (r.size = a.size);
                    break;
                  default:
                    r = typeof a.is == "string" ? f.createElement(i, { is: a.is }) : f.createElement(i);
                }
            }
            r[vt] = e, r[oe] = a;
            t: for (f = e.child; f !== null; ) {
              if (f.tag === 5 || f.tag === 6)
                r.appendChild(f.stateNode);
              else if (f.tag !== 4 && f.tag !== 27 && f.child !== null) {
                f.child.return = f, f = f.child;
                continue;
              }
              if (f === e) break t;
              for (; f.sibling === null; ) {
                if (f.return === null || f.return === e)
                  break t;
                f = f.return;
              }
              f.sibling.return = f.return, f = f.sibling;
            }
            e.stateNode = r;
            t: switch (Ne(r, i, a), i) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                a = !!a.autoFocus;
                break t;
              case "img":
                a = !0;
                break t;
              default:
                a = !1;
            }
            a && ca(e);
          }
        }
        return Wt(e), Rs(
          e,
          e.type,
          t === null ? null : t.memoizedProps,
          e.pendingProps,
          n
        ), null;
      case 6:
        if (t && e.stateNode != null)
          t.memoizedProps !== a && ca(e);
        else {
          if (typeof a != "string" && e.stateNode === null)
            throw Error(u(166));
          if (t = ye.current, gi(e)) {
            if (t = e.stateNode, n = e.memoizedProps, a = null, i = Te, i !== null)
              switch (i.tag) {
                case 27:
                case 5:
                  a = i.memoizedProps;
              }
            t[vt] = e, t = !!(t.nodeValue === n || a !== null && a.suppressHydrationWarning === !0 || $g(t.nodeValue, n)), t || Ua(e, !0);
          } else
            t = Tc(t).createTextNode(
              a
            ), t[vt] = e, e.stateNode = t;
        }
        return Wt(e), null;
      case 31:
        if (n = e.memoizedState, t === null || t.memoizedState !== null) {
          if (a = gi(e), n !== null) {
            if (t === null) {
              if (!a) throw Error(u(318));
              if (t = e.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(u(557));
              t[vt] = e;
            } else
              Nl(), (e.flags & 128) === 0 && (e.memoizedState = null), e.flags |= 4;
            Wt(e), t = !1;
          } else
            n = ku(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = n), t = !0;
          if (!t)
            return e.flags & 256 ? (tn(e), e) : (tn(e), null);
          if ((e.flags & 128) !== 0)
            throw Error(u(558));
        }
        return Wt(e), null;
      case 13:
        if (a = e.memoizedState, t === null || t.memoizedState !== null && t.memoizedState.dehydrated !== null) {
          if (i = gi(e), a !== null && a.dehydrated !== null) {
            if (t === null) {
              if (!i) throw Error(u(318));
              if (i = e.memoizedState, i = i !== null ? i.dehydrated : null, !i) throw Error(u(317));
              i[vt] = e;
            } else
              Nl(), (e.flags & 128) === 0 && (e.memoizedState = null), e.flags |= 4;
            Wt(e), i = !1;
          } else
            i = ku(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = i), i = !0;
          if (!i)
            return e.flags & 256 ? (tn(e), e) : (tn(e), null);
        }
        return tn(e), (e.flags & 128) !== 0 ? (e.lanes = n, e) : (n = a !== null, t = t !== null && t.memoizedState !== null, n && (a = e.child, i = null, a.alternate !== null && a.alternate.memoizedState !== null && a.alternate.memoizedState.cachePool !== null && (i = a.alternate.memoizedState.cachePool.pool), r = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (r = a.memoizedState.cachePool.pool), r !== i && (a.flags |= 2048)), n !== t && n && (e.child.flags |= 8192), cc(e, e.updateQueue), Wt(e), null);
      case 4:
        return ve(), t === null && nf(e.stateNode.containerInfo), Wt(e), null;
      case 10:
        return la(e.type), Wt(e), null;
      case 19:
        if (gt(ce), a = e.memoizedState, a === null) return Wt(e), null;
        if (i = (e.flags & 128) !== 0, r = a.rendering, r === null)
          if (i) Lo(a, !1);
          else {
            if (le !== 0 || t !== null && (t.flags & 128) !== 0)
              for (t = e.child; t !== null; ) {
                if (r = Pr(t), r !== null) {
                  for (e.flags |= 128, Lo(a, !1), t = r.updateQueue, e.updateQueue = t, cc(e, t), e.subtreeFlags = 0, t = n, n = e.child; n !== null; )
                    Mm(n, t), n = n.sibling;
                  return at(
                    ce,
                    ce.current & 1 | 2
                  ), Ct && na(e, a.treeForkCount), e.child;
                }
                t = t.sibling;
              }
            a.tail !== null && ie() > mc && (e.flags |= 128, i = !0, Lo(a, !1), e.lanes = 4194304);
          }
        else {
          if (!i)
            if (t = Pr(r), t !== null) {
              if (e.flags |= 128, i = !0, t = t.updateQueue, e.updateQueue = t, cc(e, t), Lo(a, !0), a.tail === null && a.tailMode === "hidden" && !r.alternate && !Ct)
                return Wt(e), null;
            } else
              2 * ie() - a.renderingStartTime > mc && n !== 536870912 && (e.flags |= 128, i = !0, Lo(a, !1), e.lanes = 4194304);
          a.isBackwards ? (r.sibling = e.child, e.child = r) : (t = a.last, t !== null ? t.sibling = r : e.child = r, a.last = r);
        }
        return a.tail !== null ? (t = a.tail, a.rendering = t, a.tail = t.sibling, a.renderingStartTime = ie(), t.sibling = null, n = ce.current, at(
          ce,
          i ? n & 1 | 2 : n & 1
        ), Ct && na(e, a.treeForkCount), t) : (Wt(e), null);
      case 22:
      case 23:
        return tn(e), as(), a = e.memoizedState !== null, t !== null ? t.memoizedState !== null !== a && (e.flags |= 8192) : a && (e.flags |= 8192), a ? (n & 536870912) !== 0 && (e.flags & 128) === 0 && (Wt(e), e.subtreeFlags & 6 && (e.flags |= 8192)) : Wt(e), n = e.updateQueue, n !== null && cc(e, n.retryQueue), n = null, t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (n = t.memoizedState.cachePool.pool), a = null, e.memoizedState !== null && e.memoizedState.cachePool !== null && (a = e.memoizedState.cachePool.pool), a !== n && (e.flags |= 2048), t !== null && gt(Dl), null;
      case 24:
        return n = null, t !== null && (n = t.memoizedState.cache), e.memoizedState.cache !== n && (e.flags |= 2048), la(se), Wt(e), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(u(156, e.tag));
  }
  function Fy(t, e) {
    switch (Gu(e), e.tag) {
      case 1:
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 3:
        return la(se), ve(), t = e.flags, (t & 65536) !== 0 && (t & 128) === 0 ? (e.flags = t & -65537 | 128, e) : null;
      case 26:
      case 27:
      case 5:
        return fl(e), null;
      case 31:
        if (e.memoizedState !== null) {
          if (tn(e), e.alternate === null)
            throw Error(u(340));
          Nl();
        }
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 13:
        if (tn(e), t = e.memoizedState, t !== null && t.dehydrated !== null) {
          if (e.alternate === null)
            throw Error(u(340));
          Nl();
        }
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 19:
        return gt(ce), null;
      case 4:
        return ve(), null;
      case 10:
        return la(e.type), null;
      case 22:
      case 23:
        return tn(e), as(), t !== null && gt(Dl), t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 24:
        return la(se), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function lg(t, e) {
    switch (Gu(e), e.tag) {
      case 3:
        la(se), ve();
        break;
      case 26:
      case 27:
      case 5:
        fl(e);
        break;
      case 4:
        ve();
        break;
      case 31:
        e.memoizedState !== null && tn(e);
        break;
      case 13:
        tn(e);
        break;
      case 19:
        gt(ce);
        break;
      case 10:
        la(e.type);
        break;
      case 22:
      case 23:
        tn(e), as(), t !== null && gt(Dl);
        break;
      case 24:
        la(se);
    }
  }
  function Ro(t, e) {
    try {
      var n = e.updateQueue, a = n !== null ? n.lastEffect : null;
      if (a !== null) {
        var i = a.next;
        n = i;
        do {
          if ((n.tag & t) === t) {
            a = void 0;
            var r = n.create, f = n.inst;
            a = r(), f.destroy = a;
          }
          n = n.next;
        } while (n !== i);
      }
    } catch (m) {
      Qt(e, e.return, m);
    }
  }
  function Ga(t, e, n) {
    try {
      var a = e.updateQueue, i = a !== null ? a.lastEffect : null;
      if (i !== null) {
        var r = i.next;
        a = r;
        do {
          if ((a.tag & t) === t) {
            var f = a.inst, m = f.destroy;
            if (m !== void 0) {
              f.destroy = void 0, i = e;
              var A = n, N = m;
              try {
                N();
              } catch (L) {
                Qt(
                  i,
                  A,
                  L
                );
              }
            }
          }
          a = a.next;
        } while (a !== r);
      }
    } catch (L) {
      Qt(e, e.return, L);
    }
  }
  function ig(t) {
    var e = t.updateQueue;
    if (e !== null) {
      var n = t.stateNode;
      try {
        Pm(e, n);
      } catch (a) {
        Qt(t, t.return, a);
      }
    }
  }
  function og(t, e, n) {
    n.props = Rl(
      t.type,
      t.memoizedProps
    ), n.state = t.memoizedState;
    try {
      n.componentWillUnmount();
    } catch (a) {
      Qt(t, e, a);
    }
  }
  function Uo(t, e) {
    try {
      var n = t.ref;
      if (n !== null) {
        switch (t.tag) {
          case 26:
          case 27:
          case 5:
            var a = t.stateNode;
            break;
          case 30:
            a = t.stateNode;
            break;
          default:
            a = t.stateNode;
        }
        typeof n == "function" ? t.refCleanup = n(a) : n.current = a;
      }
    } catch (i) {
      Qt(t, e, i);
    }
  }
  function Qn(t, e) {
    var n = t.ref, a = t.refCleanup;
    if (n !== null)
      if (typeof a == "function")
        try {
          a();
        } catch (i) {
          Qt(t, e, i);
        } finally {
          t.refCleanup = null, t = t.alternate, t != null && (t.refCleanup = null);
        }
      else if (typeof n == "function")
        try {
          n(null);
        } catch (i) {
          Qt(t, e, i);
        }
      else n.current = null;
  }
  function rg(t) {
    var e = t.type, n = t.memoizedProps, a = t.stateNode;
    try {
      t: switch (e) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          n.autoFocus && a.focus();
          break t;
        case "img":
          n.src ? a.src = n.src : n.srcSet && (a.srcset = n.srcSet);
      }
    } catch (i) {
      Qt(t, t.return, i);
    }
  }
  function Us(t, e, n) {
    try {
      var a = t.stateNode;
      mv(a, t.type, n, e), a[oe] = e;
    } catch (i) {
      Qt(t, t.return, i);
    }
  }
  function cg(t) {
    return t.tag === 5 || t.tag === 3 || t.tag === 26 || t.tag === 27 && Pa(t.type) || t.tag === 4;
  }
  function Hs(t) {
    t: for (; ; ) {
      for (; t.sibling === null; ) {
        if (t.return === null || cg(t.return)) return null;
        t = t.return;
      }
      for (t.sibling.return = t.return, t = t.sibling; t.tag !== 5 && t.tag !== 6 && t.tag !== 18; ) {
        if (t.tag === 27 && Pa(t.type) || t.flags & 2 || t.child === null || t.tag === 4) continue t;
        t.child.return = t, t = t.child;
      }
      if (!(t.flags & 2)) return t.stateNode;
    }
  }
  function js(t, e, n) {
    var a = t.tag;
    if (a === 5 || a === 6)
      t = t.stateNode, e ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(t, e) : (e = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, e.appendChild(t), n = n._reactRootContainer, n != null || e.onclick !== null || (e.onclick = Zt));
    else if (a !== 4 && (a === 27 && Pa(t.type) && (n = t.stateNode, e = null), t = t.child, t !== null))
      for (js(t, e, n), t = t.sibling; t !== null; )
        js(t, e, n), t = t.sibling;
  }
  function uc(t, e, n) {
    var a = t.tag;
    if (a === 5 || a === 6)
      t = t.stateNode, e ? n.insertBefore(t, e) : n.appendChild(t);
    else if (a !== 4 && (a === 27 && Pa(t.type) && (n = t.stateNode), t = t.child, t !== null))
      for (uc(t, e, n), t = t.sibling; t !== null; )
        uc(t, e, n), t = t.sibling;
  }
  function ug(t) {
    var e = t.stateNode, n = t.memoizedProps;
    try {
      for (var a = t.type, i = e.attributes; i.length; )
        e.removeAttributeNode(i[0]);
      Ne(e, a, n), e[vt] = t, e[oe] = n;
    } catch (r) {
      Qt(t, t.return, r);
    }
  }
  var ua = !1, me = !1, Xs = !1, sg = typeof WeakSet == "function" ? WeakSet : Set, be = null;
  function qy(t, e) {
    if (t = t.containerInfo, of = Bc, t = Om(t), Mu(t)) {
      if ("selectionStart" in t)
        var n = {
          start: t.selectionStart,
          end: t.selectionEnd
        };
      else
        t: {
          n = (n = t.ownerDocument) && n.defaultView || window;
          var a = n.getSelection && n.getSelection();
          if (a && a.rangeCount !== 0) {
            n = a.anchorNode;
            var i = a.anchorOffset, r = a.focusNode;
            a = a.focusOffset;
            try {
              n.nodeType, r.nodeType;
            } catch {
              n = null;
              break t;
            }
            var f = 0, m = -1, A = -1, N = 0, L = 0, U = t, B = null;
            e: for (; ; ) {
              for (var z; U !== n || i !== 0 && U.nodeType !== 3 || (m = f + i), U !== r || a !== 0 && U.nodeType !== 3 || (A = f + a), U.nodeType === 3 && (f += U.nodeValue.length), (z = U.firstChild) !== null; )
                B = U, U = z;
              for (; ; ) {
                if (U === t) break e;
                if (B === n && ++N === i && (m = f), B === r && ++L === a && (A = f), (z = U.nextSibling) !== null) break;
                U = B, B = U.parentNode;
              }
              U = z;
            }
            n = m === -1 || A === -1 ? null : { start: m, end: A };
          } else n = null;
        }
      n = n || { start: 0, end: 0 };
    } else n = null;
    for (rf = { focusedElem: t, selectionRange: n }, Bc = !1, be = e; be !== null; )
      if (e = be, t = e.child, (e.subtreeFlags & 1028) !== 0 && t !== null)
        t.return = e, be = t;
      else
        for (; be !== null; ) {
          switch (e = be, r = e.alternate, t = e.flags, e.tag) {
            case 0:
              if ((t & 4) !== 0 && (t = e.updateQueue, t = t !== null ? t.events : null, t !== null))
                for (n = 0; n < t.length; n++)
                  i = t[n], i.ref.impl = i.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((t & 1024) !== 0 && r !== null) {
                t = void 0, n = e, i = r.memoizedProps, r = r.memoizedState, a = n.stateNode;
                try {
                  var _ = Rl(
                    n.type,
                    i
                  );
                  t = a.getSnapshotBeforeUpdate(
                    _,
                    r
                  ), a.__reactInternalSnapshotBeforeUpdate = t;
                } catch (rt) {
                  Qt(
                    n,
                    n.return,
                    rt
                  );
                }
              }
              break;
            case 3:
              if ((t & 1024) !== 0) {
                if (t = e.stateNode.containerInfo, n = t.nodeType, n === 9)
                  sf(t);
                else if (n === 1)
                  switch (t.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      sf(t);
                      break;
                    default:
                      t.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((t & 1024) !== 0) throw Error(u(163));
          }
          if (t = e.sibling, t !== null) {
            t.return = e.return, be = t;
            break;
          }
          be = e.return;
        }
  }
  function fg(t, e, n) {
    var a = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        fa(t, n), a & 4 && Ro(5, n);
        break;
      case 1:
        if (fa(t, n), a & 4)
          if (t = n.stateNode, e === null)
            try {
              t.componentDidMount();
            } catch (f) {
              Qt(n, n.return, f);
            }
          else {
            var i = Rl(
              n.type,
              e.memoizedProps
            );
            e = e.memoizedState;
            try {
              t.componentDidUpdate(
                i,
                e,
                t.__reactInternalSnapshotBeforeUpdate
              );
            } catch (f) {
              Qt(
                n,
                n.return,
                f
              );
            }
          }
        a & 64 && ig(n), a & 512 && Uo(n, n.return);
        break;
      case 3:
        if (fa(t, n), a & 64 && (t = n.updateQueue, t !== null)) {
          if (e = null, n.child !== null)
            switch (n.child.tag) {
              case 27:
              case 5:
                e = n.child.stateNode;
                break;
              case 1:
                e = n.child.stateNode;
            }
          try {
            Pm(t, e);
          } catch (f) {
            Qt(n, n.return, f);
          }
        }
        break;
      case 27:
        e === null && a & 4 && ug(n);
      case 26:
      case 5:
        fa(t, n), e === null && a & 4 && rg(n), a & 512 && Uo(n, n.return);
        break;
      case 12:
        fa(t, n);
        break;
      case 31:
        fa(t, n), a & 4 && hg(t, n);
        break;
      case 13:
        fa(t, n), a & 4 && gg(t, n), a & 64 && (t = n.memoizedState, t !== null && (t = t.dehydrated, t !== null && (n = ev.bind(
          null,
          n
        ), Sv(t, n))));
        break;
      case 22:
        if (a = n.memoizedState !== null || ua, !a) {
          e = e !== null && e.memoizedState !== null || me, i = ua;
          var r = me;
          ua = a, (me = e) && !r ? da(
            t,
            n,
            (n.subtreeFlags & 8772) !== 0
          ) : fa(t, n), ua = i, me = r;
        }
        break;
      case 30:
        break;
      default:
        fa(t, n);
    }
  }
  function dg(t) {
    var e = t.alternate;
    e !== null && (t.alternate = null, dg(e)), t.child = null, t.deletions = null, t.sibling = null, t.tag === 5 && (e = t.stateNode, e !== null && io(e)), t.stateNode = null, t.return = null, t.dependencies = null, t.memoizedProps = null, t.memoizedState = null, t.pendingProps = null, t.stateNode = null, t.updateQueue = null;
  }
  var te = null, ke = !1;
  function sa(t, e, n) {
    for (n = n.child; n !== null; )
      mg(t, e, n), n = n.sibling;
  }
  function mg(t, e, n) {
    if (Be && typeof Be.onCommitFiberUnmount == "function")
      try {
        Be.onCommitFiberUnmount(Oa, n);
      } catch {
      }
    switch (n.tag) {
      case 26:
        me || Qn(n, e), sa(
          t,
          e,
          n
        ), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
        break;
      case 27:
        me || Qn(n, e);
        var a = te, i = ke;
        Pa(n.type) && (te = n.stateNode, ke = !1), sa(
          t,
          e,
          n
        ), ko(n.stateNode), te = a, ke = i;
        break;
      case 5:
        me || Qn(n, e);
      case 6:
        if (a = te, i = ke, te = null, sa(
          t,
          e,
          n
        ), te = a, ke = i, te !== null)
          if (ke)
            try {
              (te.nodeType === 9 ? te.body : te.nodeName === "HTML" ? te.ownerDocument.body : te).removeChild(n.stateNode);
            } catch (r) {
              Qt(
                n,
                e,
                r
              );
            }
          else
            try {
              te.removeChild(n.stateNode);
            } catch (r) {
              Qt(
                n,
                e,
                r
              );
            }
        break;
      case 18:
        te !== null && (ke ? (t = te, ip(
          t.nodeType === 9 ? t.body : t.nodeName === "HTML" ? t.ownerDocument.body : t,
          n.stateNode
        ), Hi(t)) : ip(te, n.stateNode));
        break;
      case 4:
        a = te, i = ke, te = n.stateNode.containerInfo, ke = !0, sa(
          t,
          e,
          n
        ), te = a, ke = i;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        Ga(2, n, e), me || Ga(4, n, e), sa(
          t,
          e,
          n
        );
        break;
      case 1:
        me || (Qn(n, e), a = n.stateNode, typeof a.componentWillUnmount == "function" && og(
          n,
          e,
          a
        )), sa(
          t,
          e,
          n
        );
        break;
      case 21:
        sa(
          t,
          e,
          n
        );
        break;
      case 22:
        me = (a = me) || n.memoizedState !== null, sa(
          t,
          e,
          n
        ), me = a;
        break;
      default:
        sa(
          t,
          e,
          n
        );
    }
  }
  function hg(t, e) {
    if (e.memoizedState === null && (t = e.alternate, t !== null && (t = t.memoizedState, t !== null))) {
      t = t.dehydrated;
      try {
        Hi(t);
      } catch (n) {
        Qt(e, e.return, n);
      }
    }
  }
  function gg(t, e) {
    if (e.memoizedState === null && (t = e.alternate, t !== null && (t = t.memoizedState, t !== null && (t = t.dehydrated, t !== null))))
      try {
        Hi(t);
      } catch (n) {
        Qt(e, e.return, n);
      }
  }
  function Ky(t) {
    switch (t.tag) {
      case 31:
      case 13:
      case 19:
        var e = t.stateNode;
        return e === null && (e = t.stateNode = new sg()), e;
      case 22:
        return t = t.stateNode, e = t._retryCache, e === null && (e = t._retryCache = new sg()), e;
      default:
        throw Error(u(435, t.tag));
    }
  }
  function sc(t, e) {
    var n = Ky(t);
    e.forEach(function(a) {
      if (!n.has(a)) {
        n.add(a);
        var i = nv.bind(null, t, a);
        a.then(i, i);
      }
    });
  }
  function Fe(t, e) {
    var n = e.deletions;
    if (n !== null)
      for (var a = 0; a < n.length; a++) {
        var i = n[a], r = t, f = e, m = f;
        t: for (; m !== null; ) {
          switch (m.tag) {
            case 27:
              if (Pa(m.type)) {
                te = m.stateNode, ke = !1;
                break t;
              }
              break;
            case 5:
              te = m.stateNode, ke = !1;
              break t;
            case 3:
            case 4:
              te = m.stateNode.containerInfo, ke = !0;
              break t;
          }
          m = m.return;
        }
        if (te === null) throw Error(u(160));
        mg(r, f, i), te = null, ke = !1, r = i.alternate, r !== null && (r.return = null), i.return = null;
      }
    if (e.subtreeFlags & 13886)
      for (e = e.child; e !== null; )
        pg(e, t), e = e.sibling;
  }
  var Nn = null;
  function pg(t, e) {
    var n = t.alternate, a = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Fe(e, t), qe(t), a & 4 && (Ga(3, t, t.return), Ro(3, t), Ga(5, t, t.return));
        break;
      case 1:
        Fe(e, t), qe(t), a & 512 && (me || n === null || Qn(n, n.return)), a & 64 && ua && (t = t.updateQueue, t !== null && (a = t.callbacks, a !== null && (n = t.shared.hiddenCallbacks, t.shared.hiddenCallbacks = n === null ? a : n.concat(a))));
        break;
      case 26:
        var i = Nn;
        if (Fe(e, t), qe(t), a & 512 && (me || n === null || Qn(n, n.return)), a & 4) {
          var r = n !== null ? n.memoizedState : null;
          if (a = t.memoizedState, n === null)
            if (a === null)
              if (t.stateNode === null) {
                t: {
                  a = t.type, n = t.memoizedProps, i = i.ownerDocument || i;
                  e: switch (a) {
                    case "title":
                      r = i.getElementsByTagName("title")[0], (!r || r[vl] || r[vt] || r.namespaceURI === "http://www.w3.org/2000/svg" || r.hasAttribute("itemprop")) && (r = i.createElement(a), i.head.insertBefore(
                        r,
                        i.querySelector("head > title")
                      )), Ne(r, a, n), r[vt] = t, Kt(r), a = r;
                      break t;
                    case "link":
                      var f = pp(
                        "link",
                        "href",
                        i
                      ).get(a + (n.href || ""));
                      if (f) {
                        for (var m = 0; m < f.length; m++)
                          if (r = f[m], r.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && r.getAttribute("rel") === (n.rel == null ? null : n.rel) && r.getAttribute("title") === (n.title == null ? null : n.title) && r.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
                            f.splice(m, 1);
                            break e;
                          }
                      }
                      r = i.createElement(a), Ne(r, a, n), i.head.appendChild(r);
                      break;
                    case "meta":
                      if (f = pp(
                        "meta",
                        "content",
                        i
                      ).get(a + (n.content || ""))) {
                        for (m = 0; m < f.length; m++)
                          if (r = f[m], r.getAttribute("content") === (n.content == null ? null : "" + n.content) && r.getAttribute("name") === (n.name == null ? null : n.name) && r.getAttribute("property") === (n.property == null ? null : n.property) && r.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && r.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
                            f.splice(m, 1);
                            break e;
                          }
                      }
                      r = i.createElement(a), Ne(r, a, n), i.head.appendChild(r);
                      break;
                    default:
                      throw Error(u(468, a));
                  }
                  r[vt] = t, Kt(r), a = r;
                }
                t.stateNode = a;
              } else
                Ap(
                  i,
                  t.type,
                  t.stateNode
                );
            else
              t.stateNode = gp(
                i,
                a,
                t.memoizedProps
              );
          else
            r !== a ? (r === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : r.count--, a === null ? Ap(
              i,
              t.type,
              t.stateNode
            ) : gp(
              i,
              a,
              t.memoizedProps
            )) : a === null && t.stateNode !== null && Us(
              t,
              t.memoizedProps,
              n.memoizedProps
            );
        }
        break;
      case 27:
        Fe(e, t), qe(t), a & 512 && (me || n === null || Qn(n, n.return)), n !== null && a & 4 && Us(
          t,
          t.memoizedProps,
          n.memoizedProps
        );
        break;
      case 5:
        if (Fe(e, t), qe(t), a & 512 && (me || n === null || Qn(n, n.return)), t.flags & 32) {
          i = t.stateNode;
          try {
            W(i, "");
          } catch (_) {
            Qt(t, t.return, _);
          }
        }
        a & 4 && t.stateNode != null && (i = t.memoizedProps, Us(
          t,
          i,
          n !== null ? n.memoizedProps : i
        )), a & 1024 && (Xs = !0);
        break;
      case 6:
        if (Fe(e, t), qe(t), a & 4) {
          if (t.stateNode === null)
            throw Error(u(162));
          a = t.memoizedProps, n = t.stateNode;
          try {
            n.nodeValue = a;
          } catch (_) {
            Qt(t, t.return, _);
          }
        }
        break;
      case 3:
        if (Nc = null, i = Nn, Nn = Ec(e.containerInfo), Fe(e, t), Nn = i, qe(t), a & 4 && n !== null && n.memoizedState.isDehydrated)
          try {
            Hi(e.containerInfo);
          } catch (_) {
            Qt(t, t.return, _);
          }
        Xs && (Xs = !1, Ag(t));
        break;
      case 4:
        a = Nn, Nn = Ec(
          t.stateNode.containerInfo
        ), Fe(e, t), qe(t), Nn = a;
        break;
      case 12:
        Fe(e, t), qe(t);
        break;
      case 31:
        Fe(e, t), qe(t), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, sc(t, a)));
        break;
      case 13:
        Fe(e, t), qe(t), t.child.flags & 8192 && t.memoizedState !== null != (n !== null && n.memoizedState !== null) && (dc = ie()), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, sc(t, a)));
        break;
      case 22:
        i = t.memoizedState !== null;
        var A = n !== null && n.memoizedState !== null, N = ua, L = me;
        if (ua = N || i, me = L || A, Fe(e, t), me = L, ua = N, qe(t), a & 8192)
          t: for (e = t.stateNode, e._visibility = i ? e._visibility & -2 : e._visibility | 1, i && (n === null || A || ua || me || Ul(t)), n = null, e = t; ; ) {
            if (e.tag === 5 || e.tag === 26) {
              if (n === null) {
                A = n = e;
                try {
                  if (r = A.stateNode, i)
                    f = r.style, typeof f.setProperty == "function" ? f.setProperty("display", "none", "important") : f.display = "none";
                  else {
                    m = A.stateNode;
                    var U = A.memoizedProps.style, B = U != null && U.hasOwnProperty("display") ? U.display : null;
                    m.style.display = B == null || typeof B == "boolean" ? "" : ("" + B).trim();
                  }
                } catch (_) {
                  Qt(A, A.return, _);
                }
              }
            } else if (e.tag === 6) {
              if (n === null) {
                A = e;
                try {
                  A.stateNode.nodeValue = i ? "" : A.memoizedProps;
                } catch (_) {
                  Qt(A, A.return, _);
                }
              }
            } else if (e.tag === 18) {
              if (n === null) {
                A = e;
                try {
                  var z = A.stateNode;
                  i ? op(z, !0) : op(A.stateNode, !1);
                } catch (_) {
                  Qt(A, A.return, _);
                }
              }
            } else if ((e.tag !== 22 && e.tag !== 23 || e.memoizedState === null || e === t) && e.child !== null) {
              e.child.return = e, e = e.child;
              continue;
            }
            if (e === t) break t;
            for (; e.sibling === null; ) {
              if (e.return === null || e.return === t) break t;
              n === e && (n = null), e = e.return;
            }
            n === e && (n = null), e.sibling.return = e.return, e = e.sibling;
          }
        a & 4 && (a = t.updateQueue, a !== null && (n = a.retryQueue, n !== null && (a.retryQueue = null, sc(t, n))));
        break;
      case 19:
        Fe(e, t), qe(t), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, sc(t, a)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        Fe(e, t), qe(t);
    }
  }
  function qe(t) {
    var e = t.flags;
    if (e & 2) {
      try {
        for (var n, a = t.return; a !== null; ) {
          if (cg(a)) {
            n = a;
            break;
          }
          a = a.return;
        }
        if (n == null) throw Error(u(160));
        switch (n.tag) {
          case 27:
            var i = n.stateNode, r = Hs(t);
            uc(t, r, i);
            break;
          case 5:
            var f = n.stateNode;
            n.flags & 32 && (W(f, ""), n.flags &= -33);
            var m = Hs(t);
            uc(t, m, f);
            break;
          case 3:
          case 4:
            var A = n.stateNode.containerInfo, N = Hs(t);
            js(
              t,
              N,
              A
            );
            break;
          default:
            throw Error(u(161));
        }
      } catch (L) {
        Qt(t, t.return, L);
      }
      t.flags &= -3;
    }
    e & 4096 && (t.flags &= -4097);
  }
  function Ag(t) {
    if (t.subtreeFlags & 1024)
      for (t = t.child; t !== null; ) {
        var e = t;
        Ag(e), e.tag === 5 && e.flags & 1024 && e.stateNode.reset(), t = t.sibling;
      }
  }
  function fa(t, e) {
    if (e.subtreeFlags & 8772)
      for (e = e.child; e !== null; )
        fg(t, e.alternate, e), e = e.sibling;
  }
  function Ul(t) {
    for (t = t.child; t !== null; ) {
      var e = t;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Ga(4, e, e.return), Ul(e);
          break;
        case 1:
          Qn(e, e.return);
          var n = e.stateNode;
          typeof n.componentWillUnmount == "function" && og(
            e,
            e.return,
            n
          ), Ul(e);
          break;
        case 27:
          ko(e.stateNode);
        case 26:
        case 5:
          Qn(e, e.return), Ul(e);
          break;
        case 22:
          e.memoizedState === null && Ul(e);
          break;
        case 30:
          Ul(e);
          break;
        default:
          Ul(e);
      }
      t = t.sibling;
    }
  }
  function da(t, e, n) {
    for (n = n && (e.subtreeFlags & 8772) !== 0, e = e.child; e !== null; ) {
      var a = e.alternate, i = t, r = e, f = r.flags;
      switch (r.tag) {
        case 0:
        case 11:
        case 15:
          da(
            i,
            r,
            n
          ), Ro(4, r);
          break;
        case 1:
          if (da(
            i,
            r,
            n
          ), a = r, i = a.stateNode, typeof i.componentDidMount == "function")
            try {
              i.componentDidMount();
            } catch (N) {
              Qt(a, a.return, N);
            }
          if (a = r, i = a.updateQueue, i !== null) {
            var m = a.stateNode;
            try {
              var A = i.shared.hiddenCallbacks;
              if (A !== null)
                for (i.shared.hiddenCallbacks = null, i = 0; i < A.length; i++)
                  Zm(A[i], m);
            } catch (N) {
              Qt(a, a.return, N);
            }
          }
          n && f & 64 && ig(r), Uo(r, r.return);
          break;
        case 27:
          ug(r);
        case 26:
        case 5:
          da(
            i,
            r,
            n
          ), n && a === null && f & 4 && rg(r), Uo(r, r.return);
          break;
        case 12:
          da(
            i,
            r,
            n
          );
          break;
        case 31:
          da(
            i,
            r,
            n
          ), n && f & 4 && hg(i, r);
          break;
        case 13:
          da(
            i,
            r,
            n
          ), n && f & 4 && gg(i, r);
          break;
        case 22:
          r.memoizedState === null && da(
            i,
            r,
            n
          ), Uo(r, r.return);
          break;
        case 30:
          break;
        default:
          da(
            i,
            r,
            n
          );
      }
      e = e.sibling;
    }
  }
  function Qs(t, e) {
    var n = null;
    t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (n = t.memoizedState.cachePool.pool), t = null, e.memoizedState !== null && e.memoizedState.cachePool !== null && (t = e.memoizedState.cachePool.pool), t !== n && (t != null && t.refCount++, n != null && So(n));
  }
  function Vs(t, e) {
    t = null, e.alternate !== null && (t = e.alternate.memoizedState.cache), e = e.memoizedState.cache, e !== t && (e.refCount++, t != null && So(t));
  }
  function Cn(t, e, n, a) {
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; )
        yg(
          t,
          e,
          n,
          a
        ), e = e.sibling;
  }
  function yg(t, e, n, a) {
    var i = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        Cn(
          t,
          e,
          n,
          a
        ), i & 2048 && Ro(9, e);
        break;
      case 1:
        Cn(
          t,
          e,
          n,
          a
        );
        break;
      case 3:
        Cn(
          t,
          e,
          n,
          a
        ), i & 2048 && (t = null, e.alternate !== null && (t = e.alternate.memoizedState.cache), e = e.memoizedState.cache, e !== t && (e.refCount++, t != null && So(t)));
        break;
      case 12:
        if (i & 2048) {
          Cn(
            t,
            e,
            n,
            a
          ), t = e.stateNode;
          try {
            var r = e.memoizedProps, f = r.id, m = r.onPostCommit;
            typeof m == "function" && m(
              f,
              e.alternate === null ? "mount" : "update",
              t.passiveEffectDuration,
              -0
            );
          } catch (A) {
            Qt(e, e.return, A);
          }
        } else
          Cn(
            t,
            e,
            n,
            a
          );
        break;
      case 31:
        Cn(
          t,
          e,
          n,
          a
        );
        break;
      case 13:
        Cn(
          t,
          e,
          n,
          a
        );
        break;
      case 23:
        break;
      case 22:
        r = e.stateNode, f = e.alternate, e.memoizedState !== null ? r._visibility & 2 ? Cn(
          t,
          e,
          n,
          a
        ) : Ho(t, e) : r._visibility & 2 ? Cn(
          t,
          e,
          n,
          a
        ) : (r._visibility |= 2, xi(
          t,
          e,
          n,
          a,
          (e.subtreeFlags & 10256) !== 0 || !1
        )), i & 2048 && Qs(f, e);
        break;
      case 24:
        Cn(
          t,
          e,
          n,
          a
        ), i & 2048 && Vs(e.alternate, e);
        break;
      default:
        Cn(
          t,
          e,
          n,
          a
        );
    }
  }
  function xi(t, e, n, a, i) {
    for (i = i && ((e.subtreeFlags & 10256) !== 0 || !1), e = e.child; e !== null; ) {
      var r = t, f = e, m = n, A = a, N = f.flags;
      switch (f.tag) {
        case 0:
        case 11:
        case 15:
          xi(
            r,
            f,
            m,
            A,
            i
          ), Ro(8, f);
          break;
        case 23:
          break;
        case 22:
          var L = f.stateNode;
          f.memoizedState !== null ? L._visibility & 2 ? xi(
            r,
            f,
            m,
            A,
            i
          ) : Ho(
            r,
            f
          ) : (L._visibility |= 2, xi(
            r,
            f,
            m,
            A,
            i
          )), i && N & 2048 && Qs(
            f.alternate,
            f
          );
          break;
        case 24:
          xi(
            r,
            f,
            m,
            A,
            i
          ), i && N & 2048 && Vs(f.alternate, f);
          break;
        default:
          xi(
            r,
            f,
            m,
            A,
            i
          );
      }
      e = e.sibling;
    }
  }
  function Ho(t, e) {
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; ) {
        var n = t, a = e, i = a.flags;
        switch (a.tag) {
          case 22:
            Ho(n, a), i & 2048 && Qs(
              a.alternate,
              a
            );
            break;
          case 24:
            Ho(n, a), i & 2048 && Vs(a.alternate, a);
            break;
          default:
            Ho(n, a);
        }
        e = e.sibling;
      }
  }
  var jo = 8192;
  function Ni(t, e, n) {
    if (t.subtreeFlags & jo)
      for (t = t.child; t !== null; )
        vg(
          t,
          e,
          n
        ), t = t.sibling;
  }
  function vg(t, e, n) {
    switch (t.tag) {
      case 26:
        Ni(
          t,
          e,
          n
        ), t.flags & jo && t.memoizedState !== null && Lv(
          n,
          Nn,
          t.memoizedState,
          t.memoizedProps
        );
        break;
      case 5:
        Ni(
          t,
          e,
          n
        );
        break;
      case 3:
      case 4:
        var a = Nn;
        Nn = Ec(t.stateNode.containerInfo), Ni(
          t,
          e,
          n
        ), Nn = a;
        break;
      case 22:
        t.memoizedState === null && (a = t.alternate, a !== null && a.memoizedState !== null ? (a = jo, jo = 16777216, Ni(
          t,
          e,
          n
        ), jo = a) : Ni(
          t,
          e,
          n
        ));
        break;
      default:
        Ni(
          t,
          e,
          n
        );
    }
  }
  function bg(t) {
    var e = t.alternate;
    if (e !== null && (t = e.child, t !== null)) {
      e.child = null;
      do
        e = t.sibling, t.sibling = null, t = e;
      while (t !== null);
    }
  }
  function Xo(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var a = e[n];
          be = a, Og(
            a,
            t
          );
        }
      bg(t);
    }
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        Sg(t), t = t.sibling;
  }
  function Sg(t) {
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Xo(t), t.flags & 2048 && Ga(9, t, t.return);
        break;
      case 3:
        Xo(t);
        break;
      case 12:
        Xo(t);
        break;
      case 22:
        var e = t.stateNode;
        t.memoizedState !== null && e._visibility & 2 && (t.return === null || t.return.tag !== 13) ? (e._visibility &= -3, fc(t)) : Xo(t);
        break;
      default:
        Xo(t);
    }
  }
  function fc(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var a = e[n];
          be = a, Og(
            a,
            t
          );
        }
      bg(t);
    }
    for (t = t.child; t !== null; ) {
      switch (e = t, e.tag) {
        case 0:
        case 11:
        case 15:
          Ga(8, e, e.return), fc(e);
          break;
        case 22:
          n = e.stateNode, n._visibility & 2 && (n._visibility &= -3, fc(e));
          break;
        default:
          fc(e);
      }
      t = t.sibling;
    }
  }
  function Og(t, e) {
    for (; be !== null; ) {
      var n = be;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          Ga(8, n, e);
          break;
        case 23:
        case 22:
          if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
            var a = n.memoizedState.cachePool.pool;
            a != null && a.refCount++;
          }
          break;
        case 24:
          So(n.memoizedState.cache);
      }
      if (a = n.child, a !== null) a.return = n, be = a;
      else
        t: for (n = t; be !== null; ) {
          a = be;
          var i = a.sibling, r = a.return;
          if (dg(a), a === n) {
            be = null;
            break t;
          }
          if (i !== null) {
            i.return = r, be = i;
            break t;
          }
          be = r;
        }
    }
  }
  var Zy = {
    getCacheForType: function(t) {
      var e = Ee(se), n = e.data.get(t);
      return n === void 0 && (n = t(), e.data.set(t, n)), n;
    },
    cacheSignal: function() {
      return Ee(se).controller.signal;
    }
  }, Py = typeof WeakMap == "function" ? WeakMap : Map, Rt = 0, It = null, St = null, xt = 0, Xt = 0, en = null, Ia = !1, Ci = !1, Ys = !1, ma = 0, le = 0, ka = 0, Hl = 0, Gs = 0, nn = 0, wi = 0, Qo = null, Ke = null, Is = !1, dc = 0, Tg = 0, mc = 1 / 0, hc = null, Fa = null, pe = 0, qa = null, Di = null, ha = 0, ks = 0, Fs = null, Eg = null, Vo = 0, qs = null;
  function an() {
    return (Rt & 2) !== 0 && xt !== 0 ? xt & -xt : H.T !== null ? _s() : xa();
  }
  function xg() {
    if (nn === 0)
      if ((xt & 536870912) === 0 || Ct) {
        var t = pl;
        pl <<= 1, (pl & 3932160) === 0 && (pl = 262144), nn = t;
      } else nn = 536870912;
    return t = $e.current, t !== null && (t.flags |= 32), nn;
  }
  function Ze(t, e, n) {
    (t === It && (Xt === 2 || Xt === 9) || t.cancelPendingCommit !== null) && (Bi(t, 0), Ka(
      t,
      xt,
      nn,
      !1
    )), Jn(t, n), ((Rt & 2) === 0 || t !== It) && (t === It && ((Rt & 2) === 0 && (Hl |= n), le === 4 && Ka(
      t,
      xt,
      nn,
      !1
    )), Vn(t));
  }
  function Ng(t, e, n) {
    if ((Rt & 6) !== 0) throw Error(u(327));
    var a = !n && (e & 127) === 0 && (e & t.expiredLanes) === 0 || Ln(t, e), i = a ? _y(t, e) : Zs(t, e, !0), r = a;
    do {
      if (i === 0) {
        Ci && !a && Ka(t, e, 0, !1);
        break;
      } else {
        if (n = t.current.alternate, r && !Wy(n)) {
          i = Zs(t, e, !1), r = !1;
          continue;
        }
        if (i === 2) {
          if (r = e, t.errorRecoveryDisabledLanes & r)
            var f = 0;
          else
            f = t.pendingLanes & -536870913, f = f !== 0 ? f : f & 536870912 ? 536870912 : 0;
          if (f !== 0) {
            e = f;
            t: {
              var m = t;
              i = Qo;
              var A = m.current.memoizedState.isDehydrated;
              if (A && (Bi(m, f).flags |= 256), f = Zs(
                m,
                f,
                !1
              ), f !== 2) {
                if (Ys && !A) {
                  m.errorRecoveryDisabledLanes |= r, Hl |= r, i = 4;
                  break t;
                }
                r = Ke, Ke = i, r !== null && (Ke === null ? Ke = r : Ke.push.apply(
                  Ke,
                  r
                ));
              }
              i = f;
            }
            if (r = !1, i !== 2) continue;
          }
        }
        if (i === 1) {
          Bi(t, 0), Ka(t, e, 0, !0);
          break;
        }
        t: {
          switch (a = t, r = i, r) {
            case 0:
            case 1:
              throw Error(u(345));
            case 4:
              if ((e & 4194048) !== e) break;
            case 6:
              Ka(
                a,
                e,
                nn,
                !Ia
              );
              break t;
            case 2:
              Ke = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(u(329));
          }
          if ((e & 62914560) === e && (i = dc + 300 - ie(), 10 < i)) {
            if (Ka(
              a,
              e,
              nn,
              !Ia
            ), Pn(a, 0, !0) !== 0) break t;
            ha = e, a.timeoutHandle = ap(
              Cg.bind(
                null,
                a,
                n,
                Ke,
                hc,
                Is,
                e,
                nn,
                Hl,
                wi,
                Ia,
                r,
                "Throttled",
                -0,
                0
              ),
              i
            );
            break t;
          }
          Cg(
            a,
            n,
            Ke,
            hc,
            Is,
            e,
            nn,
            Hl,
            wi,
            Ia,
            r,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    Vn(t);
  }
  function Cg(t, e, n, a, i, r, f, m, A, N, L, U, B, z) {
    if (t.timeoutHandle = -1, U = e.subtreeFlags, U & 8192 || (U & 16785408) === 16785408) {
      U = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Zt
      }, vg(
        e,
        r,
        U
      );
      var _ = (r & 62914560) === r ? dc - ie() : (r & 4194048) === r ? Tg - ie() : 0;
      if (_ = Rv(
        U,
        _
      ), _ !== null) {
        ha = r, t.cancelPendingCommit = _(
          Ug.bind(
            null,
            t,
            e,
            r,
            n,
            a,
            i,
            f,
            m,
            A,
            L,
            U,
            null,
            B,
            z
          )
        ), Ka(t, r, f, !N);
        return;
      }
    }
    Ug(
      t,
      e,
      r,
      n,
      a,
      i,
      f,
      m,
      A
    );
  }
  function Wy(t) {
    for (var e = t; ; ) {
      var n = e.tag;
      if ((n === 0 || n === 11 || n === 15) && e.flags & 16384 && (n = e.updateQueue, n !== null && (n = n.stores, n !== null)))
        for (var a = 0; a < n.length; a++) {
          var i = n[a], r = i.getSnapshot;
          i = i.value;
          try {
            if (!Je(r(), i)) return !1;
          } catch {
            return !1;
          }
        }
      if (n = e.child, e.subtreeFlags & 16384 && n !== null)
        n.return = e, e = n;
      else {
        if (e === t) break;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t) return !0;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
    }
    return !0;
  }
  function Ka(t, e, n, a) {
    e &= ~Gs, e &= ~Hl, t.suspendedLanes |= e, t.pingedLanes &= ~e, a && (t.warmLanes |= e), a = t.expirationTimes;
    for (var i = e; 0 < i; ) {
      var r = 31 - Oe(i), f = 1 << r;
      a[r] = -1, i &= ~f;
    }
    n !== 0 && to(t, n, e);
  }
  function gc() {
    return (Rt & 6) === 0 ? (Yo(0), !1) : !0;
  }
  function Ks() {
    if (St !== null) {
      if (Xt === 0)
        var t = St.return;
      else
        t = St, aa = Cl = null, us(t), bi = null, To = 0, t = St;
      for (; t !== null; )
        lg(t.alternate, t), t = t.return;
      St = null;
    }
  }
  function Bi(t, e) {
    var n = t.timeoutHandle;
    n !== -1 && (t.timeoutHandle = -1, pv(n)), n = t.cancelPendingCommit, n !== null && (t.cancelPendingCommit = null, n()), ha = 0, Ks(), It = t, St = n = ea(t.current, null), xt = e, Xt = 0, en = null, Ia = !1, Ci = Ln(t, e), Ys = !1, wi = nn = Gs = Hl = ka = le = 0, Ke = Qo = null, Is = !1, (e & 8) !== 0 && (e |= e & 32);
    var a = t.entangledLanes;
    if (a !== 0)
      for (t = t.entanglements, a &= e; 0 < a; ) {
        var i = 31 - Oe(a), r = 1 << i;
        e |= t[i], a &= ~r;
      }
    return ma = e, Hr(), n;
  }
  function wg(t, e) {
    mt = null, H.H = Mo, e === vi || e === kr ? (e = km(), Xt = 3) : e === Ju ? (e = km(), Xt = 4) : Xt = e === xs ? 8 : e !== null && typeof e == "object" && typeof e.then == "function" ? 6 : 1, en = e, St === null && (le = 1, lc(
      t,
      dn(e, t.current)
    ));
  }
  function Dg() {
    var t = $e.current;
    return t === null ? !0 : (xt & 4194048) === xt ? pn === null : (xt & 62914560) === xt || (xt & 536870912) !== 0 ? t === pn : !1;
  }
  function Bg() {
    var t = H.H;
    return H.H = Mo, t === null ? Mo : t;
  }
  function Mg() {
    var t = H.A;
    return H.A = Zy, t;
  }
  function pc() {
    le = 4, Ia || (xt & 4194048) !== xt && $e.current !== null || (Ci = !0), (ka & 134217727) === 0 && (Hl & 134217727) === 0 || It === null || Ka(
      It,
      xt,
      nn,
      !1
    );
  }
  function Zs(t, e, n) {
    var a = Rt;
    Rt |= 2;
    var i = Bg(), r = Mg();
    (It !== t || xt !== e) && (hc = null, Bi(t, e)), e = !1;
    var f = le;
    t: do
      try {
        if (Xt !== 0 && St !== null) {
          var m = St, A = en;
          switch (Xt) {
            case 8:
              Ks(), f = 6;
              break t;
            case 3:
            case 2:
            case 9:
            case 6:
              $e.current === null && (e = !0);
              var N = Xt;
              if (Xt = 0, en = null, Mi(t, m, A, N), n && Ci) {
                f = 0;
                break t;
              }
              break;
            default:
              N = Xt, Xt = 0, en = null, Mi(t, m, A, N);
          }
        }
        Jy(), f = le;
        break;
      } catch (L) {
        wg(t, L);
      }
    while (!0);
    return e && t.shellSuspendCounter++, aa = Cl = null, Rt = a, H.H = i, H.A = r, St === null && (It = null, xt = 0, Hr()), f;
  }
  function Jy() {
    for (; St !== null; ) zg(St);
  }
  function _y(t, e) {
    var n = Rt;
    Rt |= 2;
    var a = Bg(), i = Mg();
    It !== t || xt !== e ? (hc = null, mc = ie() + 500, Bi(t, e)) : Ci = Ln(
      t,
      e
    );
    t: do
      try {
        if (Xt !== 0 && St !== null) {
          e = St;
          var r = en;
          e: switch (Xt) {
            case 1:
              Xt = 0, en = null, Mi(t, e, r, 1);
              break;
            case 2:
            case 9:
              if (Gm(r)) {
                Xt = 0, en = null, Lg(e);
                break;
              }
              e = function() {
                Xt !== 2 && Xt !== 9 || It !== t || (Xt = 7), Vn(t);
              }, r.then(e, e);
              break t;
            case 3:
              Xt = 7;
              break t;
            case 4:
              Xt = 5;
              break t;
            case 7:
              Gm(r) ? (Xt = 0, en = null, Lg(e)) : (Xt = 0, en = null, Mi(t, e, r, 7));
              break;
            case 5:
              var f = null;
              switch (St.tag) {
                case 26:
                  f = St.memoizedState;
                case 5:
                case 27:
                  var m = St;
                  if (f ? yp(f) : m.stateNode.complete) {
                    Xt = 0, en = null;
                    var A = m.sibling;
                    if (A !== null) St = A;
                    else {
                      var N = m.return;
                      N !== null ? (St = N, Ac(N)) : St = null;
                    }
                    break e;
                  }
              }
              Xt = 0, en = null, Mi(t, e, r, 5);
              break;
            case 6:
              Xt = 0, en = null, Mi(t, e, r, 6);
              break;
            case 8:
              Ks(), le = 6;
              break t;
            default:
              throw Error(u(462));
          }
        }
        $y();
        break;
      } catch (L) {
        wg(t, L);
      }
    while (!0);
    return aa = Cl = null, H.H = a, H.A = i, Rt = n, St !== null ? 0 : (It = null, xt = 0, Hr(), le);
  }
  function $y() {
    for (; St !== null && !Mn(); )
      zg(St);
  }
  function zg(t) {
    var e = ng(t.alternate, t, ma);
    t.memoizedProps = t.pendingProps, e === null ? Ac(t) : St = e;
  }
  function Lg(t) {
    var e = t, n = e.alternate;
    switch (e.tag) {
      case 15:
      case 0:
        e = Wh(
          n,
          e,
          e.pendingProps,
          e.type,
          void 0,
          xt
        );
        break;
      case 11:
        e = Wh(
          n,
          e,
          e.pendingProps,
          e.type.render,
          e.ref,
          xt
        );
        break;
      case 5:
        us(e);
      default:
        lg(n, e), e = St = Mm(e, ma), e = ng(n, e, ma);
    }
    t.memoizedProps = t.pendingProps, e === null ? Ac(t) : St = e;
  }
  function Mi(t, e, n, a) {
    aa = Cl = null, us(e), bi = null, To = 0;
    var i = e.return;
    try {
      if (Yy(
        t,
        i,
        e,
        n,
        xt
      )) {
        le = 1, lc(
          t,
          dn(n, t.current)
        ), St = null;
        return;
      }
    } catch (r) {
      if (i !== null) throw St = i, r;
      le = 1, lc(
        t,
        dn(n, t.current)
      ), St = null;
      return;
    }
    e.flags & 32768 ? (Ct || a === 1 ? t = !0 : Ci || (xt & 536870912) !== 0 ? t = !1 : (Ia = t = !0, (a === 2 || a === 9 || a === 3 || a === 6) && (a = $e.current, a !== null && a.tag === 13 && (a.flags |= 16384))), Rg(e, t)) : Ac(e);
  }
  function Ac(t) {
    var e = t;
    do {
      if ((e.flags & 32768) !== 0) {
        Rg(
          e,
          Ia
        );
        return;
      }
      t = e.return;
      var n = ky(
        e.alternate,
        e,
        ma
      );
      if (n !== null) {
        St = n;
        return;
      }
      if (e = e.sibling, e !== null) {
        St = e;
        return;
      }
      St = e = t;
    } while (e !== null);
    le === 0 && (le = 5);
  }
  function Rg(t, e) {
    do {
      var n = Fy(t.alternate, t);
      if (n !== null) {
        n.flags &= 32767, St = n;
        return;
      }
      if (n = t.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !e && (t = t.sibling, t !== null)) {
        St = t;
        return;
      }
      St = t = n;
    } while (t !== null);
    le = 6, St = null;
  }
  function Ug(t, e, n, a, i, r, f, m, A) {
    t.cancelPendingCommit = null;
    do
      yc();
    while (pe !== 0);
    if ((Rt & 6) !== 0) throw Error(u(327));
    if (e !== null) {
      if (e === t.current) throw Error(u(177));
      if (r = e.lanes | e.childLanes, r |= Hu, Au(
        t,
        n,
        r,
        f,
        m,
        A
      ), t === It && (St = It = null, xt = 0), Di = e, qa = t, ha = n, ks = r, Fs = i, Eg = a, (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0 ? (t.callbackNode = null, t.callbackPriority = 0, av(ba, function() {
        return Vg(), null;
      })) : (t.callbackNode = null, t.callbackPriority = 0), a = (e.flags & 13878) !== 0, (e.subtreeFlags & 13878) !== 0 || a) {
        a = H.T, H.T = null, i = Z.p, Z.p = 2, f = Rt, Rt |= 4;
        try {
          qy(t, e, n);
        } finally {
          Rt = f, Z.p = i, H.T = a;
        }
      }
      pe = 1, Hg(), jg(), Xg();
    }
  }
  function Hg() {
    if (pe === 1) {
      pe = 0;
      var t = qa, e = Di, n = (e.flags & 13878) !== 0;
      if ((e.subtreeFlags & 13878) !== 0 || n) {
        n = H.T, H.T = null;
        var a = Z.p;
        Z.p = 2;
        var i = Rt;
        Rt |= 4;
        try {
          pg(e, t);
          var r = rf, f = Om(t.containerInfo), m = r.focusedElem, A = r.selectionRange;
          if (f !== m && m && m.ownerDocument && Sm(
            m.ownerDocument.documentElement,
            m
          )) {
            if (A !== null && Mu(m)) {
              var N = A.start, L = A.end;
              if (L === void 0 && (L = N), "selectionStart" in m)
                m.selectionStart = N, m.selectionEnd = Math.min(
                  L,
                  m.value.length
                );
              else {
                var U = m.ownerDocument || document, B = U && U.defaultView || window;
                if (B.getSelection) {
                  var z = B.getSelection(), _ = m.textContent.length, rt = Math.min(A.start, _), Gt = A.end === void 0 ? rt : Math.min(A.end, _);
                  !z.extend && rt > Gt && (f = Gt, Gt = rt, rt = f);
                  var S = bm(
                    m,
                    rt
                  ), v = bm(
                    m,
                    Gt
                  );
                  if (S && v && (z.rangeCount !== 1 || z.anchorNode !== S.node || z.anchorOffset !== S.offset || z.focusNode !== v.node || z.focusOffset !== v.offset)) {
                    var E = U.createRange();
                    E.setStart(S.node, S.offset), z.removeAllRanges(), rt > Gt ? (z.addRange(E), z.extend(v.node, v.offset)) : (E.setEnd(v.node, v.offset), z.addRange(E));
                  }
                }
              }
            }
            for (U = [], z = m; z = z.parentNode; )
              z.nodeType === 1 && U.push({
                element: z,
                left: z.scrollLeft,
                top: z.scrollTop
              });
            for (typeof m.focus == "function" && m.focus(), m = 0; m < U.length; m++) {
              var R = U[m];
              R.element.scrollLeft = R.left, R.element.scrollTop = R.top;
            }
          }
          Bc = !!of, rf = of = null;
        } finally {
          Rt = i, Z.p = a, H.T = n;
        }
      }
      t.current = e, pe = 2;
    }
  }
  function jg() {
    if (pe === 2) {
      pe = 0;
      var t = qa, e = Di, n = (e.flags & 8772) !== 0;
      if ((e.subtreeFlags & 8772) !== 0 || n) {
        n = H.T, H.T = null;
        var a = Z.p;
        Z.p = 2;
        var i = Rt;
        Rt |= 4;
        try {
          fg(t, e.alternate, e);
        } finally {
          Rt = i, Z.p = a, H.T = n;
        }
      }
      pe = 3;
    }
  }
  function Xg() {
    if (pe === 4 || pe === 3) {
      pe = 0, ml();
      var t = qa, e = Di, n = ha, a = Eg;
      (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0 ? pe = 5 : (pe = 0, Di = qa = null, Qg(t, t.pendingLanes));
      var i = t.pendingLanes;
      if (i === 0 && (Fa = null), no(n), e = e.stateNode, Be && typeof Be.onCommitFiberRoot == "function")
        try {
          Be.onCommitFiberRoot(
            Oa,
            e,
            void 0,
            (e.current.flags & 128) === 128
          );
        } catch {
        }
      if (a !== null) {
        e = H.T, i = Z.p, Z.p = 2, H.T = null;
        try {
          for (var r = t.onRecoverableError, f = 0; f < a.length; f++) {
            var m = a[f];
            r(m.value, {
              componentStack: m.stack
            });
          }
        } finally {
          H.T = e, Z.p = i;
        }
      }
      (ha & 3) !== 0 && yc(), Vn(t), i = t.pendingLanes, (n & 261930) !== 0 && (i & 42) !== 0 ? t === qs ? Vo++ : (Vo = 0, qs = t) : Vo = 0, Yo(0);
    }
  }
  function Qg(t, e) {
    (t.pooledCacheLanes &= e) === 0 && (e = t.pooledCache, e != null && (t.pooledCache = null, So(e)));
  }
  function yc() {
    return Hg(), jg(), Xg(), Vg();
  }
  function Vg() {
    if (pe !== 5) return !1;
    var t = qa, e = ks;
    ks = 0;
    var n = no(ha), a = H.T, i = Z.p;
    try {
      Z.p = 32 > n ? 32 : n, H.T = null, n = Fs, Fs = null;
      var r = qa, f = ha;
      if (pe = 0, Di = qa = null, ha = 0, (Rt & 6) !== 0) throw Error(u(331));
      var m = Rt;
      if (Rt |= 4, Sg(r.current), yg(
        r,
        r.current,
        f,
        n
      ), Rt = m, Yo(0, !1), Be && typeof Be.onPostCommitFiberRoot == "function")
        try {
          Be.onPostCommitFiberRoot(Oa, r);
        } catch {
        }
      return !0;
    } finally {
      Z.p = i, H.T = a, Qg(t, e);
    }
  }
  function Yg(t, e, n) {
    e = dn(n, e), e = Es(t.stateNode, e, 2), t = Qa(t, e, 2), t !== null && (Jn(t, 2), Vn(t));
  }
  function Qt(t, e, n) {
    if (t.tag === 3)
      Yg(t, t, n);
    else
      for (; e !== null; ) {
        if (e.tag === 3) {
          Yg(
            e,
            t,
            n
          );
          break;
        } else if (e.tag === 1) {
          var a = e.stateNode;
          if (typeof e.type.getDerivedStateFromError == "function" || typeof a.componentDidCatch == "function" && (Fa === null || !Fa.has(a))) {
            t = dn(n, t), n = Gh(2), a = Qa(e, n, 2), a !== null && (Ih(
              n,
              a,
              e,
              t
            ), Jn(a, 2), Vn(a));
            break;
          }
        }
        e = e.return;
      }
  }
  function Ps(t, e, n) {
    var a = t.pingCache;
    if (a === null) {
      a = t.pingCache = new Py();
      var i = /* @__PURE__ */ new Set();
      a.set(e, i);
    } else
      i = a.get(e), i === void 0 && (i = /* @__PURE__ */ new Set(), a.set(e, i));
    i.has(n) || (Ys = !0, i.add(n), t = tv.bind(null, t, e, n), e.then(t, t));
  }
  function tv(t, e, n) {
    var a = t.pingCache;
    a !== null && a.delete(e), t.pingedLanes |= t.suspendedLanes & n, t.warmLanes &= ~n, It === t && (xt & n) === n && (le === 4 || le === 3 && (xt & 62914560) === xt && 300 > ie() - dc ? (Rt & 2) === 0 && Bi(t, 0) : Gs |= n, wi === xt && (wi = 0)), Vn(t);
  }
  function Gg(t, e) {
    e === 0 && (e = Wn()), t = El(t, e), t !== null && (Jn(t, e), Vn(t));
  }
  function ev(t) {
    var e = t.memoizedState, n = 0;
    e !== null && (n = e.retryLane), Gg(t, n);
  }
  function nv(t, e) {
    var n = 0;
    switch (t.tag) {
      case 31:
      case 13:
        var a = t.stateNode, i = t.memoizedState;
        i !== null && (n = i.retryLane);
        break;
      case 19:
        a = t.stateNode;
        break;
      case 22:
        a = t.stateNode._retryCache;
        break;
      default:
        throw Error(u(314));
    }
    a !== null && a.delete(e), Gg(t, n);
  }
  function av(t, e) {
    return Pl(t, e);
  }
  var vc = null, zi = null, Ws = !1, bc = !1, Js = !1, Za = 0;
  function Vn(t) {
    t !== zi && t.next === null && (zi === null ? vc = zi = t : zi = zi.next = t), bc = !0, Ws || (Ws = !0, iv());
  }
  function Yo(t, e) {
    if (!Js && bc) {
      Js = !0;
      do
        for (var n = !1, a = vc; a !== null; ) {
          if (t !== 0) {
            var i = a.pendingLanes;
            if (i === 0) var r = 0;
            else {
              var f = a.suspendedLanes, m = a.pingedLanes;
              r = (1 << 31 - Oe(42 | t) + 1) - 1, r &= i & ~(f & ~m), r = r & 201326741 ? r & 201326741 | 1 : r ? r | 2 : 0;
            }
            r !== 0 && (n = !0, qg(a, r));
          } else
            r = xt, r = Pn(
              a,
              a === It ? r : 0,
              a.cancelPendingCommit !== null || a.timeoutHandle !== -1
            ), (r & 3) === 0 || Ln(a, r) || (n = !0, qg(a, r));
          a = a.next;
        }
      while (n);
      Js = !1;
    }
  }
  function lv() {
    Ig();
  }
  function Ig() {
    bc = Ws = !1;
    var t = 0;
    Za !== 0 && gv() && (t = Za);
    for (var e = ie(), n = null, a = vc; a !== null; ) {
      var i = a.next, r = kg(a, e);
      r === 0 ? (a.next = null, n === null ? vc = i : n.next = i, i === null && (zi = n)) : (n = a, (t !== 0 || (r & 3) !== 0) && (bc = !0)), a = i;
    }
    pe !== 0 && pe !== 5 || Yo(t), Za !== 0 && (Za = 0);
  }
  function kg(t, e) {
    for (var n = t.suspendedLanes, a = t.pingedLanes, i = t.expirationTimes, r = t.pendingLanes & -62914561; 0 < r; ) {
      var f = 31 - Oe(r), m = 1 << f, A = i[f];
      A === -1 ? ((m & n) === 0 || (m & a) !== 0) && (i[f] = sn(m, e)) : A <= e && (t.expiredLanes |= m), r &= ~m;
    }
    if (e = It, n = xt, n = Pn(
      t,
      t === e ? n : 0,
      t.cancelPendingCommit !== null || t.timeoutHandle !== -1
    ), a = t.callbackNode, n === 0 || t === e && (Xt === 2 || Xt === 9) || t.cancelPendingCommit !== null)
      return a !== null && a !== null && Wl(a), t.callbackNode = null, t.callbackPriority = 0;
    if ((n & 3) === 0 || Ln(t, n)) {
      if (e = n & -n, e === t.callbackPriority) return e;
      switch (a !== null && Wl(a), no(n)) {
        case 2:
        case 8:
          n = _l;
          break;
        case 32:
          n = ba;
          break;
        case 268435456:
          n = hl;
          break;
        default:
          n = ba;
      }
      return a = Fg.bind(null, t), n = Pl(n, a), t.callbackPriority = e, t.callbackNode = n, e;
    }
    return a !== null && a !== null && Wl(a), t.callbackPriority = 2, t.callbackNode = null, 2;
  }
  function Fg(t, e) {
    if (pe !== 0 && pe !== 5)
      return t.callbackNode = null, t.callbackPriority = 0, null;
    var n = t.callbackNode;
    if (yc() && t.callbackNode !== n)
      return null;
    var a = xt;
    return a = Pn(
      t,
      t === It ? a : 0,
      t.cancelPendingCommit !== null || t.timeoutHandle !== -1
    ), a === 0 ? null : (Ng(t, a, e), kg(t, ie()), t.callbackNode != null && t.callbackNode === n ? Fg.bind(null, t) : null);
  }
  function qg(t, e) {
    if (yc()) return null;
    Ng(t, e, !0);
  }
  function iv() {
    Av(function() {
      (Rt & 6) !== 0 ? Pl(
        Jl,
        lv
      ) : Ig();
    });
  }
  function _s() {
    if (Za === 0) {
      var t = Ai;
      t === 0 && (t = gl, gl <<= 1, (gl & 261888) === 0 && (gl = 256)), Za = t;
    }
    return Za;
  }
  function Kg(t) {
    return t == null || typeof t == "symbol" || typeof t == "boolean" ? null : typeof t == "function" ? t : Ma("" + t);
  }
  function Zg(t, e) {
    var n = e.ownerDocument.createElement("input");
    return n.name = e.name, n.value = e.value, t.id && n.setAttribute("form", t.id), e.parentNode.insertBefore(n, e), t = new FormData(t), n.parentNode.removeChild(n), t;
  }
  function ov(t, e, n, a, i) {
    if (e === "submit" && n && n.stateNode === i) {
      var r = Kg(
        (i[oe] || null).action
      ), f = a.submitter;
      f && (e = (e = f[oe] || null) ? Kg(e.formAction) : f.getAttribute("formAction"), e !== null && (r = e, f = null));
      var m = new zr(
        "action",
        "action",
        null,
        a,
        i
      );
      t.push({
        event: m,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (a.defaultPrevented) {
                if (Za !== 0) {
                  var A = f ? Zg(i, f) : new FormData(i);
                  ys(
                    n,
                    {
                      pending: !0,
                      data: A,
                      method: i.method,
                      action: r
                    },
                    null,
                    A
                  );
                }
              } else
                typeof r == "function" && (m.preventDefault(), A = f ? Zg(i, f) : new FormData(i), ys(
                  n,
                  {
                    pending: !0,
                    data: A,
                    method: i.method,
                    action: r
                  },
                  r,
                  A
                ));
            },
            currentTarget: i
          }
        ]
      });
    }
  }
  for (var $s = 0; $s < Uu.length; $s++) {
    var tf = Uu[$s], rv = tf.toLowerCase(), cv = tf[0].toUpperCase() + tf.slice(1);
    xn(
      rv,
      "on" + cv
    );
  }
  xn(xm, "onAnimationEnd"), xn(Nm, "onAnimationIteration"), xn(Cm, "onAnimationStart"), xn("dblclick", "onDoubleClick"), xn("focusin", "onFocus"), xn("focusout", "onBlur"), xn(Ey, "onTransitionRun"), xn(xy, "onTransitionStart"), xn(Ny, "onTransitionCancel"), xn(wm, "onTransitionEnd"), $n("onMouseEnter", ["mouseout", "mouseover"]), $n("onMouseLeave", ["mouseout", "mouseover"]), $n("onPointerEnter", ["pointerout", "pointerover"]), $n("onPointerLeave", ["pointerout", "pointerover"]), Un(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), Un(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), Un("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), Un(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), Un(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), Un(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var Go = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), uv = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Go)
  );
  function Pg(t, e) {
    e = (e & 4) !== 0;
    for (var n = 0; n < t.length; n++) {
      var a = t[n], i = a.event;
      a = a.listeners;
      t: {
        var r = void 0;
        if (e)
          for (var f = a.length - 1; 0 <= f; f--) {
            var m = a[f], A = m.instance, N = m.currentTarget;
            if (m = m.listener, A !== r && i.isPropagationStopped())
              break t;
            r = m, i.currentTarget = N;
            try {
              r(i);
            } catch (L) {
              Ur(L);
            }
            i.currentTarget = null, r = A;
          }
        else
          for (f = 0; f < a.length; f++) {
            if (m = a[f], A = m.instance, N = m.currentTarget, m = m.listener, A !== r && i.isPropagationStopped())
              break t;
            r = m, i.currentTarget = N;
            try {
              r(i);
            } catch (L) {
              Ur(L);
            }
            i.currentTarget = null, r = A;
          }
      }
    }
  }
  function Ot(t, e) {
    var n = e[ei];
    n === void 0 && (n = e[ei] = /* @__PURE__ */ new Set());
    var a = t + "__bubble";
    n.has(a) || (Wg(e, t, 2, !1), n.add(a));
  }
  function ef(t, e, n) {
    var a = 0;
    e && (a |= 4), Wg(
      n,
      t,
      a,
      e
    );
  }
  var Sc = "_reactListening" + Math.random().toString(36).slice(2);
  function nf(t) {
    if (!t[Sc]) {
      t[Sc] = !0, Nr.forEach(function(n) {
        n !== "selectionchange" && (uv.has(n) || ef(n, !1, t), ef(n, !0, t));
      });
      var e = t.nodeType === 9 ? t : t.ownerDocument;
      e === null || e[Sc] || (e[Sc] = !0, ef("selectionchange", !1, e));
    }
  }
  function Wg(t, e, n, a) {
    switch (xp(e)) {
      case 2:
        var i = jv;
        break;
      case 8:
        i = Xv;
        break;
      default:
        i = yf;
    }
    n = i.bind(
      null,
      e,
      n,
      t
    ), i = void 0, !Ou || e !== "touchstart" && e !== "touchmove" && e !== "wheel" || (i = !0), a ? i !== void 0 ? t.addEventListener(e, n, {
      capture: !0,
      passive: i
    }) : t.addEventListener(e, n, !0) : i !== void 0 ? t.addEventListener(e, n, {
      passive: i
    }) : t.addEventListener(e, n, !1);
  }
  function af(t, e, n, a, i) {
    var r = a;
    if ((e & 1) === 0 && (e & 2) === 0 && a !== null)
      t: for (; ; ) {
        if (a === null) return;
        var f = a.tag;
        if (f === 3 || f === 4) {
          var m = a.stateNode.containerInfo;
          if (m === i) break;
          if (f === 4)
            for (f = a.return; f !== null; ) {
              var A = f.tag;
              if ((A === 3 || A === 4) && f.stateNode.containerInfo === i)
                return;
              f = f.return;
            }
          for (; m !== null; ) {
            if (f = Ca(m), f === null) return;
            if (A = f.tag, A === 5 || A === 6 || A === 26 || A === 27) {
              a = r = f;
              continue t;
            }
            m = m.parentNode;
          }
        }
        a = a.return;
      }
    em(function() {
      var N = r, L = bu(n), U = [];
      t: {
        var B = Dm.get(t);
        if (B !== void 0) {
          var z = zr, _ = t;
          switch (t) {
            case "keypress":
              if (Br(n) === 0) break t;
            case "keydown":
            case "keyup":
              z = ny;
              break;
            case "focusin":
              _ = "focus", z = Nu;
              break;
            case "focusout":
              _ = "blur", z = Nu;
              break;
            case "beforeblur":
            case "afterblur":
              z = Nu;
              break;
            case "click":
              if (n.button === 2) break t;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              z = lm;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              z = k1;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              z = iy;
              break;
            case xm:
            case Nm:
            case Cm:
              z = K1;
              break;
            case wm:
              z = ry;
              break;
            case "scroll":
            case "scrollend":
              z = G1;
              break;
            case "wheel":
              z = uy;
              break;
            case "copy":
            case "cut":
            case "paste":
              z = P1;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              z = om;
              break;
            case "toggle":
            case "beforetoggle":
              z = fy;
          }
          var rt = (e & 4) !== 0, Gt = !rt && (t === "scroll" || t === "scrollend"), S = rt ? B !== null ? B + "Capture" : null : B;
          rt = [];
          for (var v = N, E; v !== null; ) {
            var R = v;
            if (E = R.stateNode, R = R.tag, R !== 5 && R !== 26 && R !== 27 || E === null || S === null || (R = uo(v, S), R != null && rt.push(
              Io(v, R, E)
            )), Gt) break;
            v = v.return;
          }
          0 < rt.length && (B = new z(
            B,
            _,
            null,
            n,
            L
          ), U.push({ event: B, listeners: rt }));
        }
      }
      if ((e & 7) === 0) {
        t: {
          if (B = t === "mouseover" || t === "pointerover", z = t === "mouseout" || t === "pointerout", B && n !== vu && (_ = n.relatedTarget || n.fromElement) && (Ca(_) || _[Na]))
            break t;
          if ((z || B) && (B = L.window === L ? L : (B = L.ownerDocument) ? B.defaultView || B.parentWindow : window, z ? (_ = n.relatedTarget || n.toElement, z = N, _ = _ ? Ca(_) : null, _ !== null && (Gt = h(_), rt = _.tag, _ !== Gt || rt !== 5 && rt !== 27 && rt !== 6) && (_ = null)) : (z = null, _ = N), z !== _)) {
            if (rt = lm, R = "onMouseLeave", S = "onMouseEnter", v = "mouse", (t === "pointerout" || t === "pointerover") && (rt = om, R = "onPointerLeave", S = "onPointerEnter", v = "pointer"), Gt = z == null ? B : Qe(z), E = _ == null ? B : Qe(_), B = new rt(
              R,
              v + "leave",
              z,
              n,
              L
            ), B.target = Gt, B.relatedTarget = E, R = null, Ca(L) === N && (rt = new rt(
              S,
              v + "enter",
              _,
              n,
              L
            ), rt.target = E, rt.relatedTarget = Gt, R = rt), Gt = R, z && _)
              e: {
                for (rt = sv, S = z, v = _, E = 0, R = S; R; R = rt(R))
                  E++;
                R = 0;
                for (var it = v; it; it = rt(it))
                  R++;
                for (; 0 < E - R; )
                  S = rt(S), E--;
                for (; 0 < R - E; )
                  v = rt(v), R--;
                for (; E--; ) {
                  if (S === v || v !== null && S === v.alternate) {
                    rt = S;
                    break e;
                  }
                  S = rt(S), v = rt(v);
                }
                rt = null;
              }
            else rt = null;
            z !== null && Jg(
              U,
              B,
              z,
              rt,
              !1
            ), _ !== null && Gt !== null && Jg(
              U,
              Gt,
              _,
              rt,
              !0
            );
          }
        }
        t: {
          if (B = N ? Qe(N) : window, z = B.nodeName && B.nodeName.toLowerCase(), z === "select" || z === "input" && B.type === "file")
            var zt = hm;
          else if (dm(B))
            if (gm)
              zt = Sy;
            else {
              zt = vy;
              var $ = yy;
            }
          else
            z = B.nodeName, !z || z.toLowerCase() !== "input" || B.type !== "checkbox" && B.type !== "radio" ? N && $t(N.elementType) && (zt = hm) : zt = by;
          if (zt && (zt = zt(t, N))) {
            mm(
              U,
              zt,
              n,
              L
            );
            break t;
          }
          $ && $(t, B, N), t === "focusout" && N && B.type === "number" && N.memoizedProps.value != null && F(B, "number", B.value);
        }
        switch ($ = N ? Qe(N) : window, t) {
          case "focusin":
            (dm($) || $.contentEditable === "true") && (ui = $, zu = N, yo = null);
            break;
          case "focusout":
            yo = zu = ui = null;
            break;
          case "mousedown":
            Lu = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Lu = !1, Tm(U, n, L);
            break;
          case "selectionchange":
            if (Ty) break;
          case "keydown":
          case "keyup":
            Tm(U, n, L);
        }
        var At;
        if (wu)
          t: {
            switch (t) {
              case "compositionstart":
                var Nt = "onCompositionStart";
                break t;
              case "compositionend":
                Nt = "onCompositionEnd";
                break t;
              case "compositionupdate":
                Nt = "onCompositionUpdate";
                break t;
            }
            Nt = void 0;
          }
        else
          ci ? sm(t, n) && (Nt = "onCompositionEnd") : t === "keydown" && n.keyCode === 229 && (Nt = "onCompositionStart");
        Nt && (rm && n.locale !== "ko" && (ci || Nt !== "onCompositionStart" ? Nt === "onCompositionEnd" && ci && (At = nm()) : (za = L, Tu = "value" in za ? za.value : za.textContent, ci = !0)), $ = Oc(N, Nt), 0 < $.length && (Nt = new im(
          Nt,
          t,
          null,
          n,
          L
        ), U.push({ event: Nt, listeners: $ }), At ? Nt.data = At : (At = fm(n), At !== null && (Nt.data = At)))), (At = my ? hy(t, n) : gy(t, n)) && (Nt = Oc(N, "onBeforeInput"), 0 < Nt.length && ($ = new im(
          "onBeforeInput",
          "beforeinput",
          null,
          n,
          L
        ), U.push({
          event: $,
          listeners: Nt
        }), $.data = At)), ov(
          U,
          t,
          N,
          n,
          L
        );
      }
      Pg(U, e);
    });
  }
  function Io(t, e, n) {
    return {
      instance: t,
      listener: e,
      currentTarget: n
    };
  }
  function Oc(t, e) {
    for (var n = e + "Capture", a = []; t !== null; ) {
      var i = t, r = i.stateNode;
      if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || r === null || (i = uo(t, n), i != null && a.unshift(
        Io(t, i, r)
      ), i = uo(t, e), i != null && a.push(
        Io(t, i, r)
      )), t.tag === 3) return a;
      t = t.return;
    }
    return [];
  }
  function sv(t) {
    if (t === null) return null;
    do
      t = t.return;
    while (t && t.tag !== 5 && t.tag !== 27);
    return t || null;
  }
  function Jg(t, e, n, a, i) {
    for (var r = e._reactName, f = []; n !== null && n !== a; ) {
      var m = n, A = m.alternate, N = m.stateNode;
      if (m = m.tag, A !== null && A === a) break;
      m !== 5 && m !== 26 && m !== 27 || N === null || (A = N, i ? (N = uo(n, r), N != null && f.unshift(
        Io(n, N, A)
      )) : i || (N = uo(n, r), N != null && f.push(
        Io(n, N, A)
      ))), n = n.return;
    }
    f.length !== 0 && t.push({ event: e, listeners: f });
  }
  var fv = /\r\n?/g, dv = /\u0000|\uFFFD/g;
  function _g(t) {
    return (typeof t == "string" ? t : "" + t).replace(fv, `
`).replace(dv, "");
  }
  function $g(t, e) {
    return e = _g(e), _g(t) === e;
  }
  function Yt(t, e, n, a, i, r) {
    switch (n) {
      case "children":
        typeof a == "string" ? e === "body" || e === "textarea" && a === "" || W(t, a) : (typeof a == "number" || typeof a == "bigint") && e !== "body" && W(t, "" + a);
        break;
      case "className":
        Ve(t, "class", a);
        break;
      case "tabIndex":
        Ve(t, "tabindex", a);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Ve(t, n, a);
        break;
      case "style":
        re(t, a, r);
        break;
      case "data":
        if (e !== "object") {
          Ve(t, "data", a);
          break;
        }
      case "src":
      case "href":
        if (a === "" && (e !== "a" || n !== "href")) {
          t.removeAttribute(n);
          break;
        }
        if (a == null || typeof a == "function" || typeof a == "symbol" || typeof a == "boolean") {
          t.removeAttribute(n);
          break;
        }
        a = Ma("" + a), t.setAttribute(n, a);
        break;
      case "action":
      case "formAction":
        if (typeof a == "function") {
          t.setAttribute(
            n,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof r == "function" && (n === "formAction" ? (e !== "input" && Yt(t, e, "name", i.name, i, null), Yt(
            t,
            e,
            "formEncType",
            i.formEncType,
            i,
            null
          ), Yt(
            t,
            e,
            "formMethod",
            i.formMethod,
            i,
            null
          ), Yt(
            t,
            e,
            "formTarget",
            i.formTarget,
            i,
            null
          )) : (Yt(t, e, "encType", i.encType, i, null), Yt(t, e, "method", i.method, i, null), Yt(t, e, "target", i.target, i, null)));
        if (a == null || typeof a == "symbol" || typeof a == "boolean") {
          t.removeAttribute(n);
          break;
        }
        a = Ma("" + a), t.setAttribute(n, a);
        break;
      case "onClick":
        a != null && (t.onclick = Zt);
        break;
      case "onScroll":
        a != null && Ot("scroll", t);
        break;
      case "onScrollEnd":
        a != null && Ot("scrollend", t);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(u(61));
          if (n = a.__html, n != null) {
            if (i.children != null) throw Error(u(60));
            t.innerHTML = n;
          }
        }
        break;
      case "multiple":
        t.multiple = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "muted":
        t.muted = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (a == null || typeof a == "function" || typeof a == "boolean" || typeof a == "symbol") {
          t.removeAttribute("xlink:href");
          break;
        }
        n = Ma("" + a), t.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          n
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        a != null && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(n, "" + a) : t.removeAttribute(n);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        a && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(n, "") : t.removeAttribute(n);
        break;
      case "capture":
      case "download":
        a === !0 ? t.setAttribute(n, "") : a !== !1 && a != null && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(n, a) : t.removeAttribute(n);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        a != null && typeof a != "function" && typeof a != "symbol" && !isNaN(a) && 1 <= a ? t.setAttribute(n, a) : t.removeAttribute(n);
        break;
      case "rowSpan":
      case "start":
        a == null || typeof a == "function" || typeof a == "symbol" || isNaN(a) ? t.removeAttribute(n) : t.setAttribute(n, a);
        break;
      case "popover":
        Ot("beforetoggle", t), Ot("toggle", t), Hn(t, "popover", a);
        break;
      case "xlinkActuate":
        En(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          a
        );
        break;
      case "xlinkArcrole":
        En(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          a
        );
        break;
      case "xlinkRole":
        En(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          a
        );
        break;
      case "xlinkShow":
        En(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          a
        );
        break;
      case "xlinkTitle":
        En(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          a
        );
        break;
      case "xlinkType":
        En(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          a
        );
        break;
      case "xmlBase":
        En(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          a
        );
        break;
      case "xmlLang":
        En(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          a
        );
        break;
      case "xmlSpace":
        En(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          a
        );
        break;
      case "is":
        Hn(t, "is", a);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (n = Ge.get(n) || n, Hn(t, n, a));
    }
  }
  function lf(t, e, n, a, i, r) {
    switch (n) {
      case "style":
        re(t, a, r);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(u(61));
          if (n = a.__html, n != null) {
            if (i.children != null) throw Error(u(60));
            t.innerHTML = n;
          }
        }
        break;
      case "children":
        typeof a == "string" ? W(t, a) : (typeof a == "number" || typeof a == "bigint") && W(t, "" + a);
        break;
      case "onScroll":
        a != null && Ot("scroll", t);
        break;
      case "onScrollEnd":
        a != null && Ot("scrollend", t);
        break;
      case "onClick":
        a != null && (t.onclick = Zt);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!Cr.hasOwnProperty(n))
          t: {
            if (n[0] === "o" && n[1] === "n" && (i = n.endsWith("Capture"), e = n.slice(2, i ? n.length - 7 : void 0), r = t[oe] || null, r = r != null ? r[n] : null, typeof r == "function" && t.removeEventListener(e, r, i), typeof a == "function")) {
              typeof r != "function" && r !== null && (n in t ? t[n] = null : t.hasAttribute(n) && t.removeAttribute(n)), t.addEventListener(e, a, i);
              break t;
            }
            n in t ? t[n] = a : a === !0 ? t.setAttribute(n, "") : Hn(t, n, a);
          }
    }
  }
  function Ne(t, e, n) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        Ot("error", t), Ot("load", t);
        var a = !1, i = !1, r;
        for (r in n)
          if (n.hasOwnProperty(r)) {
            var f = n[r];
            if (f != null)
              switch (r) {
                case "src":
                  a = !0;
                  break;
                case "srcSet":
                  i = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(u(137, e));
                default:
                  Yt(t, e, r, f, n, null);
              }
          }
        i && Yt(t, e, "srcSet", n.srcSet, n, null), a && Yt(t, e, "src", n.src, n, null);
        return;
      case "input":
        Ot("invalid", t);
        var m = r = f = i = null, A = null, N = null;
        for (a in n)
          if (n.hasOwnProperty(a)) {
            var L = n[a];
            if (L != null)
              switch (a) {
                case "name":
                  i = L;
                  break;
                case "type":
                  f = L;
                  break;
                case "checked":
                  A = L;
                  break;
                case "defaultChecked":
                  N = L;
                  break;
                case "value":
                  r = L;
                  break;
                case "defaultValue":
                  m = L;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (L != null)
                    throw Error(u(137, e));
                  break;
                default:
                  Yt(t, e, a, L, n, null);
              }
          }
        ii(
          t,
          r,
          m,
          A,
          N,
          f,
          i,
          !1
        );
        return;
      case "select":
        Ot("invalid", t), a = f = r = null;
        for (i in n)
          if (n.hasOwnProperty(i) && (m = n[i], m != null))
            switch (i) {
              case "value":
                r = m;
                break;
              case "defaultValue":
                f = m;
                break;
              case "multiple":
                a = m;
              default:
                Yt(t, e, i, m, n, null);
            }
        e = r, n = f, t.multiple = !!a, e != null ? g(t, !!a, e, !1) : n != null && g(t, !!a, n, !0);
        return;
      case "textarea":
        Ot("invalid", t), r = i = a = null;
        for (f in n)
          if (n.hasOwnProperty(f) && (m = n[f], m != null))
            switch (f) {
              case "value":
                a = m;
                break;
              case "defaultValue":
                i = m;
                break;
              case "children":
                r = m;
                break;
              case "dangerouslySetInnerHTML":
                if (m != null) throw Error(u(91));
                break;
              default:
                Yt(t, e, f, m, n, null);
            }
        q(t, a, i, r);
        return;
      case "option":
        for (A in n)
          if (n.hasOwnProperty(A) && (a = n[A], a != null))
            switch (A) {
              case "selected":
                t.selected = a && typeof a != "function" && typeof a != "symbol";
                break;
              default:
                Yt(t, e, A, a, n, null);
            }
        return;
      case "dialog":
        Ot("beforetoggle", t), Ot("toggle", t), Ot("cancel", t), Ot("close", t);
        break;
      case "iframe":
      case "object":
        Ot("load", t);
        break;
      case "video":
      case "audio":
        for (a = 0; a < Go.length; a++)
          Ot(Go[a], t);
        break;
      case "image":
        Ot("error", t), Ot("load", t);
        break;
      case "details":
        Ot("toggle", t);
        break;
      case "embed":
      case "source":
      case "link":
        Ot("error", t), Ot("load", t);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (N in n)
          if (n.hasOwnProperty(N) && (a = n[N], a != null))
            switch (N) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(u(137, e));
              default:
                Yt(t, e, N, a, n, null);
            }
        return;
      default:
        if ($t(e)) {
          for (L in n)
            n.hasOwnProperty(L) && (a = n[L], a !== void 0 && lf(
              t,
              e,
              L,
              a,
              n,
              void 0
            ));
          return;
        }
    }
    for (m in n)
      n.hasOwnProperty(m) && (a = n[m], a != null && Yt(t, e, m, a, n, null));
  }
  function mv(t, e, n, a) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var i = null, r = null, f = null, m = null, A = null, N = null, L = null;
        for (z in n) {
          var U = n[z];
          if (n.hasOwnProperty(z) && U != null)
            switch (z) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                A = U;
              default:
                a.hasOwnProperty(z) || Yt(t, e, z, null, a, U);
            }
        }
        for (var B in a) {
          var z = a[B];
          if (U = n[B], a.hasOwnProperty(B) && (z != null || U != null))
            switch (B) {
              case "type":
                r = z;
                break;
              case "name":
                i = z;
                break;
              case "checked":
                N = z;
                break;
              case "defaultChecked":
                L = z;
                break;
              case "value":
                f = z;
                break;
              case "defaultValue":
                m = z;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (z != null)
                  throw Error(u(137, e));
                break;
              default:
                z !== U && Yt(
                  t,
                  e,
                  B,
                  z,
                  a,
                  U
                );
            }
        }
        Ba(
          t,
          f,
          m,
          A,
          N,
          L,
          r,
          i
        );
        return;
      case "select":
        z = f = m = B = null;
        for (r in n)
          if (A = n[r], n.hasOwnProperty(r) && A != null)
            switch (r) {
              case "value":
                break;
              case "multiple":
                z = A;
              default:
                a.hasOwnProperty(r) || Yt(
                  t,
                  e,
                  r,
                  null,
                  a,
                  A
                );
            }
        for (i in a)
          if (r = a[i], A = n[i], a.hasOwnProperty(i) && (r != null || A != null))
            switch (i) {
              case "value":
                B = r;
                break;
              case "defaultValue":
                m = r;
                break;
              case "multiple":
                f = r;
              default:
                r !== A && Yt(
                  t,
                  e,
                  i,
                  r,
                  a,
                  A
                );
            }
        e = m, n = f, a = z, B != null ? g(t, !!n, B, !1) : !!a != !!n && (e != null ? g(t, !!n, e, !0) : g(t, !!n, n ? [] : "", !1));
        return;
      case "textarea":
        z = B = null;
        for (m in n)
          if (i = n[m], n.hasOwnProperty(m) && i != null && !a.hasOwnProperty(m))
            switch (m) {
              case "value":
                break;
              case "children":
                break;
              default:
                Yt(t, e, m, null, a, i);
            }
        for (f in a)
          if (i = a[f], r = n[f], a.hasOwnProperty(f) && (i != null || r != null))
            switch (f) {
              case "value":
                B = i;
                break;
              case "defaultValue":
                z = i;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (i != null) throw Error(u(91));
                break;
              default:
                i !== r && Yt(t, e, f, i, a, r);
            }
        w(t, B, z);
        return;
      case "option":
        for (var _ in n)
          if (B = n[_], n.hasOwnProperty(_) && B != null && !a.hasOwnProperty(_))
            switch (_) {
              case "selected":
                t.selected = !1;
                break;
              default:
                Yt(
                  t,
                  e,
                  _,
                  null,
                  a,
                  B
                );
            }
        for (A in a)
          if (B = a[A], z = n[A], a.hasOwnProperty(A) && B !== z && (B != null || z != null))
            switch (A) {
              case "selected":
                t.selected = B && typeof B != "function" && typeof B != "symbol";
                break;
              default:
                Yt(
                  t,
                  e,
                  A,
                  B,
                  a,
                  z
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var rt in n)
          B = n[rt], n.hasOwnProperty(rt) && B != null && !a.hasOwnProperty(rt) && Yt(t, e, rt, null, a, B);
        for (N in a)
          if (B = a[N], z = n[N], a.hasOwnProperty(N) && B !== z && (B != null || z != null))
            switch (N) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (B != null)
                  throw Error(u(137, e));
                break;
              default:
                Yt(
                  t,
                  e,
                  N,
                  B,
                  a,
                  z
                );
            }
        return;
      default:
        if ($t(e)) {
          for (var Gt in n)
            B = n[Gt], n.hasOwnProperty(Gt) && B !== void 0 && !a.hasOwnProperty(Gt) && lf(
              t,
              e,
              Gt,
              void 0,
              a,
              B
            );
          for (L in a)
            B = a[L], z = n[L], !a.hasOwnProperty(L) || B === z || B === void 0 && z === void 0 || lf(
              t,
              e,
              L,
              B,
              a,
              z
            );
          return;
        }
    }
    for (var S in n)
      B = n[S], n.hasOwnProperty(S) && B != null && !a.hasOwnProperty(S) && Yt(t, e, S, null, a, B);
    for (U in a)
      B = a[U], z = n[U], !a.hasOwnProperty(U) || B === z || B == null && z == null || Yt(t, e, U, B, a, z);
  }
  function tp(t) {
    switch (t) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function hv() {
    if (typeof performance.getEntriesByType == "function") {
      for (var t = 0, e = 0, n = performance.getEntriesByType("resource"), a = 0; a < n.length; a++) {
        var i = n[a], r = i.transferSize, f = i.initiatorType, m = i.duration;
        if (r && m && tp(f)) {
          for (f = 0, m = i.responseEnd, a += 1; a < n.length; a++) {
            var A = n[a], N = A.startTime;
            if (N > m) break;
            var L = A.transferSize, U = A.initiatorType;
            L && tp(U) && (A = A.responseEnd, f += L * (A < m ? 1 : (m - N) / (A - N)));
          }
          if (--a, e += 8 * (r + f) / (i.duration / 1e3), t++, 10 < t) break;
        }
      }
      if (0 < t) return e / t / 1e6;
    }
    return navigator.connection && (t = navigator.connection.downlink, typeof t == "number") ? t : 5;
  }
  var of = null, rf = null;
  function Tc(t) {
    return t.nodeType === 9 ? t : t.ownerDocument;
  }
  function ep(t) {
    switch (t) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function np(t, e) {
    if (t === 0)
      switch (e) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return t === 1 && e === "foreignObject" ? 0 : t;
  }
  function cf(t, e) {
    return t === "textarea" || t === "noscript" || typeof e.children == "string" || typeof e.children == "number" || typeof e.children == "bigint" || typeof e.dangerouslySetInnerHTML == "object" && e.dangerouslySetInnerHTML !== null && e.dangerouslySetInnerHTML.__html != null;
  }
  var uf = null;
  function gv() {
    var t = window.event;
    return t && t.type === "popstate" ? t === uf ? !1 : (uf = t, !0) : (uf = null, !1);
  }
  var ap = typeof setTimeout == "function" ? setTimeout : void 0, pv = typeof clearTimeout == "function" ? clearTimeout : void 0, lp = typeof Promise == "function" ? Promise : void 0, Av = typeof queueMicrotask == "function" ? queueMicrotask : typeof lp < "u" ? function(t) {
    return lp.resolve(null).then(t).catch(yv);
  } : ap;
  function yv(t) {
    setTimeout(function() {
      throw t;
    });
  }
  function Pa(t) {
    return t === "head";
  }
  function ip(t, e) {
    var n = e, a = 0;
    do {
      var i = n.nextSibling;
      if (t.removeChild(n), i && i.nodeType === 8)
        if (n = i.data, n === "/$" || n === "/&") {
          if (a === 0) {
            t.removeChild(i), Hi(e);
            return;
          }
          a--;
        } else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&")
          a++;
        else if (n === "html")
          ko(t.ownerDocument.documentElement);
        else if (n === "head") {
          n = t.ownerDocument.head, ko(n);
          for (var r = n.firstChild; r; ) {
            var f = r.nextSibling, m = r.nodeName;
            r[vl] || m === "SCRIPT" || m === "STYLE" || m === "LINK" && r.rel.toLowerCase() === "stylesheet" || n.removeChild(r), r = f;
          }
        } else
          n === "body" && ko(t.ownerDocument.body);
      n = i;
    } while (n);
    Hi(e);
  }
  function op(t, e) {
    var n = t;
    t = 0;
    do {
      var a = n.nextSibling;
      if (n.nodeType === 1 ? e ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (e ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), a && a.nodeType === 8)
        if (n = a.data, n === "/$") {
          if (t === 0) break;
          t--;
        } else
          n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || t++;
      n = a;
    } while (n);
  }
  function sf(t) {
    var e = t.firstChild;
    for (e && e.nodeType === 10 && (e = e.nextSibling); e; ) {
      var n = e;
      switch (e = e.nextSibling, n.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          sf(n), io(n);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (n.rel.toLowerCase() === "stylesheet") continue;
      }
      t.removeChild(n);
    }
  }
  function vv(t, e, n, a) {
    for (; t.nodeType === 1; ) {
      var i = n;
      if (t.nodeName.toLowerCase() !== e.toLowerCase()) {
        if (!a && (t.nodeName !== "INPUT" || t.type !== "hidden"))
          break;
      } else if (a) {
        if (!t[vl])
          switch (e) {
            case "meta":
              if (!t.hasAttribute("itemprop")) break;
              return t;
            case "link":
              if (r = t.getAttribute("rel"), r === "stylesheet" && t.hasAttribute("data-precedence"))
                break;
              if (r !== i.rel || t.getAttribute("href") !== (i.href == null || i.href === "" ? null : i.href) || t.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin) || t.getAttribute("title") !== (i.title == null ? null : i.title))
                break;
              return t;
            case "style":
              if (t.hasAttribute("data-precedence")) break;
              return t;
            case "script":
              if (r = t.getAttribute("src"), (r !== (i.src == null ? null : i.src) || t.getAttribute("type") !== (i.type == null ? null : i.type) || t.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin)) && r && t.hasAttribute("async") && !t.hasAttribute("itemprop"))
                break;
              return t;
            default:
              return t;
          }
      } else if (e === "input" && t.type === "hidden") {
        var r = i.name == null ? null : "" + i.name;
        if (i.type === "hidden" && t.getAttribute("name") === r)
          return t;
      } else return t;
      if (t = An(t.nextSibling), t === null) break;
    }
    return null;
  }
  function bv(t, e, n) {
    if (e === "") return null;
    for (; t.nodeType !== 3; )
      if ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") && !n || (t = An(t.nextSibling), t === null)) return null;
    return t;
  }
  function rp(t, e) {
    for (; t.nodeType !== 8; )
      if ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") && !e || (t = An(t.nextSibling), t === null)) return null;
    return t;
  }
  function ff(t) {
    return t.data === "$?" || t.data === "$~";
  }
  function df(t) {
    return t.data === "$!" || t.data === "$?" && t.ownerDocument.readyState !== "loading";
  }
  function Sv(t, e) {
    var n = t.ownerDocument;
    if (t.data === "$~") t._reactRetry = e;
    else if (t.data !== "$?" || n.readyState !== "loading")
      e();
    else {
      var a = function() {
        e(), n.removeEventListener("DOMContentLoaded", a);
      };
      n.addEventListener("DOMContentLoaded", a), t._reactRetry = a;
    }
  }
  function An(t) {
    for (; t != null; t = t.nextSibling) {
      var e = t.nodeType;
      if (e === 1 || e === 3) break;
      if (e === 8) {
        if (e = t.data, e === "$" || e === "$!" || e === "$?" || e === "$~" || e === "&" || e === "F!" || e === "F")
          break;
        if (e === "/$" || e === "/&") return null;
      }
    }
    return t;
  }
  var mf = null;
  function cp(t) {
    t = t.nextSibling;
    for (var e = 0; t; ) {
      if (t.nodeType === 8) {
        var n = t.data;
        if (n === "/$" || n === "/&") {
          if (e === 0)
            return An(t.nextSibling);
          e--;
        } else
          n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || e++;
      }
      t = t.nextSibling;
    }
    return null;
  }
  function up(t) {
    t = t.previousSibling;
    for (var e = 0; t; ) {
      if (t.nodeType === 8) {
        var n = t.data;
        if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
          if (e === 0) return t;
          e--;
        } else n !== "/$" && n !== "/&" || e++;
      }
      t = t.previousSibling;
    }
    return null;
  }
  function sp(t, e, n) {
    switch (e = Tc(n), t) {
      case "html":
        if (t = e.documentElement, !t) throw Error(u(452));
        return t;
      case "head":
        if (t = e.head, !t) throw Error(u(453));
        return t;
      case "body":
        if (t = e.body, !t) throw Error(u(454));
        return t;
      default:
        throw Error(u(451));
    }
  }
  function ko(t) {
    for (var e = t.attributes; e.length; )
      t.removeAttributeNode(e[0]);
    io(t);
  }
  var yn = /* @__PURE__ */ new Map(), fp = /* @__PURE__ */ new Set();
  function Ec(t) {
    return typeof t.getRootNode == "function" ? t.getRootNode() : t.nodeType === 9 ? t : t.ownerDocument;
  }
  var ga = Z.d;
  Z.d = {
    f: Ov,
    r: Tv,
    D: Ev,
    C: xv,
    L: Nv,
    m: Cv,
    X: Dv,
    S: wv,
    M: Bv
  };
  function Ov() {
    var t = ga.f(), e = gc();
    return t || e;
  }
  function Tv(t) {
    var e = wa(t);
    e !== null && e.tag === 5 && e.type === "form" ? wh(e) : ga.r(t);
  }
  var Li = typeof document > "u" ? null : document;
  function dp(t, e, n) {
    var a = Li;
    if (a && typeof e == "string" && e) {
      var i = Re(e);
      i = 'link[rel="' + t + '"][href="' + i + '"]', typeof n == "string" && (i += '[crossorigin="' + n + '"]'), fp.has(i) || (fp.add(i), t = { rel: t, crossOrigin: n, href: e }, a.querySelector(i) === null && (e = a.createElement("link"), Ne(e, "link", t), Kt(e), a.head.appendChild(e)));
    }
  }
  function Ev(t) {
    ga.D(t), dp("dns-prefetch", t, null);
  }
  function xv(t, e) {
    ga.C(t, e), dp("preconnect", t, e);
  }
  function Nv(t, e, n) {
    ga.L(t, e, n);
    var a = Li;
    if (a && t && e) {
      var i = 'link[rel="preload"][as="' + Re(e) + '"]';
      e === "image" && n && n.imageSrcSet ? (i += '[imagesrcset="' + Re(
        n.imageSrcSet
      ) + '"]', typeof n.imageSizes == "string" && (i += '[imagesizes="' + Re(
        n.imageSizes
      ) + '"]')) : i += '[href="' + Re(t) + '"]';
      var r = i;
      switch (e) {
        case "style":
          r = Ri(t);
          break;
        case "script":
          r = Ui(t);
      }
      yn.has(r) || (t = x(
        {
          rel: "preload",
          href: e === "image" && n && n.imageSrcSet ? void 0 : t,
          as: e
        },
        n
      ), yn.set(r, t), a.querySelector(i) !== null || e === "style" && a.querySelector(Fo(r)) || e === "script" && a.querySelector(qo(r)) || (e = a.createElement("link"), Ne(e, "link", t), Kt(e), a.head.appendChild(e)));
    }
  }
  function Cv(t, e) {
    ga.m(t, e);
    var n = Li;
    if (n && t) {
      var a = e && typeof e.as == "string" ? e.as : "script", i = 'link[rel="modulepreload"][as="' + Re(a) + '"][href="' + Re(t) + '"]', r = i;
      switch (a) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          r = Ui(t);
      }
      if (!yn.has(r) && (t = x({ rel: "modulepreload", href: t }, e), yn.set(r, t), n.querySelector(i) === null)) {
        switch (a) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (n.querySelector(qo(r)))
              return;
        }
        a = n.createElement("link"), Ne(a, "link", t), Kt(a), n.head.appendChild(a);
      }
    }
  }
  function wv(t, e, n) {
    ga.S(t, e, n);
    var a = Li;
    if (a && t) {
      var i = _n(a).hoistableStyles, r = Ri(t);
      e = e || "default";
      var f = i.get(r);
      if (!f) {
        var m = { loading: 0, preload: null };
        if (f = a.querySelector(
          Fo(r)
        ))
          m.loading = 5;
        else {
          t = x(
            { rel: "stylesheet", href: t, "data-precedence": e },
            n
          ), (n = yn.get(r)) && hf(t, n);
          var A = f = a.createElement("link");
          Kt(A), Ne(A, "link", t), A._p = new Promise(function(N, L) {
            A.onload = N, A.onerror = L;
          }), A.addEventListener("load", function() {
            m.loading |= 1;
          }), A.addEventListener("error", function() {
            m.loading |= 2;
          }), m.loading |= 4, xc(f, e, a);
        }
        f = {
          type: "stylesheet",
          instance: f,
          count: 1,
          state: m
        }, i.set(r, f);
      }
    }
  }
  function Dv(t, e) {
    ga.X(t, e);
    var n = Li;
    if (n && t) {
      var a = _n(n).hoistableScripts, i = Ui(t), r = a.get(i);
      r || (r = n.querySelector(qo(i)), r || (t = x({ src: t, async: !0 }, e), (e = yn.get(i)) && gf(t, e), r = n.createElement("script"), Kt(r), Ne(r, "link", t), n.head.appendChild(r)), r = {
        type: "script",
        instance: r,
        count: 1,
        state: null
      }, a.set(i, r));
    }
  }
  function Bv(t, e) {
    ga.M(t, e);
    var n = Li;
    if (n && t) {
      var a = _n(n).hoistableScripts, i = Ui(t), r = a.get(i);
      r || (r = n.querySelector(qo(i)), r || (t = x({ src: t, async: !0, type: "module" }, e), (e = yn.get(i)) && gf(t, e), r = n.createElement("script"), Kt(r), Ne(r, "link", t), n.head.appendChild(r)), r = {
        type: "script",
        instance: r,
        count: 1,
        state: null
      }, a.set(i, r));
    }
  }
  function mp(t, e, n, a) {
    var i = (i = ye.current) ? Ec(i) : null;
    if (!i) throw Error(u(446));
    switch (t) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof n.precedence == "string" && typeof n.href == "string" ? (e = Ri(n.href), n = _n(
          i
        ).hoistableStyles, a = n.get(e), a || (a = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, n.set(e, a)), a) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
          t = Ri(n.href);
          var r = _n(
            i
          ).hoistableStyles, f = r.get(t);
          if (f || (i = i.ownerDocument || i, f = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, r.set(t, f), (r = i.querySelector(
            Fo(t)
          )) && !r._p && (f.instance = r, f.state.loading = 5), yn.has(t) || (n = {
            rel: "preload",
            as: "style",
            href: n.href,
            crossOrigin: n.crossOrigin,
            integrity: n.integrity,
            media: n.media,
            hrefLang: n.hrefLang,
            referrerPolicy: n.referrerPolicy
          }, yn.set(t, n), r || Mv(
            i,
            t,
            n,
            f.state
          ))), e && a === null)
            throw Error(u(528, ""));
          return f;
        }
        if (e && a !== null)
          throw Error(u(529, ""));
        return null;
      case "script":
        return e = n.async, n = n.src, typeof n == "string" && e && typeof e != "function" && typeof e != "symbol" ? (e = Ui(n), n = _n(
          i
        ).hoistableScripts, a = n.get(e), a || (a = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, n.set(e, a)), a) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(u(444, t));
    }
  }
  function Ri(t) {
    return 'href="' + Re(t) + '"';
  }
  function Fo(t) {
    return 'link[rel="stylesheet"][' + t + "]";
  }
  function hp(t) {
    return x({}, t, {
      "data-precedence": t.precedence,
      precedence: null
    });
  }
  function Mv(t, e, n, a) {
    t.querySelector('link[rel="preload"][as="style"][' + e + "]") ? a.loading = 1 : (e = t.createElement("link"), a.preload = e, e.addEventListener("load", function() {
      return a.loading |= 1;
    }), e.addEventListener("error", function() {
      return a.loading |= 2;
    }), Ne(e, "link", n), Kt(e), t.head.appendChild(e));
  }
  function Ui(t) {
    return '[src="' + Re(t) + '"]';
  }
  function qo(t) {
    return "script[async]" + t;
  }
  function gp(t, e, n) {
    if (e.count++, e.instance === null)
      switch (e.type) {
        case "style":
          var a = t.querySelector(
            'style[data-href~="' + Re(n.href) + '"]'
          );
          if (a)
            return e.instance = a, Kt(a), a;
          var i = x({}, n, {
            "data-href": n.href,
            "data-precedence": n.precedence,
            href: null,
            precedence: null
          });
          return a = (t.ownerDocument || t).createElement(
            "style"
          ), Kt(a), Ne(a, "style", i), xc(a, n.precedence, t), e.instance = a;
        case "stylesheet":
          i = Ri(n.href);
          var r = t.querySelector(
            Fo(i)
          );
          if (r)
            return e.state.loading |= 4, e.instance = r, Kt(r), r;
          a = hp(n), (i = yn.get(i)) && hf(a, i), r = (t.ownerDocument || t).createElement("link"), Kt(r);
          var f = r;
          return f._p = new Promise(function(m, A) {
            f.onload = m, f.onerror = A;
          }), Ne(r, "link", a), e.state.loading |= 4, xc(r, n.precedence, t), e.instance = r;
        case "script":
          return r = Ui(n.src), (i = t.querySelector(
            qo(r)
          )) ? (e.instance = i, Kt(i), i) : (a = n, (i = yn.get(r)) && (a = x({}, n), gf(a, i)), t = t.ownerDocument || t, i = t.createElement("script"), Kt(i), Ne(i, "link", a), t.head.appendChild(i), e.instance = i);
        case "void":
          return null;
        default:
          throw Error(u(443, e.type));
      }
    else
      e.type === "stylesheet" && (e.state.loading & 4) === 0 && (a = e.instance, e.state.loading |= 4, xc(a, n.precedence, t));
    return e.instance;
  }
  function xc(t, e, n) {
    for (var a = n.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), i = a.length ? a[a.length - 1] : null, r = i, f = 0; f < a.length; f++) {
      var m = a[f];
      if (m.dataset.precedence === e) r = m;
      else if (r !== i) break;
    }
    r ? r.parentNode.insertBefore(t, r.nextSibling) : (e = n.nodeType === 9 ? n.head : n, e.insertBefore(t, e.firstChild));
  }
  function hf(t, e) {
    t.crossOrigin == null && (t.crossOrigin = e.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy), t.title == null && (t.title = e.title);
  }
  function gf(t, e) {
    t.crossOrigin == null && (t.crossOrigin = e.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy), t.integrity == null && (t.integrity = e.integrity);
  }
  var Nc = null;
  function pp(t, e, n) {
    if (Nc === null) {
      var a = /* @__PURE__ */ new Map(), i = Nc = /* @__PURE__ */ new Map();
      i.set(n, a);
    } else
      i = Nc, a = i.get(n), a || (a = /* @__PURE__ */ new Map(), i.set(n, a));
    if (a.has(t)) return a;
    for (a.set(t, null), n = n.getElementsByTagName(t), i = 0; i < n.length; i++) {
      var r = n[i];
      if (!(r[vl] || r[vt] || t === "link" && r.getAttribute("rel") === "stylesheet") && r.namespaceURI !== "http://www.w3.org/2000/svg") {
        var f = r.getAttribute(e) || "";
        f = t + f;
        var m = a.get(f);
        m ? m.push(r) : a.set(f, [r]);
      }
    }
    return a;
  }
  function Ap(t, e, n) {
    t = t.ownerDocument || t, t.head.insertBefore(
      n,
      e === "title" ? t.querySelector("head > title") : null
    );
  }
  function zv(t, e, n) {
    if (n === 1 || e.itemProp != null) return !1;
    switch (t) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof e.precedence != "string" || typeof e.href != "string" || e.href === "")
          break;
        return !0;
      case "link":
        if (typeof e.rel != "string" || typeof e.href != "string" || e.href === "" || e.onLoad || e.onError)
          break;
        switch (e.rel) {
          case "stylesheet":
            return t = e.disabled, typeof e.precedence == "string" && t == null;
          default:
            return !0;
        }
      case "script":
        if (e.async && typeof e.async != "function" && typeof e.async != "symbol" && !e.onLoad && !e.onError && e.src && typeof e.src == "string")
          return !0;
    }
    return !1;
  }
  function yp(t) {
    return !(t.type === "stylesheet" && (t.state.loading & 3) === 0);
  }
  function Lv(t, e, n, a) {
    if (n.type === "stylesheet" && (typeof a.media != "string" || matchMedia(a.media).matches !== !1) && (n.state.loading & 4) === 0) {
      if (n.instance === null) {
        var i = Ri(a.href), r = e.querySelector(
          Fo(i)
        );
        if (r) {
          e = r._p, e !== null && typeof e == "object" && typeof e.then == "function" && (t.count++, t = Cc.bind(t), e.then(t, t)), n.state.loading |= 4, n.instance = r, Kt(r);
          return;
        }
        r = e.ownerDocument || e, a = hp(a), (i = yn.get(i)) && hf(a, i), r = r.createElement("link"), Kt(r);
        var f = r;
        f._p = new Promise(function(m, A) {
          f.onload = m, f.onerror = A;
        }), Ne(r, "link", a), n.instance = r;
      }
      t.stylesheets === null && (t.stylesheets = /* @__PURE__ */ new Map()), t.stylesheets.set(n, e), (e = n.state.preload) && (n.state.loading & 3) === 0 && (t.count++, n = Cc.bind(t), e.addEventListener("load", n), e.addEventListener("error", n));
    }
  }
  var pf = 0;
  function Rv(t, e) {
    return t.stylesheets && t.count === 0 && Dc(t, t.stylesheets), 0 < t.count || 0 < t.imgCount ? function(n) {
      var a = setTimeout(function() {
        if (t.stylesheets && Dc(t, t.stylesheets), t.unsuspend) {
          var r = t.unsuspend;
          t.unsuspend = null, r();
        }
      }, 6e4 + e);
      0 < t.imgBytes && pf === 0 && (pf = 62500 * hv());
      var i = setTimeout(
        function() {
          if (t.waitingForImages = !1, t.count === 0 && (t.stylesheets && Dc(t, t.stylesheets), t.unsuspend)) {
            var r = t.unsuspend;
            t.unsuspend = null, r();
          }
        },
        (t.imgBytes > pf ? 50 : 800) + e
      );
      return t.unsuspend = n, function() {
        t.unsuspend = null, clearTimeout(a), clearTimeout(i);
      };
    } : null;
  }
  function Cc() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) Dc(this, this.stylesheets);
      else if (this.unsuspend) {
        var t = this.unsuspend;
        this.unsuspend = null, t();
      }
    }
  }
  var wc = null;
  function Dc(t, e) {
    t.stylesheets = null, t.unsuspend !== null && (t.count++, wc = /* @__PURE__ */ new Map(), e.forEach(Uv, t), wc = null, Cc.call(t));
  }
  function Uv(t, e) {
    if (!(e.state.loading & 4)) {
      var n = wc.get(t);
      if (n) var a = n.get(null);
      else {
        n = /* @__PURE__ */ new Map(), wc.set(t, n);
        for (var i = t.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), r = 0; r < i.length; r++) {
          var f = i[r];
          (f.nodeName === "LINK" || f.getAttribute("media") !== "not all") && (n.set(f.dataset.precedence, f), a = f);
        }
        a && n.set(null, a);
      }
      i = e.instance, f = i.getAttribute("data-precedence"), r = n.get(f) || a, r === a && n.set(null, i), n.set(f, i), this.count++, a = Cc.bind(this), i.addEventListener("load", a), i.addEventListener("error", a), r ? r.parentNode.insertBefore(i, r.nextSibling) : (t = t.nodeType === 9 ? t.head : t, t.insertBefore(i, t.firstChild)), e.state.loading |= 4;
    }
  }
  var Ko = {
    $$typeof: et,
    Provider: null,
    Consumer: null,
    _currentValue: st,
    _currentValue2: st,
    _threadCount: 0
  };
  function Hv(t, e, n, a, i, r, f, m, A) {
    this.tag = 1, this.containerInfo = t, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Al(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Al(0), this.hiddenUpdates = Al(null), this.identifierPrefix = a, this.onUncaughtError = i, this.onCaughtError = r, this.onRecoverableError = f, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = A, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function vp(t, e, n, a, i, r, f, m, A, N, L, U) {
    return t = new Hv(
      t,
      e,
      n,
      f,
      A,
      N,
      L,
      U,
      m
    ), e = 1, r === !0 && (e |= 24), r = _e(3, null, null, e), t.current = r, r.stateNode = t, e = Zu(), e.refCount++, t.pooledCache = e, e.refCount++, r.memoizedState = {
      element: a,
      isDehydrated: n,
      cache: e
    }, _u(r), t;
  }
  function bp(t) {
    return t ? (t = di, t) : di;
  }
  function Sp(t, e, n, a, i, r) {
    i = bp(i), a.context === null ? a.context = i : a.pendingContext = i, a = Xa(e), a.payload = { element: n }, r = r === void 0 ? null : r, r !== null && (a.callback = r), n = Qa(t, a, e), n !== null && (Ze(n, t, e), xo(n, t, e));
  }
  function Op(t, e) {
    if (t = t.memoizedState, t !== null && t.dehydrated !== null) {
      var n = t.retryLane;
      t.retryLane = n !== 0 && n < e ? n : e;
    }
  }
  function Af(t, e) {
    Op(t, e), (t = t.alternate) && Op(t, e);
  }
  function Tp(t) {
    if (t.tag === 13 || t.tag === 31) {
      var e = El(t, 67108864);
      e !== null && Ze(e, t, 67108864), Af(t, 67108864);
    }
  }
  function Ep(t) {
    if (t.tag === 13 || t.tag === 31) {
      var e = an();
      e = yl(e);
      var n = El(t, e);
      n !== null && Ze(n, t, e), Af(t, e);
    }
  }
  var Bc = !0;
  function jv(t, e, n, a) {
    var i = H.T;
    H.T = null;
    var r = Z.p;
    try {
      Z.p = 2, yf(t, e, n, a);
    } finally {
      Z.p = r, H.T = i;
    }
  }
  function Xv(t, e, n, a) {
    var i = H.T;
    H.T = null;
    var r = Z.p;
    try {
      Z.p = 8, yf(t, e, n, a);
    } finally {
      Z.p = r, H.T = i;
    }
  }
  function yf(t, e, n, a) {
    if (Bc) {
      var i = vf(a);
      if (i === null)
        af(
          t,
          e,
          a,
          Mc,
          n
        ), Np(t, a);
      else if (Vv(
        i,
        t,
        e,
        n,
        a
      ))
        a.stopPropagation();
      else if (Np(t, a), e & 4 && -1 < Qv.indexOf(t)) {
        for (; i !== null; ) {
          var r = wa(i);
          if (r !== null)
            switch (r.tag) {
              case 3:
                if (r = r.stateNode, r.current.memoizedState.isDehydrated) {
                  var f = zn(r.pendingLanes);
                  if (f !== 0) {
                    var m = r;
                    for (m.pendingLanes |= 2, m.entangledLanes |= 2; f; ) {
                      var A = 1 << 31 - Oe(f);
                      m.entanglements[1] |= A, f &= ~A;
                    }
                    Vn(r), (Rt & 6) === 0 && (mc = ie() + 500, Yo(0));
                  }
                }
                break;
              case 31:
              case 13:
                m = El(r, 2), m !== null && Ze(m, r, 2), gc(), Af(r, 2);
            }
          if (r = vf(a), r === null && af(
            t,
            e,
            a,
            Mc,
            n
          ), r === i) break;
          i = r;
        }
        i !== null && a.stopPropagation();
      } else
        af(
          t,
          e,
          a,
          null,
          n
        );
    }
  }
  function vf(t) {
    return t = bu(t), bf(t);
  }
  var Mc = null;
  function bf(t) {
    if (Mc = null, t = Ca(t), t !== null) {
      var e = h(t);
      if (e === null) t = null;
      else {
        var n = e.tag;
        if (n === 13) {
          if (t = p(e), t !== null) return t;
          t = null;
        } else if (n === 31) {
          if (t = y(e), t !== null) return t;
          t = null;
        } else if (n === 3) {
          if (e.stateNode.current.memoizedState.isDehydrated)
            return e.tag === 3 ? e.stateNode.containerInfo : null;
          t = null;
        } else e !== t && (t = null);
      }
    }
    return Mc = t, null;
  }
  function xp(t) {
    switch (t) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (_i()) {
          case Jl:
            return 2;
          case _l:
            return 8;
          case ba:
          case Sa:
            return 32;
          case hl:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var Sf = !1, Wa = null, Ja = null, _a = null, Zo = /* @__PURE__ */ new Map(), Po = /* @__PURE__ */ new Map(), $a = [], Qv = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Np(t, e) {
    switch (t) {
      case "focusin":
      case "focusout":
        Wa = null;
        break;
      case "dragenter":
      case "dragleave":
        Ja = null;
        break;
      case "mouseover":
      case "mouseout":
        _a = null;
        break;
      case "pointerover":
      case "pointerout":
        Zo.delete(e.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Po.delete(e.pointerId);
    }
  }
  function Wo(t, e, n, a, i, r) {
    return t === null || t.nativeEvent !== r ? (t = {
      blockedOn: e,
      domEventName: n,
      eventSystemFlags: a,
      nativeEvent: r,
      targetContainers: [i]
    }, e !== null && (e = wa(e), e !== null && Tp(e)), t) : (t.eventSystemFlags |= a, e = t.targetContainers, i !== null && e.indexOf(i) === -1 && e.push(i), t);
  }
  function Vv(t, e, n, a, i) {
    switch (e) {
      case "focusin":
        return Wa = Wo(
          Wa,
          t,
          e,
          n,
          a,
          i
        ), !0;
      case "dragenter":
        return Ja = Wo(
          Ja,
          t,
          e,
          n,
          a,
          i
        ), !0;
      case "mouseover":
        return _a = Wo(
          _a,
          t,
          e,
          n,
          a,
          i
        ), !0;
      case "pointerover":
        var r = i.pointerId;
        return Zo.set(
          r,
          Wo(
            Zo.get(r) || null,
            t,
            e,
            n,
            a,
            i
          )
        ), !0;
      case "gotpointercapture":
        return r = i.pointerId, Po.set(
          r,
          Wo(
            Po.get(r) || null,
            t,
            e,
            n,
            a,
            i
          )
        ), !0;
    }
    return !1;
  }
  function Cp(t) {
    var e = Ca(t.target);
    if (e !== null) {
      var n = h(e);
      if (n !== null) {
        if (e = n.tag, e === 13) {
          if (e = p(n), e !== null) {
            t.blockedOn = e, Er(t.priority, function() {
              Ep(n);
            });
            return;
          }
        } else if (e === 31) {
          if (e = y(n), e !== null) {
            t.blockedOn = e, Er(t.priority, function() {
              Ep(n);
            });
            return;
          }
        } else if (e === 3 && n.stateNode.current.memoizedState.isDehydrated) {
          t.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
          return;
        }
      }
    }
    t.blockedOn = null;
  }
  function zc(t) {
    if (t.blockedOn !== null) return !1;
    for (var e = t.targetContainers; 0 < e.length; ) {
      var n = vf(t.nativeEvent);
      if (n === null) {
        n = t.nativeEvent;
        var a = new n.constructor(
          n.type,
          n
        );
        vu = a, n.target.dispatchEvent(a), vu = null;
      } else
        return e = wa(n), e !== null && Tp(e), t.blockedOn = n, !1;
      e.shift();
    }
    return !0;
  }
  function wp(t, e, n) {
    zc(t) && n.delete(e);
  }
  function Yv() {
    Sf = !1, Wa !== null && zc(Wa) && (Wa = null), Ja !== null && zc(Ja) && (Ja = null), _a !== null && zc(_a) && (_a = null), Zo.forEach(wp), Po.forEach(wp);
  }
  function Lc(t, e) {
    t.blockedOn === e && (t.blockedOn = null, Sf || (Sf = !0, o.unstable_scheduleCallback(
      o.unstable_NormalPriority,
      Yv
    )));
  }
  var Rc = null;
  function Dp(t) {
    Rc !== t && (Rc = t, o.unstable_scheduleCallback(
      o.unstable_NormalPriority,
      function() {
        Rc === t && (Rc = null);
        for (var e = 0; e < t.length; e += 3) {
          var n = t[e], a = t[e + 1], i = t[e + 2];
          if (typeof a != "function") {
            if (bf(a || n) === null)
              continue;
            break;
          }
          var r = wa(n);
          r !== null && (t.splice(e, 3), e -= 3, ys(
            r,
            {
              pending: !0,
              data: i,
              method: n.method,
              action: a
            },
            a,
            i
          ));
        }
      }
    ));
  }
  function Hi(t) {
    function e(A) {
      return Lc(A, t);
    }
    Wa !== null && Lc(Wa, t), Ja !== null && Lc(Ja, t), _a !== null && Lc(_a, t), Zo.forEach(e), Po.forEach(e);
    for (var n = 0; n < $a.length; n++) {
      var a = $a[n];
      a.blockedOn === t && (a.blockedOn = null);
    }
    for (; 0 < $a.length && (n = $a[0], n.blockedOn === null); )
      Cp(n), n.blockedOn === null && $a.shift();
    if (n = (t.ownerDocument || t).$$reactFormReplay, n != null)
      for (a = 0; a < n.length; a += 3) {
        var i = n[a], r = n[a + 1], f = i[oe] || null;
        if (typeof r == "function")
          f || Dp(n);
        else if (f) {
          var m = null;
          if (r && r.hasAttribute("formAction")) {
            if (i = r, f = r[oe] || null)
              m = f.formAction;
            else if (bf(i) !== null) continue;
          } else m = f.action;
          typeof m == "function" ? n[a + 1] = m : (n.splice(a, 3), a -= 3), Dp(n);
        }
      }
  }
  function Bp() {
    function t(r) {
      r.canIntercept && r.info === "react-transition" && r.intercept({
        handler: function() {
          return new Promise(function(f) {
            return i = f;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function e() {
      i !== null && (i(), i = null), a || setTimeout(n, 20);
    }
    function n() {
      if (!a && !navigation.transition) {
        var r = navigation.currentEntry;
        r && r.url != null && navigation.navigate(r.url, {
          state: r.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var a = !1, i = null;
      return navigation.addEventListener("navigate", t), navigation.addEventListener("navigatesuccess", e), navigation.addEventListener("navigateerror", e), setTimeout(n, 100), function() {
        a = !0, navigation.removeEventListener("navigate", t), navigation.removeEventListener("navigatesuccess", e), navigation.removeEventListener("navigateerror", e), i !== null && (i(), i = null);
      };
    }
  }
  function Of(t) {
    this._internalRoot = t;
  }
  Uc.prototype.render = Of.prototype.render = function(t) {
    var e = this._internalRoot;
    if (e === null) throw Error(u(409));
    var n = e.current, a = an();
    Sp(n, a, t, e, null, null);
  }, Uc.prototype.unmount = Of.prototype.unmount = function() {
    var t = this._internalRoot;
    if (t !== null) {
      this._internalRoot = null;
      var e = t.containerInfo;
      Sp(t.current, 2, null, t, null, null), gc(), e[Na] = null;
    }
  };
  function Uc(t) {
    this._internalRoot = t;
  }
  Uc.prototype.unstable_scheduleHydration = function(t) {
    if (t) {
      var e = xa();
      t = { blockedOn: null, target: t, priority: e };
      for (var n = 0; n < $a.length && e !== 0 && e < $a[n].priority; n++) ;
      $a.splice(n, 0, t), n === 0 && Cp(t);
    }
  };
  var Mp = c.version;
  if (Mp !== "19.2.6")
    throw Error(
      u(
        527,
        Mp,
        "19.2.6"
      )
    );
  Z.findDOMNode = function(t) {
    var e = t._reactInternals;
    if (e === void 0)
      throw typeof t.render == "function" ? Error(u(188)) : (t = Object.keys(t).join(","), Error(u(268, t)));
    return t = M(e), t = t !== null ? C(t) : null, t = t === null ? null : t.stateNode, t;
  };
  var Gv = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: H,
    reconcilerVersion: "19.2.6"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Hc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Hc.isDisabled && Hc.supportsFiber)
      try {
        Oa = Hc.inject(
          Gv
        ), Be = Hc;
      } catch {
      }
  }
  return Jo.createRoot = function(t, e) {
    if (!d(t)) throw Error(u(299));
    var n = !1, a = "", i = Xh, r = Qh, f = Vh;
    return e != null && (e.unstable_strictMode === !0 && (n = !0), e.identifierPrefix !== void 0 && (a = e.identifierPrefix), e.onUncaughtError !== void 0 && (i = e.onUncaughtError), e.onCaughtError !== void 0 && (r = e.onCaughtError), e.onRecoverableError !== void 0 && (f = e.onRecoverableError)), e = vp(
      t,
      1,
      !1,
      null,
      null,
      n,
      a,
      null,
      i,
      r,
      f,
      Bp
    ), t[Na] = e.current, nf(t), new Of(e);
  }, Jo.hydrateRoot = function(t, e, n) {
    if (!d(t)) throw Error(u(299));
    var a = !1, i = "", r = Xh, f = Qh, m = Vh, A = null;
    return n != null && (n.unstable_strictMode === !0 && (a = !0), n.identifierPrefix !== void 0 && (i = n.identifierPrefix), n.onUncaughtError !== void 0 && (r = n.onUncaughtError), n.onCaughtError !== void 0 && (f = n.onCaughtError), n.onRecoverableError !== void 0 && (m = n.onRecoverableError), n.formState !== void 0 && (A = n.formState)), e = vp(
      t,
      1,
      !0,
      e,
      n ?? null,
      a,
      i,
      A,
      r,
      f,
      m,
      Bp
    ), e.context = bp(null), n = e.current, a = an(), a = yl(a), i = Xa(a), i.callback = null, Qa(n, i, a), n = a, e.current.lanes = n, Jn(e, n), Vn(e), t[Na] = e.current, nf(t), new Uc(e);
  }, Jo.version = "19.2.6", Jo;
}
var Up;
function _v() {
  if (Up) return Tf.exports;
  Up = 1;
  function l() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(l);
      } catch (o) {
        console.error(o);
      }
  }
  return l(), Tf.exports = Jv(), Tf.exports;
}
var a0 = _v(), Nf = { exports: {} }, _o = {};
var Hp;
function $v() {
  if (Hp) return _o;
  Hp = 1;
  var l = Symbol.for("react.transitional.element"), o = Symbol.for("react.fragment");
  function c(s, u, d) {
    var h = null;
    if (d !== void 0 && (h = "" + d), u.key !== void 0 && (h = "" + u.key), "key" in u) {
      d = {};
      for (var p in u)
        p !== "key" && (d[p] = u[p]);
    } else d = u;
    return u = d.ref, {
      $$typeof: l,
      type: s,
      key: h,
      ref: u !== void 0 ? u : null,
      props: d
    };
  }
  return _o.Fragment = o, _o.jsx = c, _o.jsxs = c, _o;
}
var jp;
function tb() {
  return jp || (jp = 1, Nf.exports = $v()), Nf.exports;
}
var b = tb();
function Xp(l, o) {
  (o == null || o > l.length) && (o = l.length);
  for (var c = 0, s = Array(o); c < o; c++) s[c] = l[c];
  return s;
}
function eb(l) {
  if (Array.isArray(l)) return l;
}
function nb(l, o) {
  var c = l == null ? null : typeof Symbol < "u" && l[Symbol.iterator] || l["@@iterator"];
  if (c != null) {
    var s, u, d, h, p = [], y = !0, T = !1;
    try {
      if (d = (c = c.call(l)).next, o !== 0) for (; !(y = (s = d.call(c)).done) && (p.push(s.value), p.length !== o); y = !0) ;
    } catch (M) {
      T = !0, u = M;
    } finally {
      try {
        if (!y && c.return != null && (h = c.return(), Object(h) !== h)) return;
      } finally {
        if (T) throw u;
      }
    }
    return p;
  }
}
function ab() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lb(l, o) {
  return eb(l) || nb(l, o) || ib(l, o) || ab();
}
function ib(l, o) {
  if (l) {
    if (typeof l == "string") return Xp(l, o);
    var c = {}.toString.call(l).slice(8, -1);
    return c === "Object" && l.constructor && (c = l.constructor.name), c === "Map" || c === "Set" ? Array.from(l) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? Xp(l, o) : void 0;
  }
}
const l0 = Object.entries, Qp = Object.setPrototypeOf, ob = Object.isFrozen, rb = Object.getPrototypeOf, cb = Object.getOwnPropertyDescriptor;
let we = Object.freeze, De = Object.seal, Yi = Object.create, i0 = typeof Reflect < "u" && Reflect, _f = i0.apply, $f = i0.construct;
we || (we = function(o) {
  return o;
});
De || (De = function(o) {
  return o;
});
_f || (_f = function(o, c) {
  for (var s = arguments.length, u = new Array(s > 2 ? s - 2 : 0), d = 2; d < s; d++)
    u[d - 2] = arguments[d];
  return o.apply(c, u);
});
$f || ($f = function(o) {
  for (var c = arguments.length, s = new Array(c > 1 ? c - 1 : 0), u = 1; u < c; u++)
    s[u - 1] = arguments[u];
  return new o(...s);
});
const $o = ge(Array.prototype.forEach), ub = ge(Array.prototype.lastIndexOf), Vp = ge(Array.prototype.pop), ji = ge(Array.prototype.push), sb = ge(Array.prototype.splice), il = Array.isArray, ir = ge(String.prototype.toLowerCase), Cf = ge(String.prototype.toString), Yp = ge(String.prototype.match), tr = ge(String.prototype.replace), Gp = ge(String.prototype.indexOf), fb = ge(String.prototype.trim), db = ge(Number.prototype.toString), mb = ge(Boolean.prototype.toString), Ip = typeof BigInt > "u" ? null : ge(BigInt.prototype.toString), kp = typeof Symbol > "u" ? null : ge(Symbol.prototype.toString), Se = ge(Object.prototype.hasOwnProperty), er = ge(Object.prototype.toString), Ce = ge(RegExp.prototype.test), jl = hb(TypeError);
function ge(l) {
  return function(o) {
    o instanceof RegExp && (o.lastIndex = 0);
    for (var c = arguments.length, s = new Array(c > 1 ? c - 1 : 0), u = 1; u < c; u++)
      s[u - 1] = arguments[u];
    return _f(l, o, s);
  };
}
function hb(l) {
  return function() {
    for (var o = arguments.length, c = new Array(o), s = 0; s < o; s++)
      c[s] = arguments[s];
    return $f(l, c);
  };
}
function Bt(l, o) {
  let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ir;
  if (Qp && Qp(l, null), !il(o))
    return l;
  let s = o.length;
  for (; s--; ) {
    let u = o[s];
    if (typeof u == "string") {
      const d = c(u);
      d !== u && (ob(o) || (o[s] = d), u = d);
    }
    l[u] = !0;
  }
  return l;
}
function gb(l) {
  for (let o = 0; o < l.length; o++)
    Se(l, o) || (l[o] = null);
  return l;
}
function He(l) {
  const o = Yi(null);
  for (const s of l0(l)) {
    var c = lb(s, 2);
    const u = c[0], d = c[1];
    Se(l, u) && (il(d) ? o[u] = gb(d) : d && typeof d == "object" && d.constructor === Object ? o[u] = He(d) : o[u] = d);
  }
  return o;
}
function pb(l) {
  switch (typeof l) {
    case "string":
      return l;
    case "number":
      return db(l);
    case "boolean":
      return mb(l);
    case "bigint":
      return Ip ? Ip(l) : "0";
    case "symbol":
      return kp ? kp(l) : "Symbol()";
    case "undefined":
      return er(l);
    case "function":
    case "object": {
      if (l === null)
        return er(l);
      const o = l, c = Gn(o, "toString");
      if (typeof c == "function") {
        const s = c(o);
        return typeof s == "string" ? s : er(s);
      }
      return er(l);
    }
    default:
      return er(l);
  }
}
function Gn(l, o) {
  for (; l !== null; ) {
    const s = cb(l, o);
    if (s) {
      if (s.get)
        return ge(s.get);
      if (typeof s.value == "function")
        return ge(s.value);
    }
    l = rb(l);
  }
  function c() {
    return null;
  }
  return c;
}
function Ab(l) {
  try {
    return Ce(l, ""), !0;
  } catch {
    return !1;
  }
}
const Fp = we(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), wf = we(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Df = we(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), yb = we(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Bf = we(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), vb = we(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), qp = we(["#text"]), Kp = we(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Mf = we(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Zp = we(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), jc = we(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), bb = De(/{{[\w\W]*|^[\w\W]*}}/g), Sb = De(/<%[\w\W]*|^[\w\W]*%>/g), Ob = De(/\${[\w\W]*/g), Tb = De(/^data-[\-\w.\u00B7-\uFFFF]+$/), Eb = De(/^aria-[\-\w]+$/), Pp = De(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), xb = De(/^(?:\w+script|data):/i), Nb = De(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Cb = De(/^html$/i), wb = De(/^[a-z][.\w]*(-[.\w]+)+$/i), Wp = De(/<[/\w!]/g), Db = De(/<[/\w]/g), Bb = De(/<\/no(script|embed|frames)/i), Mb = De(/\/>/i), Yn = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, zb = function() {
  return typeof window > "u" ? null : window;
}, Lb = function(o, c) {
  if (typeof o != "object" || typeof o.createPolicy != "function")
    return null;
  let s = null;
  const u = "data-tt-policy-suffix";
  c && c.hasAttribute(u) && (s = c.getAttribute(u));
  const d = "dompurify" + (s ? "#" + s : "");
  try {
    return o.createPolicy(d, {
      createHTML(h) {
        return h;
      },
      createScriptURL(h) {
        return h;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + d + " could not be created."), null;
  }
}, Jp = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, el = function(o, c, s, u) {
  return Se(o, c) && il(o[c]) ? Bt(u.base ? He(u.base) : {}, o[c], u.transform) : s;
};
function o0() {
  let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : zb();
  const o = (F) => o0(F);
  if (o.version = "3.4.11", o.removed = [], !l || !l.document || l.document.nodeType !== Yn.document || !l.Element)
    return o.isSupported = !1, o;
  let c = l.document;
  const s = c, u = s.currentScript;
  l.DocumentFragment;
  const d = l.HTMLTemplateElement, h = l.Node, p = l.Element, y = l.NodeFilter, T = l.NamedNodeMap;
  T === void 0 && (l.NamedNodeMap || l.MozNamedAttrMap), l.HTMLFormElement;
  const M = l.DOMParser, C = l.trustedTypes, x = p.prototype, J = Gn(x, "cloneNode"), j = Gn(x, "remove"), I = Gn(x, "nextSibling"), k = Gn(x, "childNodes"), K = Gn(x, "parentNode"), X = Gn(x, "shadowRoot"), tt = Gn(x, "attributes"), et = h && h.prototype ? Gn(h.prototype, "nodeType") : null, lt = h && h.prototype ? Gn(h.prototype, "nodeName") : null;
  if (typeof d == "function") {
    const F = c.createElement("template");
    F.content && F.content.ownerDocument && (c = F.content.ownerDocument);
  }
  let Q, G = "", P, Dt = !1, ot = 0;
  const dt = function() {
    if (ot > 0)
      throw jl('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, yt = function(g) {
    dt(), ot++;
    try {
      return Q.createHTML(g);
    } finally {
      ot--;
    }
  }, Tt = function(g) {
    dt(), ot++;
    try {
      return Q.createScriptURL(g);
    } finally {
      ot--;
    }
  }, ne = function() {
    return Dt || (P = Lb(C, u), Dt = !0), P;
  }, kt = c, V = kt.implementation, H = kt.createNodeIterator, Z = kt.createDocumentFragment, st = kt.getElementsByTagName, ht = s.importNode;
  let ft = Jp();
  o.isSupported = typeof l0 == "function" && typeof K == "function" && V && V.createHTMLDocument !== void 0;
  const Mt = bb, gt = Sb, at = Ob, ct = Tb, Le = Eb, ye = xb, On = Nb, Tn = wb;
  let ve = Pp, Ft = null;
  const fl = Bt({}, [...Fp, ...wf, ...Df, ...Bf, ...qp]);
  let qt = null;
  const Wi = Bt({}, [...Kp, ...Mf, ...Zp, ...jc]);
  let jt = Object.seal(Yi(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Zn = null, Zl = null;
  const Bn = Object.seal(Yi(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Ji = !0, dl = !0, Pl = !1, Wl = !0, Mn = !1, ml = !0, ie = !1, _i = !1, Jl = null, _l = null, ba = !1, Sa = !1, hl = !1, $l = !1, Tr = !0, Oa = !1;
  const Be = "user-content-";
  let cn = !0, Oe = !1, Ta = {}, un = null;
  const $i = Bt({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let gl = null;
  const pl = Bt({}, ["audio", "video", "img", "source", "image", "track"]);
  let Ea = null;
  const zn = Bt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Pn = "http://www.w3.org/1998/Math/MathML", Ln = "http://www.w3.org/2000/svg", sn = "http://www.w3.org/1999/xhtml";
  let Wn = sn, Al = !1, Jn = null;
  const Au = Bt({}, [Pn, Ln, sn], Cf), to = we(["mi", "mo", "mn", "ms", "mtext"]);
  let ti = Bt({}, to);
  const eo = we(["annotation-xml"]);
  let yl = Bt({}, eo);
  const no = Bt({}, ["title", "style", "font", "a", "script"]);
  let xa = null;
  const Er = ["application/xhtml+xml", "text/html"], Rn = "text/html";
  let vt = null, oe = null;
  const Na = c.createElement("form"), ei = function(g) {
    return g instanceof RegExp || g instanceof Function;
  }, ao = function() {
    let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (oe && oe === g)
      return;
    (!g || typeof g != "object") && (g = {}), g = He(g), xa = // eslint-disable-next-line unicorn/prefer-includes
    Er.indexOf(g.PARSER_MEDIA_TYPE) === -1 ? Rn : g.PARSER_MEDIA_TYPE, vt = xa === "application/xhtml+xml" ? Cf : ir, Ft = el(g, "ALLOWED_TAGS", fl, {
      transform: vt
    }), qt = el(g, "ALLOWED_ATTR", Wi, {
      transform: vt
    }), Jn = el(g, "ALLOWED_NAMESPACES", Au, {
      transform: Cf
    }), Ea = el(g, "ADD_URI_SAFE_ATTR", zn, {
      transform: vt,
      base: zn
    }), gl = el(g, "ADD_DATA_URI_TAGS", pl, {
      transform: vt,
      base: pl
    }), un = el(g, "FORBID_CONTENTS", $i, {
      transform: vt
    }), Zn = el(g, "FORBID_TAGS", He({}), {
      transform: vt
    }), Zl = el(g, "FORBID_ATTR", He({}), {
      transform: vt
    }), Ta = Se(g, "USE_PROFILES") ? g.USE_PROFILES && typeof g.USE_PROFILES == "object" ? He(g.USE_PROFILES) : g.USE_PROFILES : !1, Ji = g.ALLOW_ARIA_ATTR !== !1, dl = g.ALLOW_DATA_ATTR !== !1, Pl = g.ALLOW_UNKNOWN_PROTOCOLS || !1, Wl = g.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Mn = g.SAFE_FOR_TEMPLATES || !1, ml = g.SAFE_FOR_XML !== !1, ie = g.WHOLE_DOCUMENT || !1, Sa = g.RETURN_DOM || !1, hl = g.RETURN_DOM_FRAGMENT || !1, $l = g.RETURN_TRUSTED_TYPE || !1, ba = g.FORCE_BODY || !1, Tr = g.SANITIZE_DOM !== !1, Oa = g.SANITIZE_NAMED_PROPS || !1, cn = g.KEEP_CONTENT !== !1, Oe = g.IN_PLACE || !1, ve = Ab(g.ALLOWED_URI_REGEXP) ? g.ALLOWED_URI_REGEXP : Pp, Wn = typeof g.NAMESPACE == "string" ? g.NAMESPACE : sn, ti = Se(g, "MATHML_TEXT_INTEGRATION_POINTS") && g.MATHML_TEXT_INTEGRATION_POINTS && typeof g.MATHML_TEXT_INTEGRATION_POINTS == "object" ? He(g.MATHML_TEXT_INTEGRATION_POINTS) : Bt({}, to), yl = Se(g, "HTML_INTEGRATION_POINTS") && g.HTML_INTEGRATION_POINTS && typeof g.HTML_INTEGRATION_POINTS == "object" ? He(g.HTML_INTEGRATION_POINTS) : Bt({}, eo);
    const w = Se(g, "CUSTOM_ELEMENT_HANDLING") && g.CUSTOM_ELEMENT_HANDLING && typeof g.CUSTOM_ELEMENT_HANDLING == "object" ? He(g.CUSTOM_ELEMENT_HANDLING) : Yi(null);
    if (jt = Yi(null), Se(w, "tagNameCheck") && ei(w.tagNameCheck) && (jt.tagNameCheck = w.tagNameCheck), Se(w, "attributeNameCheck") && ei(w.attributeNameCheck) && (jt.attributeNameCheck = w.attributeNameCheck), Se(w, "allowCustomizedBuiltInElements") && typeof w.allowCustomizedBuiltInElements == "boolean" && (jt.allowCustomizedBuiltInElements = w.allowCustomizedBuiltInElements), De(jt), Mn && (dl = !1), hl && (Sa = !0), Ta && (Ft = Bt({}, qp), qt = Yi(null), Ta.html === !0 && (Bt(Ft, Fp), Bt(qt, Kp)), Ta.svg === !0 && (Bt(Ft, wf), Bt(qt, Mf), Bt(qt, jc)), Ta.svgFilters === !0 && (Bt(Ft, Df), Bt(qt, Mf), Bt(qt, jc)), Ta.mathMl === !0 && (Bt(Ft, Bf), Bt(qt, Zp), Bt(qt, jc))), Bn.tagCheck = null, Bn.attributeCheck = null, Se(g, "ADD_TAGS") && (typeof g.ADD_TAGS == "function" ? Bn.tagCheck = g.ADD_TAGS : il(g.ADD_TAGS) && (Ft === fl && (Ft = He(Ft)), Bt(Ft, g.ADD_TAGS, vt))), Se(g, "ADD_ATTR") && (typeof g.ADD_ATTR == "function" ? Bn.attributeCheck = g.ADD_ATTR : il(g.ADD_ATTR) && (qt === Wi && (qt = He(qt)), Bt(qt, g.ADD_ATTR, vt))), Se(g, "ADD_URI_SAFE_ATTR") && il(g.ADD_URI_SAFE_ATTR) && Bt(Ea, g.ADD_URI_SAFE_ATTR, vt), Se(g, "FORBID_CONTENTS") && il(g.FORBID_CONTENTS) && (un === $i && (un = He(un)), Bt(un, g.FORBID_CONTENTS, vt)), Se(g, "ADD_FORBID_CONTENTS") && il(g.ADD_FORBID_CONTENTS) && (un === $i && (un = He(un)), Bt(un, g.ADD_FORBID_CONTENTS, vt)), cn && (Ft["#text"] = !0), ie && Bt(Ft, ["html", "head", "body"]), Ft.table && (Bt(Ft, ["tbody"]), delete Zn.tbody), g.TRUSTED_TYPES_POLICY) {
      if (typeof g.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw jl('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof g.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw jl('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const q = Q;
      Q = g.TRUSTED_TYPES_POLICY;
      try {
        G = yt("");
      } catch (W) {
        throw Q = q, W;
      }
    } else g.TRUSTED_TYPES_POLICY === null ? (Q = void 0, G = "") : (Q === void 0 && (Q = ne()), Q && typeof G == "string" && (G = yt("")));
    we && we(g), oe = g;
  }, xr = Bt({}, [...wf, ...Df, ...yb]), lo = Bt({}, [...Bf, ...vb]), vl = function(g, w, q) {
    return w.namespaceURI === sn ? g === "svg" : w.namespaceURI === Pn ? g === "svg" && (q === "annotation-xml" || ti[q]) : !!xr[g];
  }, io = function(g, w, q) {
    return w.namespaceURI === sn ? g === "math" : w.namespaceURI === Ln ? g === "math" && yl[q] : !!lo[g];
  }, Ca = function(g, w, q) {
    return w.namespaceURI === Ln && !yl[q] || w.namespaceURI === Pn && !ti[q] ? !1 : !lo[g] && (no[g] || !xr[g]);
  }, wa = function(g) {
    let w = K(g);
    (!w || !w.tagName) && (w = {
      namespaceURI: Wn,
      tagName: "template"
    });
    const q = ir(g.tagName), W = ir(w.tagName);
    return Jn[g.namespaceURI] ? g.namespaceURI === Ln ? vl(q, w, W) : g.namespaceURI === Pn ? io(q, w, W) : g.namespaceURI === sn ? Ca(q, w, W) : !!(xa === "application/xhtml+xml" && Jn[g.namespaceURI]) : !1;
  }, Qe = function(g) {
    ji(o.removed, {
      element: g
    });
    try {
      K(g).removeChild(g);
    } catch {
      if (j(g), !K(g))
        throw jl("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, _n = function(g) {
    const w = k(g);
    if (w) {
      const W = [];
      $o(w, (pt) => {
        ji(W, pt);
      }), $o(W, (pt) => {
        try {
          j(pt);
        } catch {
        }
      });
    }
    const q = tt(g);
    if (q)
      for (let W = q.length - 1; W >= 0; --W) {
        const pt = q[W], Et = pt && pt.name;
        if (typeof Et == "string")
          try {
            g.removeAttribute(Et);
          } catch {
          }
      }
  }, Kt = function(g, w) {
    try {
      ji(o.removed, {
        attribute: w.getAttributeNode(g),
        from: w
      });
    } catch {
      ji(o.removed, {
        attribute: null,
        from: w
      });
    }
    if (w.removeAttribute(g), g === "is")
      if (Sa || hl)
        try {
          Qe(w);
        } catch {
        }
      else
        try {
          w.setAttribute(g, "");
        } catch {
        }
  }, Nr = function(g) {
    const w = tt(g);
    if (w)
      for (let q = w.length - 1; q >= 0; --q) {
        const W = w[q], pt = W && W.name;
        if (!(typeof pt != "string" || qt[vt(pt)]))
          try {
            g.removeAttribute(pt);
          } catch {
          }
      }
  }, Cr = function(g) {
    const w = [g];
    for (; w.length > 0; ) {
      const q = w.pop();
      (et ? et(q) : q.nodeType) === Yn.element && Nr(q);
      const pt = k(q);
      if (pt)
        for (let Et = pt.length - 1; Et >= 0; --Et)
          w.push(pt[Et]);
    }
  }, Un = function(g) {
    let w = null, q = null;
    if (ba)
      g = "<remove></remove>" + g;
    else {
      const Et = Yp(g, /^[\r\n\t ]+/);
      q = Et && Et[0];
    }
    xa === "application/xhtml+xml" && Wn === sn && (g = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + g + "</body></html>");
    const W = Q ? yt(g) : g;
    if (Wn === sn)
      try {
        w = new M().parseFromString(W, xa);
      } catch {
      }
    if (!w || !w.documentElement) {
      w = V.createDocument(Wn, "template", null);
      try {
        w.documentElement.innerHTML = Al ? G : W;
      } catch {
      }
    }
    const pt = w.body || w.documentElement;
    return g && q && pt.insertBefore(c.createTextNode(q), pt.childNodes[0] || null), Wn === sn ? st.call(w, ie ? "html" : "body")[0] : ie ? w.documentElement : pt;
  }, $n = function(g) {
    return H.call(
      g.ownerDocument || g,
      g,
      // eslint-disable-next-line no-bitwise
      y.SHOW_ELEMENT | y.SHOW_COMMENT | y.SHOW_TEXT | y.SHOW_PROCESSING_INSTRUCTION | y.SHOW_CDATA_SECTION,
      null
    );
  }, ni = function(g) {
    return g = tr(g, Mt, " "), g = tr(g, gt, " "), g = tr(g, at, " "), g;
  }, ai = function(g) {
    var w;
    g.normalize();
    const q = H.call(
      g.ownerDocument || g,
      g,
      // eslint-disable-next-line no-bitwise
      y.SHOW_TEXT | y.SHOW_COMMENT | y.SHOW_CDATA_SECTION | y.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let W = q.nextNode();
    for (; W; )
      W.data = ni(W.data), W = q.nextNode();
    const pt = (w = g.querySelectorAll) === null || w === void 0 ? void 0 : w.call(g, "template");
    pt && $o(pt, (Et) => {
      Da(Et.content) && ai(Et.content);
    });
  }, bl = function(g) {
    const w = lt ? lt(g) : null;
    return typeof w != "string" || vt(w) !== "form" ? !1 : typeof g.nodeName != "string" || typeof g.textContent != "string" || typeof g.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    g.attributes !== tt(g) || typeof g.removeAttribute != "function" || typeof g.setAttribute != "function" || typeof g.namespaceURI != "string" || typeof g.insertBefore != "function" || typeof g.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    g.nodeType !== et(g) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    g.childNodes !== k(g);
  }, Da = function(g) {
    if (!et || typeof g != "object" || g === null)
      return !1;
    try {
      return et(g) === Yn.documentFragment;
    } catch {
      return !1;
    }
  }, Hn = function(g) {
    if (!et || typeof g != "object" || g === null)
      return !1;
    try {
      return typeof et(g) == "number";
    } catch {
      return !1;
    }
  };
  function Ve(F, g, w) {
    F.length !== 0 && $o(F, (q) => {
      q.call(o, g, w, oe);
    });
  }
  const En = function(g, w) {
    return !!(ml && g.hasChildNodes() && !Hn(g.firstElementChild) && Ce(Wp, g.textContent) && Ce(Wp, g.innerHTML) || ml && g.namespaceURI === sn && w === "style" && Hn(g.firstElementChild) || g.nodeType === Yn.processingInstruction || ml && g.nodeType === Yn.comment && Ce(Db, g.data));
  }, Ye = function(g, w) {
    if (!Zn[w] && co(w) && (jt.tagNameCheck instanceof RegExp && Ce(jt.tagNameCheck, w) || jt.tagNameCheck instanceof Function && jt.tagNameCheck(w)))
      return !1;
    if (cn && !un[w]) {
      const q = K(g), W = k(g);
      if (W && q) {
        const pt = W.length;
        for (let Et = pt - 1; Et >= 0; --Et) {
          const re = Oe ? W[Et] : J(W[Et], !0);
          q.insertBefore(re, I(g));
        }
      }
    }
    return Qe(g), !0;
  }, oo = function(g) {
    if (Ve(ft.beforeSanitizeElements, g, null), bl(g))
      return Qe(g), !0;
    const w = vt(lt ? lt(g) : g.nodeName);
    if (Ve(ft.uponSanitizeElement, g, {
      tagName: w,
      allowedTags: Ft
    }), En(g, w))
      return Qe(g), !0;
    if (Zn[w] || !(Bn.tagCheck instanceof Function && Bn.tagCheck(w)) && !Ft[w])
      return Ye(g, w);
    if ((et ? et(g) : g.nodeType) === Yn.element && !wa(g) || (w === "noscript" || w === "noembed" || w === "noframes") && Ce(Bb, g.innerHTML))
      return Qe(g), !0;
    if (Mn && g.nodeType === Yn.text) {
      const W = ni(g.textContent);
      g.textContent !== W && (ji(o.removed, {
        element: g.cloneNode()
      }), g.textContent = W);
    }
    return Ve(ft.afterSanitizeElements, g, null), !1;
  }, wr = function(g, w, q) {
    if (Zl[w] || Tr && (w === "id" || w === "name") && (q in c || q in Na))
      return !1;
    const W = qt[w] || Bn.attributeCheck instanceof Function && Bn.attributeCheck(w, g);
    if (!(dl && Ce(ct, w))) {
      if (!(Ji && Ce(Le, w))) {
        if (W) {
          if (!Ea[w]) {
            if (!Ce(ve, tr(q, On, ""))) {
              if (!((w === "src" || w === "xlink:href" || w === "href") && g !== "script" && Gp(q, "data:") === 0 && gl[g])) {
                if (!(Pl && !Ce(ye, tr(q, On, "")))) {
                  if (q)
                    return !1;
                }
              }
            }
          }
        } else if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(co(g) && (jt.tagNameCheck instanceof RegExp && Ce(jt.tagNameCheck, g) || jt.tagNameCheck instanceof Function && jt.tagNameCheck(g)) && (jt.attributeNameCheck instanceof RegExp && Ce(jt.attributeNameCheck, w) || jt.attributeNameCheck instanceof Function && jt.attributeNameCheck(w, g)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          w === "is" && jt.allowCustomizedBuiltInElements && (jt.tagNameCheck instanceof RegExp && Ce(jt.tagNameCheck, q) || jt.tagNameCheck instanceof Function && jt.tagNameCheck(q)))
        ) return !1;
      }
    }
    return !0;
  }, ro = Bt({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), co = function(g) {
    return !ro[ir(g)] && Ce(Tn, g);
  }, li = function(g, w, q, W) {
    if (Q && typeof C == "object" && typeof C.getAttributeType == "function" && !q)
      switch (C.getAttributeType(g, w)) {
        case "TrustedHTML":
          return yt(W);
        case "TrustedScriptURL":
          return Tt(W);
      }
    return W;
  }, yu = function(g, w, q, W) {
    try {
      q ? g.setAttributeNS(q, w, W) : g.setAttribute(w, W), bl(g) ? Qe(g) : Vp(o.removed);
    } catch {
      Kt(w, g);
    }
  }, Re = function(g) {
    Ve(ft.beforeSanitizeAttributes, g, null);
    const w = g.attributes;
    if (!w || bl(g))
      return;
    const q = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: qt,
      forceKeepAttr: void 0
    };
    let W = w.length;
    const pt = vt(g.nodeName);
    for (; W--; ) {
      const Et = w[W], re = Et.name, $t = Et.namespaceURI, Ge = Et.value, We = vt(re), Ma = Ge;
      let Zt = re === "value" ? Ma : fb(Ma);
      if (q.attrName = We, q.attrValue = Zt, q.keepAttr = !0, q.forceKeepAttr = void 0, Ve(ft.uponSanitizeAttribute, g, q), Zt = q.attrValue, Oa && (We === "id" || We === "name") && Gp(Zt, Be) !== 0 && (Kt(re, g), Zt = Be + Zt), ml && Ce(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Zt)) {
        Kt(re, g);
        continue;
      }
      if (We === "attributename" && Yp(Zt, "href")) {
        Kt(re, g);
        continue;
      }
      if (!q.forceKeepAttr) {
        if (!q.keepAttr) {
          Kt(re, g);
          continue;
        }
        if (!Wl && Ce(Mb, Zt)) {
          Kt(re, g);
          continue;
        }
        if (Mn && (Zt = ni(Zt)), !wr(pt, We, Zt)) {
          Kt(re, g);
          continue;
        }
        Zt = li(pt, We, $t, Zt), Zt !== Ma && yu(g, re, $t, Zt);
      }
    }
    Ve(ft.afterSanitizeAttributes, g, null);
  }, Ba = function(g) {
    let w = null;
    const q = $n(g);
    for (Ve(ft.beforeSanitizeShadowDOM, g, null); w = q.nextNode(); )
      if (Ve(ft.uponSanitizeShadowNode, w, null), oo(w), Re(w), Da(w.content) && Ba(w.content), (et ? et(w) : w.nodeType) === Yn.element) {
        const pt = X(w);
        Da(pt) && (ii(pt), Ba(pt));
      }
    Ve(ft.afterSanitizeShadowDOM, g, null);
  }, ii = function(g) {
    const w = [{
      node: g,
      shadow: null
    }];
    for (; w.length > 0; ) {
      const q = w.pop();
      if (q.shadow) {
        Ba(q.shadow);
        continue;
      }
      const W = q.node, Et = (et ? et(W) : W.nodeType) === Yn.element, re = k(W);
      if (re)
        for (let $t = re.length - 1; $t >= 0; --$t)
          w.push({
            node: re[$t],
            shadow: null
          });
      if (Et) {
        const $t = lt ? lt(W) : null;
        if (typeof $t == "string" && vt($t) === "template") {
          const Ge = W.content;
          Da(Ge) && w.push({
            node: Ge,
            shadow: null
          });
        }
      }
      if (Et) {
        const $t = X(W);
        Da($t) && w.push({
          node: null,
          shadow: $t
        }, {
          node: $t,
          shadow: null
        });
      }
    }
  };
  return o.sanitize = function(F) {
    let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = null, q = null, W = null, pt = null;
    if (Al = !F, Al && (F = "<!-->"), typeof F != "string" && !Hn(F) && (F = pb(F), typeof F != "string"))
      throw jl("dirty is not a string, aborting");
    if (!o.isSupported)
      return F;
    _i ? (Ft = Jl, qt = _l) : ao(g), (ft.uponSanitizeElement.length > 0 || ft.uponSanitizeAttribute.length > 0) && (Ft = He(Ft)), ft.uponSanitizeAttribute.length > 0 && (qt = He(qt)), o.removed = [];
    const Et = Oe && typeof F != "string" && Hn(F);
    if (Et) {
      const Ge = lt ? lt(F) : F.nodeName;
      if (typeof Ge == "string") {
        const We = vt(Ge);
        if (!Ft[We] || Zn[We])
          throw jl("root node is forbidden and cannot be sanitized in-place");
      }
      if (bl(F))
        throw jl("root node is clobbered and cannot be sanitized in-place");
      try {
        ii(F);
      } catch (We) {
        throw _n(F), We;
      }
    } else if (Hn(F))
      w = Un("<!---->"), q = w.ownerDocument.importNode(F, !0), q.nodeType === Yn.element && q.nodeName === "BODY" || q.nodeName === "HTML" ? w = q : w.appendChild(q), ii(q);
    else {
      if (!Sa && !Mn && !ie && // eslint-disable-next-line unicorn/prefer-includes
      F.indexOf("<") === -1)
        return Q && $l ? yt(F) : F;
      if (w = Un(F), !w)
        return Sa ? null : $l ? G : "";
    }
    w && ba && Qe(w.firstChild);
    const re = $n(Et ? F : w);
    try {
      for (; W = re.nextNode(); )
        oo(W), Re(W), Da(W.content) && Ba(W.content);
    } catch (Ge) {
      throw Et && _n(F), Ge;
    }
    if (Et)
      return $o(o.removed, (Ge) => {
        Ge.element && Cr(Ge.element);
      }), Mn && ai(F), F;
    if (Sa) {
      if (Mn && ai(w), hl)
        for (pt = Z.call(w.ownerDocument); w.firstChild; )
          pt.appendChild(w.firstChild);
      else
        pt = w;
      return (qt.shadowroot || qt.shadowrootmode) && (pt = ht.call(s, pt, !0)), pt;
    }
    let $t = ie ? w.outerHTML : w.innerHTML;
    return ie && Ft["!doctype"] && w.ownerDocument && w.ownerDocument.doctype && w.ownerDocument.doctype.name && Ce(Cb, w.ownerDocument.doctype.name) && ($t = "<!DOCTYPE " + w.ownerDocument.doctype.name + `>
` + $t), Mn && ($t = ni($t)), Q && $l ? yt($t) : $t;
  }, o.setConfig = function() {
    let F = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ao(F), _i = !0, Jl = Ft, _l = qt;
  }, o.clearConfig = function() {
    oe = null, _i = !1, Jl = null, _l = null, Q = P, G = "";
  }, o.isValidAttribute = function(F, g, w) {
    oe || ao({});
    const q = vt(F), W = vt(g);
    return wr(q, W, w);
  }, o.addHook = function(F, g) {
    typeof g == "function" && Se(ft, F) && ji(ft[F], g);
  }, o.removeHook = function(F, g) {
    if (Se(ft, F)) {
      if (g !== void 0) {
        const w = ub(ft[F], g);
        return w === -1 ? void 0 : sb(ft[F], w, 1)[0];
      }
      return Vp(ft[F]);
    }
  }, o.removeHooks = function(F) {
    Se(ft, F) && (ft[F] = []);
  }, o.removeAllHooks = function() {
    ft = Jp();
  }, o;
}
o0();
function* r0(l = "id-", o = 0) {
  let c = o;
  for (; ; )
    c += 1, yield l + c;
}
let zf = !1;
const Rb = (l, o) => {
  zf || (zf = !0, setTimeout(() => {
    l(), zf = !1;
  }, o));
};
var Lf = { exports: {} }, Rf, _p;
function Ub() {
  if (_p) return Rf;
  _p = 1;
  var l = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Rf = l, Rf;
}
var Uf, $p;
function Hb() {
  if ($p) return Uf;
  $p = 1;
  var l = /* @__PURE__ */ Ub();
  function o() {
  }
  function c() {
  }
  return c.resetWarningCache = o, Uf = function() {
    function s(h, p, y, T, M, C) {
      if (C !== l) {
        var x = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw x.name = "Invariant Violation", x;
      }
    }
    s.isRequired = s;
    function u() {
      return s;
    }
    var d = {
      array: s,
      bigint: s,
      bool: s,
      func: s,
      number: s,
      object: s,
      string: s,
      symbol: s,
      any: s,
      arrayOf: u,
      element: s,
      elementType: s,
      instanceOf: u,
      node: s,
      objectOf: u,
      oneOf: u,
      oneOfType: u,
      shape: u,
      exact: u,
      checkPropTypes: c,
      resetWarningCache: o
    };
    return d.PropTypes = d, d;
  }, Uf;
}
var tA;
function jb() {
  return tA || (tA = 1, Lf.exports = /* @__PURE__ */ Hb()()), Lf.exports;
}
var Me = /* @__PURE__ */ jb();
const O = /* @__PURE__ */ Zv(Me);
O.shape({
  event: O.string,
  action: O.string,
  name: O.string,
  region: O.string,
  section: O.string,
  component: O.string,
  type: O.string,
  text: O.string
});
const wt = ({
  event: l = "",
  action: o = "",
  name: c = "",
  type: s = "",
  section: u = "",
  text: d = "",
  region: h = "",
  component: p = "",
  eventCallback: y,
  eventTimeout: T
}) => {
  const { dataLayer: M } = window, C = {
    event: l.toLowerCase(),
    action: o.toLowerCase(),
    name: c.toLowerCase(),
    type: s.toLowerCase(),
    region: h.toLowerCase(),
    section: u.toLowerCase(),
    text: d.toLowerCase(),
    component: p.toLowerCase()
  };
  y && (C.eventCallback = y), T && (C.eventTimeout = T), M ? M.push(C) : y && y();
}, pr = ({ children: l }) => /* @__PURE__ */ b.jsx(b.Fragment, { children: l });
pr.propTypes = {
  children: O.oneOfType([
    O.arrayOf(O.node),
    O.node,
    O.string
  ])
};
var Hf = { exports: {} };
var eA;
function Xb() {
  return eA || (eA = 1, (function(l) {
    (function() {
      var o = {}.hasOwnProperty;
      function c() {
        for (var d = "", h = 0; h < arguments.length; h++) {
          var p = arguments[h];
          p && (d = u(d, s(p)));
        }
        return d;
      }
      function s(d) {
        if (typeof d == "string" || typeof d == "number")
          return d;
        if (typeof d != "object")
          return "";
        if (Array.isArray(d))
          return c.apply(null, d);
        if (d.toString !== Object.prototype.toString && !d.toString.toString().includes("[native code]"))
          return d.toString();
        var h = "";
        for (var p in d)
          o.call(d, p) && d[p] && (h = u(h, p));
        return h;
      }
      function u(d, h) {
        return h ? d ? d + " " + h : d + h : d;
      }
      l.exports ? (c.default = c, l.exports = c) : window.classNames = c;
    })();
  })(Hf)), Hf.exports;
}
Xb();
({
  ...pr.propTypes
});
const c0 = ({ children: l, className: o = "container", ...c }) => /* @__PURE__ */ b.jsx("div", { className: o, ...c, children: /* @__PURE__ */ b.jsx("div", { className: "row", children: l }) });
c0.propTypes = {
  children: pr.propTypes.children
};
({
  ...c0.propTypes
});
pr.propTypes.children, O.oneOf(["0", "3", "4", "6", "8", "9", "12"]);
pr.propTypes.children;
function u0({
  packageName: l = "",
  component: o = "",
  type: c = "",
  configuration: s = {}
}) {
  if (!l || !o) {
    console.error("trackReactComponent: Missing required arguments.");
    return;
  }
  window.uds = window.uds || {}, window.uds.package = window.uds.package || {}, window.uds.package[l] = {
    component: o,
    type: c,
    configuration: s
  };
}
const jf = {
  alt: O.string,
  title: O.string,
  src: O.string,
  mobileSrc: O.string,
  brandLink: O.string
}, kc = {
  baseUrl: O.string,
  parentOrg: O.string,
  parentOrgUrl: O.string,
  animate: O.bool
}, Xc = {
  loggedIn: O.bool,
  loginLink: O.string,
  logoutLink: O.string,
  userName: O.string
}, iu = {
  text: O.string.isRequired,
  color: O.oneOf(["gold", "maroon", "light", "dark"]),
  href: O.string,
  classes: O.string,
  onClick: O.func,
  onFocus: O.func
}, td = O.shape({
  id: O.number,
  href: O.string,
  text: O.string,
  type: O.string,
  selected: O.bool,
  items: O.arrayOf(O.arrayOf(O.object)),
  buttons: O.arrayOf(O.shape(iu)),
  class: O.string
}), s0 = {
  isPartner: O.bool,
  isUnbranded: O.bool,
  navTree: O.arrayOf(td),
  partnerLogo: O.shape(jf),
  unbrandedLogo: O.shape(jf),
  logo: O.shape(jf),
  title: O.string,
  parentOrg: kc.parentOrg,
  parentOrgUrl: kc.parentOrgUrl,
  baseUrl: kc.baseUrl,
  loggedIn: Xc.loggedIn,
  userName: Xc.userName,
  loginLink: Xc.loginLink,
  onLoginClick: O.func,
  logoutLink: Xc.logoutLink,
  onLogoutClick: O.func,
  buttons: O.arrayOf(O.shape(iu)),
  breakpoint: O.oneOf(["Lg", "Xl"]),
  animateTitle: O.bool,
  expandOnHover: O.bool,
  mobileNavTree: O.arrayOf(td),
  hasNavigation: O.bool,
  searchUrl: O.string,
  site: O.string,
  renderDiv: O.oneOf(["true", "false"])
}, Qb = {
  ...s0,
  headerTop: O.number,
  headerHeight: O.number,
  itemOpened: O.number,
  setItemOpened: O.func,
  mobileMenuOpen: O.bool,
  setMobileMenuOpen: O.func,
  singlePageAppReset: O.func
};
function Vb(l) {
  var o = /* @__PURE__ */ Object.create(null);
  return function(c) {
    return o[c] === void 0 && (o[c] = l(c)), o[c];
  };
}
var Yb = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Gb = /* @__PURE__ */ Vb(
  function(l) {
    return Yb.test(l) || l.charCodeAt(0) === 111 && l.charCodeAt(1) === 110 && l.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Jt = "-ms-", ur = "-moz-", Ut = "-webkit-", f0 = "comm", ou = "rule", zd = "decl", Ib = "@import", kb = "@namespace", d0 = "@keyframes", Fb = "@layer", m0 = Math.abs, Ld = String.fromCharCode, ed = Object.assign;
function qb(l, o) {
  return Ae(l, 0) ^ 45 ? (((o << 2 ^ Ae(l, 0)) << 2 ^ Ae(l, 1)) << 2 ^ Ae(l, 2)) << 2 ^ Ae(l, 3) : 0;
}
function h0(l) {
  return l.trim();
}
function pa(l, o) {
  return (l = o.exec(l)) ? l[0] : l;
}
function bt(l, o, c) {
  return l.replace(o, c);
}
function Fc(l, o, c) {
  return l.indexOf(o, c);
}
function Ae(l, o) {
  return l.charCodeAt(o) | 0;
}
function Il(l, o, c) {
  return l.slice(o, c);
}
function wn(l) {
  return l.length;
}
function g0(l) {
  return l.length;
}
function or(l, o) {
  return o.push(l), l;
}
function Kb(l, o) {
  return l.map(o).join("");
}
function nA(l, o) {
  return l.filter(function(c) {
    return !pa(c, o);
  });
}
var ru = 1, ki = 1, p0 = 0, Sn = 0, he = 0, Ki = "";
function cu(l, o, c, s, u, d, h, p) {
  return { value: l, root: o, parent: c, type: s, props: u, children: d, line: ru, column: ki, length: h, return: "", siblings: p };
}
function al(l, o) {
  return ed(cu("", null, null, "", null, null, 0, l.siblings), l, { length: -l.length }, o);
}
function Xi(l) {
  for (; l.root; )
    l = al(l.root, { children: [l] });
  or(l, l.siblings);
}
function Zb() {
  return he;
}
function Pb() {
  return he = Sn > 0 ? Ae(Ki, --Sn) : 0, ki--, he === 10 && (ki = 1, ru--), he;
}
function Dn() {
  return he = Sn < p0 ? Ae(Ki, Sn++) : 0, ki++, he === 10 && (ki = 1, ru++), he;
}
function ol() {
  return Ae(Ki, Sn);
}
function qc() {
  return Sn;
}
function uu(l, o) {
  return Il(Ki, l, o);
}
function mr(l) {
  switch (l) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Wb(l) {
  return ru = ki = 1, p0 = wn(Ki = l), Sn = 0, [];
}
function Jb(l) {
  return Ki = "", l;
}
function Xf(l) {
  return h0(uu(Sn - 1, nd(l === 91 ? l + 2 : l === 40 ? l + 1 : l)));
}
function _b(l) {
  for (; (he = ol()) && he < 33; )
    Dn();
  return mr(l) > 2 || mr(he) > 3 ? "" : " ";
}
function $b(l, o) {
  for (; --o && Dn() && !(he < 48 || he > 102 || he > 57 && he < 65 || he > 70 && he < 97); )
    ;
  return uu(l, qc() + (o < 6 && ol() == 32 && Dn() == 32));
}
function nd(l) {
  for (; Dn(); )
    switch (he) {
      // ] ) " '
      case l:
        return Sn;
      // " '
      case 34:
      case 39:
        l !== 34 && l !== 39 && nd(he);
        break;
      // (
      case 40:
        l === 41 && nd(l);
        break;
      // \
      case 92:
        Dn();
        break;
    }
  return Sn;
}
function tS(l, o) {
  for (; Dn() && l + he !== 57; )
    if (l + he === 84 && ol() === 47)
      break;
  return "/*" + uu(o, Sn - 1) + "*" + Ld(l === 47 ? l : Dn());
}
function eS(l) {
  for (; !mr(ol()); )
    Dn();
  return uu(l, Sn);
}
function nS(l) {
  return Jb(Kc("", null, null, null, [""], l = Wb(l), 0, [0], l));
}
function Kc(l, o, c, s, u, d, h, p, y) {
  for (var T = 0, M = 0, C = h, x = 0, J = 0, j = 0, I = 1, k = 1, K = 1, X = 0, tt = "", et = u, lt = d, Q = s, G = tt; k; )
    switch (j = X, X = Dn()) {
      // (
      case 40:
        if (j != 108 && Ae(G, C - 1) == 58) {
          Fc(G += bt(Xf(X), "&", "&\f"), "&\f", m0(T ? p[T - 1] : 0)) != -1 && (K = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        G += Xf(X);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        G += _b(j);
        break;
      // \
      case 92:
        G += $b(qc() - 1, 7);
        continue;
      // /
      case 47:
        switch (ol()) {
          case 42:
          case 47:
            or(aS(tS(Dn(), qc()), o, c, y), y), (mr(j || 1) == 5 || mr(ol() || 1) == 5) && wn(G) && Il(G, -1, void 0) !== " " && (G += " ");
            break;
          default:
            G += "/";
        }
        break;
      // {
      case 123 * I:
        p[T++] = wn(G) * K;
      // } ; \0
      case 125 * I:
      case 59:
      case 0:
        switch (X) {
          // \0 }
          case 0:
          case 125:
            k = 0;
          // ;
          case 59 + M:
            K == -1 && (G = bt(G, /\f/g, "")), J > 0 && (wn(G) - C || I === 0 && j === 47) && or(J > 32 ? lA(G + ";", s, c, C - 1, y) : lA(bt(G, " ", "") + ";", s, c, C - 2, y), y);
            break;
          // @ ;
          case 59:
            G += ";";
          // { rule/at-rule
          default:
            if (or(Q = aA(G, o, c, T, M, u, p, tt, et = [], lt = [], C, d), d), X === 123)
              if (M === 0)
                Kc(G, o, Q, Q, et, d, C, p, lt);
              else {
                switch (x) {
                  // c(ontainer)
                  case 99:
                    if (Ae(G, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (Ae(G, 2) === 97) break;
                  default:
                    M = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                M ? Kc(l, Q, Q, s && or(aA(l, Q, Q, 0, 0, u, p, tt, u, et = [], C, lt), lt), u, lt, C, p, s ? et : lt) : Kc(G, Q, Q, Q, [""], lt, 0, p, lt);
              }
        }
        T = M = J = 0, I = K = 1, tt = G = "", C = h;
        break;
      // :
      case 58:
        C = 1 + wn(G), J = j;
      default:
        if (I < 1) {
          if (X == 123)
            --I;
          else if (X == 125 && I++ == 0 && Pb() == 125)
            continue;
        }
        switch (G += Ld(X), X * I) {
          // &
          case 38:
            K = M > 0 ? 1 : (G += "\f", -1);
            break;
          // ,
          case 44:
            p[T++] = (wn(G) - 1) * K, K = 1;
            break;
          // @
          case 64:
            ol() === 45 && (G += Xf(Dn())), x = ol(), M = C = wn(tt = G += eS(qc())), X++;
            break;
          // -
          case 45:
            j === 45 && wn(G) == 2 && (I = 0);
        }
    }
  return d;
}
function aA(l, o, c, s, u, d, h, p, y, T, M, C) {
  for (var x = u - 1, J = u === 0 ? d : [""], j = g0(J), I = 0, k = 0, K = 0; I < s; ++I)
    for (var X = 0, tt = Il(l, x + 1, x = m0(k = h[I])), et = l; X < j; ++X)
      (et = h0(k > 0 ? J[X] + " " + tt : bt(tt, /&\f/g, J[X]))) && (y[K++] = et);
  return cu(l, o, c, u === 0 ? ou : p, y, T, M, C);
}
function aS(l, o, c, s) {
  return cu(l, o, c, f0, Ld(Zb()), Il(l, 2, -2), 0, s);
}
function lA(l, o, c, s, u) {
  return cu(l, o, c, zd, Il(l, 0, s), Il(l, s + 1, -1), s, u);
}
function A0(l, o, c) {
  switch (qb(l, o)) {
    // color-adjust
    case 5103:
      return Ut + "print-" + l + l;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
      return Ut + l + l;
    // mask-composite
    case 4855:
      return Ut + l.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + l;
    // tab-size
    case 4789:
      return ur + l + l;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Ut + l + ur + l + Jt + l + l;
    // writing-mode
    case 5936:
      switch (Ae(l, o + 11)) {
        // vertical-l(r)
        case 114:
          return Ut + l + Jt + bt(l, /[svh]\w+-[tblr]{2}/, "tb") + l;
        // vertical-r(l)
        case 108:
          return Ut + l + Jt + bt(l, /[svh]\w+-[tblr]{2}/, "tb-rl") + l;
        // horizontal(-)tb
        case 45:
          return Ut + l + Jt + bt(l, /[svh]\w+-[tblr]{2}/, "lr") + l;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return Ut + l + Jt + l + l;
    // order
    case 6165:
      return Ut + l + Jt + "flex-" + l + l;
    // align-items
    case 5187:
      return Ut + l + bt(l, /(\w+).+(:[^]+)/, Ut + "box-$1$2" + Jt + "flex-$1$2") + l;
    // align-self
    case 5443:
      return Ut + l + Jt + "flex-item-" + bt(l, /flex-|-self/g, "") + (pa(l, /flex-|baseline/) ? "" : Jt + "grid-row-" + bt(l, /flex-|-self/g, "")) + l;
    // align-content
    case 4675:
      return Ut + l + Jt + "flex-line-pack" + bt(l, /align-content|flex-|-self/g, "") + l;
    // flex-shrink
    case 5548:
      return Ut + l + Jt + bt(l, "shrink", "negative") + l;
    // flex-basis
    case 5292:
      return Ut + l + Jt + bt(l, "basis", "preferred-size") + l;
    // flex-grow
    case 6060:
      return Ut + "box-" + bt(l, "-grow", "") + Ut + l + Jt + bt(l, "grow", "positive") + l;
    // transition
    case 4554:
      return Ut + bt(l, /([^-])(transform)/g, "$1" + Ut + "$2") + l;
    // cursor
    case 6187:
      return bt(bt(bt(l, /(zoom-|grab)/, Ut + "$1"), /(image-set)/, Ut + "$1"), l, "") + l;
    // background, background-image
    case 5495:
    case 3959:
      return bt(l, /(image-set\([^]*)/, Ut + "$1$`$1");
    // justify-content
    case 4968:
      return bt(bt(l, /(.+:)(flex-)?(.*)/, Ut + "box-pack:$3" + Jt + "flex-pack:$3"), /space-between/, "justify") + Ut + l + l;
    // justify-self
    case 4200:
      if (!pa(l, /flex-|baseline/)) return Jt + "grid-column-align" + Il(l, o) + l;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return Jt + bt(l, "template-", "") + l;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return c && c.some(function(s, u) {
        return o = u, pa(s.props, /grid-\w+-end/);
      }) ? ~Fc(l + (c = c[o].value), "span", 0) ? l : Jt + bt(l, "-start", "") + l + Jt + "grid-row-span:" + (~Fc(c, "span", 0) ? pa(c, /\d+/) : +pa(c, /\d+/) - +pa(l, /\d+/)) + ";" : Jt + bt(l, "-start", "") + l;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return c && c.some(function(s) {
        return pa(s.props, /grid-\w+-start/);
      }) ? l : Jt + bt(bt(l, "-end", "-span"), "span ", "") + l;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return bt(l, /(.+)-inline(.+)/, Ut + "$1$2") + l;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (wn(l) - 1 - o > 6)
        switch (Ae(l, o + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (Ae(l, o + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return bt(l, /(.+:)(.+)-([^]+)/, "$1" + Ut + "$2-$3$1" + ur + (Ae(l, o + 3) == 108 ? "$3" : "$2-$3")) + l;
          // (s)tretch
          case 115:
            return ~Fc(l, "stretch", 0) ? A0(bt(l, "stretch", "fill-available"), o, c) + l : l;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return bt(l, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(s, u, d, h, p, y, T) {
        return Jt + u + ":" + d + T + (h ? Jt + u + "-span:" + (p ? y : +y - +d) + T : "") + l;
      });
    // position: sticky
    case 4949:
      if (Ae(l, o + 6) === 121)
        return bt(l, ":", ":" + Ut) + l;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (Ae(l, Ae(l, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return bt(l, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + Ut + (Ae(l, 14) === 45 ? "inline-" : "") + "box$3$1" + Ut + "$2$3$1" + Jt + "$2box$3") + l;
        // (inline-)?gri(d)
        case 100:
          return bt(l, ":", ":" + Jt) + l;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return bt(l, "scroll-", "scroll-snap-") + l;
  }
  return l;
}
function tu(l, o) {
  for (var c = "", s = 0; s < l.length; s++)
    c += o(l[s], s, l, o) || "";
  return c;
}
function lS(l, o, c, s) {
  switch (l.type) {
    case Fb:
      if (l.children.length) break;
    case Ib:
    case kb:
    case zd:
      return l.return = l.return || l.value;
    case f0:
      return "";
    case d0:
      return l.return = l.value + "{" + tu(l.children, s) + "}";
    case ou:
      if (!wn(l.value = l.props.join(","))) return "";
  }
  return wn(c = tu(l.children, s)) ? l.return = l.value + "{" + c + "}" : "";
}
function iS(l) {
  var o = g0(l);
  return function(c, s, u, d) {
    for (var h = "", p = 0; p < o; p++)
      h += l[p](c, s, u, d) || "";
    return h;
  };
}
function oS(l) {
  return function(o) {
    o.root || (o = o.return) && l(o);
  };
}
function rS(l, o, c, s) {
  if (l.length > -1 && !l.return)
    switch (l.type) {
      case zd:
        l.return = A0(l.value, l.length, c);
        return;
      case d0:
        return tu([al(l, { value: bt(l.value, "@", "@" + Ut) })], s);
      case ou:
        if (l.length)
          return Kb(c = l.props, function(u) {
            switch (pa(u, s = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                Xi(al(l, { props: [bt(u, /:(read-\w+)/, ":" + ur + "$1")] })), Xi(al(l, { props: [u] })), ed(l, { props: nA(c, s) });
                break;
              // :placeholder
              case "::placeholder":
                Xi(al(l, { props: [bt(u, /:(plac\w+)/, ":" + Ut + "input-$1")] })), Xi(al(l, { props: [bt(u, /:(plac\w+)/, ":" + ur + "$1")] })), Xi(al(l, { props: [bt(u, /:(plac\w+)/, Jt + "input-$1")] })), Xi(al(l, { props: [u] })), ed(l, { props: nA(c, s) });
                break;
            }
            return "";
          });
    }
}
var Ht = { env: { NODE_ENV: "production" } }, Qf, Vf;
const kl = typeof Ht < "u" && Ht.env !== void 0 && (Ht.env.REACT_APP_SC_ATTR || Ht.env.SC_ATTR) || "data-styled", y0 = "active", v0 = "data-styled-version", su = "6.4.2", Rd = `/*!sc*/
`, sr = typeof window < "u" && typeof document < "u";
function iA(l) {
  if (typeof Ht < "u" && Ht.env !== void 0) {
    const o = Ht.env[l];
    if (o !== void 0 && o !== "") return o !== "false";
  }
}
const cS = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : (Vf = (Qf = iA("REACT_APP_SC_DISABLE_SPEEDY")) !== null && Qf !== void 0 ? Qf : iA("SC_DISABLE_SPEEDY")) !== null && Vf !== void 0 ? Vf : typeof Ht < "u" && Ht.env !== void 0 && Ht.env.NODE_ENV !== "production"), uS = "sc-keyframes-", sS = {}, fS = Ht.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?

`, 18: `Accessing \`useTheme\` hook outside of a \`<ThemeProvider>\` element.

\`\`\`jsx
import { useTheme } from 'styled-components';
export function StyledCompoent({ children }) {
  const theme = useTheme();
  return <div style={{ width: theme.sizes.full }}>{children}</div>;
}

import { StyledComponent } from './StyledComponent';
import { theme } from './theme';
export function App() {
  return (
    <ThemeProvider theme={theme}>
      <StyledComponent />
    </ThemeProvider>
  );
}
\`\`\`

If you need access to the theme in an uncertain composition scenario, \`React.useContext(ThemeContext)\` will not emit an error if there is no \`ThemeProvider\` ancestor.
` } : {};
function Ar(l, ...o) {
  return Ht.env.NODE_ENV === "production" ? new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${l} for more information.${o.length > 0 ? ` Args: ${o.join(", ")}` : ""}`) : new Error((function(...c) {
    let s = c[0];
    const u = [];
    for (let d = 1, h = c.length; d < h; d += 1) u.push(c[d]);
    return u.forEach((d) => {
      s = s.replace(/%[a-z]/, d);
    }), s;
  })(fS[l], ...o).trim());
}
const dS = 1 << 30;
let Zc = /* @__PURE__ */ new Map(), eu = /* @__PURE__ */ new Map(), Pc = 1;
const Qc = (l) => {
  if (Zc.has(l)) return Zc.get(l);
  for (; eu.has(Pc); ) Pc++;
  const o = Pc++;
  if (Ht.env.NODE_ENV !== "production" && ((0 | o) < 0 || o > dS)) throw Ar(16, `${o}`);
  return Zc.set(l, o), eu.set(o, l), o;
}, mS = (l) => eu.get(l), hS = (l, o) => {
  Pc = o + 1, Zc.set(l, o), eu.set(o, l);
}, oA = /invalid hook call/i, Vc = /* @__PURE__ */ new Set(), b0 = (l, o) => {
  if (Ht.env.NODE_ENV !== "production") {
    const c = `The component ${l}${o ? ` with the id of "${o}"` : ""} has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.
See https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.
`, s = console.error;
    try {
      let u = !0;
      console.error = (d, ...h) => {
        oA.test(d) ? (u = !1, Vc.delete(c)) : s(d, ...h);
      }, typeof ee.useState == "function" && ee.useState(null), u && !Vc.has(c) && (console.warn(c), Vc.add(c));
    } catch (u) {
      oA.test(u.message) && Vc.delete(c);
    } finally {
      console.error = s;
    }
  }
}, Ud = Object.freeze([]), Fi = Object.freeze({});
function S0(l, o, c = Fi) {
  return l.theme !== c.theme && l.theme || o || c.theme;
}
const gS = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, pS = /(^-|-$)/g;
function O0(l) {
  return l.replace(gS, "-").replace(pS, "");
}
const AS = /(a)(d)/gi, rA = (l) => String.fromCharCode(l + (l > 25 ? 39 : 97));
function T0(l) {
  let o, c = "";
  for (o = Math.abs(l); o > 52; o = o / 52 | 0) c = rA(o % 52) + c;
  return (rA(o % 52) + c).replace(AS, "$1-$2");
}
const ad = 5381, Yl = (l, o) => {
  let c = o.length;
  for (; c; ) l = 33 * l ^ o.charCodeAt(--c);
  return l;
}, E0 = (l) => Yl(ad, l);
function x0(l) {
  return T0(E0(l) >>> 0);
}
function Hd(l) {
  return Ht.env.NODE_ENV !== "production" && typeof l == "string" && l || l.displayName || l.name || "Component";
}
function Wc(l) {
  return typeof l == "string" && (Ht.env.NODE_ENV === "production" || l.charAt(0) === l.charAt(0).toLowerCase());
}
function yS(l) {
  return Wc(l) ? `styled.${l}` : `Styled(${Hd(l)})`;
}
const N0 = Symbol.for("react.memo"), vS = Symbol.for("react.forward_ref"), bS = { contextType: !0, defaultProps: !0, displayName: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, propTypes: !0, type: !0 }, SS = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, C0 = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, OS = { [vS]: { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, [N0]: C0 };
function cA(l) {
  return ("type" in (o = l) && o.type.$$typeof) === N0 ? C0 : "$$typeof" in l ? OS[l.$$typeof] : bS;
  var o;
}
const TS = Object.defineProperty, ES = Object.getOwnPropertyNames, xS = Object.getOwnPropertySymbols, NS = Object.getOwnPropertyDescriptor, CS = Object.getPrototypeOf, wS = Object.prototype;
function w0(l, o, c) {
  if (typeof o != "string") {
    const s = CS(o);
    s && s !== wS && w0(l, s, c);
    const u = ES(o).concat(xS(o)), d = cA(l), h = cA(o);
    for (let p = 0; p < u.length; ++p) {
      const y = u[p];
      if (!(y in SS || c && c[y] || h && y in h || d && y in d)) {
        const T = NS(o, y);
        try {
          TS(l, y, T);
        } catch {
        }
      }
    }
  }
  return l;
}
function yr(l) {
  return typeof l == "function";
}
const DS = Symbol.for("react.forward_ref");
function jd(l) {
  return l != null && (typeof l == "object" || typeof l == "function") && l.$$typeof === DS && "styledComponentId" in l;
}
function rr(l, o) {
  return l && o ? l + " " + o : l || o || "";
}
function ld(l, o) {
  return l.join("");
}
function Fl(l) {
  return l !== null && typeof l == "object" && l.constructor.name === Object.name && !("props" in l && l.$$typeof);
}
function id(l, o, c = !1) {
  if (!c && !Fl(l) && !Array.isArray(l)) return o;
  if (Array.isArray(o)) for (let s = 0; s < o.length; s++) l[s] = id(l[s], o[s]);
  else if (Fl(o)) for (const s in o) l[s] = id(l[s], o[s]);
  return l;
}
function D0(l, o) {
  Object.defineProperty(l, "toString", { value: o });
}
const BS = class {
  constructor(l) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = l, this._cGroup = 0, this._cIndex = 0;
  }
  indexOfGroup(l) {
    if (l === this._cGroup) return this._cIndex;
    let o = this._cIndex;
    if (l > this._cGroup) for (let c = this._cGroup; c < l; c++) o += this.groupSizes[c];
    else for (let c = this._cGroup - 1; c >= l; c--) o -= this.groupSizes[c];
    return this._cGroup = l, this._cIndex = o, o;
  }
  insertRules(l, o) {
    if (l >= this.groupSizes.length) {
      const u = this.groupSizes, d = u.length;
      let h = d;
      for (; l >= h; ) if (h <<= 1, h < 0) throw Ar(16, `${l}`);
      this.groupSizes = new Uint32Array(h), this.groupSizes.set(u), this.length = h;
      for (let p = d; p < h; p++) this.groupSizes[p] = 0;
    }
    let c = this.indexOfGroup(l + 1), s = 0;
    for (let u = 0, d = o.length; u < d; u++) this.tag.insertRule(c, o[u]) && (this.groupSizes[l]++, c++, s++);
    s > 0 && this._cGroup > l && (this._cIndex += s);
  }
  clearGroup(l) {
    if (l < this.length) {
      const o = this.groupSizes[l], c = this.indexOfGroup(l), s = c + o;
      this.groupSizes[l] = 0;
      for (let u = c; u < s; u++) this.tag.deleteRule(c);
      o > 0 && this._cGroup > l && (this._cIndex -= o);
    }
  }
  getGroup(l) {
    let o = "";
    if (l >= this.length || this.groupSizes[l] === 0) return o;
    const c = this.groupSizes[l], s = this.indexOfGroup(l), u = s + c;
    for (let d = s; d < u; d++) o += this.tag.getRule(d) + Rd;
    return o;
  }
}, MS = `style[${kl}][${v0}="${su}"]`, zS = new RegExp(`^${kl}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`), uA = (l) => typeof ShadowRoot < "u" && l instanceof ShadowRoot || "host" in l && l.nodeType === 11, od = (l) => {
  if (!l) return document;
  if (uA(l)) return l;
  if ("getRootNode" in l) {
    const o = l.getRootNode();
    if (uA(o)) return o;
  }
  return document;
}, LS = (l, o, c) => {
  const s = c.split(",");
  let u;
  for (let d = 0, h = s.length; d < h; d++) (u = s[d]) && l.registerName(o, u);
}, RS = (l, o) => {
  var c;
  const s = ((c = o.textContent) !== null && c !== void 0 ? c : "").split(Rd), u = [];
  for (let d = 0, h = s.length; d < h; d++) {
    const p = s[d].trim();
    if (!p) continue;
    const y = p.match(zS);
    if (y) {
      const T = 0 | parseInt(y[1], 10), M = y[2];
      T !== 0 && (hS(M, T), LS(l, M, y[3]), l.getTag().insertRules(T, u)), u.length = 0;
    } else u.push(p);
  }
}, Yf = (l) => {
  const o = od(l.options.target).querySelectorAll(MS);
  for (let c = 0, s = o.length; c < s; c++) {
    const u = o[c];
    u && u.getAttribute(kl) !== y0 && (RS(l, u), u.parentNode && u.parentNode.removeChild(u));
  }
};
let nr = !1;
function US() {
  if (nr !== !1) return nr;
  if (typeof document < "u") {
    const l = document.head.querySelector('meta[property="csp-nonce"]');
    if (l) return nr = l.nonce || l.getAttribute("content") || void 0;
    const o = document.head.querySelector('meta[name="sc-nonce"]');
    if (o) return nr = o.getAttribute("content") || void 0;
  }
  return nr = typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}
const B0 = (l, o) => {
  const c = document.head, s = l || c, u = document.createElement("style"), d = ((y) => {
    const T = Array.from(y.querySelectorAll(`style[${kl}]`));
    return T[T.length - 1];
  })(s), h = d !== void 0 ? d.nextSibling : null;
  u.setAttribute(kl, y0), u.setAttribute(v0, su);
  const p = o || US();
  return p && u.setAttribute("nonce", p), s.insertBefore(u, h), u;
}, HS = class {
  constructor(l, o) {
    this.element = B0(l, o), this.element.appendChild(document.createTextNode("")), this.sheet = ((c) => {
      var s;
      if (c.sheet) return c.sheet;
      const u = (s = c.getRootNode().styleSheets) !== null && s !== void 0 ? s : document.styleSheets;
      for (let d = 0, h = u.length; d < h; d++) {
        const p = u[d];
        if (p.ownerNode === c) return p;
      }
      throw Ar(17);
    })(this.element), this.length = 0;
  }
  insertRule(l, o) {
    try {
      return this.sheet.insertRule(o, l), this.length++, !0;
    } catch {
      return !1;
    }
  }
  deleteRule(l) {
    this.sheet.deleteRule(l), this.length--;
  }
  getRule(l) {
    const o = this.sheet.cssRules[l];
    return o && o.cssText ? o.cssText : "";
  }
}, jS = class {
  constructor(l, o) {
    this.element = B0(l, o), this.nodes = this.element.childNodes, this.length = 0;
  }
  insertRule(l, o) {
    if (l <= this.length && l >= 0) {
      const c = document.createTextNode(o);
      return this.element.insertBefore(c, this.nodes[l] || null), this.length++, !0;
    }
    return !1;
  }
  deleteRule(l) {
    this.element.removeChild(this.nodes[l]), this.length--;
  }
  getRule(l) {
    return l < this.length ? this.nodes[l].textContent : "";
  }
};
let sA = sr;
const XS = { isServer: !sr, useCSSOMInjection: !cS };
class vr {
  static registerId(o) {
    return Qc(o);
  }
  constructor(o = Fi, c = {}, s) {
    this.options = Object.assign(Object.assign({}, XS), o), this.gs = c, this.keyframeIds = /* @__PURE__ */ new Set(), this.names = new Map(s), this.server = !!o.isServer, !this.server && sr && sA && (sA = !1, Yf(this)), D0(this, () => ((u) => {
      const d = u.getTag(), { length: h } = d;
      let p = "";
      for (let y = 0; y < h; y++) {
        const T = mS(y);
        if (T === void 0) continue;
        const M = u.names.get(T);
        if (M === void 0 || !M.size) continue;
        const C = d.getGroup(y);
        if (C.length === 0) continue;
        const x = kl + ".g" + y + '[id="' + T + '"]';
        let J = "";
        for (const j of M) j.length > 0 && (J += j + ",");
        p += C + x + '{content:"' + J + '"}' + Rd;
      }
      return p;
    })(this));
  }
  rehydrate() {
    !this.server && sr && Yf(this);
  }
  reconstructWithOptions(o, c = !0) {
    const s = new vr(Object.assign(Object.assign({}, this.options), o), this.gs, c && this.names || void 0);
    return s.keyframeIds = new Set(this.keyframeIds), !this.server && sr && o.target !== this.options.target && od(this.options.target) !== od(o.target) && Yf(s), s;
  }
  allocateGSInstance(o) {
    return this.gs[o] = (this.gs[o] || 0) + 1;
  }
  getTag() {
    return this.tag || (this.tag = (o = (({ useCSSOMInjection: c, target: s, nonce: u }) => c ? new HS(s, u) : new jS(s, u))(this.options), new BS(o)));
    var o;
  }
  hasNameForId(o, c) {
    var s, u;
    return (u = (s = this.names.get(o)) === null || s === void 0 ? void 0 : s.has(c)) !== null && u !== void 0 && u;
  }
  registerName(o, c) {
    Qc(o), o.startsWith(uS) && this.keyframeIds.add(o);
    const s = this.names.get(o);
    s ? s.add(c) : this.names.set(o, /* @__PURE__ */ new Set([c]));
  }
  insertRules(o, c, s) {
    this.registerName(o, c), this.getTag().insertRules(Qc(o), s);
  }
  clearNames(o) {
    this.names.has(o) && this.names.get(o).clear();
  }
  clearRules(o) {
    this.getTag().clearGroup(Qc(o)), this.clearNames(o);
  }
  clearTag() {
    this.tag = void 0;
  }
}
const M0 = /* @__PURE__ */ new WeakSet(), QS = { animationIterationCount: 1, aspectRatio: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexShrink: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, scale: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 };
function VS(l, o) {
  return o == null || typeof o == "boolean" || o === "" ? "" : typeof o != "number" || o === 0 || l in QS || l.startsWith("--") ? String(o).trim() : o + "px";
}
const Ql = 47;
function fA(l) {
  if (l.charCodeAt(0) === 45 && l.charCodeAt(1) === 45) return l;
  let o = "";
  for (let c = 0; c < l.length; c++) {
    const s = l.charCodeAt(c);
    o += s >= 65 && s <= 90 ? "-" + String.fromCharCode(s + 32) : l[c];
  }
  return o.startsWith("ms-") ? "-" + o : o;
}
const YS = Symbol.for("sc-keyframes");
function rd(l) {
  return typeof l == "object" && l !== null && YS in l;
}
function z0(l) {
  return yr(l) && !(l.prototype && l.prototype.isReactComponent);
}
const L0 = (l) => l == null || l === !1 || l === "", GS = Symbol.for("react.client.reference");
function dA(l) {
  return l.$$typeof === GS;
}
function mA(l) {
  const o = l.$$id, c = (o && o.includes("#") ? o.split("#").pop() : o) || l.name || "unknown";
  console.warn(`Interpolating a client component (${c}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
function R0(l, o) {
  for (const c in l) {
    const s = l[c];
    l.hasOwnProperty(c) && !L0(s) && (Array.isArray(s) && M0.has(s) || yr(s) ? o.push(fA(c) + ":", s, ";") : Fl(s) ? (o.push(c + " {"), R0(s, o), o.push("}")) : o.push(fA(c) + ": " + VS(c, s) + ";"));
  }
}
function rl(l, o, c, s, u = []) {
  if (L0(l)) return u;
  const d = typeof l;
  if (d === "string") return u.push(l), u;
  if (d === "function") {
    if (dA(l)) return Ht.env.NODE_ENV !== "production" && mA(l), u;
    if (z0(l) && o) {
      const h = l(o);
      return Ht.env.NODE_ENV === "production" || typeof h != "object" || Array.isArray(h) || rd(h) || Fl(h) || h === null || console.error(`${Hd(l)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), rl(h, o, c, s, u);
    }
    return u.push(l), u;
  }
  if (Array.isArray(l)) {
    for (let h = 0; h < l.length; h++) rl(l[h], o, c, s, u);
    return u;
  }
  return jd(l) ? (u.push(`.${l.styledComponentId}`), u) : rd(l) ? (c ? (l.inject(c, s), u.push(l.getName(s))) : u.push(l), u) : dA(l) ? (Ht.env.NODE_ENV !== "production" && mA(l), u) : Fl(l) ? l.toString !== Object.prototype.toString ? (u.push(l.toString()), u) : (R0(l, u), u) : (u.push(l.toString()), u);
}
const IS = E0(su);
class kS {
  constructor(o, c, s) {
    this.rules = o, this.componentId = c, this.baseHash = Yl(IS, c), this.baseStyle = s, vr.registerId(c);
  }
  generateAndInjectStyles(o, c, s) {
    let u = this.baseStyle ? this.baseStyle.generateAndInjectStyles(o, c, s) : "";
    {
      let d = "";
      for (let h = 0; h < this.rules.length; h++) {
        const p = this.rules[h];
        if (typeof p == "string") d += p;
        else if (p) if (z0(p)) {
          const y = p(o);
          typeof y == "string" ? d += y : y != null && y !== !1 && (Ht.env.NODE_ENV === "production" || typeof y != "object" || Array.isArray(y) || rd(y) || Fl(y) || console.error(`${Hd(p)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), d += ld(rl(y, o, c, s)));
        } else d += ld(rl(p, o, c, s));
      }
      if (d) {
        this.dynamicNameCache || (this.dynamicNameCache = /* @__PURE__ */ new Map());
        const h = s.hash ? s.hash + d : d;
        let p = this.dynamicNameCache.get(h);
        if (!p) {
          if (p = T0(Yl(Yl(this.baseHash, s.hash), d) >>> 0), this.dynamicNameCache.size >= 200) {
            const y = this.dynamicNameCache.keys().next().value;
            y !== void 0 && this.dynamicNameCache.delete(y);
          }
          this.dynamicNameCache.set(h, p);
        }
        if (!c.hasNameForId(this.componentId, p)) {
          const y = s(d, "." + p, void 0, this.componentId);
          c.insertRules(this.componentId, p, y);
        }
        u = rr(u, p);
      }
    }
    return u;
  }
}
const FS = /&/g;
function U0(l, o) {
  let c = 0;
  for (; --o >= 0 && l.charCodeAt(o) === 92; ) c++;
  return !(1 & ~c);
}
function Gf(l) {
  const o = l.length;
  let c = "", s = 0, u = 0, d = 0, h = !1, p = !1;
  for (let y = 0; y < o; y++) {
    const T = l.charCodeAt(y);
    if (d !== 0 || h || T !== Ql || l.charCodeAt(y + 1) !== 42) if (h) T === 42 && l.charCodeAt(y + 1) === Ql && (h = !1, y++);
    else if (T !== 34 && T !== 39 || U0(l, y)) {
      if (d === 0) if (T === 123) u++;
      else if (T === 125) {
        if (u--, u < 0) {
          p = !0;
          let M = y + 1;
          for (; M < o; ) {
            const C = l.charCodeAt(M);
            if (C === 59 || C === 10) break;
            M++;
          }
          M < o && l.charCodeAt(M) === 59 && M++, u = 0, y = M - 1, s = M;
          continue;
        }
        u === 0 && (c += l.substring(s, y + 1), s = y + 1);
      } else T === 59 && u === 0 && (c += l.substring(s, y + 1), s = y + 1);
    } else d === 0 ? d = T : d === T && (d = 0);
    else h = !0, y++;
  }
  return p || u !== 0 || d !== 0 ? (s < o && u === 0 && d === 0 && (c += l.substring(s)), c) : l;
}
function H0(l, o) {
  const c = o + " ", s = "," + c;
  for (let u = 0; u < l.length; u++) {
    const d = l[u];
    if (d.type === "rule") {
      d.value = (c + d.value).replaceAll(",", s);
      const h = d.props, p = [];
      for (let y = 0; y < h.length; y++) p[y] = c + h[y];
      d.props = p;
    }
    Array.isArray(d.children) && d.type !== "@keyframes" && H0(d.children, o);
  }
  return l;
}
function qS({ options: l = Fi, plugins: o = Ud } = Fi) {
  let c, s, u;
  const d = (x, J, j) => j.startsWith(s) && j.endsWith(s) && j.replaceAll(s, "").length > 0 ? `.${c}` : x, h = o.slice();
  h.push((x) => {
    x.type === ou && x.value.includes("&") && (u || (u = new RegExp(`\\${s}\\b`, "g")), x.props[0] = x.props[0].replace(FS, s).replace(u, d));
  }), l.prefix && h.push(rS), h.push(lS);
  let p = [];
  const y = iS(h.concat(oS((x) => p.push(x)))), T = (x, J = "", j = "", I = "&") => {
    c = I, s = J, u = void 0;
    const k = (function(X) {
      const tt = X.indexOf("//") !== -1, et = X.indexOf("}") !== -1;
      if (!tt && !et) return X;
      if (!tt) return Gf(X);
      const lt = X.length;
      let Q = "", G = 0, P = 0, Dt = 0, ot = 0, dt = 0, yt = !1;
      for (; P < lt; ) {
        const Tt = X.charCodeAt(P);
        if (Tt !== 34 && Tt !== 39 || U0(X, P)) if (Dt === 0) if (Tt === Ql && P + 1 < lt && X.charCodeAt(P + 1) === 42) {
          for (P += 2; P + 1 < lt && (X.charCodeAt(P) !== 42 || X.charCodeAt(P + 1) !== Ql); ) P++;
          P += 2;
        } else if (Tt !== 40) if (Tt !== 41) if (ot > 0) P++;
        else if (Tt === 42 && P + 1 < lt && X.charCodeAt(P + 1) === Ql) Q += X.substring(G, P), P += 2, G = P, yt = !0;
        else if (Tt === Ql && P + 1 < lt && X.charCodeAt(P + 1) === Ql) {
          for (Q += X.substring(G, P); P < lt && X.charCodeAt(P) !== 10; ) P++;
          G = P, yt = !0;
        } else Tt === 123 ? dt++ : Tt === 125 && dt--, P++;
        else ot > 0 && ot--, P++;
        else ot++, P++;
        else P++;
        else Dt === 0 ? Dt = Tt : Dt === Tt && (Dt = 0), P++;
      }
      return yt ? (G < lt && (Q += X.substring(G)), dt === 0 ? Q : Gf(Q)) : dt === 0 ? X : Gf(X);
    })(x);
    let K = nS(j || J ? j + " " + J + " { " + k + " }" : k);
    return l.namespace && (K = H0(K, l.namespace)), p = [], tu(K, y), p;
  }, M = l;
  let C = ad;
  for (let x = 0; x < o.length; x++) o[x].name || Ar(15), C = Yl(C, o[x].name);
  return M != null && M.namespace && (C = Yl(C, M.namespace)), M != null && M.prefix && (C = Yl(C, "p")), T.hash = C !== ad ? C.toString() : "", T;
}
const KS = new vr(), ZS = qS(), j0 = ee.createContext({ shouldForwardProp: void 0, styleSheet: KS, stylis: ZS, stylisPlugins: void 0 });
j0.Consumer;
function X0() {
  return ee.useContext(j0);
}
const Xd = ee.createContext(void 0);
Xd.Consumer;
const hA = Object.prototype.hasOwnProperty, If = {};
function PS(l, o) {
  const c = typeof l != "string" ? "sc" : O0(l);
  If[c] = (If[c] || 0) + 1;
  const s = c + "-" + x0(su + c + If[c]);
  return o ? o + "-" + s : s;
}
let kf;
function WS(l, o, c) {
  const s = jd(l), u = l, d = !Wc(l), { attrs: h = Ud, componentId: p = PS(o.displayName, o.parentComponentId), displayName: y = yS(l) } = o, T = o.displayName && o.componentId ? O0(o.displayName) + "-" + o.componentId : o.componentId || p, M = s && u.attrs ? u.attrs.concat(h).filter(Boolean) : h;
  let { shouldForwardProp: C } = o;
  if (s && u.shouldForwardProp) {
    const I = u.shouldForwardProp;
    if (o.shouldForwardProp) {
      const k = o.shouldForwardProp;
      C = (K, X) => I(K, X) && k(K, X);
    } else C = I;
  }
  const x = new kS(c, T, s ? u.componentStyle : void 0);
  function J(I, k) {
    return (function(K, X, tt) {
      const { attrs: et, componentStyle: lt, defaultProps: Q, foldedComponentIds: G, styledComponentId: P, target: Dt } = K, ot = ee.useContext(Xd), dt = X0(), yt = K.shouldForwardProp || dt.shouldForwardProp;
      Ht.env.NODE_ENV !== "production" && ee.useDebugValue && ee.useDebugValue(P);
      const Tt = S0(X, ot, Q) || Fi;
      let ne, kt;
      {
        const st = ee.useRef(null), ht = st.current;
        if (ht !== null && ht[1] === Tt && ht[2] === dt.styleSheet && ht[3] === dt.stylis && ht[7] === lt && (function(ft, Mt, gt) {
          const at = ft, ct = Mt;
          let Le = 0;
          for (const ye in ct) if (hA.call(ct, ye) && (Le++, at[ye] !== ct[ye])) return !1;
          return Le === gt;
        })(ht[0], X, ht[4])) ne = ht[5], kt = ht[6];
        else {
          ne = (function(Mt, gt, at) {
            const ct = Object.assign(Object.assign({}, gt), { className: void 0, theme: at }), Le = Mt.length > 1;
            for (let ye = 0; ye < Mt.length; ye++) {
              const On = Mt[ye], Tn = yr(On) ? On(Le ? Object.assign({}, ct) : ct) : On;
              for (const ve in Tn) ve === "className" ? ct.className = rr(ct.className, Tn[ve]) : ve === "style" ? ct.style = Object.assign(Object.assign({}, ct.style), Tn[ve]) : ve in gt && gt[ve] === void 0 || (ct[ve] = Tn[ve]);
            }
            return "className" in gt && typeof gt.className == "string" && (ct.className = rr(ct.className, gt.className)), ct;
          })(et, X, Tt), kt = (function(Mt, gt, at, ct) {
            const Le = Mt.generateAndInjectStyles(gt, at, ct);
            return Ht.env.NODE_ENV !== "production" && ee.useDebugValue && ee.useDebugValue(Le), Le;
          })(lt, ne, dt.styleSheet, dt.stylis);
          let ft = 0;
          for (const Mt in X) hA.call(X, Mt) && ft++;
          st.current = [X, Tt, dt.styleSheet, dt.stylis, ft, ne, kt, lt];
        }
      }
      Ht.env.NODE_ENV !== "production" && K.warnTooManyClasses && K.warnTooManyClasses(kt);
      const V = ne.as || Dt, H = (function(st, ht, ft, Mt) {
        const gt = {};
        for (const at in st) st[at] === void 0 || at[0] === "$" || at === "as" || at === "theme" && st.theme === ft || (at === "forwardedAs" ? gt.as = st.forwardedAs : Mt && !Mt(at, ht) || (gt[at] = st[at], Mt || Ht.env.NODE_ENV !== "development" || Gb(at) || (kf || (kf = /* @__PURE__ */ new Set())).has(at) || !Wc(ht) || ht.includes("-") || (kf.add(at), console.warn(`styled-components: it looks like an unknown prop "${at}" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via \`<StyleSheetManager shouldForwardProp={...}>\` (connect an API like \`@emotion/is-prop-valid\`) or consider using transient props (\`$\` prefix for automatic filtering.)`))));
        return gt;
      })(ne, V, Tt, yt);
      let Z = rr(G, P);
      return kt && (Z += " " + kt), ne.className && (Z += " " + ne.className), H[Wc(V) && V.includes("-") ? "class" : "className"] = Z, tt && (H.ref = tt), n0(V, H);
    })(j, I, k);
  }
  J.displayName = y;
  let j = ee.forwardRef(J);
  return j.attrs = M, j.componentStyle = x, j.displayName = y, j.shouldForwardProp = C, j.foldedComponentIds = s ? rr(u.foldedComponentIds, u.styledComponentId) : "", j.styledComponentId = T, j.target = s ? u.target : l, Object.defineProperty(j, "defaultProps", { get() {
    return this._foldedDefaultProps;
  }, set(I) {
    this._foldedDefaultProps = s ? (function(k, ...K) {
      for (const X of K) id(k, X, !0);
      return k;
    })({}, u.defaultProps, I) : I;
  } }), Ht.env.NODE_ENV !== "production" && (b0(y, T), j.warnTooManyClasses = /* @__PURE__ */ ((I, k) => {
    let K = {}, X = !1;
    return (tt) => {
      !X && (K[tt] = !0, Object.keys(K).length >= 200) && (console.warn(`Over 200 classes were generated for component ${I}${k ? ` with the id of "${k}"` : ""}.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), X = !0, K = {});
    };
  })(y, T)), D0(j, () => `.${j.styledComponentId}`), d && w0(j, l, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), j;
}
var JS = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "blockquote", "body", "button", "br", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "menu", "meter", "nav", "object", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "slot", "small", "span", "strong", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use"]);
function gA(l, o) {
  const c = [l[0]];
  for (let s = 0, u = o.length; s < u; s += 1) c.push(o[s], l[s + 1]);
  return c;
}
const pA = (l) => (M0.add(l), l);
function fu(l, ...o) {
  if (yr(l) || Fl(l)) return pA(rl(gA(Ud, [l, ...o])));
  const c = l;
  return o.length === 0 && c.length === 1 && typeof c[0] == "string" ? rl(c) : pA(rl(gA(c, o)));
}
function cd(l, o, c = Fi) {
  if (!o) throw Ar(1, o);
  const s = (u, ...d) => l(o, c, fu(u, ...d));
  return s.attrs = (u) => cd(l, o, Object.assign(Object.assign({}, c), { attrs: Array.prototype.concat(c.attrs, u).filter(Boolean) })), s.withConfig = (u) => cd(l, o, Object.assign(Object.assign({}, c), u)), s;
}
const Q0 = (l) => cd(WS, l), Xe = Q0;
JS.forEach((l) => {
  Xe[l] = Q0(l);
});
class _S {
  constructor(o, c) {
    this.instanceRules = /* @__PURE__ */ new Map(), this.rules = o, this.componentId = c, this.isStatic = (function(s) {
      for (let u = 0; u < s.length; u += 1) {
        const d = s[u];
        if (yr(d) && !jd(d)) return !1;
      }
      return !0;
    })(o), vr.registerId(this.componentId);
  }
  removeStyles(o, c) {
    this.instanceRules.delete(o), this.rebuildGroup(c);
  }
  renderStyles(o, c, s, u) {
    const d = this.componentId;
    if (this.isStatic) {
      if (s.hasNameForId(d, d + o)) this.instanceRules.has(o) || this.computeRules(o, c, s, u);
      else {
        const p = this.computeRules(o, c, s, u);
        s.insertRules(d, p.name, p.rules);
      }
      return;
    }
    const h = this.instanceRules.get(o);
    if (this.computeRules(o, c, s, u), !s.server && h) {
      const p = h.rules, y = this.instanceRules.get(o).rules;
      if (p.length === y.length) {
        let T = !0;
        for (let M = 0; M < p.length; M++) if (p[M] !== y[M]) {
          T = !1;
          break;
        }
        if (T) return;
      }
    }
    this.rebuildGroup(s);
  }
  computeRules(o, c, s, u) {
    const d = ld(rl(this.rules, c, s, u)), h = { name: this.componentId + o, rules: u(d, "") };
    return this.instanceRules.set(o, h), h;
  }
  rebuildGroup(o) {
    const c = this.componentId;
    o.clearRules(c);
    for (const s of this.instanceRules.values()) o.insertRules(c, s.name, s.rules);
  }
}
function $S(l, ...o) {
  const c = fu(l, ...o), s = `sc-global-${x0(JSON.stringify(c))}`, u = new _S(c, s);
  Ht.env.NODE_ENV !== "production" && b0(s);
  const d = (p) => {
    const y = X0(), T = ee.useContext(Xd);
    let M;
    {
      const C = ee.useRef(null);
      C.current === null && (C.current = y.styleSheet.allocateGSInstance(s)), M = C.current;
    }
    Ht.env.NODE_ENV !== "production" && ee.Children.count(p.children) && console.warn(`The global style component ${s} was given child JSX. createGlobalStyle does not render children.`), Ht.env.NODE_ENV !== "production" && c.some((C) => typeof C == "string" && C.indexOf("@import") !== -1) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), y.styleSheet.server && h(M, p, y.styleSheet, T, y.stylis);
    {
      const C = u.isStatic ? [M, y.styleSheet, u] : [M, p, y.styleSheet, T, y.stylis, u], x = ee.useRef(u);
      ee.useLayoutEffect(() => {
        y.styleSheet.server || (x.current !== u && (y.styleSheet.clearRules(s), x.current = u), h(M, p, y.styleSheet, T, y.stylis));
      }, C), ee.useLayoutEffect(() => () => {
        y.styleSheet.server || u.removeStyles(M, y.styleSheet);
      }, [M, y.styleSheet, u]);
    }
    return y.styleSheet.server && u.instanceRules.delete(M), null;
  };
  function h(p, y, T, M, C) {
    if (u.isStatic) u.renderStyles(p, sS, T, C);
    else {
      const x = Object.assign(Object.assign({}, y), { theme: S0(y, M, d.defaultProps) });
      u.renderStyles(p, x, T, C);
    }
  }
  return ee.memo(d);
}
Ht.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://styled-components.com/docs/basics#react-native`);
const Yc = `__sc-${kl}__`;
Ht.env.NODE_ENV !== "production" && Ht.env.NODE_ENV !== "test" && typeof window < "u" && (window[Yc] || (window[Yc] = 0), window[Yc] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://styled-components.com/docs/faqs#why-am-i-getting-a-warning-about-several-instances-of-module-on-the-page for more info.`), window[Yc] += 1);
const Qd = "var(--bs-maroon, #8c1d40)", Vd = "var(--bs-gold, #ffc627)", qn = "#ffffff", AA = "#000000", on = "#191919", Jc = "#BFBFBF", ln = "#d0d0d0", t3 = "#e8e8e8", e3 = "#bfbfbf", n3 = "#495057", a3 = Xe.a`
  font-family:
    Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, sans-serif;
  color: ${on};
  padding: 0.5rem 1rem;
  border-radius: 400rem;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  transition: 0.03s ease-in-out;
  cursor: pointer;
  & + a {
    margin-left: 1rem;
  }
  &:hover {
    transform: scale(1.05);
  }
  &.button-light {
    background-color: ${e3} !important;
    color: ${AA} !important;
  }
  &.button-gold {
    background-color: ${Vd} !important;
    color: ${AA} !important;
  }
  &.button-dark {
    background-color: ${on} !important;
    color: ${qn} !important;
  }
  &.button-maroon {
    background-color: ${Qd} !important;
    color: ${qn} !important;
  }
`, Zi = ({
  href: l,
  color: o,
  text: c,
  classes: s,
  onClick: u,
  onKeyDown: d,
  onFocus: h,
  as: p,
  ...y
}) => /* @__PURE__ */ b.jsx(
  a3,
  {
    href: l,
    className: `button-${o} ${s ?? ""}`,
    onClick: u,
    onKeyDown: d,
    onFocus: h,
    as: p,
    ...y,
    children: c
  }
);
Zi.propTypes = { ...iu };
const l3 = {
  prefix: "fas",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"]
}, i3 = l3, o3 = {
  prefix: "fas",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
}, ud = o3, V0 = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, r3 = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, c3 = r3;
var u3 = { env: { NODE_ENV: "production" } };
function s3(l, o, c) {
  return (o = d3(o)) in l ? Object.defineProperty(l, o, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : l[o] = c, l;
}
function yA(l, o) {
  var c = Object.keys(l);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(l);
    o && (s = s.filter(function(u) {
      return Object.getOwnPropertyDescriptor(l, u).enumerable;
    })), c.push.apply(c, s);
  }
  return c;
}
function Y(l) {
  for (var o = 1; o < arguments.length; o++) {
    var c = arguments[o] != null ? arguments[o] : {};
    o % 2 ? yA(Object(c), !0).forEach(function(s) {
      s3(l, s, c[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(l, Object.getOwnPropertyDescriptors(c)) : yA(Object(c)).forEach(function(s) {
      Object.defineProperty(l, s, Object.getOwnPropertyDescriptor(c, s));
    });
  }
  return l;
}
function f3(l, o) {
  if (typeof l != "object" || !l) return l;
  var c = l[Symbol.toPrimitive];
  if (c !== void 0) {
    var s = c.call(l, o);
    if (typeof s != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(l);
}
function d3(l) {
  var o = f3(l, "string");
  return typeof o == "symbol" ? o : o + "";
}
const vA = () => {
};
let Yd = {}, Y0 = {}, G0 = null, I0 = {
  mark: vA,
  measure: vA
};
try {
  typeof window < "u" && (Yd = window), typeof document < "u" && (Y0 = document), typeof MutationObserver < "u" && (G0 = MutationObserver), typeof performance < "u" && (I0 = performance);
} catch {
}
const {
  userAgent: bA = ""
} = Yd.navigator || {}, cl = Yd, _t = Y0, SA = G0, Gc = I0;
cl.document;
const va = !!_t.documentElement && !!_t.head && typeof _t.addEventListener == "function" && typeof _t.createElement == "function", k0 = ~bA.indexOf("MSIE") || ~bA.indexOf("Trident/");
var m3 = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, h3 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, F0 = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, g3 = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, q0 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], ze = "classic", du = "duotone", p3 = "sharp", A3 = "sharp-duotone", K0 = [ze, du, p3, A3], y3 = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, v3 = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, b3 = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), S3 = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, O3 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], OA = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, T3 = ["kit"], E3 = {
  kit: {
    "fa-kit": "fak"
  }
}, x3 = ["fak", "fakd"], N3 = {
  kit: {
    fak: "fa-kit"
  }
}, TA = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, Ic = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, C3 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], w3 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], D3 = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, B3 = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, M3 = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, sd = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, z3 = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], fd = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...C3, ...z3], L3 = ["solid", "regular", "light", "thin", "duotone", "brands"], Z0 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], R3 = Z0.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), U3 = [...Object.keys(M3), ...L3, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Ic.GROUP, Ic.SWAP_OPACITY, Ic.PRIMARY, Ic.SECONDARY].concat(Z0.map((l) => "".concat(l, "x"))).concat(R3.map((l) => "w-".concat(l))), H3 = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const Aa = "___FONT_AWESOME___", dd = 16, P0 = "fa", W0 = "svg-inline--fa", ql = "data-fa-i2svg", md = "data-fa-pseudo-element", j3 = "data-fa-pseudo-element-pending", Gd = "data-prefix", Id = "data-icon", EA = "fontawesome-i2svg", X3 = "async", Q3 = ["HTML", "HEAD", "STYLE", "SCRIPT"], J0 = (() => {
  try {
    return u3.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function br(l) {
  return new Proxy(l, {
    get(o, c) {
      return c in o ? o[c] : o[ze];
    }
  });
}
const _0 = Y({}, F0);
_0[ze] = Y(Y(Y(Y({}, {
  "fa-duotone": "duotone"
}), F0[ze]), OA.kit), OA["kit-duotone"]);
const V3 = br(_0), hd = Y({}, S3);
hd[ze] = Y(Y(Y(Y({}, {
  duotone: "fad"
}), hd[ze]), TA.kit), TA["kit-duotone"]);
const xA = br(hd), gd = Y({}, sd);
gd[ze] = Y(Y({}, gd[ze]), N3.kit);
const kd = br(gd), pd = Y({}, B3);
pd[ze] = Y(Y({}, pd[ze]), E3.kit);
br(pd);
const Y3 = m3, $0 = "fa-layers-text", G3 = h3, I3 = Y({}, y3);
br(I3);
const k3 = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], Ff = g3, F3 = [...T3, ...U3], fr = cl.FontAwesomeConfig || {};
function q3(l) {
  var o = _t.querySelector("script[" + l + "]");
  if (o)
    return o.getAttribute(l);
}
function K3(l) {
  return l === "" ? !0 : l === "false" ? !1 : l === "true" ? !0 : l;
}
_t && typeof _t.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((o) => {
  let [c, s] = o;
  const u = K3(q3(c));
  u != null && (fr[s] = u);
});
const t1 = {
  styleDefault: "solid",
  familyDefault: ze,
  cssPrefix: P0,
  replacementClass: W0,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
fr.familyPrefix && (fr.cssPrefix = fr.familyPrefix);
const qi = Y(Y({}, t1), fr);
qi.autoReplaceSvg || (qi.observeMutations = !1);
const nt = {};
Object.keys(t1).forEach((l) => {
  Object.defineProperty(nt, l, {
    enumerable: !0,
    set: function(o) {
      qi[l] = o, dr.forEach((c) => c(nt));
    },
    get: function() {
      return qi[l];
    }
  });
});
Object.defineProperty(nt, "familyPrefix", {
  enumerable: !0,
  set: function(l) {
    qi.cssPrefix = l, dr.forEach((o) => o(nt));
  },
  get: function() {
    return qi.cssPrefix;
  }
});
cl.FontAwesomeConfig = nt;
const dr = [];
function Z3(l) {
  return dr.push(l), () => {
    dr.splice(dr.indexOf(l), 1);
  };
}
const nl = dd, kn = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function P3(l) {
  if (!l || !va)
    return;
  const o = _t.createElement("style");
  o.setAttribute("type", "text/css"), o.innerHTML = l;
  const c = _t.head.childNodes;
  let s = null;
  for (let u = c.length - 1; u > -1; u--) {
    const d = c[u], h = (d.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(h) > -1 && (s = d);
  }
  return _t.head.insertBefore(o, s), l;
}
const W3 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function hr() {
  let l = 12, o = "";
  for (; l-- > 0; )
    o += W3[Math.random() * 62 | 0];
  return o;
}
function Pi(l) {
  const o = [];
  for (let c = (l || []).length >>> 0; c--; )
    o[c] = l[c];
  return o;
}
function Fd(l) {
  return l.classList ? Pi(l.classList) : (l.getAttribute("class") || "").split(" ").filter((o) => o);
}
function e1(l) {
  return "".concat(l).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function J3(l) {
  return Object.keys(l || {}).reduce((o, c) => o + "".concat(c, '="').concat(e1(l[c]), '" '), "").trim();
}
function mu(l) {
  return Object.keys(l || {}).reduce((o, c) => o + "".concat(c, ": ").concat(l[c].trim(), ";"), "");
}
function qd(l) {
  return l.size !== kn.size || l.x !== kn.x || l.y !== kn.y || l.rotate !== kn.rotate || l.flipX || l.flipY;
}
function _3(l) {
  let {
    transform: o,
    containerWidth: c,
    iconWidth: s
  } = l;
  const u = {
    transform: "translate(".concat(c / 2, " 256)")
  }, d = "translate(".concat(o.x * 32, ", ").concat(o.y * 32, ") "), h = "scale(".concat(o.size / 16 * (o.flipX ? -1 : 1), ", ").concat(o.size / 16 * (o.flipY ? -1 : 1), ") "), p = "rotate(".concat(o.rotate, " 0 0)"), y = {
    transform: "".concat(d, " ").concat(h, " ").concat(p)
  }, T = {
    transform: "translate(".concat(s / 2 * -1, " -256)")
  };
  return {
    outer: u,
    inner: y,
    path: T
  };
}
function $3(l) {
  let {
    transform: o,
    width: c = dd,
    height: s = dd,
    startCentered: u = !1
  } = l, d = "";
  return u && k0 ? d += "translate(".concat(o.x / nl - c / 2, "em, ").concat(o.y / nl - s / 2, "em) ") : u ? d += "translate(calc(-50% + ".concat(o.x / nl, "em), calc(-50% + ").concat(o.y / nl, "em)) ") : d += "translate(".concat(o.x / nl, "em, ").concat(o.y / nl, "em) "), d += "scale(".concat(o.size / nl * (o.flipX ? -1 : 1), ", ").concat(o.size / nl * (o.flipY ? -1 : 1), ") "), d += "rotate(".concat(o.rotate, "deg) "), d;
}
var tO = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function n1() {
  const l = P0, o = W0, c = nt.cssPrefix, s = nt.replacementClass;
  let u = tO;
  if (c !== l || s !== o) {
    const d = new RegExp("\\.".concat(l, "\\-"), "g"), h = new RegExp("\\--".concat(l, "\\-"), "g"), p = new RegExp("\\.".concat(o), "g");
    u = u.replace(d, ".".concat(c, "-")).replace(h, "--".concat(c, "-")).replace(p, ".".concat(s));
  }
  return u;
}
let NA = !1;
function qf() {
  nt.autoAddCss && !NA && (P3(n1()), NA = !0);
}
var eO = {
  mixout() {
    return {
      dom: {
        css: n1,
        insertCss: qf
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        qf();
      },
      beforeI2svg() {
        qf();
      }
    };
  }
};
const ya = cl || {};
ya[Aa] || (ya[Aa] = {});
ya[Aa].styles || (ya[Aa].styles = {});
ya[Aa].hooks || (ya[Aa].hooks = {});
ya[Aa].shims || (ya[Aa].shims = []);
var Fn = ya[Aa];
const a1 = [], l1 = function() {
  _t.removeEventListener("DOMContentLoaded", l1), nu = 1, a1.map((l) => l());
};
let nu = !1;
va && (nu = (_t.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(_t.readyState), nu || _t.addEventListener("DOMContentLoaded", l1));
function nO(l) {
  va && (nu ? setTimeout(l, 0) : a1.push(l));
}
function Sr(l) {
  const {
    tag: o,
    attributes: c = {},
    children: s = []
  } = l;
  return typeof l == "string" ? e1(l) : "<".concat(o, " ").concat(J3(c), ">").concat(s.map(Sr).join(""), "</").concat(o, ">");
}
function CA(l, o, c) {
  if (l && l[o] && l[o][c])
    return {
      prefix: o,
      iconName: c,
      icon: l[o][c]
    };
}
var Kf = function(o, c, s, u) {
  var d = Object.keys(o), h = d.length, p = c, y, T, M;
  for (s === void 0 ? (y = 1, M = o[d[0]]) : (y = 0, M = s); y < h; y++)
    T = d[y], M = p(M, o[T], T, o);
  return M;
};
function aO(l) {
  const o = [];
  let c = 0;
  const s = l.length;
  for (; c < s; ) {
    const u = l.charCodeAt(c++);
    if (u >= 55296 && u <= 56319 && c < s) {
      const d = l.charCodeAt(c++);
      (d & 64512) == 56320 ? o.push(((u & 1023) << 10) + (d & 1023) + 65536) : (o.push(u), c--);
    } else
      o.push(u);
  }
  return o;
}
function Ad(l) {
  const o = aO(l);
  return o.length === 1 ? o[0].toString(16) : null;
}
function lO(l, o) {
  const c = l.length;
  let s = l.charCodeAt(o), u;
  return s >= 55296 && s <= 56319 && c > o + 1 && (u = l.charCodeAt(o + 1), u >= 56320 && u <= 57343) ? (s - 55296) * 1024 + u - 56320 + 65536 : s;
}
function wA(l) {
  return Object.keys(l).reduce((o, c) => {
    const s = l[c];
    return !!s.icon ? o[s.iconName] = s.icon : o[c] = s, o;
  }, {});
}
function yd(l, o) {
  let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: s = !1
  } = c, u = wA(o);
  typeof Fn.hooks.addPack == "function" && !s ? Fn.hooks.addPack(l, wA(o)) : Fn.styles[l] = Y(Y({}, Fn.styles[l] || {}), u), l === "fas" && yd("fa", o);
}
const {
  styles: gr,
  shims: iO
} = Fn, i1 = Object.keys(kd), oO = i1.reduce((l, o) => (l[o] = Object.keys(kd[o]), l), {});
let Kd = null, o1 = {}, r1 = {}, c1 = {}, u1 = {}, s1 = {};
function rO(l) {
  return ~F3.indexOf(l);
}
function cO(l, o) {
  const c = o.split("-"), s = c[0], u = c.slice(1).join("-");
  return s === l && u !== "" && !rO(u) ? u : null;
}
const f1 = () => {
  const l = (s) => Kf(gr, (u, d, h) => (u[h] = Kf(d, s, {}), u), {});
  o1 = l((s, u, d) => (u[3] && (s[u[3]] = d), u[2] && u[2].filter((p) => typeof p == "number").forEach((p) => {
    s[p.toString(16)] = d;
  }), s)), r1 = l((s, u, d) => (s[d] = d, u[2] && u[2].filter((p) => typeof p == "string").forEach((p) => {
    s[p] = d;
  }), s)), s1 = l((s, u, d) => {
    const h = u[2];
    return s[d] = d, h.forEach((p) => {
      s[p] = d;
    }), s;
  });
  const o = "far" in gr || nt.autoFetchSvg, c = Kf(iO, (s, u) => {
    const d = u[0];
    let h = u[1];
    const p = u[2];
    return h === "far" && !o && (h = "fas"), typeof d == "string" && (s.names[d] = {
      prefix: h,
      iconName: p
    }), typeof d == "number" && (s.unicodes[d.toString(16)] = {
      prefix: h,
      iconName: p
    }), s;
  }, {
    names: {},
    unicodes: {}
  });
  c1 = c.names, u1 = c.unicodes, Kd = hu(nt.styleDefault, {
    family: nt.familyDefault
  });
};
Z3((l) => {
  Kd = hu(l.styleDefault, {
    family: nt.familyDefault
  });
});
f1();
function Zd(l, o) {
  return (o1[l] || {})[o];
}
function uO(l, o) {
  return (r1[l] || {})[o];
}
function Vl(l, o) {
  return (s1[l] || {})[o];
}
function d1(l) {
  return c1[l] || {
    prefix: null,
    iconName: null
  };
}
function sO(l) {
  const o = u1[l], c = Zd("fas", l);
  return o || (c ? {
    prefix: "fas",
    iconName: c
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function ul() {
  return Kd;
}
const m1 = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function fO(l) {
  let o = ze;
  const c = i1.reduce((s, u) => (s[u] = "".concat(nt.cssPrefix, "-").concat(u), s), {});
  return K0.forEach((s) => {
    (l.includes(c[s]) || l.some((u) => oO[s].includes(u))) && (o = s);
  }), o;
}
function hu(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: c = ze
  } = o, s = V3[c][l];
  if (c === du && !l)
    return "fad";
  const u = xA[c][l] || xA[c][s], d = l in Fn.styles ? l : null;
  return u || d || null;
}
function dO(l) {
  let o = [], c = null;
  return l.forEach((s) => {
    const u = cO(nt.cssPrefix, s);
    u ? c = u : s && o.push(s);
  }), {
    iconName: c,
    rest: o
  };
}
function DA(l) {
  return l.sort().filter((o, c, s) => s.indexOf(o) === c);
}
function gu(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: c = !1
  } = o;
  let s = null;
  const u = fd.concat(w3), d = DA(l.filter((C) => u.includes(C))), h = DA(l.filter((C) => !fd.includes(C))), p = d.filter((C) => (s = C, !q0.includes(C))), [y = null] = p, T = fO(d), M = Y(Y({}, dO(h)), {}, {
    prefix: hu(y, {
      family: T
    })
  });
  return Y(Y(Y({}, M), pO({
    values: l,
    family: T,
    styles: gr,
    config: nt,
    canonical: M,
    givenPrefix: s
  })), mO(c, s, M));
}
function mO(l, o, c) {
  let {
    prefix: s,
    iconName: u
  } = c;
  if (l || !s || !u)
    return {
      prefix: s,
      iconName: u
    };
  const d = o === "fa" ? d1(u) : {}, h = Vl(s, u);
  return u = d.iconName || h || u, s = d.prefix || s, s === "far" && !gr.far && gr.fas && !nt.autoFetchSvg && (s = "fas"), {
    prefix: s,
    iconName: u
  };
}
const hO = K0.filter((l) => l !== ze || l !== du), gO = Object.keys(sd).filter((l) => l !== ze).map((l) => Object.keys(sd[l])).flat();
function pO(l) {
  const {
    values: o,
    family: c,
    canonical: s,
    givenPrefix: u = "",
    styles: d = {},
    config: h = {}
  } = l, p = c === du, y = o.includes("fa-duotone") || o.includes("fad"), T = h.familyDefault === "duotone", M = s.prefix === "fad" || s.prefix === "fa-duotone";
  if (!p && (y || T || M) && (s.prefix = "fad"), (o.includes("fa-brands") || o.includes("fab")) && (s.prefix = "fab"), !s.prefix && hO.includes(c) && (Object.keys(d).find((x) => gO.includes(x)) || h.autoFetchSvg)) {
    const x = b3.get(c).defaultShortPrefixId;
    s.prefix = x, s.iconName = Vl(s.prefix, s.iconName) || s.iconName;
  }
  return (s.prefix === "fa" || u === "fa") && (s.prefix = ul() || "fas"), s;
}
class AO {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var o = arguments.length, c = new Array(o), s = 0; s < o; s++)
      c[s] = arguments[s];
    const u = c.reduce(this._pullDefinitions, {});
    Object.keys(u).forEach((d) => {
      this.definitions[d] = Y(Y({}, this.definitions[d] || {}), u[d]), yd(d, u[d]);
      const h = kd[ze][d];
      h && yd(h, u[d]), f1();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(o, c) {
    const s = c.prefix && c.iconName && c.icon ? {
      0: c
    } : c;
    return Object.keys(s).map((u) => {
      const {
        prefix: d,
        iconName: h,
        icon: p
      } = s[u], y = p[2];
      o[d] || (o[d] = {}), y.length > 0 && y.forEach((T) => {
        typeof T == "string" && (o[d][T] = p);
      }), o[d][h] = p;
    }), o;
  }
}
let BA = [], Gi = {};
const Ii = {}, yO = Object.keys(Ii);
function vO(l, o) {
  let {
    mixoutsTo: c
  } = o;
  return BA = l, Gi = {}, Object.keys(Ii).forEach((s) => {
    yO.indexOf(s) === -1 && delete Ii[s];
  }), BA.forEach((s) => {
    const u = s.mixout ? s.mixout() : {};
    if (Object.keys(u).forEach((d) => {
      typeof u[d] == "function" && (c[d] = u[d]), typeof u[d] == "object" && Object.keys(u[d]).forEach((h) => {
        c[d] || (c[d] = {}), c[d][h] = u[d][h];
      });
    }), s.hooks) {
      const d = s.hooks();
      Object.keys(d).forEach((h) => {
        Gi[h] || (Gi[h] = []), Gi[h].push(d[h]);
      });
    }
    s.provides && s.provides(Ii);
  }), c;
}
function vd(l, o) {
  for (var c = arguments.length, s = new Array(c > 2 ? c - 2 : 0), u = 2; u < c; u++)
    s[u - 2] = arguments[u];
  return (Gi[l] || []).forEach((h) => {
    o = h.apply(null, [o, ...s]);
  }), o;
}
function Kl(l) {
  for (var o = arguments.length, c = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++)
    c[s - 1] = arguments[s];
  (Gi[l] || []).forEach((d) => {
    d.apply(null, c);
  });
}
function sl() {
  const l = arguments[0], o = Array.prototype.slice.call(arguments, 1);
  return Ii[l] ? Ii[l].apply(null, o) : void 0;
}
function bd(l) {
  l.prefix === "fa" && (l.prefix = "fas");
  let {
    iconName: o
  } = l;
  const c = l.prefix || ul();
  if (o)
    return o = Vl(c, o) || o, CA(h1.definitions, c, o) || CA(Fn.styles, c, o);
}
const h1 = new AO(), bO = () => {
  nt.autoReplaceSvg = !1, nt.observeMutations = !1, Kl("noAuto");
}, SO = {
  i2svg: function() {
    let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return va ? (Kl("beforeI2svg", l), sl("pseudoElements2svg", l), sl("i2svg", l)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: o
    } = l;
    nt.autoReplaceSvg === !1 && (nt.autoReplaceSvg = !0), nt.observeMutations = !0, nO(() => {
      TO({
        autoReplaceSvgRoot: o
      }), Kl("watch", l);
    });
  }
}, OO = {
  icon: (l) => {
    if (l === null)
      return null;
    if (typeof l == "object" && l.prefix && l.iconName)
      return {
        prefix: l.prefix,
        iconName: Vl(l.prefix, l.iconName) || l.iconName
      };
    if (Array.isArray(l) && l.length === 2) {
      const o = l[1].indexOf("fa-") === 0 ? l[1].slice(3) : l[1], c = hu(l[0]);
      return {
        prefix: c,
        iconName: Vl(c, o) || o
      };
    }
    if (typeof l == "string" && (l.indexOf("".concat(nt.cssPrefix, "-")) > -1 || l.match(Y3))) {
      const o = gu(l.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: o.prefix || ul(),
        iconName: Vl(o.prefix, o.iconName) || o.iconName
      };
    }
    if (typeof l == "string") {
      const o = ul();
      return {
        prefix: o,
        iconName: Vl(o, l) || l
      };
    }
  }
}, rn = {
  noAuto: bO,
  config: nt,
  dom: SO,
  parse: OO,
  library: h1,
  findIconDefinition: bd,
  toHtml: Sr
}, TO = function() {
  let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: o = _t
  } = l;
  (Object.keys(Fn.styles).length > 0 || nt.autoFetchSvg) && va && nt.autoReplaceSvg && rn.dom.i2svg({
    node: o
  });
};
function pu(l, o) {
  return Object.defineProperty(l, "abstract", {
    get: o
  }), Object.defineProperty(l, "html", {
    get: function() {
      return l.abstract.map((c) => Sr(c));
    }
  }), Object.defineProperty(l, "node", {
    get: function() {
      if (!va) return;
      const c = _t.createElement("div");
      return c.innerHTML = l.html, c.children;
    }
  }), l;
}
function EO(l) {
  let {
    children: o,
    main: c,
    mask: s,
    attributes: u,
    styles: d,
    transform: h
  } = l;
  if (qd(h) && c.found && !s.found) {
    const {
      width: p,
      height: y
    } = c, T = {
      x: p / y / 2,
      y: 0.5
    };
    u.style = mu(Y(Y({}, d), {}, {
      "transform-origin": "".concat(T.x + h.x / 16, "em ").concat(T.y + h.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: u,
    children: o
  }];
}
function xO(l) {
  let {
    prefix: o,
    iconName: c,
    children: s,
    attributes: u,
    symbol: d
  } = l;
  const h = d === !0 ? "".concat(o, "-").concat(nt.cssPrefix, "-").concat(c) : d;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: Y(Y({}, u), {}, {
        id: h
      }),
      children: s
    }]
  }];
}
function Pd(l) {
  const {
    icons: {
      main: o,
      mask: c
    },
    prefix: s,
    iconName: u,
    transform: d,
    symbol: h,
    title: p,
    maskId: y,
    titleId: T,
    extra: M,
    watchable: C = !1
  } = l, {
    width: x,
    height: J
  } = c.found ? c : o, j = x3.includes(s), I = [nt.replacementClass, u ? "".concat(nt.cssPrefix, "-").concat(u) : ""].filter((lt) => M.classes.indexOf(lt) === -1).filter((lt) => lt !== "" || !!lt).concat(M.classes).join(" ");
  let k = {
    children: [],
    attributes: Y(Y({}, M.attributes), {}, {
      "data-prefix": s,
      "data-icon": u,
      class: I,
      role: M.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(x, " ").concat(J)
    })
  };
  const K = j && !~M.classes.indexOf("fa-fw") ? {
    width: "".concat(x / J * 16 * 0.0625, "em")
  } : {};
  C && (k.attributes[ql] = ""), p && (k.children.push({
    tag: "title",
    attributes: {
      id: k.attributes["aria-labelledby"] || "title-".concat(T || hr())
    },
    children: [p]
  }), delete k.attributes.title);
  const X = Y(Y({}, k), {}, {
    prefix: s,
    iconName: u,
    main: o,
    mask: c,
    maskId: y,
    transform: d,
    symbol: h,
    styles: Y(Y({}, K), M.styles)
  }), {
    children: tt,
    attributes: et
  } = c.found && o.found ? sl("generateAbstractMask", X) || {
    children: [],
    attributes: {}
  } : sl("generateAbstractIcon", X) || {
    children: [],
    attributes: {}
  };
  return X.children = tt, X.attributes = et, h ? xO(X) : EO(X);
}
function MA(l) {
  const {
    content: o,
    width: c,
    height: s,
    transform: u,
    title: d,
    extra: h,
    watchable: p = !1
  } = l, y = Y(Y(Y({}, h.attributes), d ? {
    title: d
  } : {}), {}, {
    class: h.classes.join(" ")
  });
  p && (y[ql] = "");
  const T = Y({}, h.styles);
  qd(u) && (T.transform = $3({
    transform: u,
    startCentered: !0,
    width: c,
    height: s
  }), T["-webkit-transform"] = T.transform);
  const M = mu(T);
  M.length > 0 && (y.style = M);
  const C = [];
  return C.push({
    tag: "span",
    attributes: y,
    children: [o]
  }), d && C.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [d]
  }), C;
}
function NO(l) {
  const {
    content: o,
    title: c,
    extra: s
  } = l, u = Y(Y(Y({}, s.attributes), c ? {
    title: c
  } : {}), {}, {
    class: s.classes.join(" ")
  }), d = mu(s.styles);
  d.length > 0 && (u.style = d);
  const h = [];
  return h.push({
    tag: "span",
    attributes: u,
    children: [o]
  }), c && h.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [c]
  }), h;
}
const {
  styles: Zf
} = Fn;
function Sd(l) {
  const o = l[0], c = l[1], [s] = l.slice(4);
  let u = null;
  return Array.isArray(s) ? u = {
    tag: "g",
    attributes: {
      class: "".concat(nt.cssPrefix, "-").concat(Ff.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(nt.cssPrefix, "-").concat(Ff.SECONDARY),
        fill: "currentColor",
        d: s[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(nt.cssPrefix, "-").concat(Ff.PRIMARY),
        fill: "currentColor",
        d: s[1]
      }
    }]
  } : u = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: s
    }
  }, {
    found: !0,
    width: o,
    height: c,
    icon: u
  };
}
const CO = {
  found: !1,
  width: 512,
  height: 512
};
function wO(l, o) {
  !J0 && !nt.showMissingIcons && l && console.error('Icon with name "'.concat(l, '" and prefix "').concat(o, '" is missing.'));
}
function Od(l, o) {
  let c = o;
  return o === "fa" && nt.styleDefault !== null && (o = ul()), new Promise((s, u) => {
    if (c === "fa") {
      const d = d1(l) || {};
      l = d.iconName || l, o = d.prefix || o;
    }
    if (l && o && Zf[o] && Zf[o][l]) {
      const d = Zf[o][l];
      return s(Sd(d));
    }
    wO(l, o), s(Y(Y({}, CO), {}, {
      icon: nt.showMissingIcons && l ? sl("missingIconAbstract") || {} : {}
    }));
  });
}
const zA = () => {
}, Td = nt.measurePerformance && Gc && Gc.mark && Gc.measure ? Gc : {
  mark: zA,
  measure: zA
}, cr = 'FA "6.7.2"', DO = (l) => (Td.mark("".concat(cr, " ").concat(l, " begins")), () => g1(l)), g1 = (l) => {
  Td.mark("".concat(cr, " ").concat(l, " ends")), Td.measure("".concat(cr, " ").concat(l), "".concat(cr, " ").concat(l, " begins"), "".concat(cr, " ").concat(l, " ends"));
};
var Wd = {
  begin: DO,
  end: g1
};
const _c = () => {
};
function LA(l) {
  return typeof (l.getAttribute ? l.getAttribute(ql) : null) == "string";
}
function BO(l) {
  const o = l.getAttribute ? l.getAttribute(Gd) : null, c = l.getAttribute ? l.getAttribute(Id) : null;
  return o && c;
}
function MO(l) {
  return l && l.classList && l.classList.contains && l.classList.contains(nt.replacementClass);
}
function zO() {
  return nt.autoReplaceSvg === !0 ? $c.replace : $c[nt.autoReplaceSvg] || $c.replace;
}
function LO(l) {
  return _t.createElementNS("http://www.w3.org/2000/svg", l);
}
function RO(l) {
  return _t.createElement(l);
}
function p1(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: c = l.tag === "svg" ? LO : RO
  } = o;
  if (typeof l == "string")
    return _t.createTextNode(l);
  const s = c(l.tag);
  return Object.keys(l.attributes || []).forEach(function(d) {
    s.setAttribute(d, l.attributes[d]);
  }), (l.children || []).forEach(function(d) {
    s.appendChild(p1(d, {
      ceFn: c
    }));
  }), s;
}
function UO(l) {
  let o = " ".concat(l.outerHTML, " ");
  return o = "".concat(o, "Font Awesome fontawesome.com "), o;
}
const $c = {
  replace: function(l) {
    const o = l[0];
    if (o.parentNode)
      if (l[1].forEach((c) => {
        o.parentNode.insertBefore(p1(c), o);
      }), o.getAttribute(ql) === null && nt.keepOriginalSource) {
        let c = _t.createComment(UO(o));
        o.parentNode.replaceChild(c, o);
      } else
        o.remove();
  },
  nest: function(l) {
    const o = l[0], c = l[1];
    if (~Fd(o).indexOf(nt.replacementClass))
      return $c.replace(l);
    const s = new RegExp("".concat(nt.cssPrefix, "-.*"));
    if (delete c[0].attributes.id, c[0].attributes.class) {
      const d = c[0].attributes.class.split(" ").reduce((h, p) => (p === nt.replacementClass || p.match(s) ? h.toSvg.push(p) : h.toNode.push(p), h), {
        toNode: [],
        toSvg: []
      });
      c[0].attributes.class = d.toSvg.join(" "), d.toNode.length === 0 ? o.removeAttribute("class") : o.setAttribute("class", d.toNode.join(" "));
    }
    const u = c.map((d) => Sr(d)).join(`
`);
    o.setAttribute(ql, ""), o.innerHTML = u;
  }
};
function RA(l) {
  l();
}
function A1(l, o) {
  const c = typeof o == "function" ? o : _c;
  if (l.length === 0)
    c();
  else {
    let s = RA;
    nt.mutateApproach === X3 && (s = cl.requestAnimationFrame || RA), s(() => {
      const u = zO(), d = Wd.begin("mutate");
      l.map(u), d(), c();
    });
  }
}
let Jd = !1;
function y1() {
  Jd = !0;
}
function Ed() {
  Jd = !1;
}
let au = null;
function UA(l) {
  if (!SA || !nt.observeMutations)
    return;
  const {
    treeCallback: o = _c,
    nodeCallback: c = _c,
    pseudoElementsCallback: s = _c,
    observeMutationsRoot: u = _t
  } = l;
  au = new SA((d) => {
    if (Jd) return;
    const h = ul();
    Pi(d).forEach((p) => {
      if (p.type === "childList" && p.addedNodes.length > 0 && !LA(p.addedNodes[0]) && (nt.searchPseudoElements && s(p.target), o(p.target)), p.type === "attributes" && p.target.parentNode && nt.searchPseudoElements && s(p.target.parentNode), p.type === "attributes" && LA(p.target) && ~k3.indexOf(p.attributeName))
        if (p.attributeName === "class" && BO(p.target)) {
          const {
            prefix: y,
            iconName: T
          } = gu(Fd(p.target));
          p.target.setAttribute(Gd, y || h), T && p.target.setAttribute(Id, T);
        } else MO(p.target) && c(p.target);
    });
  }), va && au.observe(u, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function HO() {
  au && au.disconnect();
}
function jO(l) {
  const o = l.getAttribute("style");
  let c = [];
  return o && (c = o.split(";").reduce((s, u) => {
    const d = u.split(":"), h = d[0], p = d.slice(1);
    return h && p.length > 0 && (s[h] = p.join(":").trim()), s;
  }, {})), c;
}
function XO(l) {
  const o = l.getAttribute("data-prefix"), c = l.getAttribute("data-icon"), s = l.innerText !== void 0 ? l.innerText.trim() : "";
  let u = gu(Fd(l));
  return u.prefix || (u.prefix = ul()), o && c && (u.prefix = o, u.iconName = c), u.iconName && u.prefix || (u.prefix && s.length > 0 && (u.iconName = uO(u.prefix, l.innerText) || Zd(u.prefix, Ad(l.innerText))), !u.iconName && nt.autoFetchSvg && l.firstChild && l.firstChild.nodeType === Node.TEXT_NODE && (u.iconName = l.firstChild.data)), u;
}
function QO(l) {
  const o = Pi(l.attributes).reduce((u, d) => (u.name !== "class" && u.name !== "style" && (u[d.name] = d.value), u), {}), c = l.getAttribute("title"), s = l.getAttribute("data-fa-title-id");
  return nt.autoA11y && (c ? o["aria-labelledby"] = "".concat(nt.replacementClass, "-title-").concat(s || hr()) : (o["aria-hidden"] = "true", o.focusable = "false")), o;
}
function VO() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: kn,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function HA(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: c,
    prefix: s,
    rest: u
  } = XO(l), d = QO(l), h = vd("parseNodeAttributes", {}, l);
  let p = o.styleParser ? jO(l) : [];
  return Y({
    iconName: c,
    title: l.getAttribute("title"),
    titleId: l.getAttribute("data-fa-title-id"),
    prefix: s,
    transform: kn,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: u,
      styles: p,
      attributes: d
    }
  }, h);
}
const {
  styles: YO
} = Fn;
function v1(l) {
  const o = nt.autoReplaceSvg === "nest" ? HA(l, {
    styleParser: !1
  }) : HA(l);
  return ~o.extra.classes.indexOf($0) ? sl("generateLayersText", l, o) : sl("generateSvgReplacementMutation", l, o);
}
function GO() {
  return [...O3, ...fd];
}
function jA(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!va) return Promise.resolve();
  const c = _t.documentElement.classList, s = (M) => c.add("".concat(EA, "-").concat(M)), u = (M) => c.remove("".concat(EA, "-").concat(M)), d = nt.autoFetchSvg ? GO() : q0.concat(Object.keys(YO));
  d.includes("fa") || d.push("fa");
  const h = [".".concat($0, ":not([").concat(ql, "])")].concat(d.map((M) => ".".concat(M, ":not([").concat(ql, "])"))).join(", ");
  if (h.length === 0)
    return Promise.resolve();
  let p = [];
  try {
    p = Pi(l.querySelectorAll(h));
  } catch {
  }
  if (p.length > 0)
    s("pending"), u("complete");
  else
    return Promise.resolve();
  const y = Wd.begin("onTree"), T = p.reduce((M, C) => {
    try {
      const x = v1(C);
      x && M.push(x);
    } catch (x) {
      J0 || x.name === "MissingIcon" && console.error(x);
    }
    return M;
  }, []);
  return new Promise((M, C) => {
    Promise.all(T).then((x) => {
      A1(x, () => {
        s("active"), s("complete"), u("pending"), typeof o == "function" && o(), y(), M();
      });
    }).catch((x) => {
      y(), C(x);
    });
  });
}
function IO(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  v1(l).then((c) => {
    c && A1([c], o);
  });
}
function kO(l) {
  return function(o) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = (o || {}).icon ? o : bd(o || {});
    let {
      mask: u
    } = c;
    return u && (u = (u || {}).icon ? u : bd(u || {})), l(s, Y(Y({}, c), {}, {
      mask: u
    }));
  };
}
const FO = function(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: c = kn,
    symbol: s = !1,
    mask: u = null,
    maskId: d = null,
    title: h = null,
    titleId: p = null,
    classes: y = [],
    attributes: T = {},
    styles: M = {}
  } = o;
  if (!l) return;
  const {
    prefix: C,
    iconName: x,
    icon: J
  } = l;
  return pu(Y({
    type: "icon"
  }, l), () => (Kl("beforeDOMElementCreation", {
    iconDefinition: l,
    params: o
  }), nt.autoA11y && (h ? T["aria-labelledby"] = "".concat(nt.replacementClass, "-title-").concat(p || hr()) : (T["aria-hidden"] = "true", T.focusable = "false")), Pd({
    icons: {
      main: Sd(J),
      mask: u ? Sd(u.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: C,
    iconName: x,
    transform: Y(Y({}, kn), c),
    symbol: s,
    title: h,
    maskId: d,
    titleId: p,
    extra: {
      attributes: T,
      styles: M,
      classes: y
    }
  })));
};
var qO = {
  mixout() {
    return {
      icon: kO(FO)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(l) {
        return l.treeCallback = jA, l.nodeCallback = IO, l;
      }
    };
  },
  provides(l) {
    l.i2svg = function(o) {
      const {
        node: c = _t,
        callback: s = () => {
        }
      } = o;
      return jA(c, s);
    }, l.generateSvgReplacementMutation = function(o, c) {
      const {
        iconName: s,
        title: u,
        titleId: d,
        prefix: h,
        transform: p,
        symbol: y,
        mask: T,
        maskId: M,
        extra: C
      } = c;
      return new Promise((x, J) => {
        Promise.all([Od(s, h), T.iconName ? Od(T.iconName, T.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((j) => {
          let [I, k] = j;
          x([o, Pd({
            icons: {
              main: I,
              mask: k
            },
            prefix: h,
            iconName: s,
            transform: p,
            symbol: y,
            maskId: M,
            title: u,
            titleId: d,
            extra: C,
            watchable: !0
          })]);
        }).catch(J);
      });
    }, l.generateAbstractIcon = function(o) {
      let {
        children: c,
        attributes: s,
        main: u,
        transform: d,
        styles: h
      } = o;
      const p = mu(h);
      p.length > 0 && (s.style = p);
      let y;
      return qd(d) && (y = sl("generateAbstractTransformGrouping", {
        main: u,
        transform: d,
        containerWidth: u.width,
        iconWidth: u.width
      })), c.push(y || u.icon), {
        children: c,
        attributes: s
      };
    };
  }
}, KO = {
  mixout() {
    return {
      layer(l) {
        let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: c = []
        } = o;
        return pu({
          type: "layer"
        }, () => {
          Kl("beforeDOMElementCreation", {
            assembler: l,
            params: o
          });
          let s = [];
          return l((u) => {
            Array.isArray(u) ? u.map((d) => {
              s = s.concat(d.abstract);
            }) : s = s.concat(u.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(nt.cssPrefix, "-layers"), ...c].join(" ")
            },
            children: s
          }];
        });
      }
    };
  }
}, ZO = {
  mixout() {
    return {
      counter(l) {
        let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: c = null,
          classes: s = [],
          attributes: u = {},
          styles: d = {}
        } = o;
        return pu({
          type: "counter",
          content: l
        }, () => (Kl("beforeDOMElementCreation", {
          content: l,
          params: o
        }), NO({
          content: l.toString(),
          title: c,
          extra: {
            attributes: u,
            styles: d,
            classes: ["".concat(nt.cssPrefix, "-layers-counter"), ...s]
          }
        })));
      }
    };
  }
}, PO = {
  mixout() {
    return {
      text(l) {
        let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: c = kn,
          title: s = null,
          classes: u = [],
          attributes: d = {},
          styles: h = {}
        } = o;
        return pu({
          type: "text",
          content: l
        }, () => (Kl("beforeDOMElementCreation", {
          content: l,
          params: o
        }), MA({
          content: l,
          transform: Y(Y({}, kn), c),
          title: s,
          extra: {
            attributes: d,
            styles: h,
            classes: ["".concat(nt.cssPrefix, "-layers-text"), ...u]
          }
        })));
      }
    };
  },
  provides(l) {
    l.generateLayersText = function(o, c) {
      const {
        title: s,
        transform: u,
        extra: d
      } = c;
      let h = null, p = null;
      if (k0) {
        const y = parseInt(getComputedStyle(o).fontSize, 10), T = o.getBoundingClientRect();
        h = T.width / y, p = T.height / y;
      }
      return nt.autoA11y && !s && (d.attributes["aria-hidden"] = "true"), Promise.resolve([o, MA({
        content: o.innerHTML,
        width: h,
        height: p,
        transform: u,
        title: s,
        extra: d,
        watchable: !0
      })]);
    };
  }
};
const WO = new RegExp('"', "ug"), XA = [1105920, 1112319], QA = Y(Y(Y(Y({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), v3), H3), D3), xd = Object.keys(QA).reduce((l, o) => (l[o.toLowerCase()] = QA[o], l), {}), JO = Object.keys(xd).reduce((l, o) => {
  const c = xd[o];
  return l[o] = c[900] || [...Object.entries(c)][0][1], l;
}, {});
function _O(l) {
  const o = l.replace(WO, ""), c = lO(o, 0), s = c >= XA[0] && c <= XA[1], u = o.length === 2 ? o[0] === o[1] : !1;
  return {
    value: Ad(u ? o[0] : o),
    isSecondary: s || u
  };
}
function $O(l, o) {
  const c = l.replace(/^['"]|['"]$/g, "").toLowerCase(), s = parseInt(o), u = isNaN(s) ? "normal" : s;
  return (xd[c] || {})[u] || JO[c];
}
function VA(l, o) {
  const c = "".concat(j3).concat(o.replace(":", "-"));
  return new Promise((s, u) => {
    if (l.getAttribute(c) !== null)
      return s();
    const h = Pi(l.children).filter((x) => x.getAttribute(md) === o)[0], p = cl.getComputedStyle(l, o), y = p.getPropertyValue("font-family"), T = y.match(G3), M = p.getPropertyValue("font-weight"), C = p.getPropertyValue("content");
    if (h && !T)
      return l.removeChild(h), s();
    if (T && C !== "none" && C !== "") {
      const x = p.getPropertyValue("content");
      let J = $O(y, M);
      const {
        value: j,
        isSecondary: I
      } = _O(x), k = T[0].startsWith("FontAwesome");
      let K = Zd(J, j), X = K;
      if (k) {
        const tt = sO(j);
        tt.iconName && tt.prefix && (K = tt.iconName, J = tt.prefix);
      }
      if (K && !I && (!h || h.getAttribute(Gd) !== J || h.getAttribute(Id) !== X)) {
        l.setAttribute(c, X), h && l.removeChild(h);
        const tt = VO(), {
          extra: et
        } = tt;
        et.attributes[md] = o, Od(K, J).then((lt) => {
          const Q = Pd(Y(Y({}, tt), {}, {
            icons: {
              main: lt,
              mask: m1()
            },
            prefix: J,
            iconName: X,
            extra: et,
            watchable: !0
          })), G = _t.createElementNS("http://www.w3.org/2000/svg", "svg");
          o === "::before" ? l.insertBefore(G, l.firstChild) : l.appendChild(G), G.outerHTML = Q.map((P) => Sr(P)).join(`
`), l.removeAttribute(c), s();
        }).catch(u);
      } else
        s();
    } else
      s();
  });
}
function tT(l) {
  return Promise.all([VA(l, "::before"), VA(l, "::after")]);
}
function eT(l) {
  return l.parentNode !== document.head && !~Q3.indexOf(l.tagName.toUpperCase()) && !l.getAttribute(md) && (!l.parentNode || l.parentNode.tagName !== "svg");
}
function YA(l) {
  if (va)
    return new Promise((o, c) => {
      const s = Pi(l.querySelectorAll("*")).filter(eT).map(tT), u = Wd.begin("searchPseudoElements");
      y1(), Promise.all(s).then(() => {
        u(), Ed(), o();
      }).catch(() => {
        u(), Ed(), c();
      });
    });
}
var nT = {
  hooks() {
    return {
      mutationObserverCallbacks(l) {
        return l.pseudoElementsCallback = YA, l;
      }
    };
  },
  provides(l) {
    l.pseudoElements2svg = function(o) {
      const {
        node: c = _t
      } = o;
      nt.searchPseudoElements && YA(c);
    };
  }
};
let GA = !1;
var aT = {
  mixout() {
    return {
      dom: {
        unwatch() {
          y1(), GA = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        UA(vd("mutationObserverCallbacks", {}));
      },
      noAuto() {
        HO();
      },
      watch(l) {
        const {
          observeMutationsRoot: o
        } = l;
        GA ? Ed() : UA(vd("mutationObserverCallbacks", {
          observeMutationsRoot: o
        }));
      }
    };
  }
};
const IA = (l) => {
  let o = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return l.toLowerCase().split(" ").reduce((c, s) => {
    const u = s.toLowerCase().split("-"), d = u[0];
    let h = u.slice(1).join("-");
    if (d && h === "h")
      return c.flipX = !0, c;
    if (d && h === "v")
      return c.flipY = !0, c;
    if (h = parseFloat(h), isNaN(h))
      return c;
    switch (d) {
      case "grow":
        c.size = c.size + h;
        break;
      case "shrink":
        c.size = c.size - h;
        break;
      case "left":
        c.x = c.x - h;
        break;
      case "right":
        c.x = c.x + h;
        break;
      case "up":
        c.y = c.y - h;
        break;
      case "down":
        c.y = c.y + h;
        break;
      case "rotate":
        c.rotate = c.rotate + h;
        break;
    }
    return c;
  }, o);
};
var lT = {
  mixout() {
    return {
      parse: {
        transform: (l) => IA(l)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(l, o) {
        const c = o.getAttribute("data-fa-transform");
        return c && (l.transform = IA(c)), l;
      }
    };
  },
  provides(l) {
    l.generateAbstractTransformGrouping = function(o) {
      let {
        main: c,
        transform: s,
        containerWidth: u,
        iconWidth: d
      } = o;
      const h = {
        transform: "translate(".concat(u / 2, " 256)")
      }, p = "translate(".concat(s.x * 32, ", ").concat(s.y * 32, ") "), y = "scale(".concat(s.size / 16 * (s.flipX ? -1 : 1), ", ").concat(s.size / 16 * (s.flipY ? -1 : 1), ") "), T = "rotate(".concat(s.rotate, " 0 0)"), M = {
        transform: "".concat(p, " ").concat(y, " ").concat(T)
      }, C = {
        transform: "translate(".concat(d / 2 * -1, " -256)")
      }, x = {
        outer: h,
        inner: M,
        path: C
      };
      return {
        tag: "g",
        attributes: Y({}, x.outer),
        children: [{
          tag: "g",
          attributes: Y({}, x.inner),
          children: [{
            tag: c.icon.tag,
            children: c.icon.children,
            attributes: Y(Y({}, c.icon.attributes), x.path)
          }]
        }]
      };
    };
  }
};
const Pf = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function kA(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return l.attributes && (l.attributes.fill || o) && (l.attributes.fill = "black"), l;
}
function iT(l) {
  return l.tag === "g" ? l.children : [l];
}
var oT = {
  hooks() {
    return {
      parseNodeAttributes(l, o) {
        const c = o.getAttribute("data-fa-mask"), s = c ? gu(c.split(" ").map((u) => u.trim())) : m1();
        return s.prefix || (s.prefix = ul()), l.mask = s, l.maskId = o.getAttribute("data-fa-mask-id"), l;
      }
    };
  },
  provides(l) {
    l.generateAbstractMask = function(o) {
      let {
        children: c,
        attributes: s,
        main: u,
        mask: d,
        maskId: h,
        transform: p
      } = o;
      const {
        width: y,
        icon: T
      } = u, {
        width: M,
        icon: C
      } = d, x = _3({
        transform: p,
        containerWidth: M,
        iconWidth: y
      }), J = {
        tag: "rect",
        attributes: Y(Y({}, Pf), {}, {
          fill: "white"
        })
      }, j = T.children ? {
        children: T.children.map(kA)
      } : {}, I = {
        tag: "g",
        attributes: Y({}, x.inner),
        children: [kA(Y({
          tag: T.tag,
          attributes: Y(Y({}, T.attributes), x.path)
        }, j))]
      }, k = {
        tag: "g",
        attributes: Y({}, x.outer),
        children: [I]
      }, K = "mask-".concat(h || hr()), X = "clip-".concat(h || hr()), tt = {
        tag: "mask",
        attributes: Y(Y({}, Pf), {}, {
          id: K,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [J, k]
      }, et = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: X
          },
          children: iT(C)
        }, tt]
      };
      return c.push(et, {
        tag: "rect",
        attributes: Y({
          fill: "currentColor",
          "clip-path": "url(#".concat(X, ")"),
          mask: "url(#".concat(K, ")")
        }, Pf)
      }), {
        children: c,
        attributes: s
      };
    };
  }
}, rT = {
  provides(l) {
    let o = !1;
    cl.matchMedia && (o = cl.matchMedia("(prefers-reduced-motion: reduce)").matches), l.missingIconAbstract = function() {
      const c = [], s = {
        fill: "currentColor"
      }, u = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      c.push({
        tag: "path",
        attributes: Y(Y({}, s), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const d = Y(Y({}, u), {}, {
        attributeName: "opacity"
      }), h = {
        tag: "circle",
        attributes: Y(Y({}, s), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return o || h.children.push({
        tag: "animate",
        attributes: Y(Y({}, u), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: Y(Y({}, d), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), c.push(h), c.push({
        tag: "path",
        attributes: Y(Y({}, s), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: o ? [] : [{
          tag: "animate",
          attributes: Y(Y({}, d), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), o || c.push({
        tag: "path",
        attributes: Y(Y({}, s), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: Y(Y({}, d), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: c
      };
    };
  }
}, cT = {
  hooks() {
    return {
      parseNodeAttributes(l, o) {
        const c = o.getAttribute("data-fa-symbol"), s = c === null ? !1 : c === "" ? !0 : c;
        return l.symbol = s, l;
      }
    };
  }
}, uT = [eO, qO, KO, ZO, PO, nT, aT, lT, oT, rT, cT];
vO(uT, {
  mixoutsTo: rn
});
rn.noAuto;
rn.config;
rn.library;
rn.dom;
const Nd = rn.parse;
rn.findIconDefinition;
rn.toHtml;
const sT = rn.icon;
rn.layer;
rn.text;
rn.counter;
var Cd = { env: { NODE_ENV: "production" } };
function wd(l, o) {
  (o == null || o > l.length) && (o = l.length);
  for (var c = 0, s = Array(o); c < o; c++) s[c] = l[c];
  return s;
}
function fT(l) {
  if (Array.isArray(l)) return l;
}
function dT(l) {
  if (Array.isArray(l)) return wd(l);
}
function ll(l, o, c) {
  return (o = bT(o)) in l ? Object.defineProperty(l, o, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : l[o] = c, l;
}
function mT(l) {
  if (typeof Symbol < "u" && l[Symbol.iterator] != null || l["@@iterator"] != null) return Array.from(l);
}
function hT(l, o) {
  var c = l == null ? null : typeof Symbol < "u" && l[Symbol.iterator] || l["@@iterator"];
  if (c != null) {
    var s, u, d, h, p = [], y = !0, T = !1;
    try {
      if (d = (c = c.call(l)).next, o !== 0) for (; !(y = (s = d.call(c)).done) && (p.push(s.value), p.length !== o); y = !0) ;
    } catch (M) {
      T = !0, u = M;
    } finally {
      try {
        if (!y && c.return != null && (h = c.return(), Object(h) !== h)) return;
      } finally {
        if (T) throw u;
      }
    }
    return p;
  }
}
function gT() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pT() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function FA(l, o) {
  var c = Object.keys(l);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(l);
    o && (s = s.filter(function(u) {
      return Object.getOwnPropertyDescriptor(l, u).enumerable;
    })), c.push.apply(c, s);
  }
  return c;
}
function In(l) {
  for (var o = 1; o < arguments.length; o++) {
    var c = arguments[o] != null ? arguments[o] : {};
    o % 2 ? FA(Object(c), !0).forEach(function(s) {
      ll(l, s, c[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(l, Object.getOwnPropertyDescriptors(c)) : FA(Object(c)).forEach(function(s) {
      Object.defineProperty(l, s, Object.getOwnPropertyDescriptor(c, s));
    });
  }
  return l;
}
function AT(l, o) {
  if (l == null) return {};
  var c, s, u = yT(l, o);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(l);
    for (s = 0; s < d.length; s++) c = d[s], o.indexOf(c) === -1 && {}.propertyIsEnumerable.call(l, c) && (u[c] = l[c]);
  }
  return u;
}
function yT(l, o) {
  if (l == null) return {};
  var c = {};
  for (var s in l) if ({}.hasOwnProperty.call(l, s)) {
    if (o.indexOf(s) !== -1) continue;
    c[s] = l[s];
  }
  return c;
}
function qA(l, o) {
  return fT(l) || hT(l, o) || b1(l, o) || gT();
}
function Dd(l) {
  return dT(l) || mT(l) || b1(l) || pT();
}
function vT(l, o) {
  if (typeof l != "object" || !l) return l;
  var c = l[Symbol.toPrimitive];
  if (c !== void 0) {
    var s = c.call(l, o);
    if (typeof s != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(l);
}
function bT(l) {
  var o = vT(l, "string");
  return typeof o == "symbol" ? o : o + "";
}
function lu(l) {
  "@babel/helpers - typeof";
  return lu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, lu(l);
}
function b1(l, o) {
  if (l) {
    if (typeof l == "string") return wd(l, o);
    var c = {}.toString.call(l).slice(8, -1);
    return c === "Object" && l.constructor && (c = l.constructor.name), c === "Map" || c === "Set" ? Array.from(l) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? wd(l, o) : void 0;
  }
}
var ST = "7.0.0", Bd;
try {
  var OT = require("@fortawesome/fontawesome-svg-core/package.json");
  Bd = OT.version;
} catch {
  Bd = typeof Cd < "u" && Cd.env.FA_VERSION || "7.0.0";
}
function TT(l) {
  var o = l.beat, c = l.fade, s = l.beatFade, u = l.bounce, d = l.shake, h = l.flash, p = l.spin, y = l.spinPulse, T = l.spinReverse, M = l.pulse, C = l.fixedWidth, x = l.inverse, J = l.border, j = l.listItem, I = l.flip, k = l.size, K = l.rotation, X = l.pull, tt = l.swapOpacity, et = l.rotateBy, lt = l.widthAuto, Q = ET(Bd, ST), G = ll(ll(ll(ll(ll(ll({
    "fa-beat": o,
    "fa-fade": c,
    "fa-beat-fade": s,
    "fa-bounce": u,
    "fa-shake": d,
    "fa-flash": h,
    "fa-spin": p,
    "fa-spin-reverse": T,
    "fa-spin-pulse": y,
    "fa-pulse": M,
    "fa-fw": C,
    "fa-inverse": x,
    "fa-border": J,
    "fa-li": j,
    "fa-flip": I === !0,
    "fa-flip-horizontal": I === "horizontal" || I === "both",
    "fa-flip-vertical": I === "vertical" || I === "both"
  }, "fa-".concat(k), typeof k < "u" && k !== null), "fa-rotate-".concat(K), typeof K < "u" && K !== null && K !== 0), "fa-pull-".concat(X), typeof X < "u" && X !== null), "fa-swap-opacity", tt), "fa-rotate-by", Q && et), "fa-width-auto", Q && lt);
  return Object.keys(G).map(function(P) {
    return G[P] ? P : null;
  }).filter(function(P) {
    return P;
  });
}
function ET(l, o) {
  for (var c = l.split("-"), s = qA(c, 2), u = s[0], d = s[1], h = o.split("-"), p = qA(h, 2), y = p[0], T = p[1], M = u.split("."), C = y.split("."), x = 0; x < Math.max(M.length, C.length); x++) {
    var J = M[x] || "0", j = C[x] || "0", I = parseInt(J, 10), k = parseInt(j, 10);
    if (I !== k)
      return I > k;
  }
  for (var K = 0; K < Math.max(M.length, C.length); K++) {
    var X = M[K] || "0", tt = C[K] || "0";
    if (X !== tt && X.length !== tt.length)
      return X.length < tt.length;
  }
  return !(d && !T);
}
function xT(l) {
  return l = l - 0, l === l;
}
function S1(l) {
  return xT(l) ? l : (l = l.replace(/[\-_\s]+(.)?/g, function(o, c) {
    return c ? c.toUpperCase() : "";
  }), l.substr(0, 1).toLowerCase() + l.substr(1));
}
var NT = ["style"];
function CT(l) {
  return l.charAt(0).toUpperCase() + l.slice(1);
}
function wT(l) {
  return l.split(";").map(function(o) {
    return o.trim();
  }).filter(function(o) {
    return o;
  }).reduce(function(o, c) {
    var s = c.indexOf(":"), u = S1(c.slice(0, s)), d = c.slice(s + 1).trim();
    return u.startsWith("webkit") ? o[CT(u)] = d : o[u] = d, o;
  }, {});
}
function O1(l, o) {
  var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof o == "string")
    return o;
  var s = (o.children || []).map(function(y) {
    return O1(l, y);
  }), u = Object.keys(o.attributes || {}).reduce(function(y, T) {
    var M = o.attributes[T];
    switch (T) {
      case "class":
        y.attrs.className = M, delete o.attributes.class;
        break;
      case "style":
        y.attrs.style = wT(M);
        break;
      default:
        T.indexOf("aria-") === 0 || T.indexOf("data-") === 0 ? y.attrs[T.toLowerCase()] = M : y.attrs[S1(T)] = M;
    }
    return y;
  }, {
    attrs: {}
  }), d = c.style, h = d === void 0 ? {} : d, p = AT(c, NT);
  return u.attrs.style = In(In({}, u.attrs.style), h), l.apply(void 0, [o.tag, In(In({}, u.attrs), p)].concat(Dd(s)));
}
var T1 = !1;
try {
  T1 = Cd.env.NODE_ENV === "production";
} catch {
}
function DT() {
  if (!T1 && console && typeof console.error == "function") {
    var l;
    (l = console).error.apply(l, arguments);
  }
}
function KA(l) {
  if (l && lu(l) === "object" && l.prefix && l.iconName && l.icon)
    return l;
  if (Nd.icon)
    return Nd.icon(l);
  if (l === null)
    return null;
  if (l && lu(l) === "object" && l.prefix && l.iconName)
    return l;
  if (Array.isArray(l) && l.length === 2)
    return {
      prefix: l[0],
      iconName: l[1]
    };
  if (typeof l == "string")
    return {
      prefix: "fas",
      iconName: l
    };
}
function Wf(l, o) {
  return Array.isArray(o) && o.length > 0 || !Array.isArray(o) && o ? ll({}, l, o) : {};
}
var ZA = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  // the fixedWidth property has been deprecated as of version 7
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  rotateBy: !1,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1,
  widthAuto: !1
}, je = /* @__PURE__ */ ee.forwardRef(function(l, o) {
  var c = In(In({}, ZA), l), s = c.icon, u = c.mask, d = c.symbol, h = c.className, p = c.title, y = c.titleId, T = c.maskId, M = KA(s), C = Wf("classes", [].concat(Dd(TT(c)), Dd((h || "").split(" ")))), x = Wf("transform", typeof c.transform == "string" ? Nd.transform(c.transform) : c.transform), J = Wf("mask", KA(u)), j = sT(M, In(In(In(In({}, C), x), J), {}, {
    symbol: d,
    title: p,
    titleId: y,
    maskId: T
  }));
  if (!j)
    return DT("Could not find icon", M), null;
  var I = j.abstract, k = {
    ref: o
  };
  return Object.keys(c).forEach(function(K) {
    ZA.hasOwnProperty(K) || (k[K] = c[K]);
  }), BT(I[0], k);
});
je.displayName = "FontAwesomeIcon";
je.propTypes = {
  beat: O.bool,
  border: O.bool,
  beatFade: O.bool,
  bounce: O.bool,
  className: O.string,
  fade: O.bool,
  flash: O.bool,
  mask: O.oneOfType([O.object, O.array, O.string]),
  maskId: O.string,
  // the fixedWidth property has been deprecated as of version 7
  fixedWidth: O.bool,
  inverse: O.bool,
  flip: O.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: O.oneOfType([O.object, O.array, O.string]),
  listItem: O.bool,
  pull: O.oneOf(["right", "left"]),
  pulse: O.bool,
  rotation: O.oneOf([0, 90, 180, 270]),
  rotateBy: O.bool,
  shake: O.bool,
  size: O.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: O.bool,
  spinPulse: O.bool,
  spinReverse: O.bool,
  symbol: O.oneOfType([O.bool, O.string]),
  title: O.string,
  titleId: O.string,
  transform: O.oneOfType([O.string, O.object]),
  swapOpacity: O.bool,
  widthAuto: O.bool
};
var BT = O1.bind(null, ee.createElement);
const E1 = ({
  columnIndex: l,
  column: { title: o, links: c },
  isOpen: s = !1,
  onToggle: u
}) => {
  const [d, h] = vn(s), y = typeof window < "u" ? window.innerWidth >= 1260 : !1, [T, M] = vn(y), C = Gl(null);
  Pe(() => {
    !T && u && x(s), h(s);
  }, [s, T, u]), Pe(() => {
    const j = window.matchMedia("screen and (min-width: 1260px)"), I = (k) => M(k.matches);
    return j.addEventListener("change", I), I(j), () => j.removeEventListener("change", I);
  }, []);
  const x = (j) => {
    const I = C == null ? void 0 : C.current;
    if (!I || !I.animate) return;
    I.classList.add("footer-collapsing");
    const k = I.animate(
      [
        {
          maxHeight: j ? `${I.scrollHeight}px` : "0px"
        }
      ],
      {
        duration: 250,
        easing: "ease-in-out",
        fill: "forwards"
      }
    );
    k.onfinish = () => {
      I.classList.remove("footer-collapsing"), j ? I.classList.add("footer-column-show") : I.classList.remove("footer-column-show");
    };
  }, J = () => {
    if (T) {
      h(!0);
      return;
    }
    u ? u() : h((j) => {
      const I = !j;
      return x(I), I;
    });
  };
  return /* @__PURE__ */ b.jsx("div", { className: "col-xl flex-footer testname-column", children: /* @__PURE__ */ b.jsxs("div", { className: "card accordion-item desktop-disable-xl", children: [
    /* @__PURE__ */ b.jsx("div", { className: "footer-accordion-header", children: /* @__PURE__ */ b.jsx("div", { className: "h5", children: T ? /* @__PURE__ */ b.jsx("p", { className: "accordion-button", children: o }) : /* @__PURE__ */ b.jsxs(
      "button",
      {
        id: `footlink-header-${l}`,
        className: "footer-accordion-button",
        "aria-expanded": d || T,
        "aria-controls": `footlink-${l}`,
        onClick: J,
        type: "button",
        disabled: T,
        children: [
          o,
          /* @__PURE__ */ b.jsx(
            je,
            {
              className: d || T ? "column-open" : "",
              icon: V0
            }
          )
        ]
      }
    ) }) }),
    /* @__PURE__ */ b.jsx(
      "div",
      {
        id: `footlink-${l}`,
        className: "footer-accordion-body",
        role: "region",
        ref: C,
        children: c.map((j) => /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: j.url,
            title: j.title,
            children: j.text
          },
          `footlink-${o}-link-${j.text}`
        ))
      }
    )
  ] }) });
};
E1.propTypes = {
  columnIndex: O.number.isRequired,
  column: Me.shape({
    title: O.string,
    links: Me.arrayOf(
      Me.shape({
        url: O.string.isRequired,
        title: O.string,
        text: O.string.isRequired
      })
    )
  }),
  isOpen: O.bool,
  onToggle: O.func
};
const _d = ({
  contact: { title: l = "", contactLink: o = "", contributionLink: c = "", columns: s },
  isUnbranded: u = !1
}) => {
  const [d, h] = vn(
    /** @type {number | null} */
    null
  );
  return /* @__PURE__ */ b.jsx("div", { className: "wrapper", id: "wrapper-footer-columns", "data-testid": "contact", children: /* @__PURE__ */ b.jsx("div", { className: "container", id: "footer-columns", children: /* @__PURE__ */ b.jsxs("div", { className: "row", "data-testid": "columns-container", children: [
    /* @__PURE__ */ b.jsxs("div", { className: "col-xl-3", id: "info-column", children: [
      /* @__PURE__ */ b.jsx("div", { className: "h5", children: l }),
      o && /* @__PURE__ */ b.jsx("p", { className: "contact-link", children: /* @__PURE__ */ b.jsx("a", { href: o, children: "Contact Us" }) }),
      !u && c && /* @__PURE__ */ b.jsx(
        "p",
        {
          className: "contribute-button",
          "data-testid": "contact-contribution-link",
          children: /* @__PURE__ */ b.jsx(
            Zi,
            {
              color: "gold",
              href: c,
              text: "Support ASU",
              classes: "btn"
            }
          )
        }
      )
    ] }),
    s && s.length && /* @__PURE__ */ b.jsx(b.Fragment, { children: s.map((p, y) => /* @__PURE__ */ b.jsx(
      E1,
      {
        columnIndex: y,
        column: p,
        isOpen: d === y,
        onToggle: () => {
          h(
            d === y ? null : y
          );
        }
      },
      `footlink-${p.title}`
    )) })
  ] }) }) });
};
_d.propTypes = {
  contact: Me.shape({
    title: O.string.isRequired,
    contactLink: O.string.isRequired,
    contributionLink: O.string,
    columns: Me.arrayOf(
      Me.shape({
        title: O.string,
        links: Me.arrayOf(
          Me.shape({
            url: O.string.isRequired,
            title: O.string,
            text: O.string.isRequired
          })
        )
      })
    )
  }),
  isUnbranded: Me.bool
};
const MT = "data:image/png;base64,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", Qi = {
  MAPS_AND_LOCATIONS: "https://www.asu.edu/about/locations-maps",
  JOBS: "https://cfo.asu.edu/applicant",
  DIRECTORY: "https://search.asu.edu/?search-tabs=web_dir_faculty_staff",
  CONTACT_ASU: "https://www.asu.edu/about/contact",
  MY_ASU: "https://my.asu.edu/",
  RANKINGS: "https://www.asu.edu/rankings"
}, ar = {
  COPYRIGHT_AND_TRADEMARK: "https://www.asu.edu/about/copyright-trademark",
  ACCESSIBILITY_REPORT: "https://accessibility.asu.edu/report",
  PRIVACY: "https://www.asu.edu/about/privacy",
  TERMS_OF_USE: "https://www.asu.edu/about/terms-of-use",
  EMERGENCY: "https://www.asu.edu/emergency/"
}, Vi = {
  type: "internal link",
  section: "secondary footer"
}, zT = () => /* @__PURE__ */ b.jsx(
  "div",
  {
    className: "wrapper",
    id: "wrapper-footer-innovation",
    "data-testid": "innovation",
    children: /* @__PURE__ */ b.jsx("div", { className: "container", id: "footer-innovation", children: /* @__PURE__ */ b.jsx("div", { className: "row", children: /* @__PURE__ */ b.jsx("div", { className: "col", children: /* @__PURE__ */ b.jsxs("div", { className: "d-flex footer-innovation-links", children: [
      /* @__PURE__ */ b.jsxs("nav", { className: "nav", "aria-label": "University Services", children: [
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Qi.MAPS_AND_LOCATIONS,
            onFocus: () => wt({
              ...Vi,
              text: "maps and locations"
            }),
            children: "Maps and Locations"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Qi.JOBS,
            onFocus: () => wt({
              ...Vi,
              text: "jobs"
            }),
            children: "Jobs"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Qi.DIRECTORY,
            onFocus: () => wt({
              ...Vi,
              text: "directory"
            }),
            children: "Directory"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Qi.CONTACT_ASU,
            onFocus: () => wt({
              ...Vi,
              text: "contact asu"
            }),
            children: "Contact ASU"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Qi.MY_ASU,
            onFocus: () => wt({
              ...Vi,
              text: "my asu"
            }),
            children: "My ASU"
          }
        )
      ] }),
      /* @__PURE__ */ b.jsx(
        "a",
        {
          className: "img-link",
          href: Qi.RANKINGS,
          onFocus: () => wt({
            ...Vi,
            text: "#1 in the u.s. for innovation"
          }),
          children: /* @__PURE__ */ b.jsx(
            "img",
            {
              src: MT,
              alt: "Repeatedly ranked #1 on 30+ lists in the last 3 years",
              width: "459",
              height: "100",
              loading: "lazy",
              decoding: "async"
            }
          )
        }
      )
    ] }) }) }) })
  }
), lr = {
  type: "internal link",
  section: "tertiary footer"
}, LT = () => {
  function l() {
    try {
      return window.location.href;
    } catch (o) {
      return console.error(o), "";
    }
  }
  return /* @__PURE__ */ b.jsx("div", { className: "wrapper", id: "wrapper-footer-colophon", "data-testid": "legal", children: /* @__PURE__ */ b.jsx("div", { className: "container", id: "footer-colophon", children: /* @__PURE__ */ b.jsx("div", { className: "row", children: /* @__PURE__ */ b.jsx("div", { className: "col", children: /* @__PURE__ */ b.jsxs(
    "nav",
    {
      className: "nav colophon",
      "aria-label": "University Legal and Compliance",
      children: [
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: ar.COPYRIGHT_AND_TRADEMARK,
            onFocus: () => wt({
              ...lr,
              text: "copyright and trademark"
            }),
            children: "Copyright and Trademark"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: `${ar.ACCESSIBILITY_REPORT}#a11yref=${l()}`,
            onFocus: () => wt({
              ...lr,
              text: "accessibility"
            }),
            children: "Accessibility"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: ar.TERMS_OF_USE,
            onFocus: () => wt({
              ...lr,
              text: "terms of use"
            }),
            children: "Terms of Use"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: ar.EMERGENCY,
            onFocus: () => wt({
              ...lr,
              text: "emergency"
            }),
            children: "Emergency"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: ar.PRIVACY,
            onFocus: () => wt({
              ...lr,
              text: "privacy"
            }),
            children: "Privacy"
          }
        ),
        /* @__PURE__ */ b.jsx("button", { type: "button", id: "manualConsentoptout", children: "Manage my privacy settings" })
      ]
    }
  ) }) }) }) });
};
const RT = {
  prefix: "fab",
  iconName: "square-instagram",
  icon: [448, 512, ["instagram-square"], "e055", "M194.4 211.7a53.3 53.3 0 1 0 59.3 88.7 53.3 53.3 0 1 0 -59.3-88.7zm142.3-68.4c-5.2-5.2-11.5-9.3-18.4-12c-18.1-7.1-57.6-6.8-83.1-6.5c-4.1 0-7.9 .1-11.2 .1c-3.3 0-7.2 0-11.4-.1c-25.5-.3-64.8-.7-82.9 6.5c-6.9 2.7-13.1 6.8-18.4 12s-9.3 11.5-12 18.4c-7.1 18.1-6.7 57.7-6.5 83.2c0 4.1 .1 7.9 .1 11.1s0 7-.1 11.1c-.2 25.5-.6 65.1 6.5 83.2c2.7 6.9 6.8 13.1 12 18.4s11.5 9.3 18.4 12c18.1 7.1 57.6 6.8 83.1 6.5c4.1 0 7.9-.1 11.2-.1c3.3 0 7.2 0 11.4 .1c25.5 .3 64.8 .7 82.9-6.5c6.9-2.7 13.1-6.8 18.4-12s9.3-11.5 12-18.4c7.2-18 6.8-57.4 6.5-83c0-4.2-.1-8.1-.1-11.4s0-7.1 .1-11.4c.3-25.5 .7-64.9-6.5-83l0 0c-2.7-6.9-6.8-13.1-12-18.4zm-67.1 44.5A82 82 0 1 1 178.4 324.2a82 82 0 1 1 91.1-136.4zm29.2-1.3c-3.1-2.1-5.6-5.1-7.1-8.6s-1.8-7.3-1.1-11.1s2.6-7.1 5.2-9.8s6.1-4.5 9.8-5.2s7.6-.4 11.1 1.1s6.5 3.9 8.6 7s3.2 6.8 3.2 10.6c0 2.5-.5 5-1.4 7.3s-2.4 4.4-4.1 6.2s-3.9 3.2-6.2 4.2s-4.8 1.5-7.3 1.5l0 0c-3.8 0-7.5-1.1-10.6-3.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM357 389c-18.7 18.7-41.4 24.6-67 25.9c-26.4 1.5-105.6 1.5-132 0c-25.6-1.3-48.3-7.2-67-25.9s-24.6-41.4-25.8-67c-1.5-26.4-1.5-105.6 0-132c1.3-25.6 7.1-48.3 25.8-67s41.5-24.6 67-25.8c26.4-1.5 105.6-1.5 132 0c25.6 1.3 48.3 7.1 67 25.8s24.6 41.4 25.8 67c1.5 26.3 1.5 105.4 0 131.9c-1.3 25.6-7.1 48.3-25.8 67z"]
}, UT = RT, HT = {
  prefix: "fab",
  iconName: "square-youtube",
  icon: [448, 512, [61798, "youtube-square"], "f431", "M282 256.2l-95.2-54.1V310.3L282 256.2zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm14.4 136.1c7.6 28.6 7.6 88.2 7.6 88.2s0 59.6-7.6 88.1c-4.2 15.8-16.5 27.7-32.2 31.9C337.9 384 224 384 224 384s-113.9 0-142.2-7.6c-15.7-4.2-28-16.1-32.2-31.9C42 315.9 42 256.3 42 256.3s0-59.7 7.6-88.2c4.2-15.8 16.5-28.2 32.2-32.4C110.1 128 224 128 224 128s113.9 0 142.2 7.7c15.7 4.2 28 16.6 32.2 32.4z"]
}, jT = HT, XT = {
  prefix: "fab",
  iconName: "tiktok",
  icon: [448, 512, [], "e07b", "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"]
}, QT = {
  prefix: "fab",
  iconName: "square-facebook",
  icon: [448, 512, ["facebook-square"], "f082", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h98.2V334.2H109.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H255V480H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
}, VT = QT, YT = {
  prefix: "fab",
  iconName: "linkedin",
  icon: [448, 512, [], "f08c", "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"]
}, GT = {
  prefix: "fab",
  iconName: "square-x-twitter",
  icon: [448, 512, [], "e61a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"]
}, IT = "data:image/png;base64,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", Xl = {
  type: "external link",
  section: "primary footer"
}, $d = ({
  social: {
    logoUrl: l,
    unitLogo: o = IT,
    mediaLinks: c = {
      facebook: "",
      twitter: "",
      linkedIn: "",
      tiktok: "",
      instagram: "",
      youtube: ""
    }
  }
}) => /* @__PURE__ */ b.jsx("div", { className: "wrapper", id: "wrapper-endorsed-footer", "data-testid": "social", children: /* @__PURE__ */ b.jsx("div", { className: "container", id: "endorsed-footer", children: /* @__PURE__ */ b.jsxs("div", { className: "row", children: [
  /* @__PURE__ */ b.jsx("div", { className: "col-md", id: "endorsed-logo", children: /* @__PURE__ */ b.jsx(
    "a",
    {
      href: l,
      onFocus: () => wt({
        ...Xl,
        type: "internal link",
        text: "asu logo"
      }),
      children: /* @__PURE__ */ b.jsx(
        "img",
        {
          src: o,
          alt: "ASU University Technology Office Arizona State University."
        }
      )
    }
  ) }),
  c && /* @__PURE__ */ b.jsx("div", { className: "col-md", id: "social-media", children: /* @__PURE__ */ b.jsxs("nav", { className: "nav", "aria-label": "Social Media", children: [
    c.facebook && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.facebook,
        "data-testid": "facebook",
        onFocus: () => wt({
          ...Xl,
          text: "facebook icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          je,
          {
            title: "Facebook Social Media Icon",
            icon: VT,
            className: "social-icon"
          }
        )
      }
    ),
    c.twitter && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.twitter,
        "data-testid": "twitter",
        onFocus: () => wt({
          ...Xl,
          text: "twitter icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          je,
          {
            title: "Twitter Social Media Icon",
            icon: GT,
            className: "social-icon"
          }
        )
      }
    ),
    c.instagram && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.instagram,
        "data-testid": "instagram",
        onFocus: () => wt({
          ...Xl,
          text: "instagram icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          je,
          {
            title: "Instagram Social Media Icon",
            icon: UT,
            className: "social-icon"
          }
        )
      }
    ),
    c.youtube && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.youtube,
        "data-testid": "youtube",
        onFocus: () => wt({
          ...Xl,
          text: "youtube icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          je,
          {
            title: "YouTube Social Media Icon",
            icon: jT,
            className: "social-icon"
          }
        )
      }
    ),
    c.linkedIn && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.linkedIn,
        "data-testid": "linkedin",
        onFocus: () => wt({
          ...Xl,
          text: "linkedin icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          je,
          {
            title: "LinkedIn Social Media Icon",
            icon: YT,
            className: "social-icon"
          }
        )
      }
    ),
    c.tiktok && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.tiktok,
        "data-testid": "tiktok",
        onFocus: () => wt({
          ...Xl,
          text: "tiktok icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          je,
          {
            title: "TikTok Social Media Icon",
            icon: XT,
            className: "social-icon"
          }
        )
      }
    )
  ] }) })
] }) }) });
$d.propTypes = {
  social: Me.shape({
    unitLogo: O.string,
    mediaLinks: Me.shape({
      facebook: O.string,
      twitter: O.string,
      linkedIn: O.string,
      tiktok: O.string,
      instagram: O.string,
      youtube: O.string
    })
  })
};
const kT = fu`
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
`, FT = fu`
  display: flex;
  align-items: center;
`, qT = Xe.footer`
  // Variables
  --color-divider-darker: #1e1e1e;
  --color-base-white: #ffffff;
  --color-base-grey-2: #e8e8e8;
  --color-base-gold: var(--bs-gold, #ffc627);
  --color-divider-lighter: #393939;
  --color-base-grey-7: #191919;
  --color-base-grey-4: #bfbfbf;

  // Base Styles
  * {
    box-sizing: border-box;
    font-family:
      Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, sans-serif;
    line-height: 1.5rem;

    a:focus,
    button:focus {
      outline: none;
      box-shadow:
        0 0 0 2px var(--color-base-white),
        0 0 0 4px var(--color-base-grey-7) !important;
      -webkit-tap-highlight-color: transparent;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
  }

  .btn,
  a[class^="button-"] {
    text-decoration: none !important;
    padding: 1rem 2rem;
    white-space: nowrap;
    line-height: 1rem;
    width: max-content !important;
    font-size: 1rem;
    display: inline-block;
    &:active {
      transform: scale(0.95);
    }
  }

  h5,
  .h5 {
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: -0.015rem;
    margin: 1rem 0;
  }

  .nav {
    display: flex;
    flex-wrap: wrap;
    ${kT}
  }

  // Footer Sections
  #wrapper-endorsed-footer,
  #wrapper-footer-columns {
    background: var(--color-divider-darker);

    h5,
    .h5 {
      color: var(--color-base-white);
      font-weight: 700;
    }
  }

  #wrapper-endorsed-footer {
    a {
      color: var(--color-base-grey-2);
    }

    & + #wrapper-footer-columns {
      border-top: 2px solid var(--color-divider-lighter);
    }
  }

  #wrapper-footer-innovation {
    background-color: var(--color-base-gold);
  }

  #wrapper-footer-colophon {
    background-color: var(--color-base-grey-2);
  }

  #wrapper-footer-innovation,
  #wrapper-footer-colophon {
    a {
      margin-right: 1.5rem;
      text-decoration: none;
      color: var(--color-base-grey-7);
    }
  }

  // Endorsed Footer
  #endorsed-logo {
    --endorsed-logo-display: block;
    --endorsed-logo-padding-top: 12px;
    --endorsed-logo-padding-bottom: 12px;
    --endorsed-logo-img-max-height: 6rem;
    --endorsed-logo-img-width: 100%;
    --endorsed-logo-img-max-width: 320px;
    padding-top: var(--endorsed-logo-padding-top);
    padding-bottom: var(--endorsed-logo-padding-bottom);
    display: var(--endorsed-logo-display);
    align-items: center;

    img {
      width: var(--endorsed-logo-img-width);
      max-width: var(--endorsed-logo-img-max-width);
      height: auto;
      max-height: var(--endorsed-logo-img-max-height);
      transform: scale(1.13);
      padding: 0;
      margin: 0;
    }

    @media (min-width: 768px) {
      --endorsed-logo-display: flex;
      --endorsed-logo-padding-top: 20px;
      --endorsed-logo-padding-bottom: 20px;
      --endorsed-logo-img-max-height: 6rem;
      --endorsed-logo-img-width: auto;
    }
  }

  #endorsed-footer {
    #social-media {
      .nav {
        padding-bottom: 1.5rem;

        .nav-link .social-icon {
          &:hover {
            color: var(--color-base-white);
          }
        }

        @media (min-width: 768px) {
          padding: 2.5rem 0;
          justify-content: flex-end;
        }
      }

      .nav-link {
        padding: 0.75rem 1rem 0.5rem 1rem;
        font-size: 2rem;
        color: var(--color-base-grey-4);
        line-height: 1;
        padding-top: 7px;

        &:first-child {
          @media (max-width: 575.98px) {
            padding-left: 0;
          }
        }

        &:last-child {
          @media (min-width: 768px) {
            /* padding-right: 0; */
          }
        }
      }
    }
  }

  // Footer Columns
  #footer-columns {
    #info-column {
      .contact-link {
        margin-bottom: 1.5rem;

        a {
          color: var(--color-base-grey-2);
          line-height: 1.5rem;
          text-decoration: underline;

          &:hover {
            color: var(--color-base-gold);
          }
        }
      }

      .contribute-button {
        margin-bottom: 1.5rem;
      }
    }

    .flex-footer {
      .accordion-item,
      .footer-accordion-header,
      .footer-accordion-body {
        background: var(--color-divider-darker);
        color: var(--color-base-white);
        border: 0;
      }

      .footer-accordion-header {
        border-top: 1px solid var(--color-divider-lighter);
        padding-left: 0;

        h5,
        .h5 {
          margin: 0;
          a,
          .footer-accordion-button {
            ${FT}
            justify-content: space-between;
          }
        }

        a,
        .footer-accordion-button {
          color: var(--color-base-grey-2);
          padding: 1.5rem 0;
          text-decoration: none;
          background: none;
          border: none;
          font: inherit;
          color: inherit;
          cursor: pointer;
          text-align: inherit;
          width: 100%;
          transition: background-color 0.15s ease;

          &:hover {
            background: var(--color-divider-darker);
          }

          svg,
          fa-chevron-up {
            margin-left: 1rem;
            transition: 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            margin-left: 0.5rem;
            font-size: 1rem;

            &.column-open {
              transform: rotate(180deg);
            }
          }
        }

        @media (min-width: 1260px) {
          border-top: 0;
          padding: 0;
          a,
          .footer-accordion-button {
            padding: 0;
            cursor: default;
          }

          span {
            display: none;
          }
        }
      }

      .footer-accordion-body {
        display: none;
        overflow: hidden;
        padding: 0 0 0 1.5rem;

        &.footer-collapsing {
          display: block;
          max-height: 0px;
        }
        &.footer-column-show {
          display: block;
          max-height: 1000px;
        }

        .nav-link {
          color: var(--color-base-grey-2);
          padding: 0 0 1rem;
          line-height: 1.5rem;
          text-decoration: none;
          display: block;

          &:hover {
            color: var(--color-base-gold);
            text-decoration: underline;
          }
        }

        @media (min-width: 1260px) {
          padding: 0;
          display: block;
          min-height: fit-content;
          overflow: visible;
        }
      }
    }

    @media (min-width: 1260px) {
      padding-bottom: 3rem;
      padding-top: 3rem;
      h5,
      .h5 {
        margin: 0 0 1.5rem 0;
      }
      .footer-accordion-header:has(.h5, h5) {
        h5,
        .h5 {
          margin: 0 0 1.5rem 0;
        }
      }
    }
  }

  // Footer Innovation
  #footer-innovation {
    .footer-innovation-links {
      justify-content: space-between;
      align-items: center;
      font-weight: 700;

      .img-link {
        order: 2;
        margin-right: 0;
        transform: translate(1.5rem, 0);
        padding-top: 24px;
        padding-bottom: 24px;

        img {
          height: auto;
          width: auto;
          max-width: 320px;
        }
      }

      .nav-link {
        padding: 0;
      }

      @media (max-width: 991.98px) {
        flex-direction: column;
        padding: 0.5rem 0;

        .img-link {
          margin-right: 0;
          transform: none;

          img {
            width: 100%;
            height: auto;
            order: -1;
          }
        }

        .nav {
          display: grid;
          grid-template-rows: 1fr 1fr 1fr;
          grid-auto-flow: column;
          justify-items: start;
          width: 100%;

          .nav-link {
            margin-right: 0;
            padding: 0.5rem 0;

            &:nth-child(n + 4) {
              justify-self: end;
            }
          }
        }
      }
      @media (min-width: 991.98px) {
        .img-link {
          padding-right: 16px;
        }
      }
      @media (max-width: 576px) {
        .img-link {
          img {
            max-width: 100%;
          }
        }
      }
    }
  }

  // Footer Colophon
  #wrapper-footer-colophon {
    .colophon {
      margin: 1rem 0;
    }

    .nav-link {
      padding: 0;
    }

    @media (max-width: 767.98px) {
      .nav {
        display: grid;
        grid-template-rows: 1fr 1fr 1fr;
        grid-auto-flow: column;
        justify-items: start;
        width: 100%;

        .nav-link {
          margin-right: 0;
          padding: 0.5rem 0;

          &:nth-child(n + 4) {
            justify-self: end;
          }
        }
      }
    }
  }

  //footer manual consent opt-out
  .footer-legal-links,
  .footer-menu,
  .nav {
    &.colophon #manualConsentoptout,
    #manualConsentoptout {
      color: #484848;
      border: none;
      background-color: transparent;
      width: auto;
      cursor: pointer;
      padding: 0;
      text-align: right;
      justify-self: end;
      font-size: 1rem;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  // Bootstrap Default Stylings
  .row {
    --bs-gutter-x: 24px;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(-1 * var(--bs-gutter-y));
    margin-right: calc(-0.5 * var(--bs-gutter-x));
    margin-left: calc(-0.5 * var(--bs-gutter-x));

    > * {
      flex-shrink: 0;
      width: 100%;
      max-width: 100%;
      padding-right: calc(var(--bs-gutter-x) * 0.5);
      padding-left: calc(var(--bs-gutter-x) * 0.5);
      margin-top: var(--bs-gutter-y);
    }
  }

  .col {
    flex: 1 0 0%;
  }

  .d-flex {
    display: flex;
  }

  .container {
    --bs-gutter-x: 24px;
    --bs-gutter-y: 0;
    width: 100%;
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
    margin-right: auto;
    margin-left: auto;
  }

  @media (max-width: 767.98px) {
    .container,
    .container-fluid,
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }

  @media (min-width: 576px) {
    .container {
      max-width: 540px;
    }
  }

  @media (min-width: 768px) {
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
      max-width: 768px;
    }
    .col-md {
      flex: 1 0 0%;
    }
  }

  @media (min-width: 992px) {
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
      max-width: 992px;
    }
  }

  @media (min-width: 1260px) {
    .col-xl-3 {
      flex: 0 0 auto;
      width: 25%;
    }
    .col-xl {
      flex: 1 0 0%;
    }
    .accordion-item {
      svg,
      .fa-chevron-up {
        display: none;
      }
    }
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
      max-width: 1224px;
    }
  }
`, x1 = ({ isUnbranded: l }) => /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
  !l && /* @__PURE__ */ b.jsx(zT, {}),
  !l && /* @__PURE__ */ b.jsx(LT, {})
] });
x1.propTypes = {
  isUnbranded: Me.bool
};
const N1 = ({ social: l, contact: o, isUnbranded: c = !1 }) => (Pe(() => {
  typeof window < "u" && u0({
    packageName: "component-StyledFooter",
    component: "Component Footer",
    type: "NA",
    configuration: {
      social: l,
      contact: o
    }
  });
}, []), /* @__PURE__ */ b.jsxs(qT, { role: "contentinfo", children: [
  !c && l && /* @__PURE__ */ b.jsx($d, { social: l }),
  o && /* @__PURE__ */ b.jsx(_d, { contact: o, isUnbranded: c }),
  /* @__PURE__ */ b.jsx(x1, { isUnbranded: c })
] }));
N1.propTypes = {
  social: Me.shape($d.propTypes),
  contact: Me.shape(_d.propTypes),
  isUnbranded: Me.bool
};
const KT = (l, o, c) => {
  a0.createRoot(c).render(ee.createElement(l, o));
}, EE = ({ targetSelector: l, props: o }) => {
  KT(N1, o, document.querySelector(l));
}, ZT = "data:image/png;base64,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", PT = { Lg: "992px", Xl: "1260px" }, C1 = kv(), w1 = ({ initialValue: l, children: o }) => {
  const c = {
    ...l,
    breakpoint: PT[l.breakpoint]
  };
  return /* @__PURE__ */ b.jsx(C1.Provider, { value: c, children: o });
};
w1.propTypes = {
  initialValue: O.shape(Qb).isRequired,
  children: O.node.isRequired
};
const Kn = () => {
  const l = Fv(C1);
  if (l === void 0)
    throw new Error("useAppContext must be used within a AppContextProvider");
  return l;
}, ut = "uds-hdr-", D = {
  // Login component
  LOGIN_STATUS: `${ut}login-status`,
  USER_NAME: `${ut}name`,
  SIGNOUT: `${ut}signout`,
  // Navigation
  NAV_LINK: `${ut}nav-link`,
  NAV_ITEM_SELECTED: `${ut}nav-item-selected`,
  OPEN_LINK: `${ut}open-link`,
  ICON_NAV_ITEM: `${ut}icon-nav-item`,
  MOBILE_ONLY: `${ut}mobile-only`,
  CHEVRON_ICON: `${ut}chevron-icon`,
  OPEN: `${ut}open`,
  // Dropdown
  HEADER_DROPDOWN: (l) => `${ut}header-dropdown-${l}`,
  OPENED: `${ut}opened`,
  DROPDOWN_CONTAINER: `${ut}dropdown-container`,
  DROPDOWN_CONTAINER_COLUMN: `${ut}dropdown-container-column`,
  DROPDOWN_BUTTON_CONTAINER: `${ut}dropdown-button-container`,
  // Search
  SEARCH_BUTTON: `${ut}search-button`,
  OPEN_SEARCH: `${ut}open-search`,
  SEARCH_ICON: `${ut}search-icon`,
  SUBMIT_BUTTON: `${ut}submit-button`,
  SUBMIT_SEARCH: `${ut}submit-search`,
  // Header sections
  UNIVERSAL_NAV: `${ut}universal-nav`,
  UNIVERSAL_NAV_UNBRANDED: `${ut}universal-nav-unbranded`,
  HEADER_TOP: `${ut}header-top`,
  LINKS_CONTAINER: `${ut}links-container`,
  HEADER_MAIN: `${ut}header-main`,
  CONTENT_CONTAINER: `${ut}content-container`,
  NAV_LIST: `${ut}nav-list`,
  BUTTONS_CONTAINER: `${ut}buttons-container`,
  NAV_BUTTON: `${ut}nav-button`,
  UL_HEADING: `${ut}ul-heading`,
  // Title
  TITLE: `${ut}title`,
  PARTNER_TITLE: `${ut}partner-title`,
  UNIT_NAME: `${ut}unit-name`,
  SUBUNIT_NAME: `${ut}subunit-name`,
  TITLE_SUBUNIT_NAME: `${ut}title-subunit-name`,
  EXPAND_TITLE: `${ut}expand-title`,
  NO_NAVIGATION: `${ut}no-navigation`,
  // Partner/Logo
  PARTNER: `${ut}partner`,
  PARTNERS_LOGOS: `${ut}partners-logos`,
  LOGO_VERT: `${ut}vert`,
  LOGO_HORIZ: `${ut}horiz`,
  // Menu icons
  MENU_SEARCH_ICON: `${ut}menu-search-icon`,
  MENU_CLOSE_ICON: `${ut}menu-close-icon`,
  NAVBAR: "navbar",
  NAVBAR_EXPAND_XL: "navbar-expand-xl",
  NAVBAR_BRAND: "navbar-brand",
  NAVBAR_TOGGLER: "navbar-toggler",
  NAVBAR_NAV: "navbar-nav",
  NAV_ITEM: "nav-item",
  COLLAPSED: "collapsed",
  CONTAINER: "container",
  CONTAINER_XL: "container-xl",
  FORM_CONTROL: "form-control",
  VISUALLY_HIDDEN: "visually-hidden",
  VISUALLY_HIDDEN_FOCUSABLE: "visually-hidden-focusable",
  MOBILE_MENU_OPEN: `${ut}mobile-menu-open`
}, PA = (l) => D.HEADER_DROPDOWN(l), bn = (...l) => l.filter(Boolean).join(" "), Or = (l) => {
  const o = window == null ? void 0 : window.matchMedia(`(max-width: ${l})`), [c, s] = vn(o == null ? void 0 : o.matches), u = (d) => {
    s(d.matches);
  };
  return Pe(() => (o.addEventListener("change", u), () => o.removeEventListener("change", u)), []), c;
}, WT = Xe.div`
  background-color: ${t3};
  padding: 0.5rem 0rem;
  transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
  .${D.HEADER_TOP} {
    height: 100%;
    .nav {
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .${D.LINKS_CONTAINER} {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1.5rem;
        .${D.NAV_LINK} {
          color: ${on};
          font-size: 0.75rem;
          line-height: 1;
          white-space: nowrap;
          text-decoration: none;
          display: flex;
          align-items: center;

          &:hover {
            text-decoration: underline;
          }

          &.visually-hidden-focusable:not(:focus):not(:active) {
            clip: rect(0 0 0 0);
            clip-path: inset(100%);
            height: 1px;
            overflow: hidden;
            position: absolute;
            white-space: nowrap;
            width: 1px;
          }
        }
      }
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    width: 100%;
    min-height: auto;
    position: sticky;
    bottom: 0;
    padding: 0;
    .${D.HEADER_TOP} {
      width: 100%;
      .nav {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column-reverse;
        .${D.LINKS_CONTAINER} {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-auto-flow: row;
          justify-items: start;
          width: 100%;
          gap: 0;
          border-top: 1px solid ${ln};
          border-left: 1px solid ${ln};
          .${D.NAV_LINK} {
            white-space: normal;
            margin-right: 0;
            text-align: center;
            width: 100%;
            font-size: 0.875rem;
            padding: 1rem 1.5rem;
            border-bottom: 1px solid ${ln};
            border-right: 1px solid ${ln};
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;

            &.visually-hidden-focusable:not(:focus):not(:active) {
              border: none;
            }
          }
        }
      }
    }
  }

  @media screen and (orientation: landscape) and (max-width: ${({
  breakpoint: l
}) => l}) {
    .${D.HEADER_TOP} .nav .${D.LINKS_CONTAINER} {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  }

  /* Unbranded sites: the gray bar stays visually hidden but keyboard
  reachable, and is revealed only while a skip/accessibility link has focus. */
  &.${D.UNIVERSAL_NAV_UNBRANDED}:not(:focus-within) {
    position: absolute;
    width: 1px;
    height: 1px;
    min-height: 0;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    clip-path: inset(100%);
    white-space: nowrap;
    border: 0;
  }
`, JT = Xe.div`
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
  > a {
    padding: 0;
    margin: 0;
    color: ${on};
    text-decoration: none;
    line-height: 1;
    vertical-align: middle;
  }
  > span.${D.USER_NAME} {
    font-weight: 700;
    line-height: 1;
  }
  > a.${D.SIGNOUT}:before {
    content: "(";
    margin-left: 4px;
  }
  > a.${D.SIGNOUT}:after {
    content: ") ";
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    width: 100%;
    margin-right: 0;
    justify-content: center;
  }
`, WA = {
  section: "topbar"
}, _T = () => {
  const {
    loggedIn: l,
    userName: o,
    logoutLink: c,
    loginLink: s,
    onLoginClick: u,
    onLogoutClick: d,
    breakpoint: h
  } = Kn();
  return (
    // @ts-ignore
    /* @__PURE__ */ b.jsx(
      JT,
      {
        className: bn(D.NAV_LINK, D.LOGIN_STATUS),
        breakpoint: h,
        children: l ? /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
          o ? /* @__PURE__ */ b.jsx("span", { className: D.USER_NAME, "data-testid": "user-name", children: o }) : "",
          /* @__PURE__ */ b.jsx(
            "a",
            {
              className: D.SIGNOUT,
              href: c,
              onFocus: () => wt({
                ...WA,
                text: "sign out"
              }),
              onClick: (p) => d == null ? void 0 : d(p),
              children: "Sign Out"
            }
          )
        ] }) : /* @__PURE__ */ b.jsx(
          "a",
          {
            href: s,
            onFocus: () => wt({
              ...WA,
              text: "sign in"
            }),
            onClick: (p) => u == null ? void 0 : u(p),
            children: "Sign In"
          }
        )
      }
    )
  );
}, $T = Xe.form`
  display: flex;
  align-items: center;
  button {
    border: none;
    background: transparent;
    cursor: pointer;
  }
  .${D.SEARCH_BUTTON} {
    transition: cubic-bezier(0.19, 1, 0.19, 1);
    font-size: 0.75rem;
    line-height: 1;
    color: ${on};
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    span {
      margin-right: 0.25rem;
    }
  }
  input[name="q"] {
    width: 200px;
    background-color: ${qn};
    border: 0;
    border-radius: 0;
    padding: 0.5rem 0.5rem;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1;
    color: ${n3};
    border: 1px solid ${ln};
    outline: ${on};
    margin-left: 1.5rem;
    display: unset;
    vertical-align: middle;

    &::placeholder {
      font-size: 0.75rem;
      line-height: 1;
    }
    &:focus,
    &:focus-visible {
      border: 1px solid ${on};
    }
  }
  .${D.SUBMIT_BUTTON} {
    margin-left: 0.5rem;
  }
  .${D.CLOSE_SEARCH} {
    background-color: ${qn};
    border: 1px solid ${ln};
    border-radius: 100%;
    padding: 0.45rem 0.75rem;
    margin-left: 0.5rem;
  }
  &.${D.OPEN_SEARCH} {
    margin-left: -1rem;
    .${D.SEARCH_BUTTON} {
      transform: translate(1.9rem);
      pointer-events: none;
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    width: 100%;
    padding: 0 1rem 1rem;
    label {
      position: relative;
      font-size: 0.875rem;
      margin-bottom: 0;
      width: 100%;
      svg.${D.SEARCH_ICON} {
        position: absolute;
        top: 50%;
        left: 1rem;
        transform: translate(0, -50%);
      }
      input[name="q"] {
        width: 100%;
        margin: 0;
        padding: 0.5rem 3rem 0.5rem 2.25rem;
        font-size: 1rem;
        line-height: 1.5;

        &::placeholder {
          font-size: 1rem;
          line-height: 1.5;
        }

        &::-webkit-search-cancel-button,
        &::-webkit-search-decoration,
        &::-webkit-search-results-button,
        &::-webkit-search-results-decoration {
          display: none;
        }
      }
      .${D.SUBMIT_SEARCH} {
        position: absolute;
        top: 50%;
        right: 0.5rem;
        transform: translate(0, -50%);
        border-radius: 50%;
        width: 2rem;
        height: 2rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        background-color: ${Qd};
        color: ${qn};
        font-size: 0.75rem;
      }
    }
  }
`, Md = ({
  inputRef: l,
  hasInputValue: o,
  setHasInputValue: c,
  isMobile: s,
  style: u = {},
  className: d = "",
  onBlur: h
}) => {
  const p = (T) => {
    const M = T.target.value;
    c(M.length > 0);
  }, y = {
    ref: l,
    className: `form-control ${d}`,
    type: "search",
    name: "q",
    placeholder: "Search asu.edu",
    required: !0,
    onChange: p,
    onBlur: h,
    style: {
      paddingLeft: o ? ".5rem" : void 0,
      ...u
    }
  };
  return s ? /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
    !o && /* @__PURE__ */ b.jsx(
      je,
      {
        className: D.SEARCH_ICON,
        icon: ud
      }
    ),
    /* @__PURE__ */ b.jsx("input", { ...y }),
    o && /* @__PURE__ */ b.jsx(
      "button",
      {
        type: "submit",
        "aria-label": "Submit search",
        className: D.SUBMIT_SEARCH,
        children: /* @__PURE__ */ b.jsx(je, { icon: ud, size: "lg" })
      }
    )
  ] }) : /* @__PURE__ */ b.jsx("input", { ...y });
};
Md.propTypes = {
  inputRef: O.shape({
    current: O.instanceOf(Element)
  }).isRequired,
  hasInputValue: O.bool.isRequired,
  setHasInputValue: O.func.isRequired,
  isMobile: O.bool.isRequired,
  style: O.object,
  className: O.string,
  onBlur: O.func
};
const JA = {
  event: "search",
  action: "type",
  name: "onenter",
  type: "main search",
  region: "navbar",
  section: "topbar"
}, D1 = () => {
  const { breakpoint: l, searchUrl: o = "", site: c = "" } = Kn(), s = Or(l), u = Gl(null), [d, h] = vn(!1), [p, y] = vn(!1);
  Pe(() => {
    var C;
    d && typeof ((C = u == null ? void 0 : u.current) == null ? void 0 : C.focus) == "function" && u.current.focus();
  }, [d]);
  const T = (C) => {
    const x = C == null ? void 0 : C.currentTarget;
    C.preventDefault();
    let J = !1;
    const j = () => {
      !J && typeof (x == null ? void 0 : x.submit) == "function" && (J = !0, x.submit());
    }, I = x && x.elements ? (
      /** @type {HTMLInputElement|null} */
      x.elements.namedItem("q")
    ) : null;
    setTimeout(j, 2e3), wt({
      ...JA,
      text: I ? I.value : "",
      eventCallback: j,
      eventTimeout: 2e3
    });
  }, M = () => {
    h((C) => {
      const x = !C;
      return wt({
        ...JA,
        event: "link",
        action: "click",
        name: "onclick",
        text: x ? "search icon" : "close search icon"
      }), x;
    });
  };
  return /* @__PURE__ */ b.jsx("search", { children: /* @__PURE__ */ b.jsxs(
    $T,
    {
      breakpoint: l,
      action: o,
      onSubmit: T,
      method: "get",
      name: "gs",
      className: d ? D.OPEN_SEARCH : "",
      "data-testid": "universal-nav-search-form",
      role: "search",
      children: [
        s ? /* @__PURE__ */ b.jsx("label", { children: /* @__PURE__ */ b.jsx(
          Md,
          {
            inputRef: u,
            hasInputValue: p,
            setHasInputValue: y,
            isMobile: s
          }
        ) }) : /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
          !d && /* @__PURE__ */ b.jsxs(
            "button",
            {
              type: "button",
              "aria-label": "Search asu.edu",
              onClick: M,
              className: D.SEARCH_BUTTON,
              "data-testid": "search-button",
              children: [
                /* @__PURE__ */ b.jsx("span", { children: "Search" }),
                /* @__PURE__ */ b.jsx(je, { icon: ud })
              ]
            }
          ),
          d && /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
            /* @__PURE__ */ b.jsx(
              Md,
              {
                inputRef: u,
                hasInputValue: p,
                setHasInputValue: y,
                isMobile: s,
                onBlur: () => {
                  p || h(!1);
                }
              }
            ),
            /* @__PURE__ */ b.jsx(
              Zi,
              {
                color: "dark",
                text: "Search",
                as: "button",
                classes: D.SUBMIT_BUTTON
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ b.jsx("input", { name: "url_host", value: c, type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "site", value: "default_collection", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "sort", value: "date:D:L:d1", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "output", value: "xml_no_dtd", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "ie", value: "UTF-8", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "oe", value: "UTF-8", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "client", value: "asu_frontend", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "proxystylesheet", value: "asu_frontend", type: "hidden" })
      ]
    }
  ) });
}, tE = {
  event: "link",
  action: "click",
  name: "onclick",
  region: "navbar",
  type: "internal link",
  section: "topbar",
  text: ""
}, B1 = () => {
  const { breakpoint: l, isUnbranded: o } = Kn(), c = Or(l);
  function s() {
    try {
      return window.location.href;
    } catch (h) {
      return console.error(h), "";
    }
  }
  const u = [
    {
      className: bn(
        D.NAV_LINK,
        D.VISUALLY_HIDDEN_FOCUSABLE
      ),
      href: "#skip-to-content",
      text: "Skip to main content",
      isAccessibilityLink: !0
    },
    {
      className: bn(
        D.NAV_LINK,
        D.VISUALLY_HIDDEN_FOCUSABLE
      ),
      href: `https://accessibility.asu.edu/report#a11yref=${s()}`,
      text: "Report an accessibility problem",
      isAccessibilityLink: !0
    },
    {
      className: D.NAV_LINK,
      href: "https://asu.edu",
      text: "ASU Home"
    },
    {
      className: D.NAV_LINK,
      href: "https://my.asu.edu",
      text: "My ASU"
    },
    {
      className: D.NAV_LINK,
      href: "https://www.asu.edu/academics/colleges-schools",
      text: "Colleges and Schools"
    }
  ], d = o ? u.filter((h) => h.isAccessibilityLink) : u;
  return /* @__PURE__ */ b.jsx(
    WT,
    {
      breakpoint: l,
      className: bn(
        D.UNIVERSAL_NAV,
        o && D.UNIVERSAL_NAV_UNBRANDED
      ),
      "data-testid": "universal-navbar",
      "data-elastic-exclude": "data-elastic-exclude",
      children: /* @__PURE__ */ b.jsx("div", { className: "container-xl", children: /* @__PURE__ */ b.jsx("div", { className: D.HEADER_TOP, children: /* @__PURE__ */ b.jsxs("nav", { className: "nav", "aria-label": "ASU Global", children: [
        /* @__PURE__ */ b.jsxs("div", { className: D.LINKS_CONTAINER, children: [
          d.map((h) => /* @__PURE__ */ b.jsx(
            "a",
            {
              className: h.className,
              href: h.href,
              onClick: () => wt({ ...tE, text: h.text }),
              children: h.text
            },
            h.href
          )),
          !o && /* @__PURE__ */ b.jsx(_T, {})
        ] }),
        !c && !o && /* @__PURE__ */ b.jsx(D1, {})
      ] }) }) })
    }
  );
}, eE = Xe.div`
  background-color: ${qn};
  border-bottom: 1px solid ${ln};
  padding: 0 12px;
  .navbar {
    padding: 0;
    display: flex;
    align-items: flex-start;
    flex-wrap: nowrap;
  }
  .navbar.${D.MOBILE_MENU_OPEN} {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto auto auto 1fr;
    grid-template-areas:
      "logo . toggler"
      "title title title"
      "search search search"
      "nav nav nav";

    max-height: calc(100dvh - ${({ headerTop: l }) => l}px);
    overflow: hidden;
    .${D.PARTNER_TITLE}, .navbar-brand {
      grid-area: logo;
      grid-column: 1;
      grid-row: 1;
    }
    .navbar-toggler {
      grid-area: toggler;
      grid-column: 3;
      grid-row: 1;
    }
    .${D.EXPAND_TITLE} {
      grid-area: title;
    }
    & > * {
      grid-column: 1 / -1;
    }
    & > form {
      grid-area: search;
    }
    & > nav {
      grid-area: nav;
      display: grid;
      grid-template-rows: 1fr auto;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }
  .navbar-brand {
    .${D.LOGO_VERT} {
      display: block;
      height: 72px;
      width: auto;
      margin: 20px 1rem 20px 0;
    }
    .${D.LOGO_HORIZ} {
      display: none;
    }
  }
  .navbar-toggler {
    display: none;
  }
  .${D.EXPAND_TITLE} {
    width: 100%;
  }
  @media (min-width: ${({ breakpoint: l }) => l}) {
    .${D.NO_NAVIGATION} {
      margin-top: 16px;
      display: flex;
      align-items: center;
      .${D.TITLE} {
        width: 100%;
      }
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    padding: 0;
    .navbar {
      padding: 1.5rem 0 0 0;
      flex-wrap: wrap;
      justify-content: space-between;
      &.${D.PARTNER} {
        flex-direction: row-reverse;
      }
    }
    .${D.PARTNER} .${D.CONTENT_CONTAINER} {
      min-height: calc(100vh - 240px);
    }
    .navbar-brand {
      padding: 0;
      margin: 0;

      .${D.LOGO_VERT} {
        display: none;
      }

      .${D.LOGO_HORIZ} {
        display: block;
        height: 32px;
        width: auto;
        margin-bottom: 1rem;
        margin-left: 2rem;
      }
    }
    .navbar-toggler {
      display: initial;
      background: transparent;
      color: ${on};
      border: 0;
      border-radius: 0;
      font-size: 1.25rem;
      margin-right: 2rem;
      cursor: pointer;
      min-width: 44px;
      min-height: 44px;
      padding: 0.25rem 0.45rem;

      .${D.MENU_SEARCH_ICON} {
        display: none;
      }

      &.collapsed {
        .${D.MENU_SEARCH_ICON} {
          width: 24px;
          height: auto;
          display: unset;
        }
        .${D.MENU_CLOSE_ICON} {
          display: none;
        }
      }
      .${D.NO_NAVIGATION} + nav .${D.BUTTONS_CONTAINER} {
        border-top: 1px solid ${Jc};
      }
    }
  }
`, M1 = "data:image/png;base64,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", z1 = "data:image/png;base64,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", _A = Xe.a`
  display: unset;
  padding: 0;
  margin: 0;
  font-size: unset;
  line-height: unset;
  white-space: unset;
`, nE = () => {
  const { logo: l, isUnbranded: o, unbrandedLogo: c } = Kn();
  return o ? /* @__PURE__ */ b.jsxs(
    _A,
    {
      href: (c == null ? void 0 : c.brandLink) ?? "/",
      className: D.NAVBAR_BRAND,
      "data-testid": "logo",
      onFocus: () => wt({ text: "unbranded logo" }),
      children: [
        /* @__PURE__ */ b.jsx(
          "img",
          {
            className: D.LOGO_VERT,
            src: c == null ? void 0 : c.src,
            alt: (c == null ? void 0 : c.alt) ?? "",
            decoding: "async",
            fetchpriority: "high"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "img",
          {
            className: D.LOGO_HORIZ,
            src: c == null ? void 0 : c.src,
            alt: (c == null ? void 0 : c.alt) ?? "",
            decoding: "async",
            fetchpriority: "high"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ b.jsxs(
    _A,
    {
      href: (l == null ? void 0 : l.brandLink) ?? "https://asu.edu",
      className: D.NAVBAR_BRAND,
      "data-testid": "logo",
      onFocus: () => wt({ text: "asu logo" }),
      children: [
        /* @__PURE__ */ b.jsx(
          "img",
          {
            className: D.LOGO_VERT,
            src: (l == null ? void 0 : l.src) ?? M1,
            alt: (l == null ? void 0 : l.alt) ?? "Arizona State University logo",
            title: (l == null ? void 0 : l.title) ?? "ASU homepage",
            width: "303",
            height: "234",
            decoding: "async",
            fetchpriority: "high"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "img",
          {
            className: D.LOGO_HORIZ,
            src: (l == null ? void 0 : l.mobileSrc) ?? z1,
            alt: (l == null ? void 0 : l.alt) ?? "Arizona State University logo",
            title: (l == null ? void 0 : l.title) ?? "ASU homepage",
            width: "400",
            height: "72",
            decoding: "async",
            fetchpriority: "high"
          }
        )
      ]
    }
  );
}, aE = Xe.nav`
  white-space: nowrap;
  > .${D.CONTENT_CONTAINER} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: none;
    height: auto;
    margin: inherit;
    font-size: inherit;
    color: inherit;
    flex-direction: row;
  }
  .${D.NAV_LIST} {
    display: flex;
    margin: 0;
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    width: 100%;
    > .${D.CONTENT_CONTAINER} {
      flex-direction: column;
      justify-content: flex-start;
      overflow-y: auto;
      min-height: 0;
      > *:last-child {
        margin-bottom: 1rem;
      }
    }
    .${D.NAV_LIST} {
      flex-direction: column;
      width: 100%;
    }
    .${D.BUTTONS_CONTAINER} {
      display: flex;
      align-items: center;
      padding: 1rem 2rem;
      width: 100%;
    }
  }
`, lE = Xe.div`
  --container-width: 1200px;
  --gap: 2rem;
  position: fixed;
  background-color: ${qn};
  border: 1px solid ${ln};
  margin: 0;
  z-index: 1031;
  visibility: hidden;
  white-space: normal;
  &.${D.OPENED} {
    visibility: visible;
  }
  &.mega {
    width: min(var(--container-width), 100%);
    left: calc((100% - var(--container-width)) / 2);
  }
  &.aligned-right:not(.mega) {
    position: absolute;
    right: 0;
  }
  > .${D.DROPDOWN_CONTAINER} {
    max-width: var(--container-width);
    margin: 0 auto;
    /*
      max-height is calculated from
      100% view Height
      minus offset
      minus 2rem padding
    */
    max-height: calc(100vh - ${({ heightOffset: l }) => l}px - 2rem);
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    justify-content: stretch;

    .${D.DROPDOWN_CONTAINER_COLUMN} {
      --span: 1; /* component overrides using inline style */
      --col: 1; /* component overrides using inline style */
      width: calc(var(--container-width) / var(--cols) * var(--span));
      padding: var(--gap);
      padding-bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      row-gap: var(--gap);

      & > *:last-child {
        padding-bottom: var(--gap);
      }

      &:not(:last-child) {
        border-right: 1px solid ${ln};
      }
    }

    .${D.UL_HEADING} {
      margin-top: 0;
      font-size: 1.5rem;
      letter-spacing: -0.035em;
      font-weight: 700;
      text-align: left;
      opacity: 1;
      margin: 0;
      margin-bottom: -1.5rem;
      line-height: calc(100% + 0.12em);
    }
    ul {
      --ul-gap: 1rem;
      &:is(:last-child) {
        flex-grow: 0;
      }
      margin: 0;
      width: calc(
        var(--container-width) / var(--cols, 1) * var(--span, 1) - var(--gap) *
          2
      );
      display: flex;
      flex-direction: row;
      column-gap: var(--ul-gap);
      flex-wrap: wrap;
      .${D.NAV_LINK} {
        padding: 0;
        flex-basis: calc(
          (100% / var(--span)) - var(--ul-gap) * (var(--span) - 1) / var(--span)
        );
        a {
          width: 100%;
          display: inline-block;
          margin: 0.75rem 0;
          position: relative;
          line-height: 1rem;
          color: ${on};
          &:hover {
            color: ${Qd};
            text-decoration: underline;
          }
        }
        & + .${D.NAV_BUTTON} {
          width: 100%;
          margin-top: auto;
          padding-top: var(--gap);
          & + .${D.NAV_BUTTON} {
            margin-top: 1rem;
          }
        }
      }
    }
  }

  .${D.NAV_BUTTON} {
    flex: 1 1;
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-end;
    flex-wrap: nowrap;
    width: fit-content;
  }
  .${D.DROPDOWN_BUTTON_CONTAINER} {
    border-top: 1px solid ${ln};
    border-bottom: 1px solid ${ln};
    > div {
      max-width: var(--container-width);
      margin: 0 auto;
      display: flex;
      padding: 1rem 2rem;
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    position: initial;
    border: none;
    max-height: unset;
    visibility: visible;
    display: none;
    &.${D.OPENED} {
      display: block;
    }
    > .${D.DROPDOWN_CONTAINER} {
      max-width: 100%;
      max-height: unset;
      overflow-y: unset;
      overflow-x: unset;
      flex-direction: column;

      .${D.DROPDOWN_CONTAINER_COLUMN} {
        width: 100%;
        border-right: unset;
        &:not(:first-child) {
          padding-top: 0;
        }
      }
      ul {
        width: 100%;
        max-width: 100%;
        padding: 0;
        &:not(:last-child) {
          border: none;
        }
        .${D.UL_HEADING} {
          font-size: 1.25rem;
        }
        .${D.NAV_BUTTON} {
          // padding-top: 1.5rem;
        }
        .${D.NAV_LINK} {
          flex-basis: 100%;
          padding: 0 1rem;
          &:not(:last-child) {
            border-bottom: 1px solid ${ln};
          }
          a {
            padding: 1rem 0;
            margin: 0;
          }
        }
      }
    }
    .${D.DROPDOWN_BUTTON_CONTAINER} {
      margin-top: 0;
      > div {
        max-width: 100%;
        padding: 1rem 3rem;
      }
    }
  }
`, iE = {
  event: "link",
  action: "click",
  name: "onclick",
  type: "internal link",
  region: "navbar",
  section: "main navbar",
  component: "dropdown menu",
  text: ""
}, L1 = ({ text: l }) => /* @__PURE__ */ b.jsx("h3", { className: D.UL_HEADING, children: l });
L1.propTypes = {
  text: O.string
};
const R1 = ({ link: l, dropdownName: o, handleLinkEvent: c }) => /* @__PURE__ */ b.jsx("div", { className: D.NAV_BUTTON, children: /* @__PURE__ */ b.jsx(
  Zi,
  {
    text: l.text,
    color: l.color || "maroon",
    href: l.href,
    onClick: (s) => c(s, l),
    onKeyDown: (s) => c(s, l)
  }
) });
R1.propTypes = {
  link: O.shape({
    text: O.string,
    color: O.string,
    href: O.string
  }),
  dropdownName: O.string,
  handleLinkEvent: O.func
};
const U1 = ({ link: l, dropdownName: o, handleLinkEvent: c }) => /* @__PURE__ */ b.jsx("li", { className: D.NAV_LINK, children: /* @__PURE__ */ b.jsx(
  "a",
  {
    ...l.href ? {} : { tabIndex: 0 },
    href: l.href,
    onClick: (s) => c(s, l),
    onKeyDown: (s) => c(s, l),
    children: l.text
  }
) });
U1.propTypes = {
  link: O.shape({
    text: O.string,
    href: O.string
  }),
  dropdownName: O.string,
  handleLinkEvent: O.func
};
const H1 = ({
  dropdownName: l,
  items: o = [],
  buttons: c = [],
  classes: s = "",
  listId: u,
  opened: d,
  parentLink: h
}) => {
  const {
    breakpoint: p,
    headerHeight: y,
    setItemOpened: T,
    setMobileMenuOpen: M,
    mobileMenuOpen: C
  } = Kn(), x = o.reduce((Q, G) => G != null && G[0] ? Q + (G[0].span || 1) : Q, 0), J = x > 2, j = Gl(null), [I, k] = vn(!1), K = o.length > 1;
  Pe(() => {
    var Q;
    if (typeof window < "u" && j.current) {
      const G = (Q = j == null ? void 0 : j.current) == null ? void 0 : Q.getBoundingClientRect().left, P = window.innerWidth * 0.55;
      k(G > P);
    }
  }, []), Pe(() => {
    var Q;
    d && ((Q = j == null ? void 0 : j.current) != null && Q.parentElement) && j.current.parentElement.scrollIntoView(
      /** @type {ScrollIntoViewOptions} */
      {
        behavior: "smooth",
        block: "start"
      }
    );
  }, [j, d]);
  const X = (Q) => Q == null ? void 0 : Q.stopPropagation(), tt = (Q, G) => {
    var ne, kt;
    const { key: P, type: Dt, target: ot } = Q, dt = ot == null ? void 0 : ot.parentElement, yt = () => {
      var H;
      const V = (H = dt == null ? void 0 : dt.nextElementSibling) == null ? void 0 : H.firstChild;
      typeof (V == null ? void 0 : V.focus) == "function" && V.focus();
    }, Tt = () => {
      var H;
      const V = (H = dt == null ? void 0 : dt.previousElementSibling) == null ? void 0 : H.firstChild;
      typeof (V == null ? void 0 : V.focus) == "function" && V.focus();
    };
    X(Q), P === "ArrowDown" ? (Q.preventDefault(), yt()) : P === "ArrowUp" ? (Q.preventDefault(), Tt()) : P === "Escape" && d ? (T(), typeof ((ne = h == null ? void 0 : h.current) == null ? void 0 : ne.focus) == "function" && h.current.focus()) : P === "Escape" && !d && C ? M(!1) : (P === "Enter" || P === " " || Dt === "click") && (M(!1), T(), (kt = G == null ? void 0 : G.onClick) == null || kt.call(G, Q), wt({ ...iE, text: G.text }));
  }, et = (Q, G) => {
    if (!Q) return null;
    const P = `${Q.text}-${Q.href}-${G}`;
    return Q.type === "heading" ? /* @__PURE__ */ b.jsx(L1, { text: Q.text }, P) : Q.type === "button" ? /* @__PURE__ */ b.jsx(
      R1,
      {
        link: Q,
        dropdownName: l,
        handleLinkEvent: tt
      },
      P
    ) : /* @__PURE__ */ b.jsx(
      U1,
      {
        link: Q,
        dropdownName: l,
        handleLinkEvent: tt
      },
      P
    );
  };
  let lt = y;
  return c.length > 0 && (lt += 64), /* @__PURE__ */ b.jsxs(
    lE,
    {
      ref: j,
      className: `${s}${I ? " aligned-right" : ""}${J ? " mega" : ""}`,
      breakpoint: p,
      heightOffset: lt,
      children: [
        /* @__PURE__ */ b.jsx(
          "div",
          {
            style: { "--cols": x < 3 ? 4 : x },
            id: K ? u : "",
            className: D.DROPDOWN_CONTAINER,
            children: /* @__PURE__ */ b.jsx(b.Fragment, { children: o == null ? void 0 : o.map((Q, G) => {
              const Dt = r0(`dropdown-item-${G}-`).next().value;
              return Q != null && Q.length ? /* @__PURE__ */ b.jsx(
                "div",
                {
                  className: D.DROPDOWN_CONTAINER_COLUMN,
                  style: { "--span": Q[0].span || 1 },
                  id: K ? `${u}-${Dt}` : u,
                  children: (() => {
                    let ot = [];
                    const dt = [];
                    return Q.forEach((yt, Tt) => {
                      yt.type === "heading" ? (ot.length > 0 && (dt.push(ot), ot = []), dt.push([yt])) : yt.type === "button" ? (ot.length > 0 && (dt.push(ot), ot = []), dt.push([yt])) : ot.push(yt);
                    }), ot.length > 0 && dt.push(ot), dt.map((yt, Tt) => {
                      const ne = `${Dt}-group-${Tt}`;
                      return yt.length === 1 && yt[0].type === "heading" || yt.length === 1 && yt[0].type === "button" ? et(yt[0], Tt) : /* @__PURE__ */ b.jsx("ul", { children: yt.map((kt, V) => et(kt, V)) }, ne);
                    });
                  })()
                },
                `${u}-${Dt}`
              ) : null;
            }) })
          }
        ),
        c.length > 0 && /* @__PURE__ */ b.jsx("div", { className: D.DROPDOWN_BUTTON_CONTAINER, children: /* @__PURE__ */ b.jsx("div", { children: c.map((Q, G) => /* @__PURE__ */ b.jsx(
          Zi,
          {
            color: Q.color,
            text: Q.text,
            href: Q.href,
            onClick: X
          },
          `${Q.text}-${Q.href || G}`
        )) }) })
      ]
    }
  );
};
H1.propTypes = {
  dropdownName: O.string,
  items: O.arrayOf(
    O.arrayOf(
      O.shape({
        text: O.string,
        selected: O.bool,
        onClick: O.func,
        href: O.string
      })
    )
  ),
  buttons: O.arrayOf(O.shape(iu)),
  classes: O.string,
  listId: O.string,
  opened: O.bool,
  setItemOpened: O.func,
  parentLink: O.shape({
    current: O.instanceOf(HTMLElement)
  })
};
const oE = Xe.li`
  position: relative;
  padding: 0;
  max-width: 100%;
  margin: 0 0.5rem 0 0;
  &:has(.${D.OPEN_LINK}) > a:after,
  &:hover > a:after {
    width: calc(100% + 24px);
  }
  > a {
    display: inline-block;
    padding: 0.5rem 0.75rem;
    line-height: 1rem;
    color: ${on};

    &[aria-expanded="true"] {
      background-color: ${qn};
      position: sticky;
      top: 0;
      z-index: 1;
    }
    &:after {
      transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      content: "";
      display: block;
      height: 0.5rem;
      position: relative;
      top: 0.6rem;
      right: 12px;
      width: 0;
      background-image: linear-gradient(
        to right,
        transparent 0.5%,
        ${Vd} 0.5%
      );
    }
    &.${D.NAV_ITEM_SELECTED}:after {
      width: calc(100% + 24px);
    }
    &.nav-item {
      display: block;
    }
    > span {
      position: relative;
      .${D.CHEVRON_ICON} {
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
        margin-left: 0.5rem;
        font-size: 0.75rem;

        &.${D.OPEN} {
          transform: rotate(180deg);
        }
      }
    }
    .${D.MOBILE_ONLY} {
      display: none;
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    border-bottom: 1px solid ${Jc};
    margin: 0;
    &:first-child {
      border-top: 1px solid ${Jc};
    }
    &:hover > a:after {
      width: 100%;
    }
    .${D.ICON_NAV_ITEM} {
      display: none;
    }
    > a {
      padding: 1rem 2rem 0.75rem;
      width: 100%;
      &.${D.OPEN_LINK} {
        border-bottom: 1px solid ${Jc};
      }
      &:after {
        right: 0;
        top: 0.8rem;
      }
      &.${D.NAV_ITEM_SELECTED}:after {
        width: 100%;
      }
      > span {
        display: flex;
        justify-content: space-between;
        .${D.CHEVRON_ICON} {
          font-size: 1.25rem;
        }
      }
      .${D.MOBILE_ONLY} {
        display: initial;
      }
    }
  }
`, rE = {
  event: "collapse",
  type: "click"
}, Jf = {
  event: "link",
  action: "click",
  name: "onclick",
  type: "internal link",
  region: "navbar",
  section: "main navbar",
  component: "navigation link",
  text: ""
}, j1 = ({ children: l }) => /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
  /* @__PURE__ */ b.jsx(
    je,
    {
      icon: i3,
      className: D.ICON_NAV_ITEM,
      alt: ""
    }
  ),
  /* @__PURE__ */ b.jsx("span", { className: D.MOBILE_ONLY, children: l })
] });
j1.propTypes = {
  children: O.node
};
const X1 = ({ link: l, setItemOpened: o, itemOpened: c }) => {
  const s = Gl(null), u = Gl(null), d = l.id === c, {
    breakpoint: h,
    expandOnHover: p = !1,
    title: y,
    mobileMenuOpen: T = !1,
    setMobileMenuOpen: M
  } = Kn(), C = Or(h);
  Pe(() => {
    const k = (X) => {
      var tt;
      d && !C && !((tt = s == null ? void 0 : s.current) != null && tt.contains(X == null ? void 0 : X.target)) && o();
    }, K = () => {
      requestAnimationFrame(() => {
        const X = s.current;
        d && !C && X && !X.contains(document.activeElement) && o();
      });
    };
    return document.addEventListener("click", k, !0), document.addEventListener("focusin", K), () => {
      document.removeEventListener("click", k, !0), document.removeEventListener("focusin", K);
    };
  }, [d, o, C]);
  const x = qv(() => {
    var k;
    return l.type === "icon-home" ? /* @__PURE__ */ b.jsx(j1, { children: l.text }) : /* @__PURE__ */ b.jsxs("span", { children: [
      l.text,
      !!((k = l.items) != null && k.length) && /* @__PURE__ */ b.jsx(
        je,
        {
          icon: V0,
          className: bn(
            D.CHEVRON_ICON,
            d && D.OPEN
          ),
          alt: ""
        }
      )
    ] });
  }, [l]), J = () => {
    var tt;
    const k = !!((tt = l.items) != null && tt.length), K = d ? "close" : "open", { text: X } = l;
    wt(
      // @ts-ignore
      k ? {
        ...Jf,
        ...rE,
        action: K,
        text: X
      } : {
        ...Jf,
        text: l.type === "icon-home" ? "home button" : X
      }
    );
  }, j = (k) => {
    var tt, et, lt, Q;
    if (!l.items && (l.href || l.onClick) && (k.key === "Enter" || k.key === " " || k.type === "click")) {
      wt({ ...Jf, text: l.text }), M(!1), o(), (tt = l.onClick) == null || tt.call(l, k);
      return;
    }
    const { key: K } = k;
    if ([
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "Enter",
      " ",
      "Escape",
      "Click"
    ].includes(K)) {
      if (k.preventDefault(), K === "Escape" && d) {
        typeof ((et = s == null ? void 0 : s.current) == null ? void 0 : et.focus) == "function" && s.current.focus(), o();
        return;
      }
      if (K === "Escape" && !d && T) {
        M(!1);
        return;
      }
      if ((K === "Enter" || K === " ") && (l.items ? o() : (M(!1), o(), (lt = l.onClick) == null || lt.call(l, k)), J()), (K === "ArrowDown" || K === "ArrowRight") && d) {
        const G = document.querySelector(
          `.${PA(l.id)} li.${D.NAV_LINK} a`
        );
        typeof (G == null ? void 0 : G.focus) == "function" && G.focus();
      }
    } else k.type === "click" && l.items ? (k.preventDefault(), J(), o()) : k.type === "click" && (J(), (Q = l.onClick) == null || Q.call(l, k));
  }, I = () => {
    p && !C && (o(), J());
  };
  return /* @__PURE__ */ b.jsxs(
    oE,
    {
      breakpoint: h,
      ref: s,
      onMouseEnter: I,
      onMouseLeave: I,
      children: [
        /* @__PURE__ */ b.jsx(
          "a",
          {
            onKeyDown: j,
            onClick: j,
            href: l.href,
            ...l.items ? { "aria-expanded": d } : {},
            ...l.href ? {} : { tabIndex: 0 },
            "aria-owns": l.items ? `dropdown-${l.id}` : null,
            className: bn(
              l.class,
              l.selected && D.NAV_ITEM_SELECTED,
              d && D.OPEN_LINK
            ),
            "data-testid": "nav-item",
            title: l.type === "icon-home" && y ? `${y} home page` : l.text,
            ref: u,
            children: x
          }
        ),
        l.items && /* @__PURE__ */ b.jsx(
          H1,
          {
            items: l.items,
            buttons: l.buttons,
            dropdownName: l.text,
            classes: bn(
              PA(l.id),
              d && D.OPENED
            ),
            listId: `dropdown-${l.id}`,
            opened: d,
            parentLink: u
          }
        )
      ]
    }
  );
};
X1.propTypes = {
  link: td,
  setItemOpened: O.func,
  itemOpened: O.number
};
const cE = "Header buttons cannot have both an onClick and an href property as this breaks accessibility. Please remove one", $A = () => {
  const {
    navTree: l = [],
    mobileNavTree: o = [],
    buttons: c = [],
    breakpoint: s,
    itemOpened: u,
    setItemOpened: d
  } = Kn(), h = Or(s), p = (C) => {
    u === C ? d(() => {
    }) : setTimeout(() => d(() => C), 1);
  }, y = (C) => {
    C.onClick && C.href && console.error(cE);
  }, T = (C) => () => {
    wt({
      event: "link",
      action: "click",
      name: "onclick",
      region: "navbar",
      type: "internal link",
      section: "main navbar",
      text: C.text
    }), C.onClick && C.onClick();
  }, M = (C, x) => {
    const J = { ...C, id: x }, I = r0(`${C.text}-${x}-`).next().value;
    return /* @__PURE__ */ b.jsx(
      X1,
      {
        link: J,
        setItemOpened: () => p(x),
        itemOpened: u
      },
      I
    );
  };
  return (
    // @ts-ignore
    /* @__PURE__ */ b.jsxs(aE, { breakpoint: s, "data-testid": "navigation", "aria-label": "Site", children: [
      !!(l.length || o.length || c.length) && /* @__PURE__ */ b.jsxs("div", { className: D.CONTENT_CONTAINER, children: [
        !!(l != null && l.length || o != null && o.length) && /* @__PURE__ */ b.jsx("ul", { className: D.NAV_LIST, children: o != null && o.length && h ? o == null ? void 0 : o.map((C, x) => M(C, x)) : l == null ? void 0 : l.map((C, x) => M(C, x)) }),
        !!(c != null && c.length) && /* @__PURE__ */ b.jsx(
          "form",
          {
            className: D.BUTTONS_CONTAINER,
            "data-testid": "buttons-container",
            children: c.map((C) => (y(C), /* @__PURE__ */ n0(
              Zi,
              {
                ...C,
                key: C.text,
                onClick: T(C)
              }
            )))
          }
        )
      ] }),
      h && /* @__PURE__ */ b.jsx(B1, {})
    ] })
  );
}, uE = "data:image/png;base64,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", sE = Xe.div`
  margin: 0.5rem 0;
  a {
    display: inline-block;
    &:not(:last-child) {
      border-right: 1px solid ${ln};
      margin-right: 1.5rem;
      padding-right: 1.5rem;
    }
    img {
      height: 52px;
      width: auto;
      &.${D.LOGO_VERT} {
        display: initial;
      }
      &.${D.LOGO_HORIZ} {
        display: none;
      }
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    margin: 0.5rem 0 1rem 1rem;
    a {
      &:not(:last-child) {
        margin-right: 1rem;
        padding-right: 1rem;
      }
      img {
        height: 32px;
        width: auto;
        &.${D.LOGO_VERT} {
          display: none;
        }
        &.${D.LOGO_HORIZ} {
          height: 24px;
          width: auto;
          display: initial;
        }
      }
    }
  }
  @media (max-width: 370px) {
    margin: 0.5rem 0 1rem 0.5rem;
    a {
      &:not(:last-child) {
        margin-right: 0.5rem;
        padding-right: 0.5rem;
      }
      img {
        height: 29px;
        &.${D.LOGO_HORIZ} {
          height: 21px;
        }
      }
    }
  }
`, fE = () => {
  const { partnerLogo: l, logo: o, breakpoint: c } = Kn();
  return (
    // @ts-ignore
    /* @__PURE__ */ b.jsxs(sE, { breakpoint: c, "data-testid": "partner", children: [
      /* @__PURE__ */ b.jsx(
        "a",
        {
          href: (l == null ? void 0 : l.brandLink) ?? "https://starbucks.asu.edu/",
          onClick: () => wt({
            event: "link",
            action: "click",
            name: "onclick",
            region: "navbar",
            type: "internal link",
            section: "main navbar",
            text: "partner logo"
          }),
          children: /* @__PURE__ */ b.jsx(
            "img",
            {
              src: (l == null ? void 0 : l.src) ?? uE,
              alt: (l == null ? void 0 : l.alt) ?? "ASU Starbucks logo",
              width: "232",
              height: "81",
              decoding: "async",
              fetchpriority: "high"
            }
          )
        }
      ),
      /* @__PURE__ */ b.jsxs(
        "a",
        {
          href: (o == null ? void 0 : o.brandLink) ?? "https://asu.edu",
          onClick: () => wt({ text: "asu logo" }),
          children: [
            /* @__PURE__ */ b.jsx(
              "img",
              {
                className: D.LOGO_VERT,
                src: (o == null ? void 0 : o.src) ?? M1,
                alt: (o == null ? void 0 : o.alt) ?? "Arizona State University logo",
                width: "303",
                height: "234",
                decoding: "async",
                fetchpriority: "high"
              }
            ),
            /* @__PURE__ */ b.jsx(
              "img",
              {
                className: D.LOGO_HORIZ,
                src: (o == null ? void 0 : o.mobileSrc) ?? z1,
                alt: (o == null ? void 0 : o.alt) ?? "Arizona State University logo",
                width: "400",
                height: "72",
                decoding: "async",
                fetchpriority: "high"
              }
            )
          ]
        }
      )
    ] })
  );
}, dE = (l, o) => {
  const c = new Date(l);
  return c.setMinutes(c.getMinutes() + o), c;
}, mE = (l) => {
  const o = "localhost", c = "title_loaded", s = /* @__PURE__ */ new Date(), u = l || window.location.hostname, d = localStorage.getItem("title_loaded"), h = s.getTime() > parseInt(d, 10), p = u === o, y = document.referrer.includes(u);
  if (p || !y && (!d || h)) {
    const M = dE(s, 10).getTime();
    return localStorage.setItem(c, M.toString()), !0;
  }
  return !1;
}, hE = {
  "992px": "993px",
  "1260px": "1261px"
}, t0 = Xe.div`
  line-height: 1;
  font-size: 1rem;
  font-weight: 700;
  padding: 0 2rem 1rem 2rem;
  letter-spacing: -1px;
  display: inline-block;
  margin: 0;
  width: fit-content;

  &.active {
    background-position: -200%;
  }

  > .${D.UNIT_NAME} {
    display: none;
  }
  .${D.UNIT_NAME},
    .${D.SUBUNIT_NAME},
    .${D.TITLE_SUBUNIT_NAME} {
    color: ${on};
  }

  .${D.SUBUNIT_NAME}, .${D.TITLE_SUBUNIT_NAME} {
    background-image: linear-gradient(
      to right,
      transparent 51%,
      ${Vd} 51%,
      95%,
      transparent
    );
    background-position: 0 0;
    background-size: 200%;
    display: inline-block;
    transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
    transition-duration: 1.5s;
    &.active {
      background-position: -200%;
    }
  }

  @media (min-width: ${({ breakpoint: l }) => hE[l]}) {
    line-height: 1;
    font-weight: 700;
    padding: 0;
    margin: 1rem 0 0.5rem 0;
    > .${D.UNIT_NAME} {
      font-size: 1rem;
      margin-bottom: 0.5rem;
      display: block;

      :hover {
        text-decoration: underline;
      }
    }
    .${D.SUBUNIT_NAME} {
      font-size: 1.5rem;
      margin-bottom: 0;
      display: inline-block;

      :hover {
        text-decoration: underline;
      }
    }
    .${D.TITLE_SUBUNIT_NAME} {
      font-size: 2rem;
      font-weight: 700;
      display: inline-block;
      margin: 0.5rem 0 0.5rem 0;

      :hover {
        text-decoration: underline;
      }
    }
  }
`, Q1 = () => {
  const [l, o] = vn(!1), { title: c, parentOrg: s, parentOrgUrl: u, baseUrl: d, breakpoint: h, animateTitle: p } = Kn();
  return Pe(() => {
    if (p !== !1) {
      let y = d === "/" ? window.location.hostname : d;
      !y.includes(window.location.hostname) && y.indexOf("/") === 0 && (y = window.location.hostname + y), mE(y) && o(!0);
    }
  }, [l, p, d]), s ? /* @__PURE__ */ b.jsxs(
    t0,
    {
      breakpoint: h,
      className: D.TITLE,
      "data-testid": "title",
      children: [
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: D.UNIT_NAME,
            href: u,
            onClick: () => wt({
              event: "link",
              action: "click",
              name: "onclick",
              region: "navbar",
              type: "internal link",
              section: "main navbar",
              text: s
            }),
            title: `${s} home page`,
            children: s
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: bn(
              D.SUBUNIT_NAME,
              l && "active"
            ),
            href: d,
            onClick: () => wt({
              event: "link",
              action: "click",
              name: "onclick",
              region: "navbar",
              type: "internal link",
              section: "main navbar",
              text: c
            }),
            title: `${c} home page`,
            children: c
          }
        )
      ]
    }
  ) : /* @__PURE__ */ b.jsx(
    t0,
    {
      breakpoint: h,
      className: D.TITLE,
      "data-testid": "title",
      children: /* @__PURE__ */ b.jsx(
        "a",
        {
          className: bn(
            D.TITLE_SUBUNIT_NAME,
            l && "active"
          ),
          href: d,
          onClick: () => wt({
            event: "link",
            action: "click",
            name: "onclick",
            region: "navbar",
            type: "internal link",
            section: "main navbar",
            text: c
          }),
          title: `${c} home page`,
          children: c
        }
      )
    }
  );
};
Q1.propTypes = { ...kc };
const gE = () => {
  const {
    breakpoint: l,
    isPartner: o,
    isUnbranded: c,
    hasNavigation: s,
    itemOpened: u,
    setItemOpened: d,
    mobileMenuOpen: h,
    setMobileMenuOpen: p,
    mobileMenuToggleRef: y,
    headerTop: T
  } = Kn(), M = Or(l), C = () => {
    p((J) => !J);
  };
  Pe(() => (document.body.style.overflow = h || u !== void 0 ? "hidden" : "unset", () => {
    document.body.style.overflow = "unset";
  }), [h, u, M]), Pe(() => {
    p(!1), d();
  }, [M]);
  const x = () => {
    C(), wt({
      event: "collapse",
      action: h ? "close" : "open",
      type: "click",
      text: "menu button tablet"
    });
  };
  return /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
    !M && /* @__PURE__ */ b.jsx(B1, {}),
    /* @__PURE__ */ b.jsx(eE, { breakpoint: l, headerTop: T, children: /* @__PURE__ */ b.jsx("div", { className: "container-xl", children: /* @__PURE__ */ b.jsx("div", { className: D.HEADER_MAIN, children: /* @__PURE__ */ b.jsxs(
      "div",
      {
        className: bn(
          D.NAVBAR,
          D.NAVBAR_EXPAND_XL,
          o && D.PARTNER,
          h && D.MOBILE_MENU_OPEN
        ),
        children: [
          !o && /* @__PURE__ */ b.jsx(nE, {}),
          /* @__PURE__ */ b.jsxs(
            "button",
            {
              ref: y,
              className: bn(
                D.NAVBAR_TOGGLER,
                !h && D.COLLAPSED
              ),
              type: "button",
              onClick: x,
              "aria-label": h ? "Close menu" : "Open menu",
              "aria-expanded": h,
              children: [
                /* @__PURE__ */ b.jsx(
                  "img",
                  {
                    src: ZT,
                    alt: "Menu and Search Icon",
                    className: D.MENU_SEARCH_ICON
                  }
                ),
                /* @__PURE__ */ b.jsx(
                  je,
                  {
                    icon: c3,
                    alt: "",
                    className: D.MENU_CLOSE_ICON
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ b.jsxs(
            "div",
            {
              className: bn(
                !o && D.EXPAND_TITLE,
                o && D.PARTNER_TITLE,
                !s && D.NO_NAVIGATION
              ),
              children: [
                o ? /* @__PURE__ */ b.jsx(fE, {}) : /* @__PURE__ */ b.jsx(Q1, {}),
                !M && /* @__PURE__ */ b.jsx($A, {})
              ]
            }
          ),
          h && M && !c && /* @__PURE__ */ b.jsx(D1, {}),
          h && M && /* @__PURE__ */ b.jsx($A, {})
        ]
      }
    ) }) }) })
  ] });
}, pE = (l, o) => l == null ? void 0 : l.findIndex(
  (c) => {
    var s;
    return (c == null ? void 0 : c.href) === o || // !Some applications might send invalid items props as an empty string
    Array.isArray(c.items) && ((s = c.items) == null ? void 0 : s.flat().find(({ href: u }) => u === o));
  }
), AE = (l) => l == null ? void 0 : l.find((o) => o.selected), e0 = (l) => {
  if (!Array.isArray(l) || l.length === 0 || AE(l))
    return l;
  let o = "";
  if (window != null && window.location && (o = window.location.pathname + window.location.search), !o)
    return l;
  const c = pE(l, o);
  if (c === -1)
    return l;
  const s = [...l];
  return s[c].selected = !0, s;
}, V1 = { Lg: "992px", Xl: "1260px" }, yE = $S`
  html {
    scrollbar-gutter: stable;
  }
`, vE = Xe.header`
  font-family:
    Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, sans-serif;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  .container-xl {
    height: 100%;
    max-width: 1224px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
  }
  button,
  a {
    text-decoration: none;
    &:focus {
      outline: none !important;
      box-shadow:
        0px 0px 0px 2px ${qn},
        0px 0px 0px 4px ${on} !important;
    }
  }
  @media (min-width: ${({ breakpoint: l }) => V1[l]}) {
    &.scrolled {
      .${D.TITLE} {
        margin: 0.5rem 0 0 0;
      }
      a.${D.UNIT_NAME} {
        display: none;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      }
      a.${D.SUBUNIT_NAME} {
        margin: 0.52rem 0;
      }
      a.${D.SUBUNIT_NAME}, a.${D.TITLE_SUBUNIT_NAME} {
        font-size: 1.5em;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      }
      .navbar-brand img {
        height: 64px;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
        margin: 12px 1rem 12px 0;
      }
    }
  }
  @media (max-width: 1260px) {
    .container-xl {
      padding-left: 0;
      padding-right: 0;
      max-width: 100%;
    }
  }
`, bE = Xe.div`
  font-family:
    Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, sans-serif;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  .container-xl {
    height: 100%;
    max-width: 1224px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
  }
  button,
  a {
    text-decoration: none;
    &:focus {
      outline: none !important;
      box-shadow:
        0px 0px 0px 2px ${qn},
        0px 0px 0px 4px ${on} !important;
    }
  }
  @media (min-width: ${({ breakpoint: l }) => V1[l]}) {
    &.scrolled {
      .${D.TITLE} {
        margin: 0.5rem 0 0 0;
      }
      a.${D.UNIT_NAME} {
        display: none;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      }
      a.${D.SUBUNIT_NAME} {
        margin: 0.52rem 0;
      }
      a.${D.SUBUNIT_NAME}, a.${D.TITLE_SUBUNIT_NAME} {
        font-size: 1.5em;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      }
      .navbar-brand img {
        height: 64px;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
        margin: 12px 1rem 12px 0;
      }
    }
  }
  @media (max-width: 1260px) {
    .container-xl {
      padding-left: 0;
      padding-right: 0;
      max-width: 100%;
    }
  }
`, Y1 = ({
  isPartner: l = !1,
  isUnbranded: o = !1,
  navTree: c,
  title: s,
  baseUrl: u = "/",
  parentOrg: d,
  parentOrgUrl: h,
  partnerLogo: p,
  unbrandedLogo: y,
  logo: T,
  loggedIn: M,
  userName: C,
  loginLink: x,
  onLoginClick: J,
  logoutLink: j,
  onLogoutClick: I,
  buttons: k,
  breakpoint: K = "Xl",
  animateTitle: X = !1,
  expandOnHover: tt = !1,
  mobileNavTree: et,
  searchUrl: lt,
  site: Q,
  renderDiv: G = "false"
}) => {
  const P = e0(c) || [], Dt = e0(et) || [], ot = Gl(null), dt = Gl(null), [yt, Tt] = vn(void 0), [ne, kt] = vn(!1), [V, H] = vn(150), [Z, st] = vn(0), ht = (ct = void 0) => {
    Tt(ct);
  }, ft = (ct = !1) => {
    dt != null && dt.current && typeof dt.current.focus == "function" && dt.current.focus(), kt(ct);
  }, Mt = () => {
    ot != null && ot.current && (ot.current.focus(), typeof window < "u" && window.scrollTo(0, 0)), ft(), ht(), typeof document < "u" && (document.body.style.overflow = "unset");
  }, gt = () => {
    if (typeof window > "u") return;
    const ct = window.scrollY;
    ot != null && ot.current && (ct > ot.current.getBoundingClientRect().top ? ot.current.classList.add("scrolled") : ot.current.classList.remove("scrolled"), st(ot.current.getBoundingClientRect().top), H(ot.current.getBoundingClientRect().bottom));
  };
  Pe(() => {
    typeof window < "u" && u0({
      packageName: "component-header",
      component: "Component Header",
      type: "NA",
      configuration: {
        site: Q,
        isPartner: l,
        isUnbranded: o,
        searchUrl: lt,
        navTree: P,
        parentOrg: d,
        buttons: k,
        mobileNavTree: Dt
      }
    });
  }, []), Pe(() => {
    ot != null && ot.current && (H(ot.current.getBoundingClientRect().bottom), st(ot.current.getBoundingClientRect().top));
  }, [ot, ne]), Pe(() => {
    if (typeof window > "u") return;
    const ct = () => Rb(gt, 100);
    return window.addEventListener("scroll", ct), () => {
      window.removeEventListener("scroll", ct);
    };
  }, []);
  const at = () => {
    const ct = G === "true" ? bE : vE;
    return /* @__PURE__ */ b.jsx(ct, { id: "asuHeader", breakpoint: K, ref: ot, children: /* @__PURE__ */ b.jsx(gE, {}) });
  };
  return /* @__PURE__ */ b.jsxs(
    w1,
    {
      initialValue: {
        isPartner: l,
        isUnbranded: o,
        navTree: P,
        title: s,
        baseUrl: u,
        parentOrg: d,
        parentOrgUrl: h,
        partnerLogo: p,
        unbrandedLogo: y,
        logo: T,
        loggedIn: M,
        userName: C,
        loginLink: x,
        onLoginClick: J,
        logoutLink: j,
        onLogoutClick: I,
        buttons: k,
        breakpoint: K,
        animateTitle: X,
        expandOnHover: tt,
        mobileNavTree: Dt,
        hasNavigation: !!(P != null && P.length) || !!(Dt != null && Dt.length),
        searchUrl: lt,
        headerTop: Z,
        headerHeight: V,
        itemOpened: yt,
        setItemOpened: ht,
        mobileMenuOpen: ne,
        setMobileMenuOpen: ft,
        singlePageAppReset: Mt,
        mobileMenuToggleRef: dt,
        site: Q
      },
      children: [
        /* @__PURE__ */ b.jsx(yE, {}),
        at()
      ]
    }
  );
};
Y1.propTypes = { ...s0 };
const SE = (l, o, c) => {
  a0.createRoot(c).render(ee.createElement(l, o));
}, xE = ({ targetSelector: l, props: o }) => {
  SE(Y1, o, document.querySelector(l));
};
export {
  N1 as ASUFooter,
  Y1 as ASUHeader,
  EE as initASUFooter,
  xE as initGlobalHeader
};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*! @license DOMPurify 3.4.11 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.11/LICENSE */
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
